(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'xeditable',
            'summernote',
            'frapontillo.bootstrap-switch'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', 'editableOptions'];

    function run(stateHandler, translationHandler, editableOptions) {
        stateHandler.initialize();
        translationHandler.initialize();
        editableOptions.theme = 'bs3';
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'generateAuthKeys': {
                url: 'api/generate-authenticator-key',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false,
            _googleAuth = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isGoogleAuthEnabled: isGoogleAuthEnabled
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                _googleAuth = _identity.tfaActive;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }

        function isGoogleAuthEnabled () {
            return _googleAuth;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                if (isAuthenticated && Principal.hasAnyAuthority(['ROLE_MERCHANT']) && $rootScope.toState.name !== 'merchant') {
                    $state.go('merchant');
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('login');
                    }
                }
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {"name": previousStateName, "params": previousStateParams};
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                oneTimePassword: credentials.otp
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                if (data.isTfaActive === undefined || !data.isTfaActive) {
                    var bearerToken = headers('Authorization');
                    if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                        var jwt = bearerToken.slice(7, bearerToken.length);
                        service.storeAuthenticationToken(jwt, credentials.rememberMe);
                        return jwt;
                    }
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService'];

    function SidebarController($scope, $state, Auth, Principal, ProfileService) {
        $scope.$on('$viewContentLoaded', function () {
            setTimeout(function () {
                Layout.initSidebar($state);
                Layout.initContent();
                Layout.initFooter();
            }, 0)
        });

        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: []
            },
            views: {
                'login@': {
                    templateUrl: 'app/layouts/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', '$window', 'Principal', function ($translate,$translatePartialLoader, $window, Principal) {
                    $translatePartialLoader.addPart('home');
                    if (Principal.isAuthenticated()) {
                        $window.location.href = "/";
                    }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', '$location', '$window', 'Auth'];

    function LoginController ($rootScope, $state, $timeout, $location, $window, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.isOtpRequired = false;
        vm.otp = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            // $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                otp: vm.otp
            }).then(function (data) {
                vm.authenticationError = false;
                if (data.data.isTfaActive === undefined || !data.data.isTfaActive) {
                    $rootScope.$broadcast('authenticationSuccess');
                    $window.location.href = "/";
                } else {
                    vm.isOtpRequired = true;
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['$scope', '$state', '$location', '$window', 'Auth', 'Principal', 'ProfileService'];

    function HeaderController($scope, $state, $location, $window, Auth, Principal, ProfileService) {
        $scope.$on('$viewContentLoaded', function () {
            setTimeout(function () {
                Layout.initHeader();
            }, 0)
        });

        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.logout = logout;
        vm.$state = $state;

        function logout() {
            $location.path('/login').replace();
            Auth.logout();
            $window.location.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('GoogleAuthDialogController', GoogleAuthDialogController);

    GoogleAuthDialogController.$inject = ['$timeout', '$window', '$location', '$uibModalInstance', 'GoogleAuth', 'Auth'];

    function GoogleAuthDialogController ($timeout, $window, $location, $uibModalInstance, GoogleAuth, Auth) {
        var vm = this;
        vm.passwordStatus = -1;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            var gAuthData = {
                newState: false,
                password: vm.userPassword
            };
            GoogleAuth.changeAuthKey(gAuthData, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            if (result.status) {
                vm.passwordStatus = 1;
                logout();
            } else {
                vm.passwordStatus = 0;
            }
        }

        function onSaveError (error) {
            vm.isSaving = false;
            logout();
        }

        function logout() {
            $location.path('/login').replace();
            Auth.logout();
            $window.location.reload();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('google-auth', {
            parent: 'app',
            url: '/google-auth',
            data: {
                authorities: []
            },
            views: {
                'google-auth@': {
                    templateUrl: 'app/layouts/google-auth/google-auth.html',
                    controller: 'GoogleAuthController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('googleAuth');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('GoogleAuth', GoogleAuth);

    GoogleAuth.$inject = ['$resource'];

    function GoogleAuth($resource) {
        var resourceUrl = 'api/google-authenticator';

        return $resource(resourceUrl, {}, {
            'generateAuthKey': {
                url: resourceUrl + '/generate',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'verifyPassword': {
                url: resourceUrl + '/verify-password',
                method: 'POST',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'verifyAuthKey': {
                url: resourceUrl + '/verify',
                method: 'POST',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'changeAuthKey': {
                url: resourceUrl + '/change-state',
                method: 'POST',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('GoogleAuthController', GoogleAuthController);

    GoogleAuthController.$inject = ['$state', '$window', '$location','Auth', 'GoogleAuth', 'Principal'];

    function GoogleAuthController ($state, $window, $location, Auth, GoogleAuth, Principal) {
        var vm = this;
        vm.step = 1;
        vm.logout = logout;
        vm.stepStyle = stepStyle;
        vm.back = back;
        vm.next = next;
        vm.userPassword = "";
        vm.passwordStatus = -1;
        vm.tfaVerifiedMessage = -1;
        vm.passwordVerified = false;
        vm.verifyPassword = verifyPassword;
        vm.isNextEnabled = isNextEnabled;
        vm.tfaNewStateEnabled = false;
        vm.isTfaEnabled = isTfaEnabled;
        vm.changeTfaState = changeTfaState;
        vm.newTfaVerified = false;
        vm.verifyTfa = verifyTfa;
        vm.save = save;

        Principal.identity().then(function(account) {
            vm.userName = account.login;
        });

        function verifyPassword() {
            vm.verifyingPassword = true;
            var gAuthData = {
                username: vm.userName,
                password: vm.userPassword
            };
            GoogleAuth.verifyPassword(gAuthData, onSuccess, onFailure);
            function onSuccess(data) {
                vm.verifyingPassword = false;
                if (angular.isDefined(data)) {
                    vm.passwordVerified = data.status;
                    if (data.status) {
                        vm.passwordStatus = 1;
                    } else {
                        vm.passwordStatus = 0;
                    }
                } else {
                    vm.passwordVerified = false;
                    vm.passwordStatus = 0;
                }
            }
            function onFailure() {
                vm.verifyingPassword = false;
                vm.passwordVerified = false;
                vm.passwordStatus = 0;
            }
        }

        function stepStyle(step) {
            if (step < vm.step) {
                return 'done';
            }
            if (step === vm.step) {
                return 'active';
            }
        }

        function back() {
            vm.step--;
        }

        function next() {
            vm.step++;
            if (vm.step === 2) {
                generateAuthKey();
            }
            if (vm.step === 3) {
                vm.newTfaVerified = false;
                vm.oneTimePassword = null;
            }
        }

        function isNextEnabled() {
            if (vm.step === 1 && (!vm.tfaNewStateEnabled || !vm.passwordVerified)) {
                return false;
            }
            if (vm.step === 2 && vm.loadingAuthKeys) {
                return false;
            }
            if (vm.step === 3 && !vm.newTfaVerified) {
                return false;
            }
            return true;
        }

        function isTfaEnabled() {
            return vm.tfaNewStateEnabled;
        }

        function changeTfaState(state) {
            vm.tfaNewStateEnabled = state;
        }

        function generateAuthKey() {
            vm.loadingAuthKeys = true;
            GoogleAuth.generateAuthKey(null, function(data) {
                    vm.tfaSecretKey = data.secretKey;
                    vm.tfaQrUrl = data.totpQrUrl;
                    vm.loadingAuthKeys = false;
                },
                function() {
                    vm.tfaSecretKey = null;
                    vm.tfaQrUrl = null;
                    vm.loadingAuthKeys = false;
                }
            );
        }

        function verifyTfa() {
            vm.verifyingAuthKeys = true;
            var gAuthData = {
                gAuthSecretKey: vm.tfaSecretKey,
                tfaQrUrl: vm.tfaQrUrl,
                oneTimePassword: vm.oneTimePassword
            };
            GoogleAuth.verifyAuthKey(gAuthData, onSuccess, onFailure);
            function onSuccess(data) {
                vm.verifyingAuthKeys = false;
                if (angular.isDefined(data)) {
                    vm.newTfaVerified = data.status;
                    if (vm.newTfaVerified) {
                        vm.tfaVerifiedMessage = 1;
                    } else {
                        vm.tfaVerifiedMessage = 0;
                    }
                } else {
                    vm.newTfaVerified = false;
                    vm.tfaVerifiedMessage = 0;
                }
            }
            function onFailure() {
                vm.verifyingAuthKeys = false;
                vm.newTfaVerified = false;
                vm.tfaVerifiedMessage = 0;
            }
        }

        function save() {
            vm.isSaving = true;
            var gAuthData = {
                newState: true,
                gAuthSecretKey: vm.tfaSecretKey,
                tfaQrUrl: vm.tfaQrUrl,
                oneTimePassword: vm.oneTimePassword
            };
            GoogleAuth.changeAuthKey(gAuthData, onSuccess, onFailure);
            function onSuccess() {
                vm.isSaving = false;
                logout();
            }
            function onFailure() {
                vm.isSaving = false;
                logout();
            }
        }

        function logout() {
            $location.path('/login').replace();
            Auth.logout();
            $window.location.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM']
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CustomerStats', CustomerStats)
        .factory('TotalTransfer', TotalTransfer)
        .factory('TotalPayment', TotalPayment);

    CustomerStats.$inject = ['$resource'];

    function CustomerStats($resource) {
        var resourceUrl = 'api/new-customer-count';
        return $resource(resourceUrl, {}, {
            'get': {method: 'GET', isArray: true}
        });
    }


    TotalTransfer.$inject = ['$resource'];

    function TotalTransfer($resource) {
        var resourceUrl = 'api/transfer-count';
        return $resource(resourceUrl, {}, {
            'get': {method: 'GET', isArray: true},
            'getNewUsers': {url:'api/transfer-new-user-count', method: 'GET', isArray: true}
        });
    }


    TotalPayment.$inject = ['$resource'];

    function TotalPayment($resource) {
        var resourceUrl = 'api/payment-count';
        return $resource(resourceUrl, {}, {
            'get': {method: 'GET', isArray: true},
            'getNewUsers': {url:'api/payment-new-user-count', method: 'GET', isArray: true}
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', '$state', 'SmsRussiaBalance', 'SmsRussiaLimit', 'CustomerStats', 'TotalTransfer', 'TotalPayment', 'Config'];

    function HomeController($scope, Principal, $state, SmsRussiaBalance, SmsRussiaLimit, CustomerStats, TotalTransfer, TotalPayment, Config) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.register = register;
        vm.smsRussiaBalance = SmsRussiaBalance.get();
        vm.smsRussiaLimit = SmsRussiaLimit.get();
        vm.getUsedSmsPercentage = getUsedSmsPercentage;
        vm.allConfigs = {}
        vm.transferNewUsers = [];
        vm.paymentNewUsers = [];
        vm.findTransferNewUsersByDate = findTransferNewUsersByDate;
        vm.findPaymentNewUsersByDate = findPaymentNewUsersByDate;

        if (Principal.hasAnyAuthority(['ROLE_MERCHANT'])) {
            $state.go('merchant');
        }

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();
        loadConfigs();
        getNewUsers();
        getTotalTransfers();
        getTransferNewUsers();
        getTotalPayments();
        getPaymentNewUsers();


        function loadConfigs() {
            Config.query(function (result) {
                vm.configs = result;
                for (var i = 0; i < vm.configs.length; i++) {
                    vm.allConfigs[vm.configs[i].name] = vm.configs[i];
                }
                vm.searchQuery = null;
            });
        }
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function getUsedSmsPercentage(usedSms) {
            return usedSms * 100 / vm.smsRussiaLimit.total_limit;
        }

        function getNewUsers() {
            CustomerStats.get(onSuccess);

            function onSuccess(data) {
                vm.newCustomers = data;
            }
        }

        function getTotalTransfers() {
            TotalTransfer.get(onSuccess);

            function onSuccess(data) {
                vm.transfers = data;
            }
        }

        function getTransferNewUsers() {
            TotalTransfer.getNewUsers(onSuccess);

            function onSuccess(data) {
                vm.transferNewUsers = data;
            }
        }

        function findTransferNewUsersByDate(date){
            var result = 0;
            vm.transferNewUsers.forEach(function(value) {
                if (value.date === date) {
                    result += value.count;
                }
            });
            return result;
        }

        function getTotalPayments() {
            TotalPayment.get(onSuccess);

            function onSuccess(data) {
                vm.payments = data;
            }
        }

        function getPaymentNewUsers() {
            TotalPayment.getNewUsers(onSuccess);

            function onSuccess(data) {
                vm.paymentNewUsers = data;
            }
        }

        function findPaymentNewUsersByDate(date){
            var result = 0;
            vm.paymentNewUsers.forEach(function(value) {
                if (value.date === date) {
                    result += value.count;
                }
            });
            return result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentDialogController', VpPaymentDialogController);

    VpPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'VpPayment', 'Transaction', 'Customer'];

    function VpPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, VpPayment, Transaction, Customer) {
        var vm = this;

        vm.vpPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.transactions = Transaction.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vpPayment.id !== null) {
                VpPayment.update(vm.vpPayment, onSaveSuccess, onSaveError);
            } else {
                VpPayment.save(vm.vpPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:vpPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentDetailController', VpPaymentDetailController);

    VpPaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'VpPayment', 'Transaction', 'Customer'];

    function VpPaymentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, VpPayment, Transaction, Customer) {
        var vm = this;

        vm.vpPayment = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:vpPaymentUpdate', function(event, result) {
            vm.vpPayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentDeleteController',VpPaymentDeleteController);

    VpPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'VpPayment'];

    function VpPaymentDeleteController($uibModalInstance, entity, VpPayment) {
        var vm = this;

        vm.vpPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VpPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vp-payment', {
            parent: 'entity',
            url: '/vp-payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.vpPayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vp-payment/vp-payments.html',
                    controller: 'VpPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                field: null,
                client: null,
                amount: null,
                valueString1: null,
                valueLong1: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        field: $stateParams.field,
                        client: $stateParams.client,
                        amount: $stateParams.amount,
                        valueString1: $stateParams.valueString1,
                        valueLong1: $stateParams.valueLong1,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vpPayment');
                    $translatePartialLoader.addPart('vpRequestType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vp-payment-detail', {
            parent: 'vp-payment',
            url: '/vp-payment/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.vpPayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vp-payment/vp-payment-detail.html',
                    controller: 'VpPaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vpPayment');
                    $translatePartialLoader.addPart('vpRequestType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VpPayment', function($stateParams, VpPayment) {
                    return VpPayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vp-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vp-payment-detail.edit', {
            parent: 'vp-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.new', {
            parent: 'vp-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                account: null,
                                amount: null,
                                amountFee: null,
                                localRate: null,
                                serviceRate: null,
                                date: null,
                                sign: null,
                                agentRequestId: null,
                                serverRequestId: null,
                                serverTransactionId: null,
                                payUrl: null,
                                client: null,
                                method: null,
                                status: null,
                                responseCode: null,
                                verifyRawXml: null,
                                paymentRawXml: null,
                                statusChecked: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('vp-payment');
                });
            }]
        })
        .state('vp-payment.edit', {
            parent: 'vp-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.delete', {
            parent: 'vp-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-delete-dialog.html',
                    controller: 'VpPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.profile', {
            url: '/profile/{phone}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'CUSTOMER_SUPPORT_PAYGRAM']
            },
            views: {
                'content@': {
                    controller: 'DepositProfileRedirectController',
                    controllerAs: 'vm'
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('VpPayment', VpPayment)
        .factory('VpPaymentTotalAmount', VpPaymentTotalAmount);

    VpPayment.$inject = ['$resource', 'DateUtils'];

    function VpPayment ($resource, DateUtils) {
        var resourceUrl =  'api/vp-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    VpPaymentTotalAmount.$inject = ['$resource'];

    function VpPaymentTotalAmount($resource) {
        var resourceUrl = 'api/vp-payments/total-amount';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentController', VpPaymentController);

    VpPaymentController.$inject = ['$state', 'DataUtils', 'VpPayment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone', 'VpPaymentTotalAmount'];

    function VpPaymentController($state, DataUtils, VpPayment, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone, VpPaymentTotalAmount) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.openProfile = openProfile;
        vm.currentSearch = pagingParams.search;
        vm.searchQuery = {
            field: pagingParams.field,
            client: pagingParams.client,
            amount: pagingParams.amount,
            valueString1: pagingParams.valueString1,
            valueLong1: pagingParams.valueLong1,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };
        vm.operators = [
            {mts:"MTS"},
            {"beelinehphone":"Beeline"},
            {"yota_phone":"Yota Phone"},
            {"tele2":"Tele2"},
            {"megafon":"Megafon"},
            {"other":"Other"}
        ];

        initDatePicker();
        loadAll();
        getTotalAmount();

        function loadAll () {
            VpPayment.query({
                field: pagingParams.field,
                client: pagingParams.client,
                amount: pagingParams.amount,
                valueString1: pagingParams.valueString1,
                valueLong1: pagingParams.valueLong1,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vpPayments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                $state.go('profile-detail', {id: data.profileId});
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                client: vm.searchQuery.client,
                amount: vm.searchQuery.amount,
                valueString1: vm.searchQuery.valueString1,
                valueLong1: vm.searchQuery.valueLong1,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate
            });
        }

        function search(searchQuery) {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = {
                field: null,
                client: null,
                amount: null,
                valueString1: null,
                valueLong1: null,
                fromDate: null,
                toDate: null
            };
            vm.transition();
        }

        function getTotalAmount() {
            VpPaymentTotalAmount.get({
                field: pagingParams.field,
                client: pagingParams.client,
                amount: pagingParams.amount,
                valueString1: pagingParams.valueString1,
                valueLong1: pagingParams.valueLong1,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate
            }, function (data) {
                vm.totalAmount = data.totalAmount;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UzbCardDialogController', UzbCardDialogController);

    UzbCardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'isEdit', 'UzbCard'];

    function UzbCardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, isEdit, UzbCard) {
        var vm = this;

        vm.uzbCard = entity;
        vm.isEdit = isEdit;
        vm.clear = clear;
        vm.save = save;

        if (vm.uzbCard.isBlocked === undefined) {
            vm.uzbCard.isBlocked = true;
        }
        if (vm.uzbCard.userPhone === undefined) {
            vm.uzbCard.userPhone = '73335557777'
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.uzbCard.id !== null) {
                UzbCard.update(vm.uzbCard, onSaveSuccess, onSaveError);
            } else {
                vm.uzbCard.country = 'UZB';
                if (vm.uzbCard.userPhone) {
                    vm.uzbCard.userPhone = vm.uzbCard.userPhone.replace(/\D/g, '');
                }
                UzbCard.save(vm.uzbCard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:uzbCardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UzbCardDetailController', UzbCardDetailController);

    UzbCardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UzbCard', 'Customer'];

    function UzbCardDetailController($scope, $rootScope, $stateParams, previousState, entity, UzbCard, Customer) {
        var vm = this;

        vm.uzbCard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:uzbCardUpdate', function(event, result) {
            vm.uzbCard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UzbCardDeleteController',UzbCardDeleteController);

    UzbCardDeleteController.$inject = ['$uibModalInstance', 'entity', 'UzbCard'];

    function UzbCardDeleteController($uibModalInstance, entity, UzbCard) {
        var vm = this;

        vm.uzbCard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UzbCard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('uzb-card', {
            parent: 'entity',
            url: '/uzb-card?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.uzbCard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uzb-card/uzb-cards.html',
                    controller: 'UzbCardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                owner: null,
                cardNumber: null,
                phone: null,
                blocked: -1
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        owner: $stateParams.owner,
                        cardNumber: $stateParams.cardNumber,
                        phone: $stateParams.phone,
                        blocked: $stateParams.blocked
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uzbCard');
                    $translatePartialLoader.addPart('tkbCard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('uzb-card-detail', {
            parent: 'uzb-card',
            url: '/uzb-card/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.uzbCard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uzb-card/uzb-card-detail.html',
                    controller: 'UzbCardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uzbCard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UzbCard', function($stateParams, UzbCard) {
                    return UzbCard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'uzb-card',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('uzb-card-detail.edit', {
            parent: 'uzb-card-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uzb-card.new', {
            parent: 'uzb-card',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                owner: null,
                                number: null,
                                id: null
                            };
                        },
                        isEdit: function() {
                            return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('uzb-card');
                });
            }]
        })
        .state('uzb-card.edit', {
            parent: 'uzb-card',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }],
                        isEdit: [function () { return true; }]
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uzb-card.delete', {
            parent: 'uzb-card',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-delete-dialog.html',
                    controller: 'UzbCardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('UzbCard', UzbCard);

    UzbCard.$inject = ['$resource'];

    function UzbCard ($resource) {
        var resourceUrl =  'api/uzb-cards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UzbCardController', UzbCardController);

    UzbCardController.$inject = ['$state', '$window', 'UzbCard', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function UzbCardController($state, $window, UzbCard, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.clear = clear;
        vm.openProfile = openProfile;
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            owner: pagingParams.owner,
            cardNumber: pagingParams.cardNumber,
            phone: pagingParams.phone,
            blocked: pagingParams.blocked
        };
        loadAll();

        function loadAll () {
            UzbCard.query({
                userPhone: vm.searchQuery.userPhone,
                owner: vm.searchQuery.owner,
                cardNumber: vm.searchQuery.cardNumber,
                phone: vm.searchQuery.phone,
                blocked: vm.searchQuery.blocked,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.uzbCards = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                owner: vm.searchQuery.owner,
                cardNumber: vm.searchQuery.cardNumber,
                phone: vm.searchQuery.phone,
                blocked: vm.searchQuery.blocked
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                owner: null,
                cardNumber: null,
                phone: null,
                blocked: -1
            };
            vm.transition();
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskDialogController', TransactionAsyncTaskDialogController);

    TransactionAsyncTaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TransactionAsyncTask', 'Transaction'];

    function TransactionAsyncTaskDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TransactionAsyncTask, Transaction) {
        var vm = this;

        vm.transactionAsyncTask = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.transactions = Transaction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.transactionAsyncTask.id !== null) {
                TransactionAsyncTask.update(vm.transactionAsyncTask, onSaveSuccess, onSaveError);
            } else {
                TransactionAsyncTask.save(vm.transactionAsyncTask, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:transactionAsyncTaskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.nextCheckDate = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskDetailController', TransactionAsyncTaskDetailController);

    TransactionAsyncTaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TransactionAsyncTask', 'Transaction'];

    function TransactionAsyncTaskDetailController($scope, $rootScope, $stateParams, previousState, entity, TransactionAsyncTask, Transaction) {
        var vm = this;

        vm.transactionAsyncTask = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:transactionAsyncTaskUpdate', function(event, result) {
            vm.transactionAsyncTask = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskDeleteController',TransactionAsyncTaskDeleteController);

    TransactionAsyncTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'TransactionAsyncTask'];

    function TransactionAsyncTaskDeleteController($uibModalInstance, entity, TransactionAsyncTask) {
        var vm = this;

        vm.transactionAsyncTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TransactionAsyncTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transaction-async-task', {
            parent: 'entity',
            url: '/transaction-async-task?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.transactionAsyncTask.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-tasks.html',
                    controller: 'TransactionAsyncTaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionAsyncTask');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('transaction-async-task-detail', {
            parent: 'transaction-async-task',
            url: '/transaction-async-task/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.transactionAsyncTask.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-detail.html',
                    controller: 'TransactionAsyncTaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionAsyncTask');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TransactionAsyncTask', function($stateParams, TransactionAsyncTask) {
                    return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'transaction-async-task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('transaction-async-task-detail.edit', {
            parent: 'transaction-async-task-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transaction-async-task.new', {
            parent: 'transaction-async-task',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                gateway: null,
                                serviceId: null,
                                method: null,
                                errorMessage: null,
                                status: null,
                                repeatTime: null,
                                nextCheckDate: null,
                                createdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('transaction-async-task');
                });
            }]
        })
        .state('transaction-async-task.edit', {
            parent: 'transaction-async-task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transaction-async-task.delete', {
            parent: 'transaction-async-task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-delete-dialog.html',
                    controller: 'TransactionAsyncTaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TransactionAsyncTask', TransactionAsyncTask);

    TransactionAsyncTask.$inject = ['$resource', 'DateUtils'];

    function TransactionAsyncTask ($resource, DateUtils) {
        var resourceUrl =  'api/transaction-async-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.nextCheckDate = DateUtils.convertDateTimeFromServer(data.nextCheckDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskController', TransactionAsyncTaskController);

    TransactionAsyncTaskController.$inject = ['$state', 'TransactionAsyncTask', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TransactionAsyncTaskController($state, TransactionAsyncTask, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TransactionAsyncTask.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transactionAsyncTasks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionStatusDialogController', TransactionStatusDialogController);

    TransactionStatusDialogController.$inject = ['$state', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TransactionStatus'];

    function TransactionStatusDialogController($state, $timeout, $scope, $stateParams, $uibModalInstance, entity, TransactionStatus) {
        var vm = this;

        vm.transaction = entity;
        vm.clear = clear;
        vm.save = save;
        vm.status = $stateParams.status;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.transaction.id !== null) {
                TransactionStatus.update({id: vm.transaction.id, statusChangeReason: vm.transaction.statusChangeReason}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:transactionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TransactionStatus', TransactionStatus);

    TransactionStatus.$inject = ['$resource', 'DateUtils'];

    function TransactionStatus ($resource, DateUtils) {
        var resourceUrl =  'api/transactions/change_status';

        return $resource(resourceUrl, {}, {
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionDialogController', TransactionDialogController);

    TransactionDialogController.$inject = ['$state', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Transaction'];

    function TransactionDialogController($state, $timeout, $scope, $stateParams, $uibModalInstance, entity, Transaction) {
        var vm = this;

        vm.transaction = entity;
        vm.clear = clear;
        vm.save = save;
        vm.status = $stateParams.status;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.transaction.id !== null) {
                if (vm.status == 'fail') {
                    vm.transaction.status = 'FAILURE';
                } else if (vm.status == 'success') {
                    vm.transaction.status = 'SUCCESS';
                }
                Transaction.update(vm.transaction, onSaveSuccess, onSaveError);
                $state.go('request', null, {reload: 'request'});
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:transactionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionDetailController', TransactionDetailController);

    TransactionDetailController.$inject = ['$scope', '$http', '$rootScope', 'previousState', 'entity', 'DateUtils', 'DataUtils', '$filter'];

    function TransactionDetailController($scope, $http, $rootScope, previousState, entity, DateUtils, DataUtils, $filter) {
        var vm = this;
        var translate = $filter('translate');
        vm.transaction = entity;
        vm.previousState = previousState.name;
        vm.dateDiff = DateUtils.transactionDateDifference;
        vm.getSentAmount = DataUtils.getSentAmount;
        vm.getErrorMessage = getErrorMessage;
        vm.collapse = collapse;
        vm.shouldCollapse = false;
        vm.serverResponse = DataUtils.getResponse(vm.transaction);
        vm.generatePaynetReceipt = generatePaynetReceipt;
        vm.isEditable = isEditable;

        boxColor();

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:transactionUpdate', function (event, result) {
            vm.transaction = result;
            boxColor();
        });
        $scope.$on('$destroy', unsubscribe);

        function boxColor() {
            var status = vm.transaction.status;
            if (status == 'SUCCESS') {
                vm.statusColor = 'green-seagreen';
            } else if (status == 'FAILURE') {
                vm.statusColor = 'red-mint';
            } else if (status == 'INPROGRESS') {
                vm.statusColor = 'yellow-saffron';
            }
        }

        function isEditable() {
            return (vm.transaction.status == 'SUCCESS' || vm.transaction.status == 'FAILURE') && vm.transaction.transactionType == 'WITHDRAW';
        }

        function getErrorMessage(transaction) {
            return translate('transaction.dialog.fail.' + transaction.errorMessage);
        }

        function collapse() {
            vm.shouldCollapse = !vm.shouldCollapse;
        }

        function generatePaynetReceipt(id) {
            $http({
                url: 'api/transactions/' + id + '/paynet-receipt',
                method: 'GET',
                responseType: 'arraybuffer'
            }).success(function (response) {
                var blob = new Blob([response], {
                    type: 'application/pdf'
                });
                saveAs(blob, 'paynet-receipt_' + vm.transaction.requestNo + '.pdf');
            }).error(function () {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionDeleteController',TransactionDeleteController);

    TransactionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Transaction'];

    function TransactionDeleteController($uibModalInstance, entity, Transaction) {
        var vm = this;

        vm.transaction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Transaction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TransactionCheckStatus', TransactionCheckStatus);

    TransactionCheckStatus.$inject = ['$resource', 'DateUtils'];

    function TransactionCheckStatus($resource, DateUtils) {
        var resourceUrl = 'api/transactions/:id/check_status';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }

                    return data;
                }
            }

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('transaction', {
                parent: 'entity',
                url: '/transaction?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'],
                    pageTitle: 'global.menu.payments'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/transaction/transactions.html',
                        controller: 'TransactionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'pubDate,desc',
                        squash: true
                    },
                    field: null,
                    amount: null,
                    fromDate: null,
                    toDate: null,
                    gateway: null,
                    status: null,
                    mode: null,
                    providerCountryId: null,
                    providerCategoryId: null,
                    providerId: null,
                    providerSegmentId: null,
                    client: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            field: $stateParams.field,
                            amount: $stateParams.amount,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            gateway: $stateParams.gateway,
                            status: $stateParams.status,
                            mode: $stateParams.mode,
                            date: $stateParams.date,
                            providerCountryId: $stateParams.providerCountryId,
                            providerCategoryId: $stateParams.providerCategoryId,
                            providerId: $stateParams.providerId,
                            providerSegmentId:$stateParams.providerSegmentId,
                            client: $stateParams.client,
                            firstRun: $stateParams.firstRun
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('transactionType');
                        $translatePartialLoader.addPart('transactionStatus');
                        $translatePartialLoader.addPart('gateway');
                        $translatePartialLoader.addPart('transactionMode');
                        $translatePartialLoader.addPart('transactionGateway');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('transaction-detail', {
                parent: 'entity',
                url: '/transaction/{id}',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'],
                    pageTitle: 'bozorakaAdminApp.transaction.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/transaction/transaction-detail.html',
                        controller: 'TransactionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('transactionType');
                        $translatePartialLoader.addPart('transactionStatus');
                        $translatePartialLoader.addPart('gateway');
                        $translatePartialLoader.addPart('transactionMode');
                        $translatePartialLoader.addPart('transactionGateway');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Transaction', function ($stateParams, Transaction) {
                        return Transaction.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'transaction',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('transaction-detail.edit', {
                parent: 'transaction-detail',
                url: '/{status}',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_AGENT_UZB', 'ROLE_AGENT_KOR', 'ROLE_SELLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/transaction/transaction-dialog.html',
                        controller: 'TransactionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Transaction', function (Transaction) {
                                return Transaction.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                            $state.go('^', {}, {reload: false});
                        }, function () {
                            $state.go('^');
                        });
                }]
            })
            .state('transaction.new', {
                parent: 'transaction',
                url: '/new',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_AGENT_UZB', 'ROLE_AGENT_KOR', 'ROLE_SELLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/transaction/transaction-dialog.html',
                        controller: 'TransactionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    description: null,
                                    amount: null,
                                    transactionType: null,
                                    pubDate: null,
                                    transactionNumber: null,
                                    errorMessage: null,
                                    status: null,
                                    requestNo: null,
                                    gateway: null,
                                        amountInSom: null,
                                    approvalDate: null,
                                    client: null,
                                    mode: null,
                                    autoModeResponse: null,
                                    mangoAutoModeResponse: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                            $state.go('transaction', null, {reload: 'transaction'});
                        }, function () {
                            $state.go('transaction');
                        });
                }]
            })
            .state('transaction.edit', {
                parent: 'transaction',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_AGENT_UZB', 'ROLE_AGENT_KOR', 'ROLE_SELLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/transaction/transaction-dialog.html',
                        controller: 'TransactionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Transaction', function (Transaction) {
                                return Transaction.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                            $state.go('transaction', null, {reload: 'transaction'});
                        }, function () {
                            $state.go('^');
                        });
                }]
            })
            .state('transaction.delete', {
                parent: 'transaction',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_AGENT_UZB', 'ROLE_AGENT_KOR', 'ROLE_SELLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/transaction/transaction-delete-dialog.html',
                        controller: 'TransactionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Transaction', function (Transaction) {
                                return Transaction.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                            $state.go('transaction', null, {reload: 'transaction'});
                        }, function () {
                            $state.go('^');
                        });
                }]
            })
            .state('transaction-detail.editStatus', {
                parent: 'transaction-detail',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/transaction/transaction-status-dialog.html',
                        controller: 'TransactionStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Transaction', function (Transaction) {
                                return Transaction.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('transaction-detail', null, {reload: 'transaction-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('stats-partner', {
                parent: 'entity',
                url: '/stats-partner?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.reconciliation'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-partner/stats-partner.html',
                        controller: 'StatsPartnerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'pubDate,desc',
                        squash: true
                    },
                    field: null,
                    fromDate: null,
                    toDate: null,
                    fromZonedDate: null,
                    toZonedDate: null,
                    status: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            field: $stateParams.field,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            fromZonedDate: $stateParams.fromZonedDate,
                            toZonedDate: $stateParams.toZonedDate,
                            status: $stateParams.status
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('transactionType');
                        $translatePartialLoader.addPart('transactionStatus');
                        $translatePartialLoader.addPart('gateway');
                        $translatePartialLoader.addPart('transactionMode');
                        $translatePartialLoader.addPart('transactionGateway');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Transaction', Transaction)
        .factory('TransactionIdByNumber', TransactionIdByNumber);

    Transaction.$inject = ['$resource', 'DateUtils'];

    function Transaction ($resource, DateUtils) {
        var resourceUrl =  'api/transactions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pubDate = DateUtils.convertDateTimeFromServer(data.pubDate);
                        data.approvalDate = DateUtils.convertDateTimeFromServer(data.approvalDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    TransactionIdByNumber.$inject = ['$resource'];

    function TransactionIdByNumber ($resource) {
        var resourceUrl =  'api/transactions/id/number/:transactionNo';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('TransactionSearch', TransactionSearch);

    TransactionSearch.$inject = ['$resource'];

    function TransactionSearch($resource) {
        var resourceUrl =  'api/_search/transactions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionController', TransactionController);

    TransactionController.$inject = ['$scope', '$state', '$window', 'Transaction', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils', 'DataUtils', 'ProviderCountry', 'ProviderCategory', 'Provider', 'ProviderSegment', 'ProfileIdByPhone'];

    function TransactionController($scope, $state, $window, Transaction, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils, DataUtils, ProviderCountry, ProviderCategory, Provider, ProviderSegment, ProfileIdByPhone) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.openProfile = openProfile;
        vm.dateDiff = DateUtils.transactionDateDifference;
        vm.getDirectAmount = DataUtils.getDirectAmount;
        vm.getSentAmount = DataUtils.getSentAmount;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.providerCountries = ProviderCountry.getAsList();
        vm.providerCategories = [];
        vm.providers = [];
        vm.providerSegments = [];
        vm.searchQuery = {
            field: pagingParams.field,
            amount: pagingParams.amount,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            gateway: pagingParams.gateway,
            status: pagingParams.status,
            mode: pagingParams.mode,
            providerCountryId: pagingParams.providerCountryId,
            providerCategoryId: pagingParams.providerCategoryId,
            providerId: pagingParams.providerId,
            providerSegmentId: pagingParams.providerSegmentId,
            client: 'immigrant'
        };
        vm.getProviderCategories = getProviderCategories;
        vm.getProviders = getProviders;
        vm.getProviderSegments = getProviderSegments;
        initDatePicker();

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.toDate = moment().format('MM/DD/YYYY');
                pagingParams.toDate = vm.searchQuery.toDate;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.fromDate = moment(vm.searchQuery.toDate, 'MM/DD/YYYY').subtract(1, "months").format('MM/DD/YYYY');
                pagingParams.fromDate = vm.searchQuery.fromDate;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function getProviderCategories() {
            if (!vm.searchQuery.providerCountryId) {
                vm.providerCategories = [];
                return;
            }
            ProviderCategory.getAllByCountry({
                id: vm.searchQuery.providerCountryId
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.providerCategories = data;
            }

            function onError() {
                vm.providerCategories = [];
            }
        }

        function getProviders() {
            if (!vm.searchQuery.providerCategoryId) {
                vm.providers = [];
                return;
            }
            Provider.getAllByCategory({
                id: vm.searchQuery.providerCategoryId
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.providers = data;
            }

            function onError() {
                vm.providers = [];
            }
        }

        function getProviderSegments() {
            if (!vm.searchQuery.providerId) {
                vm.providerSegments = [];
                return;
            }
            ProviderSegment.getAllByProvider({
                id: vm.searchQuery.providerId
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.providerSegments = data;
            }

            function onError() {
                vm.providerSegments = [];
            }
        }

        function loadAll() {
            Transaction.query({
                field: pagingParams.field,
                amount: pagingParams.amount,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                gateway: pagingParams.gateway,
                transactionStatus: pagingParams.status,
                transactionMode: pagingParams.mode,
                client: 'immigrant',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                providerCountryId: pagingParams.providerCountryId,
                providerCategoryId: pagingParams.providerCategoryId,
                providerId: pagingParams.providerId,
                providerSegmentId: pagingParams.providerSegmentId,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transactions = data;
                vm.page = pagingParams.page;
                getProviderCategories();
                getProviders();
                getProviderSegments();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                amount: vm.searchQuery.amount,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                gateway: vm.searchQuery.gateway,
                status: vm.searchQuery.status,
                client: 'immigrant',
                providerCountryId: vm.searchQuery.providerCountryId,
                providerCategoryId: vm.searchQuery.providerCategoryId,
                providerId: vm.searchQuery.providerId,
                providerSegmentId: vm.searchQuery.providerSegmentId,
                mode: vm.searchQuery.mode,
                firstRun: false
            });
        }

        function search(searchQuery) {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'pubDate';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'pubDate';
            vm.reverse = false;
            vm.searchQuery = {
                field: null,
                amount: null,
                fromDate: null,
                toDate: null,
                gateway: null,
                status: 'UNKNOWN',
                mode: 'UNKNOWN'
            };
            vm.transition();
        }
        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('DepositTransactionRedirectController', DepositTransactionRedirectController);

    DepositTransactionRedirectController.$inject = ['$stateParams', '$location', 'TransactionIdByNumber'];

    function DepositTransactionRedirectController($stateParams, $location, TransactionIdByNumber) {

        TransactionIdByNumber.get({transactionNo: $stateParams.transactionNo}, onSuccess);

        function onSuccess(data) {
            $location.path("transaction/" + data.transactionId);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferInfoDialogController', TkbTransferInfoDialogController);

    TkbTransferInfoDialogController.$inject = ['$uibModalInstance', '$timeout', 'entity', 'myID', 'customer'];

    function TkbTransferInfoDialogController($uibModalInstance, $timeout, entity, myID, customer) {
        var vm = this;
        vm.payment = entity;
        vm.myID = myID;
        vm.customer = customer;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        $timeout(function () {
            new Clipboard('.mt-clipboard');
        }, 100);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferDialogController', TkbTransferDialogController);

    TkbTransferDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TkbTransfer', 'Customer'];

    function TkbTransferDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TkbTransfer, Customer) {
        var vm = this;

        vm.tkbTransfer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbTransfer.id !== null) {
                TkbTransfer.update(vm.tkbTransfer, onSaveSuccess, onSaveError);
            } else {
                TkbTransfer.save(vm.tkbTransfer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbTransferUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferDetailController', TkbTransferDetailController);

    TkbTransferDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TkbTransfer', 'Customer'];

    function TkbTransferDetailController($scope, $rootScope, $stateParams, previousState, entity, TkbTransfer, Customer) {
        var vm = this;

        vm.tkbTransfer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:tkbTransferUpdate', function(event, result) {
            vm.tkbTransfer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferDeleteController',TkbTransferDeleteController);

    TkbTransferDeleteController.$inject = ['$uibModalInstance', 'entity', 'TkbTransfer'];

    function TkbTransferDeleteController($uibModalInstance, entity, TkbTransfer) {
        var vm = this;

        vm.tkbTransfer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TkbTransfer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tkb-transfer', {
            parent: 'entity',
            url: '/tkb-transfer?page&externalId&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.tkbTransfer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfers.html',
                    controller: 'TkbTransferController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                externalId: null,
                amount: null,
                receiverOwner: null,
                receiverCardNumber: null,
                state: -1,
                creditState: -1,
                gateway: 'ALL',
                currency: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        externalId: $stateParams.externalId,
                        amount: $stateParams.amount,
                        receiverOwner: $stateParams.receiverOwner,
                        receiverCardNumber: $stateParams.receiverCardNumber,
                        state: $stateParams.state,
                        creditState: $stateParams.creditState,
                        gateway: $stateParams.gateway,
                        currency: $stateParams.currency,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbTransfer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tkb-transfer-detail', {
            parent: 'tkb-transfer',
            url: '/tkb-transfer/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbTransfer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfer-detail.html',
                    controller: 'TkbTransferDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbTransfer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TkbTransfer', function($stateParams, TkbTransfer) {
                    return TkbTransfer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tkb-transfer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tkb-transfer-detail.edit', {
            parent: 'tkb-transfer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfer-dialog.html',
                    controller: 'TkbTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbTransfer', function(TkbTransfer) {
                            return TkbTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-transfer.new', {
            parent: 'tkb-transfer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfer-dialog.html',
                    controller: 'TkbTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                orderId: null,
                                externalId: null,
                                referenceId: null,
                                type: null,
                                senderOwner: null,
                                senderCardNumber: null,
                                receiverCardNumber: null,
                                amountRub: null,
                                amountUzs: null,
                                rate: null,
                                tkbCommissionAmount: null,
                                ubCommissionAmount: null,
                                spCommissionAmount: null,
                                tkbCommissionRate: null,
                                ubCommissionRate: null,
                                spCommissionRate: null,
                                state: null,
                                statusCode: null,
                                message: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tkb-transfer', null, { reload: 'tkb-transfer' });
                }, function() {
                    $state.go('tkb-transfer');
                });
            }]
        })
        .state('tkb-transfer.edit', {
            parent: 'tkb-transfer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfer-dialog.html',
                    controller: 'TkbTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbTransfer', function(TkbTransfer) {
                            return TkbTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-transfer', null, { reload: 'tkb-transfer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-transfer.delete', {
            parent: 'tkb-transfer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-transfer/tkb-transfer-delete-dialog.html',
                    controller: 'TkbTransferDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TkbTransfer', function(TkbTransfer) {
                            return TkbTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-transfer', null, { reload: 'tkb-transfer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbTransfer', TkbTransfer);

    TkbTransfer.$inject = ['$resource', 'DateUtils'];

    function TkbTransfer ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-transfers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getTransferState': {url: 'api/transfer-state/:externalId', method: 'GET'},
            'confirmTransfer': {url: 'api/transfer-confirm/:externalId', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getGatewayDiagnostics': { url: 'api/gateway/diagnostics', method: 'GET' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferController', TkbTransferController);

    TkbTransferController.$inject = ['$state', '$window', '$http', '$uibModal', 'DateUtils', 'TkbTransfer', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function TkbTransferController($state, $window, $http, $uibModal, DateUtils, TkbTransfer, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.search = search;
        vm.excel = excel;
        vm.clear = clear;
        vm.externalId = null;
        vm.checkList = [];
        vm.getTransferState = getTransferState;
        vm.confirmTransfer = confirmTransfer;
        vm.initPopover = initPopover;
        vm.initCreditPopover = initCreditPopover;
        vm.openTransferInfo = openTransferInfo;
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            externalId: pagingParams.externalId,
            amount: pagingParams.amount,
            receiverOwner: pagingParams.receiverOwner,
            receiverCardNumber: pagingParams.receiverCardNumber,
            state: pagingParams.state,
            creditState: pagingParams.creditState,
            gateway: pagingParams.gateway,
            currency: pagingParams.currency,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        initDatePicker();
        loadAll();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setMonth(vm.searchQuery.from.getMonth() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll () {
            getDateTimeFromPicker();
            TkbTransfer.query({
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                amount: vm.searchQuery.amount,
                receiverOwner: vm.searchQuery.receiverOwner,
                receiverCardNumber: vm.searchQuery.receiverCardNumber,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                currency: vm.searchQuery.currency,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tkbTransfers = data;
                vm.page = pagingParams.page;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                amount: vm.searchQuery.amount,
                receiverOwner: vm.searchQuery.receiverOwner,
                receiverCardNumber: vm.searchQuery.receiverCardNumber,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                currency: vm.searchQuery.currency,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                externalId: null,
                amount: null,
                receiverOwner: null,
                receiverCardNumber: null,
                state: null,
                creditState: null,
                gateway: 'ALL',
                currency: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }

        function excel() {
            getDateTimeFromPicker();
            var fromDate = vm.searchQuery.fromDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            var toDate = vm.searchQuery.toDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = (vm.searchQuery.userPhone == null ? "" : "userPhone=" + vm.searchQuery.userPhone)
                + (vm.searchQuery.externalId == null ? '' : "&externalId=" + vm.searchQuery.externalId)
                + (vm.searchQuery.amount == null ? '' : "&amount=" + vm.searchQuery.amount)
                + (vm.searchQuery.receiverOwner == null ? '' : "&receiverOwner=" + vm.searchQuery.receiverOwner)
                + (vm.searchQuery.receiverCardNumber == null ? '' : "&receiverCardNumber=" + vm.searchQuery.receiverCardNumber)
                + (vm.searchQuery.state == null ? '-1' : "&state=" + vm.searchQuery.state)
                + (vm.searchQuery.creditState == null ? '-1' : "&creditState=" + vm.searchQuery.creditState)
                + (vm.searchQuery.gateway == null ? 'ALL' : "&gateway=" + vm.searchQuery.gateway)
                + (vm.searchQuery.currency == null ? '' : "&currency=" + vm.searchQuery.currency)
                + "&fromDate=" + fromDate
                + '&toDate=' + toDate;
            $http({
                url: 'api/tkb-transfers-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'tkb-transfers-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function getTransferState(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.getTransferState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmTransfer(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.confirmTransfer({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function initPopover($event, transfer) {
            if (!transfer.message) {
                return;
            }
            var message = transfer.message;
            var elementId = transfer.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + message + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initCreditPopover($event, transfer) {
            if (!transfer.creditMessage) {
                return;
            }
            var creditMessage = transfer.creditMessage;
            var elementId = transfer.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function copyPopoverText() {
            var textElement = document.getElementById('popover-text');
            if (!textElement) return;

            var textArea = document.createElement('textarea');
            textArea.value = textElement.innerText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        function openTransferInfo(id) {
            var transfer = vm.tkbTransfers.find(function(item) {
                return item.id === id;
            });
            $uibModal.open({
                templateUrl: 'app/entities/tkb-transfer/tkb-transfer-info-dialog.html',
                controller: 'TkbTransferInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-info-dialog-xl',
                resolve: {
                    entity: transfer,
                    myID: ['MyID', function (MyID) {
                        if (transfer.myIDId) {
                            return MyID.get({id: transfer.myIDId}).$promise;
                        } else {
                            return null;
                        }
                    }],
                    customer: ['Customer', function (Customer) {
                        return Customer.get({id: transfer.userId}).$promise;
                    }]
                },

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentInfoDialogController', TkbPaymentInfoDialogController);

    TkbPaymentInfoDialogController.$inject = ['$uibModalInstance', 'entity'];

    function TkbPaymentInfoDialogController($uibModalInstance, entity) {
        var vm = this;
        vm.payment = entity;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentDialogController', TkbPaymentDialogController);

    TkbPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'TkbPayment', 'Customer', 'Transaction'];

    function TkbPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, TkbPayment, Customer, Transaction) {
        var vm = this;

        vm.tkbPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.customers = Customer.query();
        vm.transactions = Transaction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbPayment.id !== null) {
                TkbPayment.update(vm.tkbPayment, onSaveSuccess, onSaveError);
            } else {
                TkbPayment.save(vm.tkbPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentDetailController', TkbPaymentDetailController);

    TkbPaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'TkbPayment', 'Customer', 'Transaction'];

    function TkbPaymentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, TkbPayment, Customer, Transaction) {
        var vm = this;

        vm.tkbPayment = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:tkbPaymentUpdate', function(event, result) {
            vm.tkbPayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentDeleteController',TkbPaymentDeleteController);

    TkbPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TkbPayment'];

    function TkbPaymentDeleteController($uibModalInstance, entity, TkbPayment) {
        var vm = this;

        vm.tkbPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TkbPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tkb-payment', {
            parent: 'entity',
            url: '/tkb-payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.tkbPayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-payment/tkb-payments.html',
                    controller: 'TkbPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                externalId: null,
                account: null,
                state: -1,
                creditState: -1,
                gateway: 'ALL',
                transactionStatus: 'UNKNOWN',
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        externalId: $stateParams.externalId,
                        account: $stateParams.account,
                        state: $stateParams.state,
                        creditState: $stateParams.creditState,
                        gateway: $stateParams.gateway,
                        transactionStatus: $stateParams.transactionStatus,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbPayment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tkb-payment-detail', {
            parent: 'tkb-payment',
            url: '/tkb-payment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbPayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-payment/tkb-payment-detail.html',
                    controller: 'TkbPaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbPayment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TkbPayment', function($stateParams, TkbPayment) {
                    return TkbPayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tkb-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tkb-payment-detail.edit', {
            parent: 'tkb-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-payment/tkb-payment-dialog.html',
                    controller: 'TkbPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbPayment', function(TkbPayment) {
                            return TkbPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-payment.new', {
            parent: 'tkb-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-payment/tkb-payment-dialog.html',
                    controller: 'TkbPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                orderId: null,
                                externalId: null,
                                referenceId: null,
                                account: null,
                                senderOwner: null,
                                senderCardNumber: null,
                                amount: null,
                                commissionAmount: null,
                                amountUzs: null,
                                ubCommissionAmount: null,
                                spCommissionAmount: null,
                                fieldJson: null,
                                state: null,
                                errorCode: null,
                                errorMessage: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tkb-payment', null, { reload: 'tkb-payment' });
                }, function() {
                    $state.go('tkb-payment');
                });
            }]
        })
        .state('tkb-payment.edit', {
            parent: 'tkb-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-payment/tkb-payment-dialog.html',
                    controller: 'TkbPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbPayment', function(TkbPayment) {
                            return TkbPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-payment', null, { reload: 'tkb-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-payment.delete', {
            parent: 'tkb-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-payment/tkb-payment-delete-dialog.html',
                    controller: 'TkbPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TkbPayment', function(TkbPayment) {
                            return TkbPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-payment', null, { reload: 'tkb-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbPayment', TkbPayment);

    TkbPayment.$inject = ['$resource', 'DateUtils'];

    function TkbPayment ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getPaymentState': {url: 'api/payment-state/:externalId', method: 'GET'},
            'confirmPayment': {url: 'api/payment-confirm/:externalId', method: 'GET'},
            'recreditPayment': {url: 'api/payment-recredit/:orderId', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'paymentInfo': {url: 'api/payment-info/:paymentId', method: 'GET'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentController', TkbPaymentController);

    TkbPaymentController.$inject = ['$state', '$window', '$http', '$uibModal', 'DateUtils', 'TkbPayment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function TkbPaymentController($state, $window, $http, $uibModal, DateUtils, TkbPayment, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;
        vm.tkbPayments = [];
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.search = search;
        vm.excel = excel;
        vm.clear = clear;
        vm.getPaymentState = getPaymentState;
        vm.confirmPayment = confirmPayment;
        vm.recreditPayment = recreditPayment;
        vm.openPaymentInfo = openPaymentInfo;
        vm.initPopover = initPopover;
        vm.initCreditPopover = initCreditPopover;
        vm.checkList = [];
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            externalId: pagingParams.externalId,
            account: pagingParams.account,
            state: pagingParams.state,
            creditState: pagingParams.creditState,
            gateway: pagingParams.gateway,
            transactionStatus: pagingParams.transactionStatus,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        initDatePicker();
        loadAll();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setMonth(vm.searchQuery.from.getMonth() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll() {
            getDateTimeFromPicker();
            TkbPayment.query({
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                account: vm.searchQuery.account,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                transactionStatus: vm.searchQuery.transactionStatus,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tkbPayments = data;
                vm.tkbPayments.forEach(function (payment) {
                    if (payment.fieldJson) {
                        var parsed = JSON.parse(payment.fieldJson);
                        payment.description = parsed.description;
                    }
                });
                vm.page = pagingParams.page;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                account: vm.searchQuery.account,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                transactionStatus: vm.searchQuery.transactionStatus,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                externalId: null,
                account: null,
                state: null,
                creditState: null,
                gateway: 'ALL',
                transactionStatus: "UNKNOWN",
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        function excel() {
            getDateTimeFromPicker();
            var fromDate = vm.searchQuery.fromDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            var toDate = vm.searchQuery.toDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = (vm.searchQuery.userPhone == null ? "" : "userPhone=" + vm.searchQuery.userPhone)
                + (vm.searchQuery.externalId == null ? '' : "&externalId=" + vm.searchQuery.externalId)
                + (vm.searchQuery.account == null ? '' : "&account=" + vm.searchQuery.account)
                + (vm.searchQuery.state == null ? '' : "&state=" + vm.searchQuery.state)
                + (vm.searchQuery.creditState == null ? '' : "&creditState=" + vm.searchQuery.creditState)
                + (vm.searchQuery.gateway == null ? 'ALL' : "&gateway=" + vm.searchQuery.gateway)
                + (vm.searchQuery.transactionStatus == null ? 'UNKNOWN' : "&transactionStatus=" + vm.searchQuery.transactionStatus)
                + "&fromDate=" + fromDate
                + '&toDate=' + toDate;
            $http({
                url: 'api/tkb-payments-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'tkb-payments-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url,'_blank');
            }
        }

        function getPaymentState(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.getPaymentState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmPayment(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.confirmPayment({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function recreditPayment(orderId) {
            vm.checkList[orderId] = true;
            TkbPayment.recreditPayment({orderId: orderId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[orderId] = false;
                vm.orderId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[orderId] = false;
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function initPopover($event, payment) {
            if (!payment.errorMessage) {
                return;
            }
            var errorMessage = payment.errorMessage;
            var elementId = payment.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + errorMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initCreditPopover($event, payment) {
            if (!payment.creditDescription) {
                return;
            }
            var creditMessage = payment.creditDescription;
            var elementId = payment.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function copyPopoverText() {
            var textElement = document.getElementById('popover-text');
            if (!textElement) return;

            var textArea = document.createElement('textarea');
            textArea.value = textElement.innerText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        function openPaymentInfo(id) {
            $uibModal.open({
                templateUrl: 'app/entities/tkb-payment/tkb-payment-info-dialog.html',
                controller: 'TkbPaymentInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-info-dialog-xl',
                resolve: {
                    entity: ['TkbPayment', function(TkbPayment) {
                        return TkbPayment.paymentInfo({ paymentId: id }).$promise;
                    }]
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbCardDialogController', TkbCardDialogController);

    TkbCardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TkbCard', 'Customer'];

    function TkbCardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TkbCard, Customer) {
        var vm = this;

        vm.tkbCard = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbCard.id !== null) {
                TkbCard.update(vm.tkbCard, onSaveSuccess, onSaveError);
            } else {
                TkbCard.save(vm.tkbCard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbCardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbCardDetailController', TkbCardDetailController);

    TkbCardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TkbCard', 'Customer'];

    function TkbCardDetailController($scope, $rootScope, $stateParams, previousState, entity, TkbCard, Customer) {
        var vm = this;

        vm.tkbCard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:tkbCardUpdate', function(event, result) {
            vm.tkbCard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbCardDeleteController',TkbCardDeleteController);

    TkbCardDeleteController.$inject = ['$uibModalInstance', 'entity', 'TkbCard', 'AlertService'];

    function TkbCardDeleteController($uibModalInstance, entity, TkbCard, AlertService) {
        var vm = this;

        vm.tkbCard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TkbCard.delete({id: id},
                onSuccess, onError);
        }
        function onSuccess(){
                $uibModalInstance.close(true);
        }
        function onError(error) {
            AlertService.error(error.data.errorDescription);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tkb-card', {
            parent: 'entity',
            url: '/tkb-card?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbCard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-card/tkb-cards.html',
                    controller: 'TkbCardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                externalId: null,
                gateway: 'ALL',
                owner: null,
                cardNumber: null,
                referenceId: null,
                state: -1,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        externalId: $stateParams.externalId,
                        gateway: $stateParams.gateway,
                        owner: $stateParams.owner,
                        cardNumber: $stateParams.cardNumber,
                        referenceId: $stateParams.referenceId,
                        state: $stateParams.state,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbCard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tkb-card-detail', {
            parent: 'tkb-card',
            url: '/tkb-card/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbCard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-card/tkb-card-detail.html',
                    controller: 'TkbCardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbCard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TkbCard', function($stateParams, TkbCard) {
                    return TkbCard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tkb-card',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tkb-card-detail.edit', {
            parent: 'tkb-card-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-card.new', {
            parent: 'tkb-card',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                orderId: null,
                                externalId: null,
                                state: null,
                                referenceId: null,
                                number: null,
                                expireYear: null,
                                expireMonth: null,
                                owner: null,
                                provider: null,
                                statusCode: null,
                                message: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('tkb-card');
                });
            }]
        })
        .state('tkb-card.edit', {
            parent: 'tkb-card',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-card.delete', {
            parent: 'tkb-card',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-delete-dialog.html',
                    controller: 'TkbCardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbCard', TkbCard);

    TkbCard.$inject = ['$resource', 'DateUtils'];

    function TkbCard ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-cards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'deleteByReferenceId': {url: 'api/tkb-cards/:referenceId', method: 'DELETE'},
            'delete': {url: 'api/tkb-cards/:id/delete', method: 'DELETE'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbCardController', TkbCardController);

    TkbCardController.$inject = ['$state', '$window', 'TkbCard', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function TkbCardController($state, $window, TkbCard, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.search = search;
        vm.clear = clear;
        vm.referenceId = null;
        vm.deleteByReferenceId = deleteByReferenceId;
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            externalId: pagingParams.externalId,
            merchant: pagingParams.merchant,
            gateway: pagingParams.gateway,
            owner: pagingParams.owner,
            cardNumber: pagingParams.cardNumber,
            referenceId: pagingParams.referenceId,
            state: pagingParams.state,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        loadAll();

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll () {
            TkbCard.query({
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                merchant: vm.searchQuery.merchant,
                gateway: vm.searchQuery.gateway,
                owner: vm.searchQuery.owner,
                cardNumber: vm.searchQuery.cardNumber,
                referenceId: vm.searchQuery.referenceId,
                state: vm.searchQuery.state,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tkbCards = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                merchant: vm.searchQuery.merchant,
                gateway: vm.searchQuery.gateway,
                owner: vm.searchQuery.owner,
                cardNumber: vm.searchQuery.cardNumber,
                referenceId: vm.searchQuery.referenceId,
                state: vm.searchQuery.state,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                externalId: null,
                merchant: 'ALL',
                gateway: 'ALL',
                owner: null,
                cardNumber: null,
                referenceId: null,
                state: -1,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            vm.transition();
        }

        function deleteByReferenceId() {
            TkbCard.deleteByReferenceId({referenceId: vm.referenceId}, onSuccess, onError);

            function onSuccess() {
                vm.referenceId = null;
                loadAll();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDialogController', TicketPaymentDialogController);

    TicketPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketPayment', 'Passenger', 'Customer'];

    function TicketPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketPayment, Passenger, Customer) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.passengers = Passenger.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketPayment.id !== null) {
                TicketPayment.update(vm.ticketPayment, onSaveSuccess, onSaveError);
            } else {
                TicketPayment.save(vm.ticketPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:ticketPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.departureDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDetailController', TicketPaymentDetailController);

    TicketPaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketPayment', 'Passenger', 'Customer'];

    function TicketPaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketPayment, Passenger, Customer) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:ticketPaymentUpdate', function(event, result) {
            vm.ticketPayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDeleteController',TicketPaymentDeleteController);

    TicketPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketPayment'];

    function TicketPaymentDeleteController($uibModalInstance, entity, TicketPayment) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-payment', {
            parent: 'entity',
            url: '/ticket-payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.ticketPayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-payment/ticket-payments.html',
                    controller: 'TicketPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                field: null,
                status: 'UNKNOWN',
                userPhone: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        field: $stateParams.field,
                        status: $stateParams.status,
                        userPhone: $stateParams.userPhone,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketPayment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-payment-detail', {
            parent: 'ticket-payment',
            url: '/ticket-payment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.ticketPayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-detail.html',
                    controller: 'TicketPaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketPayment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketPayment', function($stateParams, TicketPayment) {
                    return TicketPayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-payment-detail.edit', {
            parent: 'ticket-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-payment.new', {
            parent: 'ticket-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ticketId: null,
                                transactionId: null,
                                fromCity: null,
                                toCity: null,
                                departureDate: null,
                                returnDate: null,
                                status: null,
                                amount: null,
                                currency: null,
                                tripType: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('ticket-payment');
                });
            }]
        })
        .state('ticket-payment.edit', {
            parent: 'ticket-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-payment.delete', {
            parent: 'ticket-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-delete-dialog.html',
                    controller: 'TicketPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-order', {
                parent: 'entity',
                url: '/ticket-orders?page&sort&field&status&fromDate&toDate',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ticket-payment/ticket-order.html',
                        controller: 'TicketOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'orderId,desc',
                        squash: true
                    },
                    field: {
                        value: null,
                        squash: true
                    },
                    status: {
                        value: null,
                        squash: true
                    },
                    fromDate: {
                        value: null,
                        squash: true
                    },
                    toDate: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        function ($stateParams) {
                            return {
                                page: $stateParams.page,
                                sort: $stateParams.sort,
                                field: $stateParams.field,
                                status: $stateParams.status,
                                fromDate: $stateParams.fromDate,
                                toDate: $stateParams.toDate
                            };
                        }
                    ],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('ticketPayment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TicketPayment', TicketPayment);

    TicketPayment.$inject = ['$resource', 'DateUtils'];

    function TicketPayment ($resource, DateUtils) {
        var resourceUrl =  'api/ticket-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.departureDate = DateUtils.convertDateTimeFromServer(data.departureDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryFromMySafar': { url: 'api/ticket-payments/my-safar', method: 'GET' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentController', TicketPaymentController);

    TicketPaymentController.$inject = ['$state', 'TicketPayment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TicketPaymentController($state, TicketPayment, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            field: pagingParams.field,
            status: pagingParams.status,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };
        initDatePicker();


        if (!pagingParams.firstRun) {
            loadAll();
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.toDate = moment().format('MM/DD/YYYY');
                pagingParams.toDate = vm.searchQuery.toDate;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.fromDate = moment(vm.searchQuery.toDate, 'MM/DD/YYYY').subtract(1, "months").format('MM/DD/YYYY');
                pagingParams.fromDate = vm.searchQuery.fromDate;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll () {
            TicketPayment.query({
                field: pagingParams.field,
                valueString1: pagingParams.status,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ticketPayments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                field: vm.searchQuery.field,
                status: vm.searchQuery.status,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchQuery = {
                field: null,
                status: 'UNKNOWN',
                fromDate: null,
                toDate: null,
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketOrderDetailDialogController', TicketOrderDetailDialogController);

    TicketOrderDetailDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'selectedTicket'];

    function TicketOrderDetailDialogController ($timeout, $scope, $uibModalInstance, selectedTicket) {
        var vm = this;

        vm.selectedTicket = selectedTicket;
        vm.close = close;
        vm.passengersCollapsed = false;
        vm.segmentGroups = { outgoing: [], return: [], other: [] };
        vm.hhmm = hhmm;
        vm.durationLabel = durationLabel;
        vm.togglePassengers = togglePassengers;

        buildSegmentGroups();

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function buildSegmentGroups() {
            vm.segmentGroups = { outgoing: [], return: [], other: [] };

            var segs = (vm.selectedTicket && vm.selectedTicket.segments) ? vm.selectedTicket.segments : [];
            segs.forEach(function (s) {
                if (s && s.direction === 0) vm.segmentGroups.outgoing.push(s);
                else if (s && s.direction === 1) vm.segmentGroups.return.push(s);
                else vm.segmentGroups.other.push(s);
            });
        }

        function hhmm(timeStr) {
            if (!timeStr) return '';
            var p = timeStr.split(':');
            return p[0] + ':' + p[1];
        }

        function durationLabel(duration) {
            if (!duration || !duration.flight) return '';
            var total = duration.flight.common;
            var h = Math.floor(total / 60);
            var m = total % 60;
            return h + ' hours ' + m + ' min';
        }

        function togglePassengers() {
            vm.passengersCollapsed = !vm.passengersCollapsed;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketOrderController', TicketOrderController);

    TicketOrderController.$inject = ['$scope', '$state', '$uibModal', 'TicketPayment', 'ProfileIdByPhone'];

    function TicketOrderController($scope, $state, $uibModal, TicketPayment, ProfileIdByPhone) {
        var vm = this;

        vm.itemsPerPage = 10;
        vm.page = 1;
        vm.maxPage = 1;
        vm.totalItems = 0;

        vm.ticketPayments = [];
        vm.loading = false;

        vm.searchQuery = {
            field: null,
            status: null,
            fromDate: null,
            toDate: null
        };

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.openProfile = openProfile;
        vm.openTicketDetails = openTicketDetails;

        init();
        initDatePicker();

        function init() {
            loadPage(1);
        }

        function initDatePicker() {
            var pagingParams = angular.copy(vm.searchQuery) || {};

            $('.input-daterange input').each(function () {
                var name = $(this).attr('name');
                if (name === 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                }
                if (name === 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({
                autoclose: true,
                todayHighlight: true,
                clearBtn: true
            })

                .on('changeDate', 'input[name="from"]', function (e) {
                    $scope.$applyAsync(function () {
                        vm.searchQuery.fromDate = moment(e.date).format('MM/DD/YYYY');
                        pagingParams.fromDate = vm.searchQuery.fromDate;
                    });
                })

                .on('changeDate', 'input[name="to"]', function (e) {
                    $scope.$applyAsync(function () {
                        vm.searchQuery.toDate = moment(e.date).format('MM/DD/YYYY');
                        pagingParams.toDate = vm.searchQuery.toDate;
                    });
                });
        }

        function buildParams(page) {
            var pagingParams = angular.copy(vm.searchQuery) || {};

            var params = {
                valueInt1: page,
                size: vm.itemsPerPage,

                field: pagingParams.field,
                valueString1: pagingParams.status,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate
            };

            Object.keys(params).forEach(function (k) {
                if (params[k] === null || params[k] === undefined || params[k] === '') {
                    delete params[k];
                }
            });

            return params;
        }

        function loadPage(page) {
            if (page < 1) page = 1;
            if (vm.maxPage && page > vm.maxPage) page = vm.maxPage;

            vm.loading = true;

            loadAll(page);
        }

        function loadAll(page) {
            TicketPayment.queryFromMySafar(buildParams(page), onSuccess, onError);
            function onSuccess(data) {

                vm.ticketPayments = data.result || [];
                vm.page = data.page || page;

                vm.totalItems = data.count || 0;
                vm.maxPage = data.max_page || Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadPage(vm.page);
        }

        function search() {
            vm.page = 1;
            loadPage(1);
        }

        function clear() {
            vm.searchQuery = {
                field: null,
                status: null,
                toDate: null,
                fromDate: null
            };
            $('.input-daterange input').each(function () {
                var name = $(this).attr('name');
                if (name === 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                }
                if (name === 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            vm.page = 1;
            loadPage(1);
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                $state.go('profile-detail', {id: data.profileId});
            }
        }

        function openTicketDetails(ticket) {
            $uibModal.open({
                templateUrl: 'app/entities/ticket-payment/ticket-order-detail-dialog.html',
                controller: 'TicketOrderDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'ticket-order-detail-dialog-xl',
                resolve: {
                    selectedTicket: ticket
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-weekly', {
                parent: 'entity',
                url: '/stats-weekly',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.statistics.weekly'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-weekly/stats-weekly.html',
                        controller: 'StatsWeeklyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMerchants');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

/**
 * Created by Gayratjon Rayimjonov on 5/29/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsWeekly', StatsWeekly)
        .factory('StatsWeeklyTransfer', StatsWeeklyTransfer);

    StatsWeekly.$inject = ['$resource', 'DateUtils'];

    function StatsWeekly ($resource, DateUtils) {
        var resourceUrl =  'api/stats-weekly';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            }
        });
    }

    StatsWeeklyTransfer.$inject = ['$resource', 'DateUtils'];

    function StatsWeeklyTransfer ($resource, DateUtils) {
        var resourceUrl =  'api/stats-weekly-transfer';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsWeeklyController', StatsWeeklyController);

    StatsWeeklyController.$inject = ['StatsWeekly', 'AlertService', 'DateUtils', 'StatsWeeklyTransfer'];

    function StatsWeeklyController(StatsWeekly, AlertService, DateUtils, StatsWeeklyTransfer) {

        var vm = this;
        vm.search = search;
        var today = new Date(moment());
        var mon = '';
        var tue = '';
        var wed = '';
        var thu = '';
        var fri = '';
        var sat = '';
        var sun = '';
        var selectedDate = '';
        var transactionExistingDateList = [];
        var amountTransfer = [];
        var countTransfer = [];
        var countTransaction = [];
        var amountTransaction = [];
        getDateRange(today);

        function search() {
            StatsWeekly.query(vm.searchQuery, onSuccess, onError);
            StatsWeeklyTransfer.query(vm.searchQuery, onSuccessTransfer, onError);

            function onSuccess(data) {
                $.when(prepareAmountObjectAsArray(data)).done(function () {
                    highCharts();
                });
            }

            function onSuccessTransfer(data) {
                $.when(prepareTransferObjectAsArray(data)).done(function () {
                    highchartTransfer();
                });
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function highCharts() {
            Highcharts.chart('highchart', {
                title: {
                    text: 'Weekly TRANSACTIONS and SALES'
                },
                xAxis: [{
                    categories: ['Mon (' + mon + ')', 'Tue (' + tue + ')', 'Wed (' + wed + ')',
                        'Thu (' + thu + ')', 'Fri (' + fri + ')', 'Sat (' + sat + ')',
                        'Sun (' + sun + ')'],
                    crosshair: true
                }],
                yAxis: [{ // Primary yAxis
                    labels: {
                        format: '{value}',
                        style: {
                            color: Highcharts.getOptions().colors[5]
                        }
                    },
                    title: {
                        text: 'TRANSACTIONS',
                        style: {
                            color: Highcharts.getOptions().colors[5]
                        }
                    }
                }, { // Secondary yAxis
                    title: {
                        text: 'SALES',
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    },
                    labels: {
                        format: Highcharts.valueOf().value,
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    },
                    opposite: true
                }],
                tooltip: {
                    shared: true
                },
                legend: {
                    layout: 'vertical',
                    align: 'center',
                    x: 120,
                    verticalAlign: 'top',
                    y: 100,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                series: [{
                    name: 'Sales',
                    type: 'column',
                    yAxis: 1,
                    data: amountTransaction,
                    tooltip: {
                        valueSuffix: ''
                    }

                }, {
                    name: 'Transactions',
                    type: 'spline',
                    color: 'red',
                    data: countTransaction,
                    tooltip: {
                        valueSuffix: ''
                    }
                }]
            });
        }

        function highchartTransfer() {
            Highcharts.chart('highchartTransfer', {
                title: {
                    text: 'Weekly TRANSFERS and SALES'
                },
                xAxis: [{
                    categories: ['Mon (' + mon + ')', 'Tue (' + tue + ')', 'Wed (' + wed + ')',
                        'Thu (' + thu + ')', 'Fri (' + fri + ')', 'Sat (' + sat + ')',
                        'Sun (' + sun + ')'],
                    crosshair: true
                }],
                yAxis: [{ // Primary yAxis
                    labels: {
                        format: '{value}',
                        style: {
                            color: Highcharts.getOptions().colors[5]
                        }
                    },
                    title: {
                        text: 'TRANSFERS',
                        style: {
                            color: Highcharts.getOptions().colors[5]
                        }
                    }
                }, { // Secondary yAxis
                    title: {
                        text: 'SALES',
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    },
                    labels: {
                        format: Highcharts.valueOf().value,
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    },
                    opposite: true
                }],
                tooltip: {
                    shared: true
                },
                legend: {
                    layout: 'vertical',
                    align: 'center',
                    x: 120,
                    verticalAlign: 'top',
                    y: 100,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                series: [{
                    name: 'Sales',
                    type: 'column',
                    yAxis: 1,
                    data: amountTransfer,
                    tooltip: {
                        valueSuffix: ''
                    }

                }, {
                    name: 'Transfers',
                    type: 'spline',
                    color: 'red',
                    data: countTransfer,
                    tooltip: {
                        valueSuffix: ''
                    }
                }]
            });
        }


        function getDateRange(date) {
            selectedDate = date;
            var fromDate = new Date(moment(selectedDate).day(1).format("MM/DD/YYYY"));
            var toDate = new Date(moment(selectedDate).day(7).format("MM/DD/YYYY"));

            $('#datetimepicker').datetimepicker({weekStart: 1});
            var firstDateToShow = moment(selectedDate).day(1).format("MM/DD/YYYY");
            var lastDateToShow = moment(selectedDate).day(7).format("MM/DD/YYYY");
            $("#week").val(firstDateToShow + " ~ " + lastDateToShow);
            mon = moment(selectedDate).day(1).format("DD/MMM");
            tue = moment(selectedDate).day(2).format("DD/MMM");
            wed = moment(selectedDate).day(3).format("DD/MMM");
            thu = moment(selectedDate).day(4).format("DD/MMM");
            fri = moment(selectedDate).day(5).format("DD/MMM");
            sat = moment(selectedDate).day(6).format("DD/MMM");
            sun = moment(selectedDate).day(7).format("DD/MMM");

            vm.searchQuery = {
                fromDate: DateUtils.converterDateFormat(fromDate),
                toDate: DateUtils.converterDateFormat(toDate)
            };
            transactionExistingDateList = [];
            search();
        }

        function prepareAmountObjectAsArray(data) {
            countTransaction = [];
            amountTransaction = [];
            for (var day = 1; day <= 7; day++) {
                var index = getExistingWeekdayIndex(day, data);
                if (index >= 0) {
                    countTransaction.push(data[index].count);
                    amountTransaction.push(data[index].amount);
                } else {
                    countTransaction.push(0);
                    amountTransaction.push(0);
                }
            }
        }

        function prepareTransferObjectAsArray(data) {
            amountTransfer = [];
            countTransfer = [];
            for (var day = 1; day <= 7; day++) {
                var index = getExistingWeekdayIndex(day, data);
                if (index >= 0) {
                    countTransfer.push(data[index].count);
                    amountTransfer.push((data[index].amount / 100 ));
                } else {
                    countTransfer.push(0);
                    amountTransfer.push(0);
                }
            }
        }

        function getExistingWeekdayIndex(day, data) {
            if (day == 7) {
                day = 0;
            }
            for (var i = 0; i < data.length; i++) {
                var existingWeekDay = new Date(data[i].date).getDay();
                if (existingWeekDay == day) {
                    return i;
                }
            }
            return -1;
        }

        $('#datetimepicker')
            .datetimepicker()
            .on('changeDate', function (ev) {
                var value = new Date($("#week").val());
                $('#datetimepicker').datetimepicker('hide');
                getDateRange(value);
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-transfer-sender', {
                parent: 'entity',
                url: '/stats-transfer-sender?page&search',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                    pageTitle: 'global.menu.statistics.transferSenderCount'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-transfer-sender/stats-transfer-sender.html',
                        controller: 'StatsTransferSenderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'count(tkb.id),desc',
                        squash: true
                    },
                    userPhone: null,
                    count: 2,
                    amount: 0,
                    fromDate: null,
                    toDate: null,
                    fromZonedDate: null,
                    toZonedDate: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            userPhone: $stateParams.userPhone,
                            count: $stateParams.count,
                            amount: $stateParams.amount,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            fromZonedDate: $stateParams.fromZonedDate,
                            toZonedDate: $stateParams.toZonedDate,
                            firstRun: $stateParams.firstRun,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('tkbTransfer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsTransferSender', StatsTransferSender);

    StatsTransferSender.$inject = ['$resource', 'DateUtils'];

    function StatsTransferSender($resource) {
        var resourceUrl = 'api/stats-transfer-sender-count';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsTransferSenderController', StatsTransferSenderController);

    StatsTransferSenderController.$inject = ['$http', '$scope', '$state', '$window', 'StatsTransferSender', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils', 'ProfileIdByPhone'];

    function StatsTransferSenderController($http, $scope, $state, $window, StatsTransferSender, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils, ProfileIdByPhone) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.excel = excel;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            count: pagingParams.count,
            amount: pagingParams.amount,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            fromZonedDate: pagingParams.fromZonedDate,
            toZonedDate: pagingParams.toZonedDate,
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromZonedDate = false;
        vm.datePickerOpenStatus.toZonedDate = false;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'fromZonedDate') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'toZonedDate') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url,'_blank');
            }
        }

        function loadAll() {
            StatsTransferSender.query({
                userPhone: vm.searchQuery.userPhone,
                count: vm.searchQuery.count,
                amount: vm.searchQuery.amount,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate === '' ? null : vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate === '' ? null : vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'count(tkb.id)') {
                    result.push('count(tkb.id)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transferCount = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                count: vm.searchQuery.count,
                amount: vm.searchQuery.amount,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                firstRun: false
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(tkb.id)';
            vm.reverse = true;
            vm.transition();
        }

        function excel() {
            getDateTimeFromPicker();
            vm.searchQuery.fromDate = DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            vm.searchQuery.toDate = DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = "userPhone=" + vm.searchQuery.userPhone
                + "&count=" + vm.searchQuery.count
                + "&amount=" + vm.searchQuery.amount
                + "&fromDate=" + vm.searchQuery.fromDate
                + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-transfer-sender-count-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'statistics-transfer-sender-count-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(tkb.id)';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                count: 2,
                amount: 0,
                fromZonedDate: null,
                toZonedDate: null,
                fromDate: null,
                toDate: null,
            };
            vm.transferCount = [];
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-transfer-receiver', {
                parent: 'entity',
                url: '/stats-transfer-receiver?page&search',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                    pageTitle: 'global.menu.statistics.transferReceiverCount'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-transfer-receiver/stats-transfer-receiver.html',
                        controller: 'StatsTransferReceiverController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'count(tkb.id),desc',
                        squash: true
                    },
                    receiverCardNumber: null,
                    count: 2,
                    senderCount: 1,
                    amount: 0,
                    fromDate: null,
                    toDate: null,
                    fromZonedDate: null,
                    toZonedDate: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            receiverCardNumber: $stateParams.receiverCardNumber,
                            count: $stateParams.count,
                            senderCount: $stateParams.senderCount,
                            amount: $stateParams.amount,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            fromZonedDate: $stateParams.fromZonedDate,
                            toZonedDate: $stateParams.toZonedDate,
                            firstRun: $stateParams.firstRun,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('tkbTransfer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsTransferReceiver', StatsTransferReceiver);

    StatsTransferReceiver.$inject = ['$resource', 'DateUtils'];

    function StatsTransferReceiver($resource) {
        var resourceUrl = 'api/stats-transfer-receiver-count';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsTransferReceiverController', StatsTransferReceiverController);

    StatsTransferReceiverController.$inject = ['$http', '$scope', '$state', '$window', 'StatsTransferReceiver', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils', 'ProfileIdByPhone'];

    function StatsTransferReceiverController($http, $scope, $state, $window, StatsTransferReceiver, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils, ProfileIdByPhone) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.excel = excel;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            receiverCardNumber: pagingParams.receiverCardNumber,
            count: pagingParams.count,
            senderCount: pagingParams.senderCount,
            amount: pagingParams.amount,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            fromZonedDate: pagingParams.fromZonedDate,
            toZonedDate: pagingParams.toZonedDate,
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromZonedDate = false;
        vm.datePickerOpenStatus.toZonedDate = false;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'fromZonedDate') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'toZonedDate') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url,'_blank');
            }
        }

        function loadAll() {
            StatsTransferReceiver.query({
                receiverCardNumber: vm.searchQuery.receiverCardNumber,
                count: vm.searchQuery.count,
                senderCount: vm.searchQuery.senderCount,
                amount: vm.searchQuery.amount,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate === '' ? null : vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate === '' ? null : vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'count(tkb.id)') {
                    result.push('count(tkb.id)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transferCount = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                receiverCardNumber: vm.searchQuery.receiverCardNumber,
                count: vm.searchQuery.count,
                senderCount: vm.searchQuery.senderCount,
                amount: vm.searchQuery.amount,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                firstRun: false
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(tkb.id)';
            vm.reverse = true;
            vm.transition();
        }

        function excel() {
            getDateTimeFromPicker();
            vm.searchQuery.fromDate = DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            vm.searchQuery.toDate = DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = (vm.searchQuery.receiverCardNumber !== null ? "receiverCardNumber=" + vm.searchQuery.receiverCardNumber + "&" : "")
                + "count=" + vm.searchQuery.count
                + "&senderCount=" + vm.searchQuery.senderCount
                + "&amount=" + vm.searchQuery.amount
                + "&fromDate=" + vm.searchQuery.fromDate
                + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-transfer-receiver-count-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'statistics-transfer-receiver-count-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(tkb.id)';
            vm.reverse = false;
            vm.searchQuery = {
                receiverCardNumber: null,
                count: 2,
                senderCount: 1,
                amount: 0,
                fromZonedDate: null,
                toZonedDate: null,
                fromDate: null,
                toDate: null,
            };
            vm.transferCount = [];
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-search', {
                parent: 'entity',
                url: '/stats-search?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.productSearchLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-search/stats-search.html',
                        controller: 'StatsSearchController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'query,asc',
                        squash: true
                    },
                    field: null,
                    fromDate: null,
                    toDate: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            field: $stateParams.field,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsSearch', StatsSearch);

    StatsSearch.$inject = ['$resource'];

    function StatsSearch($resource) {
        var resourceUrl = 'api/stats-search';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsSearchController', StatsSearchController);

    StatsSearchController.$inject = ['$state', 'StatsSearch', 'AlertService', 'ParseLinks', 'paginationConstants', 'pagingParams'];

    function StatsSearchController($state, StatsSearch, AlertService, ParseLinks, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.load = load;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.searchQuery = {
            field: pagingParams.field,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        initDatePicker();

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function load() {
            StatsSearch.query({
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'query') {
                    result.push('query');
                }
                return result;
            }

            function onSuccess(data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.queries = data;
                // vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,

            });
        }

        function search(searchQuery) {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'query';
            vm.reverse = true;
            // vm.transition();
            vm.load();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'query';
            vm.reverse = true;
            vm.searchQuery = {
                field: null,
                fromDate: null,
                toDate: null
            };
            // vm.transition();
        }
    }
})();

/**
 * Created by Khasan on 6/12/2017.
 */
(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-profit', {
                parent: 'entity',
                url: '/stats-profit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.statistics.profit'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-profit/stats-profit.html',
                        controller: 'StatsProfitController',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMerchants');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
/**
 * Created by user on 6/14/2017.
 */

/**
 * Created by Gayratjon Rayimjonov on 6/14/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsProfitMargin', StatsProfitMargin);

    StatsProfitMargin.$inject = ['$resource', 'DateUtils'];

    function StatsProfitMargin ($resource, DateUtils) {
        var resourceUrl =  'api/stats-profit';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsProfitController', StatsProfitController);

    StatsProfitController.$inject = ['AlertService', 'DateUtils', 'StatsProfitMargin'];

    function StatsProfitController(AlertService, DateUtils, StatsProfitMargin) {

        var vm = this;
        vm.search = search;
        var today = new Date(moment());
        var mon = '';
        var tue = '';
        var wed = '';
        var thu = '';
        var fri = '';
        var sat = '';
        var sun = '';
        var selectedDate = '';
        getDateRange(today);

        function search() {
            StatsProfitMargin.query(vm.searchQuery, onSuccess, onError);

            function onSuccess(data, headers) {
                callBarchsrt(data);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function callBarchsrt(data) {
            Highcharts.chart('barchart', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Total Transfer Profit'
                },
                xAxis: {
                    categories: ['Mon(' + mon + ')', 'Tue(' + tue + ')', 'Wed(' + wed + ')',
                        'Thu(' + thu + ')', 'Fri(' + fri + ')', 'Sat(' + sat + ')', 'Sun(' + sun + ')']
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'T o t a l ' + ' ' +   ' P r o f i t'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                        }
                    }
                },
                legend: {
                    align: 'right',
                    x: -30,
                    verticalAlign: 'top',
                    y: 25,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                    borderColor: '#CCC',
                    borderWidth: 1,
                    shadow: true
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{point.y}<br/>'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                        }
                    }
                },
                series: data
            });
        }


        function getDateRange(date) {
            selectedDate = date;
            var fromDate = new Date(moment(selectedDate).day(1).format("MM/DD/YYYY"));
            var toDate = new Date(moment(selectedDate).day(7).format("MM/DD/YYYY"));

            $('#datetimepicker').datetimepicker({weekStart: 1});
            var firstDateToShow = moment(selectedDate).day(1).format("MM/DD/YYYY");
            var lastDateToShow = moment(selectedDate).day(7).format("MM/DD/YYYY");
            $("#week").val(firstDateToShow + " ~ " + lastDateToShow);
            mon = moment(selectedDate).day(1).format("DD/MMM");
            tue = moment(selectedDate).day(2).format("DD/MMM");
            wed = moment(selectedDate).day(3).format("DD/MMM");
            thu = moment(selectedDate).day(4).format("DD/MMM");
            fri = moment(selectedDate).day(5).format("DD/MMM");
            sat = moment(selectedDate).day(6).format("DD/MMM");
            sun = moment(selectedDate).day(7).format("DD/MMM");
            callBarchsrt();

            vm.searchQuery = {
                fromDate: DateUtils.converterDateFormat(fromDate),
                toDate: DateUtils.converterDateFormat(toDate)
            };
            search();
        }

        $('#datetimepicker')
            .datetimepicker()
            .on('changeDate', function (ev) {
                var value = new Date($("#week").val());
                $('#datetimepicker').datetimepicker('hide');
                getDateRange(value);
            });


    }
})();

/**
 * Created by Gayratjon Rayimjonov on 10/24/2017.
 */
(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-periodical', {
                parent: 'entity',
                url: '/stats-periodical',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.statistics.periodical'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-periodical/stats-periodical.html',
                        controller: 'StatsPeriodicalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMerchants');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

/**
 * Created by Gayratjon Rayimjonov on 10/24/2017.
 */
(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsPeriodical', StatsPeriodical)
        .factory('StatsByCountry', StatsByCountry);

    StatsPeriodical.$inject = ['$resource', 'DateUtils'];

    function StatsPeriodical($resource, DateUtils) {
        var resourceUrl = 'api/stats-periodical';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
    }

    StatsByCountry.$inject = ['$resource', 'DateUtils'];

    function StatsByCountry($resource) {
        var resourceUrl = 'api/stats-by-country';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/**
 * Created by Gayratjon Rayimjonov on 10/24/2017.
 */

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsPeriodicalController', StatsPeriodicalController);

    StatsPeriodicalController.$inject = ['$http', '$scope', '$state', 'DateUtils', 'DataUtils', 'StatsPeriodical', 'StatsByCountry'];

    function StatsPeriodicalController($http, $scope, $state, DateUtils, DataUtils, StatsPeriodical, StatsByCountry) {
        var vm = this;
        vm.search = search;
        vm.excel = excel;
        vm.searchQuery = {};
        vm.stats = {
            totalTransactionsAmount : 0,
            largestTransactionsAmount: 0,
            transfersAmount:0,
            largestTransfersAmount:0,
            newUsers: 0,
            activeUsers: 0,
            failureTransactionCount: 0,
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function search() {
            vm.searchQuery.fromDate = DateUtils.converterDateTimeFormat(vm.fromDate);
            vm.searchQuery.toDate = DateUtils.converterDateTimeFormat(vm.toDate);
            StatsPeriodical.query(vm.searchQuery, onSuccess);
            StatsByCountry.query(vm.searchQuery, onSuccessByCountry);

            function onSuccess(data) {
                vm.stats = data;
            }

            function onSuccessByCountry(data) {
                createChartByCountry(data);
            }
        }

        function createChartByCountry(data) {
            var countryNames = data.map(function (value) {
                return value.countryName;
            });
            var successData = data.map(function (value) {
                return {
                    y: value.totalSuccessAmount,
                    count: value.successCount
                };
            });
            var failData = data.map(function (value) {
                return {
                    y: value.totalFailAmount,
                    count: value.failCount
                };
            });

            Highcharts.chart('statsByCountry', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Stats by Country'
                },
                xAxis: {
                    categories: countryNames
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'T o t a l ' + ' ' + ' A m o u n t'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                        }
                    }
                },
                legend: {
                    align: 'right',
                    x: -30,
                    verticalAlign: 'top',
                    y: 25,
                    floating: true,
                    backgroundColor: '#ffffff',
                    shadow: true
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: <b>{point.y} ₽</b><br/>COUNT: <b>{point.count}</b>'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                        }
                    }
                },
                series: [{
                        name: "SUCCESS",
                        data: successData,
                        color: '#26C281'
                    },
                    {
                        name: "FAILURE",
                        data: failData,
                        color: '#e7505a'
                    }
                ]
            });
        }

        function excel() {
            vm.searchQuery.fromDate = DateUtils.converterDateTimeFormat(vm.fromDate);
            vm.searchQuery.toDate = DateUtils.converterDateTimeFormat(vm.toDate);
            var data = "client=" + vm.searchQuery.client + "&fromDate=" + vm.searchQuery.fromDate + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-periodical-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'periodical-statistics-' + DateUtils.currentTimestamp() + '-' + vm.searchQuery.client + '.xlsx');
            }).error(function () {
            });
        }
    }
})();


(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsPartner', StatsPartner);

    StatsPartner.$inject = ['$resource', 'DateUtils'];

    function StatsPartner($resource, DateUtils) {
        var resourceUrl = 'api/stats-partner';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsPartnerController', StatsPartnerController);

    StatsPartnerController.$inject = ['$http', '$scope', '$state', 'StatsPartner', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils', 'DataUtils'];

    function StatsPartnerController($http, $scope, $state, StatsPartner, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils, DataUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.excel = excel;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dateDiff = DateUtils.transactionDateDifference;
        vm.getDirectAmount = DataUtils.getDirectAmount;
        vm.getSentAmount = DataUtils.getSentAmount;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchQuery = {
            field: pagingParams.field,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            fromZonedDate: pagingParams.fromZonedDate,
            toZonedDate: pagingParams.toZonedDate,
            status: pagingParams.status
        };

        loadAll();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromZonedDate = false;
        vm.datePickerOpenStatus.toZonedDate = false;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'fromZonedDate') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'toZonedDate') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll() {
            StatsPartner.query({
                field: pagingParams.field,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                fromZonedDate: pagingParams.fromZonedDate,
                toZonedDate: pagingParams.toZonedDate,
                transactionStatus: pagingParams.status,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transactions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                status: vm.searchQuery.status
            });
        }

        function search(searchQuery) {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'pubDate';
            vm.reverse = true;
            vm.transition();
        }

        function excel() {
            getDateTimeFromPicker();
            vm.searchQuery.fromDate = DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            vm.searchQuery.toDate = DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = "partner=" + vm.searchQuery.field + "&status=" + vm.searchQuery.status + "&fromDate=" + vm.searchQuery.fromDate + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-partner-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'statistics-by-partner-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'pubDate';
            vm.reverse = false;
            vm.searchQuery = {
                field: null,
                fromZonedDate: null,
                toZonedDate: null,
                fromDate: null,
                toDate: null,
                serviceType: 'UNKNOWN',
                status: 'UNKNOWN'
            };
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-my-id', {
                parent: 'entity',
                url: '/stats-my-id?page&search',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                    pageTitle: 'global.menu.statistics.myID'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-my-id/stats-my-id.html',
                        controller: 'StatsMyIDController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'count(myID.id),desc',
                        squash: true
                    },
                    documentNumber: null,
                    fromDate: null,
                    toDate: null,
                    fromZonedDate: null,
                    toZonedDate: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            documentNumber: $stateParams.documentNumber,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            fromZonedDate: $stateParams.fromZonedDate,
                            toZonedDate: $stateParams.toZonedDate,
                            firstRun: $stateParams.firstRun,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('myID');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsMyID', StatsMyID);

    StatsMyID.$inject = ['$resource', 'DateUtils'];

    function StatsMyID($resource) {
        var resourceUrl = 'api/stats-my-id-count';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsMyIDController', StatsMyIDController);

    StatsMyIDController.$inject = ['$http', '$scope', '$state', '$window', 'StatsMyID', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function StatsMyIDController($http, $scope, $state, $window, StatsMyID, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            documentNumber: pagingParams.documentNumber,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            fromZonedDate: pagingParams.fromZonedDate,
            toZonedDate: pagingParams.toZonedDate,
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromZonedDate = false;
        vm.datePickerOpenStatus.toZonedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'fromZonedDate') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'toZonedDate') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll() {
            StatsMyID.query({
                documentNumber: vm.searchQuery.documentNumber,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate === '' ? null : vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate === '' ? null : vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'count(myID.id)') {
                    result.push('count(myID.id)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.myIDCount = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                documentNumber: vm.searchQuery.documentNumber,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                firstRun: false
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(myID.id)';
            vm.reverse = true;
            vm.transition();
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(myID.id)';
            vm.reverse = true;
            vm.searchQuery = {
                documentNumber: null,
                fromZonedDate: null,
                toZonedDate: null,
                fromDate: null,
                toDate: null,
            };
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-monthly-balance', {
                parent: 'entity',
                url: '/stats-monthly-balance?page&search',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                    pageTitle: 'statistics-monthly-balance.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-monthly-balance/stats-monthly-balance.html',
                        controller: 'StatsMonthlyBalanceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    field: "",
                    fromDate: null,
                    toDate: null,
                    client: "",
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            field: $stateParams.field,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            date: $stateParams.date,
                            client: $stateParams.client,
                            firstRun: $stateParams.firstRun
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMonthlyBalance');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsMonthlyBalance', StatsMonthlyBalance)
        .factory('StatsMonthlyBalanceTotalAmount', StatsMonthlyBalanceTotalAmount);;

    StatsMonthlyBalance.$inject = ['$resource'];

    function StatsMonthlyBalance($resource) {
        var resourceUrl = 'api/stats-monthly-balance';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: true}
        });
    }

    StatsMonthlyBalanceTotalAmount.$inject = ['$resource'];

    function StatsMonthlyBalanceTotalAmount($resource) {
        var resourceUrl = 'api/stats-monthly-balance/total-amount';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsMonthlyBalanceController', StatsMonthlyBalanceController);

    StatsMonthlyBalanceController.$inject = ['$scope', '$http', '$state', 'StatsMonthlyBalance', 'StatsMonthlyBalanceTotalAmount', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils'];

    function StatsMonthlyBalanceController($scope, $http, $state, StatsMonthlyBalance, StatsMonthlyBalanceTotalAmount, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.excel = excel;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            field: pagingParams.field,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        initDatePicker();

        if (!pagingParams.firstRun) {
            loadAll();
            getTotalMonthlyBalance();
        }

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll() {
            StatsMonthlyBalance.get({
                field: pagingParams.field,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.statistics = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                serviceType: vm.searchQuery.serviceType,
                status: vm.searchQuery.status,
                mode: vm.searchQuery.mode,
                firstRun: false
            });
        }

        function search() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function getTotalMonthlyBalance() {
            StatsMonthlyBalanceTotalAmount.get({
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate
            }, function (data) {
                vm.stats = data;
            })
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                field: "",
                fromDate: null,
                toDate: null
            };
            vm.transition();
        }

        function excel() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            var data = "field=" + vm.searchQuery.field + "&fromDate=" + vm.searchQuery.fromDate + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-monthly-balance-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'statistics-monthly-balance-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {

            });
        }

    }
})();

/**
 * Created by Gayratjon Rayimjonov on 5/24/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsService', StatsService);

    StatsService.$inject = ['$resource', 'DateUtils'];

    function StatsService ($resource, DateUtils) {
        var resourceUrl =  'api/stats-service';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        // data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();

/**
 * Created by Gayratjon Rayimjonov on 5/25/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsPerTime', StatsPerTime);

    StatsPerTime.$inject = ['$resource', 'DateUtils'];

    function StatsPerTime ($resource, DateUtils) {
        var resourceUrl =  'api/stats-per-time';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-daily', {
                parent: 'entity',
                url: '/stats-daily',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.statistics.daily'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-daily/stats-daily.html',
                        controller: 'StatsDailyController',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMerchants');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

/**
 * Created by Gayratjon Rayimjonov on 5/24/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsDaily', StatsDaily);

    StatsDaily.$inject = ['$resource', 'DateUtils'];


    function StatsDaily ($resource, DateUtils) {
        var resourceUrl =  'api/stats-daily';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsDailyController', StatsDailyController);

    StatsDailyController.$inject = ['DateUtils', 'StatsDaily', 'AlertService', 'StatsService', 'StatsActiveUserOS', 'StatsPerTime'];

    function StatsDailyController(DateUtils, StatsDaily, AlertService, StatsService, StatsActiveUserOS, StatsPerTime) {
        var vm = this;
        vm.search = search;
        vm.searchQuery = {
            fromDate: DateUtils.currentDate()
        };
        search();

        var options = {
            onSelectedDateChanged: function (event, date) {
                vm.searchQuery = {
                    fromDate: DateUtils.converterDateFormat(date),
                    client: vm.searchQuery.client
                };
            }
        };

        function search() {
            StatsDaily.query(vm.searchQuery, onSuccess, onError);
            StatsService.query(vm.searchQuery, onSuccessService, onError);
            StatsActiveUserOS.query(vm.searchQuery, onSuccessActiveUserOS, onError);
            StatsPerTime.query(vm.searchQuery, onSuccessTransactionPerTime, onError);

            function onSuccess(data, headers) {
                vm.stats = data;
            }

            function onSuccessService(data, headers) {
                makeServiceTypesPieChart(data);
            }

            function onSuccessActiveUserOS(data, headers) {
                makeActiveUserOSPieChart(data);
            }

            function onSuccessTransactionPerTime(data, headers) {
                makeTransactionPerTimeChart(data);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        };

        $('#paginator').datepaginator(options);

        function makeServiceTypesPieChart(data) {
            var chart1 = AmCharts.makeChart("piechart1", {
                "type": "pie",
                "startDuration": 0,
                "theme": "light",
                "addClassNames": true,
                "legend": {
                    "position": "right",
                    "marginRight": 100,
                    "autoMargins": false
                },
                "innerRadius": "30%",
                "defs": {
                    "filter": [{
                        "id": "shadow",
                        "width": "200%",
                        "height": "200%",
                        "feOffset": {
                            "result": "offOut",
                            "in": "SourceAlpha",
                            "dx": 0,
                            "dy": 0
                        },
                        "feGaussianBlur": {
                            "result": "blurOut",
                            "in": "offOut",
                            "stdDeviation": 5
                        },
                        "feBlend": {
                            "in": "SourceGraphic",
                            "in2": "blurOut",
                            "mode": "normal"
                        }
                    }]
                },
                "dataProvider": data,
                "valueField": "amount",
                "titleField": "titleField",
                "export": {
                    "enabled": true
                }
            });

            chart1.addListener("init", handleInit);

            chart1.addListener("rollOverSlice", function (e) {
                handleRollOver(e);
            });
        }

        function handleInit() {
            chart1.legend.addListener("rollOverItem", handleRollOver);
        }

        function handleRollOver(e) {
            var wedge = e.dataItem.wedge.node;
            wedge.parentNode.appendChild(wedge);
        }


        function makeActiveUserOSPieChart(data) {
            var chart = AmCharts.makeChart("piechart2", {
                "type": "pie",
                "theme": "light",
                "dataProvider": data,
                "valueField": "numberOfUsers",
                "titleField": "OSType",
                "descriptionField": "description",
                "balloon": {
                    "fixedPosition": true
                },
                "export": {
                    "enabled": true
                },
                "radius": "100"
            });
        }

        function makeActiveUserMerchantPieChart(data) {
            var chart4 = AmCharts.makeChart("piechart3", {
                "type": "pie",
                "theme": "light",
                "dataProvider": data,
                "valueField": "numberOfUsers",
                "titleField": "MerchantType",
                "descriptionField": "description",
                "balloon": {
                    "fixedPosition": true
                },
                "export": {
                    "enabled": true
                },
                "radius": "100"
            });
        }

        function makeTransactionPerTimeChart(data) {
            var chart = AmCharts.makeChart("barchart", {
                "type": "serial",
                "addClassNames": true,
                "theme": "light",
                "autoMargins": false,
                "marginLeft": 30,
                "marginRight": 8,
                "marginTop": 10,
                "marginBottom": 26,
                "balloon": {
                    "adjustBorderColor": false,
                    "horizontalPadding": 10,
                    "verticalPadding": 8,
                    "color": "#ffffff"
                },

                "dataProvider": data,
                "valueAxes": [{
                    "axisAlpha": 0,
                    "position": "left"
                }],
                "startDuration": 1,
                "graphs": [{
                    "alphaField": "alpha",
                    "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
                    "fillAlphas": 1,
                    "title": "Success",
                    "type": "column",
                    "valueField": "successes",
                    "dashLengthField": "dashLengthColumn"
                }, {
                    "id": "graph2",
                    "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:20px;'>[[value]]</span> [[additional]]</span>",
                    "bullet": "round",
                    "lineThickness": 4,
                    "bulletSize": 20,
                    "bulletBorderAlpha": 4,
                    "bulletColor": "red",
                    "useLineColorForBulletBorder": false,
                    "bulletBorderThickness": 3,
                    "fillAlphas": 0,
                    "lineAlpha": 1,
                    "title": "Failure",
                    "valueField": "failures",
                    "dashLengthField": "dashLengthLine"
                }],
                "categoryField": "timeSlot",
                "categoryAxis": {
                    "gridPosition": "start",
                    "axisAlpha": 0,
                    "tickLength": 0
                },
                "export": {
                    "enabled": true
                }
            });
        }
    }
})();

/**
 * Created by Gayratjon Rayimjonov on 5/24/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsActiveUserOS', StatsActiveUserOS);

    StatsActiveUserOS.$inject = ['$resource', 'DateUtils'];

    function StatsActiveUserOS ($resource, DateUtils) {
        var resourceUrl =  'api/stats-active-os';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        // data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDialogController', SmsLimitDialogController);

    SmsLimitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SmsLimit'];

    function SmsLimitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.smsLimit.id !== null) {
                SmsLimit.update(vm.smsLimit, onSaveSuccess, onSaveError);
            } else {
                SmsLimit.save(vm.smsLimit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:smsLimitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDetailController', SmsLimitDetailController);

    SmsLimitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SmsLimit'];

    function SmsLimitDetailController($scope, $rootScope, $stateParams, previousState, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:smsLimitUpdate', function(event, result) {
            vm.smsLimit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDeleteController',SmsLimitDeleteController);

    SmsLimitDeleteController.$inject = ['$uibModalInstance', 'entity', 'SmsLimit'];

    function SmsLimitDeleteController($uibModalInstance, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SmsLimit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sms-limit', {
            parent: 'entity',
            url: '/sms-limit?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.smsLimit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-limit/sms-limits.html',
                    controller: 'SmsLimitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smsLimit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sms-limit-detail', {
            parent: 'sms-limit',
            url: '/sms-limit/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.smsLimit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-limit/sms-limit-detail.html',
                    controller: 'SmsLimitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smsLimit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SmsLimit', function($stateParams, SmsLimit) {
                    return SmsLimit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sms-limit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sms-limit-detail.edit', {
            parent: 'sms-limit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-limit/sms-limit-dialog.html',
                    controller: 'SmsLimitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SmsLimit', function(SmsLimit) {
                            return SmsLimit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sms-limit.new', {
            parent: 'sms-limit',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-limit/sms-limit-dialog.html',
                    controller: 'SmsLimitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                phone: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sms-limit', null, { reload: 'sms-limit' });
                }, function() {
                    $state.go('sms-limit');
                });
            }]
        })
        .state('sms-limit.edit', {
            parent: 'sms-limit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-limit/sms-limit-dialog.html',
                    controller: 'SmsLimitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SmsLimit', function(SmsLimit) {
                            return SmsLimit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sms-limit', null, { reload: 'sms-limit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sms-limit.delete', {
            parent: 'sms-limit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-limit/sms-limit-delete-dialog.html',
                    controller: 'SmsLimitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SmsLimit', function(SmsLimit) {
                            return SmsLimit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sms-limit', null, { reload: 'sms-limit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('SmsLimit', SmsLimit);

    SmsLimit.$inject = ['$resource', 'DateUtils'];

    function SmsLimit ($resource, DateUtils) {
        var resourceUrl =  'api/sms-limits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitController', SmsLimitController);

    SmsLimitController.$inject = ['$state', 'SmsLimit', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SmsLimitController($state, SmsLimit, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            SmsLimit.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.smsLimits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('SmsRussiaBalance', SmsRussiaBalance)
        .factory('SmsRussiaLimit', SmsRussiaLimit);

    SmsRussiaBalance.$inject = ['$resource'];

    function SmsRussiaBalance ($resource) {
        var resourceUrl =  'api/sms-ru/balance';
        return $resource(resourceUrl, {}, {
        });
    }

    SmsRussiaLimit.$inject = ['$resource'];

    function SmsRussiaLimit ($resource) {
        var resourceUrl =  'api/sms-ru/limit';
        return $resource(resourceUrl, {}, {
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionDialogController', SegmentFieldOptionDialogController);

    SegmentFieldOptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SegmentFieldOption'];

    function SegmentFieldOptionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SegmentFieldOption) {
        var vm = this;

        vm.segmentFieldOption = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.segmentFieldOption.id !== null) {
                SegmentFieldOption.update(vm.segmentFieldOption, onSaveSuccess, onSaveError);
            } else {
                SegmentFieldOption.save(vm.segmentFieldOption, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:segmentFieldOptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionDetailController', SegmentFieldOptionDetailController);

    SegmentFieldOptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SegmentFieldOption'];

    function SegmentFieldOptionDetailController($scope, $rootScope, $stateParams, previousState, entity, SegmentFieldOption) {
        var vm = this;

        vm.segmentFieldOption = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:segmentFieldOptionUpdate', function(event, result) {
            vm.segmentFieldOption = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionDeleteController',SegmentFieldOptionDeleteController);

    SegmentFieldOptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SegmentFieldOption'];

    function SegmentFieldOptionDeleteController($uibModalInstance, entity, SegmentFieldOption) {
        var vm = this;

        vm.segmentFieldOption = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SegmentFieldOption.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('segment-field-option', {
            parent: 'entity',
            url: '/segment-field-option?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.segmentFieldOption.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/segment-field-option/segment-field-options.html',
                    controller: 'SegmentFieldOptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                label: null,
                segmentFieldId: null,
                value: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        label: $stateParams.label,
                        segmentFieldId: $stateParams.segmentFieldId,
                        value: $stateParams.value
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('segmentFieldOption');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('segment-field-option.new', {
            parent: 'segment-field-option',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field-option/segment-field-option-dialog.html',
                    controller: 'SegmentFieldOptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                value: null,
                                position: null,
                                segmentFieldId: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('segment-field-option', null, { reload: 'segment-field-option' });
                }, function() {
                    $state.go('segment-field-option');
                });
            }]
        })

            .state('segment-field-option.edit', {
            parent: 'segment-field-option',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field-option/segment-field-option-dialog.html',
                    controller: 'SegmentFieldOptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SegmentFieldOption', function(SegmentFieldOption) {
                            return SegmentFieldOption.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('segment-field-option', null, { reload: 'segment-field-option' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('SegmentFieldOption', SegmentFieldOption);

    SegmentFieldOption.$inject = ['$resource', 'DateUtils'];

    function SegmentFieldOption ($resource, DateUtils) {
        var resourceUrl =  'api/segment-field-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionController', SegmentFieldOptionController);

    SegmentFieldOptionController.$inject = ['$state', 'SegmentFieldOption', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SegmentFieldOptionController($state, SegmentFieldOption, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            label: pagingParams.label,
            segmentFieldId: pagingParams.segmentFieldId,
            value: pagingParams.value
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            SegmentFieldOption.query({
                label: pagingParams.label,
                segmentFieldId: pagingParams.segmentFieldId,
                value: pagingParams.value,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.segmentFieldOptions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                label: vm.searchQuery.label,
                segmentFieldId: vm.searchQuery.segmentFieldId,
                value: vm.searchQuery.value,
                firstRun: false
            });
        }
        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                label: null,
                segmentFieldId: null,
                value: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldDialogController', SegmentFieldDialogController);

    SegmentFieldDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'SegmentField', 'ProviderSegment'];

    function SegmentFieldDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, SegmentField, ProviderSegment) {
        var vm = this;

        vm.segmentField = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.providerSegments = ProviderSegment.getAsList();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.segmentField.id !== null) {
                SegmentField.update(vm.segmentField, onSaveSuccess, onSaveError);
            } else {
                SegmentField.save(vm.segmentField, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:segmentFieldUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldDetailController', SegmentFieldDetailController);

    SegmentFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'SegmentField', 'ProviderSegment'];

    function SegmentFieldDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, SegmentField, ProviderSegment) {
        var vm = this;

        vm.segmentField = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:segmentFieldUpdate', function(event, result) {
            vm.segmentField = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldDeleteController',SegmentFieldDeleteController);

    SegmentFieldDeleteController.$inject = ['$uibModalInstance', 'entity', 'SegmentField'];

    function SegmentFieldDeleteController($uibModalInstance, entity, SegmentField) {
        var vm = this;

        vm.segmentField = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SegmentField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('segment-field', {
            parent: 'entity',
            url: '/segment-field?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.segmentField.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/segment-field/segment-fields.html',
                    controller: 'SegmentFieldController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                label: null,
                providerName: null,
                providerSegment: null,
                name: null,
                type: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        label: $stateParams.label,
                        providerName: $stateParams.providerName,
                        providerSegment: $stateParams.providerSegment,
                        name: $stateParams.name,
                        type: $stateParams.type
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('segmentField');
                    $translatePartialLoader.addPart('fieldType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('segment-field-detail', {
            parent: 'segment-field',
            url: '/segment-field/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.segmentField.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/segment-field/segment-field-detail.html',
                    controller: 'SegmentFieldDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('segmentField');
                    $translatePartialLoader.addPart('fieldType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SegmentField', function($stateParams, SegmentField) {
                    return SegmentField.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'segment-field',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('segment-field-detail.edit', {
            parent: 'segment-field-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field/segment-field-dialog.html',
                    controller: 'SegmentFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SegmentField', function(SegmentField) {
                            return SegmentField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('segment-field.new', {
            parent: 'segment-field',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field/segment-field-dialog.html',
                    controller: 'SegmentFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                name: null,
                                type: null,
                                value: null,
                                minLength: null,
                                maxLength: null,
                                min: null,
                                max: null,
                                format: null,
                                pattern: null,
                                hidden: false,
                                required: false,
                                prefixesJson: null,
                                position: null,
                                segmentFieldOptionId: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('segment-field', null, { reload: 'segment-field' });
                }, function() {
                    $state.go('segment-field');
                });
            }]
        })
        .state('segment-field.edit', {
            parent: 'segment-field',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field/segment-field-dialog.html',
                    controller: 'SegmentFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SegmentField', function(SegmentField) {
                            return SegmentField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('segment-field', null, { reload: 'segment-field' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('segment-field.delete', {
            parent: 'segment-field',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/segment-field/segment-field-delete-dialog.html',
                    controller: 'SegmentFieldDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SegmentField', function(SegmentField) {
                            return SegmentField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('segment-field', null, { reload: 'segment-field' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('SegmentField', SegmentField)
        .factory('ProviderSegmentField', ProviderSegmentField);

    SegmentField.$inject = ['$resource', 'DateUtils'];

    function SegmentField ($resource, DateUtils) {
        var resourceUrl =  'api/segment-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    ProviderSegmentField.$inject = ['$resource'];
    function ProviderSegmentField ($resource) {
        var resourceUrl =  'api/provider-segments/:id/segment-fields';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldController', SegmentFieldController);

    SegmentFieldController.$inject = ['$state', 'DataUtils', 'SegmentField', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SegmentFieldController($state, DataUtils, SegmentField, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            label: pagingParams.label,
            providerName: pagingParams.providerName,
            providerSegment: pagingParams.providerSegment,
            name: pagingParams.name,
            type: pagingParams.type
        };

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            SegmentField.query({
                label: pagingParams.label,
                providerName: pagingParams.providerName,
                providerSegment: pagingParams.providerSegment,
                name: pagingParams.name,
                type: pagingParams.type,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.segmentFields = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                label: vm.searchQuery.label,
                providerName: vm.searchQuery.providerName,
                providerSegment: vm.searchQuery.providerSegment,
                name: vm.searchQuery.name,
                type: vm.searchQuery.type,
                firstRun: false
            });
        }

        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                label: null,
                providerName: null,
                providerSegment: null,
                name: null,
                type: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderSegmentDialogController', ProviderSegmentDialogController);

    ProviderSegmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProviderSegment', 'Provider', 'ProviderSegmentField'];

    function ProviderSegmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProviderSegment, Provider, ProviderSegmentField) {
        var vm = this;

        vm.providerSegment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.providers = Provider.getAsList();
        vm.providerSegments = vm.providerSegment.providerId?ProviderSegment.getAllByProvider({id: vm.providerSegment.providerId}):[];
        vm.providerSegmentFields = vm.providerSegment.id == null ? [] : ProviderSegmentField.get({id: vm.providerSegment.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.providerSegment.id !== null) {
                ProviderSegment.update(vm.providerSegment, onSaveSuccess, onSaveError);
            } else {
                ProviderSegment.save(vm.providerSegment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerSegmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderSegmentDetailController', ProviderSegmentDetailController);

    ProviderSegmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProviderSegment', 'Provider'];

    function ProviderSegmentDetailController($scope, $rootScope, $stateParams, previousState, entity, ProviderSegment, Provider) {
        var vm = this;

        vm.providerSegment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerSegmentUpdate', function(event, result) {
            vm.providerSegment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderSegmentDeleteController',ProviderSegmentDeleteController);

    ProviderSegmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProviderSegment'];

    function ProviderSegmentDeleteController($uibModalInstance, entity, ProviderSegment) {
        var vm = this;

        vm.providerSegment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProviderSegment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider-segment', {
            parent: 'entity',
            url: '/provider-segment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.providerSegment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-segment/provider-segments.html',
                    controller: 'ProviderSegmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                name: null,
                providerName: null,
                partnerServiceId: null,
                accountFieldId: null,
                amountCharge: null,
                amountField: null,
                type: null,
                mode: null,
                status: null,
                firstRun: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        name: $stateParams.name,
                        providerName: $stateParams.providerName,
                        partnerServiceId: $stateParams.partnerServiceId,
                        accountFieldId: $stateParams.accountFieldId,
                        amountCharge: $stateParams.amountCharge,
                        amountField: $stateParams.amountField,
                        type: $stateParams.type,
                        mode: $stateParams.mode,
                        status: $stateParams.status,
                        firstRun: $stateParams.firstRun
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('providerSegment');
                    $translatePartialLoader.addPart('providerStatus');
                    $translatePartialLoader.addPart('providerSegmentType');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-segment.edit', {
            parent: 'provider-segment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-segment/provider-segment-dialog.html',
                    controller: 'ProviderSegmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProviderSegment', function(ProviderSegment) {
                            return ProviderSegment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider-segment', null, { reload: 'provider-segment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-segment.new', {
            parent: 'provider-segment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-segment/provider-segment-dialog.html',
                    controller: 'ProviderSegmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                segmentField: null
                            }
                        }
                    }
                }).result.then(function() {
                    $state.go('provider-segment', null, { reload: 'provider-segment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProviderSegment', ProviderSegment);

    ProviderSegment.$inject = ['$resource', 'DateUtils'];

    function ProviderSegment($resource, DateUtils) {
        var resourceUrl = 'api/provider-segments/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-segment-list'
            },
            'getAllByProvider': {
                method: 'GET',
                isArray: true,
                url: 'api/providers/:id/provider-segments'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderSegmentController', ProviderSegmentController);

    ProviderSegmentController.$inject = ['$state', 'ProviderSegment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderSegmentController($state, ProviderSegment, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            name: pagingParams.name,
            providerName: pagingParams.providerName,
            partnerServiceId: pagingParams.partnerServiceId,
            accountFieldId: pagingParams.accountFieldId,
            amountCharge: pagingParams.amountCharge,
            amountField: pagingParams.amountField,
            type: pagingParams.type,
            mode: pagingParams.mode,
            status: pagingParams.status
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll() {
            ProviderSegment.query({
                name: pagingParams.name,
                providerName: pagingParams.providerName,
                partnerServiceId: pagingParams.partnerServiceId,
                accountFieldId: pagingParams.accountFieldId,
                amountCharge: pagingParams.amountCharge,
                amountField: pagingParams.amountField,
                type: pagingParams.type,
                mode: pagingParams.mode,
                status: pagingParams.status,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providerSegments = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                name: vm.searchQuery.name,
                providerName: vm.searchQuery.providerName,
                partnerServiceId: vm.searchQuery.partnerServiceId,
                accountFieldId: vm.searchQuery.accountFieldId,
                amountCharge: vm.searchQuery.amountCharge,
                amountField: vm.searchQuery.amountField,
                type: vm.searchQuery.type,
                mode: vm.searchQuery.mode,
                status: vm.searchQuery.status,
                firstRun: false
            });
        }

        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                name: null,
                providerName: null,
                partnerServiceId: null,
                accountFieldId: null,
                amountCharge: null,
                amountField: null,
                type: null,
                mode: null,
                status: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryDialogController', ProviderCountryDialogController);

    ProviderCountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProviderCountry'];

    function ProviderCountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProviderCountry) {
        var vm = this;

        vm.providerCountry = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.providerCountry.id !== null) {
                ProviderCountry.update(vm.providerCountry, onSaveSuccess, onSaveError);
            } else {
                ProviderCountry.save(vm.providerCountry, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerCountryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryDetailController', ProviderCountryDetailController);

    ProviderCountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProviderCountry'];

    function ProviderCountryDetailController($scope, $rootScope, $stateParams, previousState, entity, ProviderCountry) {
        var vm = this;

        vm.providerCountry = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerCountryUpdate', function(event, result) {
            vm.providerCountry = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryDeleteController',ProviderCountryDeleteController);

    ProviderCountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProviderCountry'];

    function ProviderCountryDeleteController($uibModalInstance, entity, ProviderCountry) {
        var vm = this;

        vm.providerCountry = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProviderCountry.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider-country', {
            parent: 'entity',
            url: '/provider-country?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.providerCountry.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-country/provider-countries.html',
                    controller: 'ProviderCountryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('providerCountry');
                    $translatePartialLoader.addPart('providerStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-country-detail', {
            parent: 'provider-country',
            url: '/provider-country/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.providerCountry.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-country/provider-country-detail.html',
                    controller: 'ProviderCountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('providerCountry');
                    $translatePartialLoader.addPart('providerStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProviderCountry', function($stateParams, ProviderCountry) {
                    return ProviderCountry.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provider-country',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provider-country-detail.edit', {
            parent: 'provider-country-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-country/provider-country-dialog.html',
                    controller: 'ProviderCountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProviderCountry', function(ProviderCountry) {
                            return ProviderCountry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-country.new', {
            parent: 'provider-country',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-country/provider-country-dialog.html',
                    controller: 'ProviderCountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                status: null,
                                flagImage: null,
                                isFavourite: null,
                                position: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('provider-country', null, { reload: 'provider-country' });
                }, function() {
                    $state.go('provider-country');
                });
            }]
        })
        .state('provider-country.edit', {
            parent: 'provider-country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-country/provider-country-dialog.html',
                    controller: 'ProviderCountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProviderCountry', function(ProviderCountry) {
                            return ProviderCountry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider-country', null, { reload: 'provider-country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-country.delete', {
            parent: 'provider-country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-country/provider-country-delete-dialog.html',
                    controller: 'ProviderCountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProviderCountry', function(ProviderCountry) {
                            return ProviderCountry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider-country', null, { reload: 'provider-country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProviderCountry', ProviderCountry);

    ProviderCountry.$inject = ['$resource', 'DateUtils'];

    function ProviderCountry ($resource, DateUtils) {
        var resourceUrl =  'api/provider-countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-country-list'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCountryController', ProviderCountryController);

    ProviderCountryController.$inject = ['$state', 'ProviderCountry', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderCountryController($state, ProviderCountry, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            ProviderCountry.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providerCountries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDialogController', ProviderCategoryDialogController);

    ProviderCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProviderCategory', 'ProviderCountry'];

    function ProviderCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProviderCategory, ProviderCountry) {
        var vm = this;

        vm.providerCategory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.providercountries = ProviderCountry.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.providerCategory.id !== null) {
                ProviderCategory.update(vm.providerCategory, onSaveSuccess, onSaveError);
            } else {
                ProviderCategory.save(vm.providerCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDetailController', ProviderCategoryDetailController);

    ProviderCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProviderCategory', 'ProviderCountry'];

    function ProviderCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, ProviderCategory, ProviderCountry) {
        var vm = this;

        vm.providerCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerCategoryUpdate', function(event, result) {
            vm.providerCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDeleteController',ProviderCategoryDeleteController);

    ProviderCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProviderCategory'];

    function ProviderCategoryDeleteController($uibModalInstance, entity, ProviderCategory) {
        var vm = this;

        vm.providerCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProviderCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider-category', {
            parent: 'entity',
            url: '/provider-category?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.providerCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-category/provider-categories.html',
                    controller: 'ProviderCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                name: null,
                countryId: null,
                status: null,
                providerId: null,
                firstRun: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        name: $stateParams.name,
                        countryId: $stateParams.countryId,
                        status: $stateParams.status,
                        providerId: $stateParams.providerId,
                        firstRun: $stateParams.firstRun
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('providerCategory');
                    $translatePartialLoader.addPart('providerStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-category.edit', {
            parent: 'provider-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-category/provider-category-dialog.html',
                    controller: 'ProviderCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProviderCategory', function(ProviderCategory) {
                            return ProviderCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provider-category', null, { reload: 'provider-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-category.new', {
            parent: 'provider-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-category/provider-category-dialog.html',
                    controller: 'ProviderCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {

                            }
                        }
                    }
                }).result.then(function() {
                    $state.go('provider-category', null, { reload: 'provider-category' });
                }, function() {
                    $state.go('provider-category');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProviderCategory', ProviderCategory);

    ProviderCategory.$inject = ['$resource', 'DateUtils'];

    function ProviderCategory($resource, DateUtils) {
        var resourceUrl = 'api/provider-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAllByCountry': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-countries/:id/categories'
            },
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-category-list'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryController', ProviderCategoryController);

    ProviderCategoryController.$inject = ['$state', 'ProviderCategory', 'ProviderCountry', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderCategoryController($state, ProviderCategory, ProviderCountry, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.providerCountries = ProviderCountry.getAsList();
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            countryId: pagingParams.countryId,
            name: pagingParams.name,
            providerId: pagingParams.providerId,
            status: pagingParams.status
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            ProviderCategory.query({
                name: pagingParams.name,
                countryId: pagingParams.countryId,
                status: pagingParams.status,
                providerId: pagingParams.providerId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providerCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                name: vm.searchQuery.name,
                countryId: vm.searchQuery.countryId,
                status: vm.searchQuery.status,
                providerId: vm.searchQuery.providerId,
                firstRun: false
            });
        }
        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                name: null,
                countryId: null,
                status: null,
                providerId: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderDialogController', ProviderDialogController);

    ProviderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provider', 'ProviderCategory'];

    function ProviderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Provider, ProviderCategory) {
        var vm = this;

        vm.provider = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.providerCategories = ProviderCategory.getAsList();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.provider.id !== null) {
                Provider.update(vm.provider, onSaveSuccess, onSaveError);
            } else {
                Provider.save(vm.provider, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderDetailController', ProviderDetailController);

    ProviderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provider', 'ProviderCategory'];

    function ProviderDetailController($scope, $rootScope, $stateParams, previousState, entity, Provider, ProviderCategory) {
        var vm = this;

        vm.provider = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerUpdate', function(event, result) {
            vm.provider = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderDeleteController',ProviderDeleteController);

    ProviderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provider'];

    function ProviderDeleteController($uibModalInstance, entity, Provider) {
        var vm = this;

        vm.provider = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provider.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('provider', {
                parent: 'entity',
                url: '/provider?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.provider.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/provider/providers.html',
                        controller: 'ProviderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    name: null,
                    categoryId: null,
                    gateway: null,
                    status: null,
                    providerId: null,
                    firstRun: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            name: $stateParams.name,
                            categoryId: $stateParams.categoryId,
                            gateway: $stateParams.gateway,
                            status: $stateParams.status,
                            providerId: $stateParams.providerId,
                            firstRun: $stateParams.firstRun
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('provider');
                        $translatePartialLoader.addPart('providerStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('provider.edit', {
                parent: 'provider',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/provider/provider-dialog.html',
                        controller: 'ProviderDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Provider', function(Provider) {
                                return Provider.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('provider', null, { reload: 'provider' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('provider.new', {
                parent: 'provider',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/provider/provider-dialog.html',
                        controller: 'ProviderDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    shouldDisplayName: false
                                }
                            }
                        }
                    }).result.then(function() {
                        $state.go('provider', null, { reload: 'provider' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Provider', Provider);

    Provider.$inject = ['$resource', 'DateUtils'];

    function Provider($resource, DateUtils) {
        var resourceUrl = 'api/providers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-list'
            },
            'getAllByCategory': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-categories/:id/providers'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderController', ProviderController);

    ProviderController.$inject = ['$state', 'Provider', 'ProviderCategory', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProviderController($state, Provider, ProviderCategory, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.providerCategories = ProviderCategory.getAsList();
        vm.loadAll = loadAll;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            name: pagingParams.name,
            categoryId: pagingParams.categoryId,
            gateway: pagingParams.gateway,
            status: pagingParams.status,
            providerId: pagingParams.providerId
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            Provider.query({
                name: pagingParams.name,
                categoryId: pagingParams.categoryId,
                gateway: pagingParams.gateway,
                status: pagingParams.status,
                providerId: pagingParams.providerId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.providers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                name: vm.searchQuery.name,
                categoryId: vm.searchQuery.categoryId,
                gateway: vm.searchQuery.gateway,
                status: vm.searchQuery.status,
                providerId: vm.searchQuery.providerId,
                firstRun: false
            });
        }

        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                name: null,
                categoryId: null,
                gateway: null,
                status: null,
                providerId: null
            };
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTransferLimitController', ProfileTransferLimitController);

    ProfileTransferLimitController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', 'previousState', 'entity', 'CustomerTransferLimit'];

    function ProfileTransferLimitController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, previousState, entity, CustomerTransferLimit) {
        var vm = this;

        vm.profile = entity;
        var monthKeys = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun',
            'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];

        function loadMonthNames() {
            var translateKeys = monthKeys.map(function (key) {
                return 'profile.detail.months.' + key;
            });

            $translate(translateKeys).then(function (translations) {
                vm.monthNames = monthKeys.map(function (key) {
                    return translations['profile.detail.months.' + key];
                });

                var now = new Date();
                var currentMonthName = vm.monthNames[now.getMonth()];

                vm.now = now;
                vm.startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                vm.endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                vm.monthStart = vm.startOfMonth.getDate() + ' ' + currentMonthName;
                vm.monthEnd = vm.endOfMonth.getDate() + ' ' + currentMonthName;
            });
        }

        loadMonthNames();

        var translateWatcher = $rootScope.$on('$translateChangeSuccess', function () {
            loadMonthNames();
        });

        $scope.$on('$destroy', function () {
            translateWatcher();
        });

        loadAll();

        function loadAll() {
            CustomerTransferLimit.get({
                id: vm.profile.customerId,
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.dailyTransferCount = data.dailyTransferCount;
                vm.monthlyTransferAmount = data.monthlyTransferAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProfileTransaction', ProfileTransaction)
        .factory('ProfileTransfer', ProfileTransfer)
        .factory('ProfileTkbCard', ProfileTkbCard)
        .factory('ProfileUniredPayment', ProfileUniredPayment)
        .factory('ProfileUzbCards', ProfileUzbCards)
        .factory('ProfileTransactionAmount', ProfileTransactionAmount)
        .factory('ProfileTransferAmount', ProfileTransferAmount);

    ProfileTransaction.$inject = ['$resource'];

    function ProfileTransaction($resource) {
        var resourceUrl = 'api/profile-transaction-history';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileTransfer.$inject = ['$resource'];

    function ProfileTransfer($resource) {
        var resourceUrl = 'api/profile-transfer-history';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileTkbCard.$inject = ['$resource'];

    function ProfileTkbCard($resource) {
        var resourceUrl = 'api/profile-cards';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileUniredPayment.$inject = ['$resource'];

    function ProfileUniredPayment($resource) {
        var resourceUrl = 'api/profile-unired-payments';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }


    ProfileUzbCards.$inject = ['$resource'];

    function ProfileUzbCards($resource) {
        var resourceUrl = 'api/profile-receiver-cards';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileTransactionAmount.$inject = ['$resource'];

    function ProfileTransactionAmount($resource) {
        var resourceUrl = 'api/profiles/:profileId/total-transaction-amount';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false }
        });
    }

    ProfileTransferAmount.$inject = ['$resource'];

    function ProfileTransferAmount($resource) {
        var resourceUrl = 'api/profiles/:profileId/total-transfer-amount';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTransactionController', ProfileTransactionController);

    ProfileTransactionController.$inject = ['$scope', '$state', '$uibModal', 'entity', 'ProfileTransaction', 'ProfileTransfer', 'ProfileTkbCard', 'ProfileUniredPayment', 'ProfileUzbCards', 'ProfileTransactionAmount', 'ProfileTransferAmount', 'ParseLinks', 'AlertService', 'pagingParams', 'DateUtils', 'DataUtils', 'TkbTransfer', 'TkbPayment'];

    function ProfileTransactionController($scope, $state, $uibModal, entity, ProfileTransaction, ProfileTransfer, ProfileTkbCard, ProfileUniredPayment, ProfileUzbCards, ProfileTransactionAmount, ProfileTransferAmount, ParseLinks, AlertService, pagingParams, DateUtils, DataUtils, TkbTransfer, TkbPayment) {
        var vm = this;

        vm.profile = entity;
        vm.itemsPerPage = 20;
        vm.activeTab = pagingParams.activeTab;
        vm.activateTab = activateTab;

        vm.predicateTranHist = pagingParams.predicateTranHist;
        vm.reverseTranHist = pagingParams.ascendingTranHist;
        vm.transitionTranHist = transitionTranHist;
        vm.loadAllTranHist = loadAllTranHist;

        vm.predicateTransfer = pagingParams.predicateTransfer;
        vm.reverseTransfer = pagingParams.ascendingTransfer;
        vm.transitionTransfer = transitionTransfer;
        vm.loadAllTransfers = loadAllTransfers;

        vm.predicateTkbCard = pagingParams.predicateTkbCard;
        vm.reverseTkbCard = pagingParams.ascendingTkbCard;
        vm.transitionTkbCard = transitionTkbCard;
        vm.loadAllTkbCard = loadAllTkbCard;
        vm.predicateTkbPayment = pagingParams.predicateTkbPayment;
        vm.reverseTkbPayment = pagingParams.ascendingTkbPayment;
        vm.predicateUzbCards = pagingParams.predicateUzbCards;
        vm.reverseUzbCards = pagingParams.ascendingUzbCards;
        vm.transitionTkbPayment = transitionTkbPayment;
        vm.loadAllTkbPayment = loadAllTkbPayment;
        vm.loadAllUzbCards = loadAllUzbCards;
        vm.transitionUzbCards = transitionUzbCards;
        vm.dateDiff = DateUtils.transactionDateDifference;
        vm.getDirectAmount = DataUtils.getDirectAmount;
        vm.getSentAmount = DataUtils.getSentAmount;
        vm.getCurrencyNameForClient = DataUtils.getCurrencyNameForClient;
        vm.getCurrencySymbolForClient = DataUtils.getCurrencySymbolForClient;
        vm.checkList = [];
        vm.getTransferState = getTransferState;
        vm.confirmTransfer = confirmTransfer;
        vm.getPaymentState = getPaymentState;
        vm.confirmPayment = confirmPayment;
        vm.initPopover = initPopover;
        vm.initCreditPopover = initCreditPopover;
        vm.initPaymentPopover = initPaymentPopover;
        vm.initPaymentCreditPopover = initPaymentCreditPopover;
        vm.openTransferInfo = openTransferInfo;
        vm.openSenderCardDeleteModal = openSenderCardDeleteModal;
        vm.openPaymentInfo = openPaymentInfo;
        vm.openUzbCardEditModal = openUzbCardEditModal;

        loadAllTransfers();
        loadAllTranHist();
        loadAllTkbCard();
        loadAllTkbPayment();
        loadAllUzbCards();
        getTotalTransactionAmount();
        getTotalTransferAmount();

        function loadAllTranHist() {
            ProfileTransaction.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTranHist - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc')];
                if (vm.predicateTranHist !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTranHist = ParseLinks.parse(headers('link'));
                vm.totalItemsTranHist = headers('X-Total-Count');
                vm.queryCountTranHist = vm.totalItemsTranHist;
                vm.transactionHistories = data;
                vm.pageTranHist = pagingParams.pageTranHist;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTranHist() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTransfers() {
            ProfileTransfer.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTransfer - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc')];
                if (vm.predicateTransfer !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTransfer = ParseLinks.parse(headers('link'));
                vm.totalItemsTransfer = headers('X-Total-Count');
                vm.queryCountTransfer = vm.totalItemsTransfer;
                vm.transfers = data;
                vm.pageTransfer = pagingParams.pageTransfer;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTransfer() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTkbCard() {
            ProfileTkbCard.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTkbCard - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc')];
                if (vm.predicateTkbCard !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTkbCard = ParseLinks.parse(headers('link'));
                vm.totalItemsTkbCard = headers('X-Total-Count');
                vm.queryCountTkbCard = vm.totalItemsTkbCard;
                vm.tkbCards = data;
                vm.pageTkbCard = pagingParams.pageTkbCard;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTkbCard() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTkbPayment() {
            ProfileUniredPayment.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTkbPayment - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc')];
                if (vm.predicateTkbPayment !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTkbPayment = ParseLinks.parse(headers('link'));
                vm.totalItemsTkbPayment = headers('X-Total-Count');
                vm.queryCountTkbPayment = vm.totalItemsTkbPayment;
                vm.tkbPayments = data;
                vm.tkbPayments.forEach(function (payment) {
                    if (payment.fieldJson) {
                        var parsed = JSON.parse(payment.fieldJson);
                        payment.description = parsed.description;
                    }
                });
                vm.pageTkbPayment = pagingParams.pageTkbPayment;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTkbPayment() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbPayment: vm.pageTkbPayment,
                sortTkbPayment: vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllUzbCards() {
            ProfileUzbCards.query({
                profileId: vm.profile.id,
                page: pagingParams.pageUzbCards - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateUzbCards + ',' + (vm.reverseUzbCards ? 'asc' : 'desc')];
                if (vm.predicateUzbCards !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksUzbCards = ParseLinks.parse(headers('link'));
                vm.totalItemsUzbCards = headers('X-Total-Count');
                vm.queryCountUzbCards = vm.totalItemsUzbCards;
                vm.uzbCards = data;
                vm.pageUzbCards = pagingParams.pageUzbCards;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionUzbCards() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbPayment: vm.pageTkbPayment,
                sortTkbPayment: vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc'),
                pageUzbCards: vm.pageUzbCards,
                sortUzbCards: vm.predicateUzbCards + ',' + (vm.reverseUzbCards ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function activateTab(tab) {
            vm.activeTab = tab;
        }

        function getTotalTransactionAmount() {
            ProfileTransactionAmount.query({
                profileId: vm.profile.id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalTransactionAmount = data.totalAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getTotalTransferAmount() {
            ProfileTransferAmount.query({
                profileId: vm.profile.id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalTransferAmount = data.totalTransferAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getTransferState(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.getTransferState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmTransfer(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.confirmTransfer({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function getPaymentState(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.getPaymentState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmPayment(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.confirmPayment({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function initPopover($event, transfer) {
            if (!transfer.message) {
                return;
            }
            var message = transfer.message;
            var elementId = transfer.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + message + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initCreditPopover($event, transfer) {
            if (!transfer.creditMessage) {
                return;
            }
            var creditMessage = transfer.creditMessage;
            var elementId = transfer.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initPaymentPopover($event, payment) {
            if (!payment.errorMessage) {
                return;
            }
            var errorMessage = payment.errorMessage;
            var elementId = payment.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + errorMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initPaymentCreditPopover($event, payment) {
            if (!payment.creditDescription) {
                return;
            }
            var creditMessage = payment.creditDescription;
            var elementId = payment.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function copyPopoverText() {
            var textElement = document.getElementById('popover-text');
            if (!textElement) return;

            var textArea = document.createElement('textarea');
            textArea.value = textElement.innerText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        function openTransferInfo(id) {
            var transfer = vm.transfers.find(function (item) {
                return item.id === id;
            });
            $uibModal.open({
                templateUrl: 'app/entities/tkb-transfer/tkb-transfer-info-dialog.html',
                controller: 'TkbTransferInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-infopenTrao-dialog-xl',
                resolve: {
                    entity: transfer,
                    myID: ['MyID', function (MyID) {
                        if (transfer.myIDId) {
                            return MyID.get({id: transfer.myIDId}).$promise;
                        } else {
                            return null;
                        }
                    }],
                    customer: ['Customer', function (Customer) {
                        return Customer.get({id: transfer.userId}).$promise;
                    }]
                },

            });
        }

        function openSenderCardDeleteModal(cardId) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/tkb-card/tkb-card-delete-dialog.html',
                controller: 'TkbCardDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['TkbCard', function (TkbCard) {
                        return TkbCard.get({id: cardId}).$promise;
                    }]
                }
            });
            modalInstance.result.then(function () {
                if (cardId) {
                    var newCards = [];
                    angular.forEach(vm.tkbCards, function (card) {
                        if (card.id !== cardId) {
                            newCards.push(card);
                        }
                    });
                    vm.tkbCards = newCards;
                }
            });
        }

        function openPaymentInfo(id) {
            $uibModal.open({
                templateUrl: 'app/entities/tkb-payment/tkb-payment-info-dialog.html',
                controller: 'TkbPaymentInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-info-dialog-xl',
                resolve: {
                    entity: ['TkbPayment', function(TkbPayment) {
                        return TkbPayment.paymentInfo({ paymentId: id }).$promise;
                    }]
                }
            });
        }

        function openUzbCardEditModal(id) {
            $uibModal.open({
                templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                controller: 'UzbCardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['UzbCard', function(UzbCard) {
                        return UzbCard.get({ id: id }).$promise;
                    }]
                }
            }).result.then(function() {
                loadAllUzbCards();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTicketOrdersController', ProfileTicketOrdersController);

    ProfileTicketOrdersController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', '$uibModal', 'entity', 'TicketPayment'];

    function ProfileTicketOrdersController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, $uibModal, entity, TicketPayment) {
        var vm = this;

        vm.profile = entity;
        vm.itemsPerPage = 10;
        vm.page = 1;
        vm.maxPage = 1;
        vm.totalItems = 0;

        vm.ticketPayments = [];
        vm.loading = false;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.openTicketDetails = openTicketDetails;

        init();

        function init() {
            loadPage(1);
        }

        function buildParams(page) {
            console.log(vm.profile.customerPhone)
            var params = {
                valueInt1: page,
                size: vm.itemsPerPage,
                field: vm.profile.customerPhone
            };

            Object.keys(params).forEach(function (k) {
                if (params[k] === null || params[k] === undefined || params[k] === '') {
                    delete params[k];
                }
            });

            return params;
        }

        function loadPage(page) {
            if (page < 1) page = 1;
            if (vm.maxPage && page > vm.maxPage) page = vm.maxPage;

            vm.loading = true;

            loadAll(page);
        }

        function loadAll (page) {
            TicketPayment.queryFromMySafar(buildParams(page), onSuccess, onError);
            function onSuccess(data) {

                vm.ticketPayments = data.result || [];
                vm.page = data.page || page;

                vm.totalItems = data.count || 0;
                vm.maxPage = data.max_page || Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadPage(vm.page);
        }

        function openTicketDetails(ticket) {
            $uibModal.open({
                templateUrl: 'app/entities/ticket-payment/ticket-order-detail-dialog.html',
                controller: 'TicketOrderDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'ticket-order-detail-dialog-xl',
                resolve: {
                    selectedTicket: ticket
                }
            });
        }

    }
})();

/**
 * Created by Gayratjon Rayimjonov on 9/22/2017.
 */
(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileStatusDialogController', ProfileStatusDialogController);

    ProfileStatusDialogController.$inject = ['$scope', '$timeout', '$uibModalInstance', 'entity', 'CustomerStatusLogs'];

    function ProfileStatusDialogController($scope, $timeout, $uibModalInstance, entity, CustomerStatusLogs) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.getStatusOptions = getStatusOptions;
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.customerStatusLogs = {
                profileId:vm.profile.id,
                changeReason: vm.reason,
                status: vm.customerStatus
            };

            CustomerStatusLogs.save(vm.customerStatusLogs, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.profile.customerFullName = result.fullName;
            vm.profile.customerStatus = result.status;
            vm.profile.accountNo = result.accountNo;
            vm.profile.balance = result.balance;
            vm.profile.totalMileage = result.totalMileage;
            if (result.bankId == 0) {
                vm.profile.customerBank = 'Bozoraka';
            }
            $scope.$emit('bozorakaAdminApp:profileUpdate', vm.profile);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getStatusOptions() {
            if (vm.profile.customerStatus == 'ACTIVE') {
                return ['DEACTIVATED', 'BANNED'];
            } else if (vm.profile.customerStatus == 'DEACTIVATED') {
                return ['ACTIVE', 'BANNED'];
            } else if (vm.profile.customerStatus == 'BANNED') {
                return ['REACTIVATED'];
            } else {
                return [];
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationDialogController', ProfileNotificationDialogController);

    ProfileNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'languages', 'CustomerNotification', 'Profile'];

    function ProfileNotificationDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, languages, CustomerNotification, Profile) {
        var vm = this;

        vm.profileId = $stateParams.id;
        vm.notification = entity;
        vm.languages = languages;
        vm.clear = clear;
        defineCustomerId();
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.language = {
            'en': {
                label: 'English',
                check: false,
                title: null,
                message: null
            },
            'ru': {
                label: 'Russian',
                check: false,
                title: null,
                message: null
            },
            'uz': {
                label: 'Uzbek',
                check: false,
                title: null,
                message: null
            },
            'tj': {
                label: 'Tоҷикӣ',
                check: false,
                title: null,
                message: null
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function defineCustomerId() {
            Profile.get({id: vm.profileId}).$promise.then(function (profile) {
                vm.notification.customerId = profile.customerId;
            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.notification.id !== null) {
                CustomerNotification.update(vm.notification, onSaveSuccess, onSaveError);
            } else {
                    vm.languages.forEach(function (languageKey) {
                    if (vm.language[languageKey].check === true) {
                        console.log(vm.language[languageKey].title);
                        vm.notification.title = vm.language[languageKey].title;
                        vm.notification.message = vm.language[languageKey].message;
                        vm.notification.language = languageKey;
                        vm.isSaving = true;
                        var notificationForLanguage = {
                            title: vm.language[languageKey].title,
                            message: vm.language[languageKey].message,
                            language: languageKey,
                            eventType: 'MESSAGE',
                            url: vm.notification.url,
                            readStatus: false,
                            status: vm.notification.status,
                            deleted: false,
                            pushDate: vm.notification.pushDate,
                            expiryDate: vm.notification.expiryDate,
                            customerId: vm.notification.customerId
                        }
                        CustomerNotification.save(notificationForLanguage, onSaveSuccess, onSaveError);
                    }
                });
            }
        }


        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:notificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;

        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationDetailController', ProfileNotificationDetailController);

    ProfileNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity'];

    function ProfileNotificationDetailController($scope, $rootScope, $stateParams, $uibModalInstance, entity) {
        var vm = this;

        vm.customerNotification = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:customerNotificationUpdate', function(event, result) {
            vm.customerNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationDeleteController', ProfileNotificationDeleteController);

    ProfileNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerNotification'];

    function ProfileNotificationDeleteController($uibModalInstance, entity, CustomerNotification) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomerNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProfileNotification', ProfileNotification);

    ProfileNotification.$inject = ['$resource'];

    function ProfileNotification($resource) {
        var resourceUrl = 'api/profiles/:profileId/notifications';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationController', ProfileNotificationController);

    ProfileNotificationController.$inject = ['$state', 'entity', 'ProfileNotification', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'FirebaseToken'];

    function ProfileNotificationController($state, entity, ProfileNotification, ParseLinks, AlertService, paginationConstants, pagingParams, FirebaseToken) {

        var vm = this;

        vm.profile = entity;
        vm.languages = FirebaseToken.getByProfile({profileId: vm.profile.id});
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateNotification;
        vm.reverse = pagingParams.ascendingNotification;
        vm.transition = transition;
        vm.itemsPerPage = 50;

        loadAll();

        function loadAll () {
            ProfileNotification.query({
                profileId: vm.profile.id,
                page: pagingParams.pageNotification - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notifications = data;
                vm.page = pagingParams.pageNotification;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageNotification: vm.page,
                sortNotification: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', 'previousState', 'entity', 'Profile', 'Customer', 'DataUtils', 'CustomerStatusLogs', 'Chat'];

    function ProfileDetailController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, previousState, entity, Profile, Customer, DataUtils, CustomerStatusLogs, Chat) {
        var vm = this;

        vm.profile = entity;
        vm.previousState = previousState.name;
        vm.save = save;
        vm.openChat = openChat;
        vm.getCustomerChatByCustomerId = getCustomerChatByCustomerId;
        vm.getCustomerStatusLogsByCustomerId = getCustomerStatusLogsByCustomerId;
        vm.getCurrencyNameForClient = DataUtils.getCurrencyNameForClient;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:profileUpdate', function (event, result) {
            vm.profile = result;
        });

        $scope.$on('$destroy', unsubscribe);
        getCustomerStatusLogsByCustomerId();
        getCustomerChatByCustomerId();

        vm.dateOfBirth = new Date(vm.profile.customerDateOfBirth);

        loadNationalities();

        function save() {
            vm.customer = {
                id: vm.profile.customerId,
                fullName: vm.profile.customerFullName,
                status: vm.profile.customerStatus,
                dateOfBirth: vm.dateOfBirth,
                gender: vm.profile.customerGender,
                passportNumber: vm.profile.passportNumber,
                allowAnyIp: vm.profile.allowAnyIp
            };
            vm.isSaving = true;
            if (vm.profile.customerId !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.profile.customerFullName = result.fullName;
            vm.profile.customerStatus = result.status;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getCustomerChatByCustomerId() {
            Chat.getByCustomerId({customerId: vm.profile.customerId}, function (data) {
                if(!data){
                    vm.customerChat = [];
                } else {
                    vm.customerChat = data;
                }
            });
        }

        function openChat() {
            $window.open('/#/chat/' +  vm.customerChat.chatId, '_blank');
        }

        function getCustomerStatusLogsByCustomerId() {
            CustomerStatusLogs.query({customerId: vm.profile.customerId}, function (data) {
                vm.customerStatusLogs = data;
            });
        }

        function loadNationalities() {
            $http.get('i18n/' + $translate.use() + '/nationalityList.json').success(function (nationalities) {
                vm.nationalities = nationalities;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileChangePhoneDialogController', ProfileChangePhoneDialogController);

    ProfileChangePhoneDialogController.$inject = ['$scope', '$timeout', '$uibModalInstance', 'entity', 'ProfileChangePhone', 'AlertService'];

    function ProfileChangePhoneDialogController($scope, $timeout, $uibModalInstance, entity, ProfileChangePhone, AlertService) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isValidPhonePrefix = isValidPhonePrefix;
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.changePhone = {
                phone: vm.newPhone,
                profileId: vm.profile.id
            };

            ProfileChangePhone.update(vm.changePhone, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.profile.customerFullName = result.fullName;
            vm.profile.customerStatus = result.status;
            vm.profile.accountNo = result.accountNo;
            vm.profile.balance = result.balance;
            vm.profile.totalMileage = result.totalMileage;
            vm.profile.customerPhone = result.phone;

            $scope.$emit('bozorakaAdminApp:profileUpdate', vm.profile);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function isValidPhonePrefix() {
            return !(vm.newPhone.startsWith('010') || vm.newPhone.startsWith('7'));
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('profile', {
                parent: 'entity',
                url: '/profile?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'],
                    pageTitle: 'global.menu.user.information'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profiles.html',
                        controller: 'ProfileController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    field: null,
                    fromDate: null,
                    toDate: null,
                    status: null,
                    passportNumber: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            field: $stateParams.field,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            status: $stateParams.status,
                            passportNumber: $stateParams.passportNumber,
                            firstRun: $stateParams.firstRun
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('profile-detail', {
                parent: 'entity',
                url: '/profile/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'],
                    pageTitle: 'bozorakaAdminApp.profile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profile-detail.html',
                        controller: 'ProfileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Profile', function ($stateParams, Profile) {
                        return Profile.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'profile',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('profile-transaction', {
                parent: 'entity',
                url: '/profile/{id}/transactions?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'],
                    pageTitle: 'bozorakaAdminApp.profile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profile-transaction.html',
                        controller: 'ProfileTransactionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    pageTranHist: {
                        value: '1',
                        squash: true
                    },
                    sortTranHist: {
                        value: 'pubDate,desc',
                        squash: true
                    },
                    pageTransfer: {
                        value: '1',
                        squash: true
                    },
                    sortTransfer: {
                        value: 'id,desc',
                        squash: true
                    },
                    pageTkbCard: {
                        value: '1',
                        squash: true
                    },
                    sortTkbCard: {
                        value: 'id,desc',
                        squash: true
                    },
                    pageTkbPayment: {
                        value: '1',
                        squash: true
                    },
                    sortTkbPayment: {
                        value: 'id,desc',
                        squash: true
                    },
                    pageUzbCards: {
                        value: '1',
                        squash: true
                    },
                    sortUzbCards: {
                        value: 'id,desc',
                        squash: true
                    },
                    activeTab: 'tab_1'
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            pageTranHist: PaginationUtil.parsePage($stateParams.pageTranHist),
                            sortTranHist: $stateParams.sortTranHist,
                            predicateTranHist: PaginationUtil.parsePredicate($stateParams.sortTranHist),
                            ascendingTranHist: PaginationUtil.parseAscending($stateParams.sortTranHist),
                            pageTransfer: PaginationUtil.parsePage($stateParams.pageTransfer),
                            sortTransfer: $stateParams.sortTransfer,
                            predicateTransfer: PaginationUtil.parsePredicate($stateParams.sortTransfer),
                            ascendingTransfer: PaginationUtil.parseAscending($stateParams.sortTransfer),
                            pageTkbCard: PaginationUtil.parsePage($stateParams.pageTkbCard),
                            sortTkbCard: $stateParams.sortTkbCard,
                            predicateTkbCard: PaginationUtil.parsePredicate($stateParams.sortTkbCard),
                            ascendingTkbCard: PaginationUtil.parseAscending($stateParams.sortTkbCard),
                            pageTkbPayment: PaginationUtil.parsePage($stateParams.pageTkbPayment),
                            sortTkbPayment: $stateParams.sortTkbPayment,
                            predicateTkbPayment: PaginationUtil.parsePredicate($stateParams.sortTkbPayment),
                            ascendingTkbPayment: PaginationUtil.parseAscending($stateParams.sortTkbPayment),
                            pageUzbCards: PaginationUtil.parsePage($stateParams.pageUzbCards),
                            sortUzbCards: $stateParams.sortUzbCards,
                            predicateUzbCards: PaginationUtil.parsePredicate($stateParams.sortUzbCards),
                            ascendingUzbCards: PaginationUtil.parseAscending($stateParams.sortUzbCards),
                            activeTab: $stateParams.activeTab
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('tkbTransfer');
                        $translatePartialLoader.addPart('tkbCard');
                        $translatePartialLoader.addPart('tkbPayment');
                        $translatePartialLoader.addPart('uzbCard');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Profile', function ($stateParams, Profile) {
                        return Profile.get({id: $stateParams.id}).$promise;
                    }]
                    ,
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'profile-transaction',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('profile.new', {
                parent: 'profile',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-dialog.html',
                        controller: 'ProfileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accountNo: null,
                                    balance: null,
                                    totalMileage: null,
                                    registrationDate: null,
                                    isAgent: false,
                                    isMango: false,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('profile', null, {reload: 'profile'});
                    }, function () {
                        $state.go('profile');
                    });
                }]
            })
            .state('profile.edit', {
                parent: 'profile',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-dialog.html',
                        controller: 'ProfileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Profile', function (Profile) {
                                return Profile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile', null, {reload: 'profile'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile.delete', {
                parent: 'profile',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-delete-dialog.html',
                        controller: 'ProfileDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Profile', function (Profile) {
                                return Profile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile', null, {reload: 'profile'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile-detail.editStatus', {
                parent: 'profile-detail',
                url: '/status/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-status-dialog.html',
                        controller: 'ProfileStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Profile', function (Profile) {
                                return Profile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile-detail.changePhone', {
                    parent: 'profile-detail',
                    url: '/phone-number/edit',
                    data: {
                        authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/profile/profile-change-phone-dialog.html',
                            controller: 'ProfileChangePhoneDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                entity: ['Profile', function (Profile) {
                                    return Profile.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('^', {}, {reload: false});
                        }, function () {
                            $state.go('^');
                        });
                    }]
            })
            .state('profile-notification', {
                parent: 'entity',
                url: '/profile/{id}/notifications?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY'],
                    pageTitle: 'profile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profile-notification.html',
                        controller: 'ProfileNotificationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    sortNotification: {
                        value: 'createdDate,desc',
                        squash: true
                    },
                    pageNotification: {
                        value: 1,
                        squash: true
                    },
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            pageNotification: PaginationUtil.parsePage($stateParams.pageNotification),
                            sortNotification: $stateParams.sortNotification,
                            predicateNotification: PaginationUtil.parsePredicate($stateParams.sortNotification),
                            ascendingNotification: PaginationUtil.parseAscending($stateParams.sortNotification),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('customerNotification');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Profile', function ($stateParams, Profile) {
                        return Profile.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'profile-notification',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('profile-notification.edit', {
                parent: 'profile-notification',
                url: '/{notificationId}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-notification-dialog.html',
                        controller: 'ProfileNotificationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('customerNotification');
                                $translatePartialLoader.addPart('notificationStatus');
                                return $translate.refresh();
                            }],
                            entity: ['CustomerNotification', function (CustomerNotification) {
                                return CustomerNotification.get({id: $stateParams.notificationId}).$promise;
                            }],
                            languages: ['FirebaseToken', function (FirebaseToken) {
                                return FirebaseToken.getByProfile({profileId: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile-notification', null, {reload: 'profile-notification'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile-notification.view', {
                parent: 'profile-notification',
                url: '/{notificationId}/view',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-notification-detail.html',
                        controller: 'ProfileNotificationDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('customerNotification');
                                $translatePartialLoader.addPart('notificationStatus');
                                return $translate.refresh();
                            }],
                            entity: ['CustomerNotification', function (CustomerNotification) {
                                return CustomerNotification.get({id: $stateParams.notificationId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile-notification', null, {reload: 'profile-notification'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile-notification.new', {
                parent: 'profile-notification',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-notification-dialog.html',
                        controller: 'ProfileNotificationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('customerNotification');
                                $translatePartialLoader.addPart('notificationStatus');
                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    title: null,
                                    message: null,
                                    language: null,
                                    collapseKey: null,
                                    eventType: 'PROMO_CODE',
                                    url: null,
                                    readStatus: false,
                                    status: 'PENDING',
                                    deleted: false,
                                    pushDate: null,
                                    expiryDate: null,
                                    createdBy: null,
                                    createdDate: null,
                                    lastModifiedBy: null,
                                    lastModifiedDate: null,
                                    id: null
                                };
                            },
                            languages: ['FirebaseToken', function (FirebaseToken) {
                                return FirebaseToken.getByProfile({profileId: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile-notification', null, {reload: 'profile-notification'});
                    }, function () {
                        $state.go('profile-notification');
                    });
                }]
            })
            .state('profile-notification.delete', {
                parent: 'profile-notification',
                url: '/{notificationId}/delete',
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-notification-delete-dialog.html',
                        controller: 'ProfileNotificationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        data: {
                            authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY']
                        },
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('customerNotification');
                                return $translate.refresh();
                            }],
                            entity: ['CustomerNotification', function (CustomerNotification) {
                                return CustomerNotification.get({id: $stateParams.notificationId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('profile-notification', null, {reload: 'profile-notification'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('profile-transfer-limit', {
                parent: 'entity',
                url: '/profile/{id}/transfer-limit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY'],
                    pageTitle: 'profile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profile-transfer-limit.html',
                        controller: 'ProfileTransferLimitController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Profile', function ($stateParams, Profile) {
                        return Profile.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'profile-transfer-limit',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('profile-ticket-orders', {
                parent: 'entity',
                url: '/profile/{id}/ticket-orders',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_MARKET_MANAGER', 'ROLE_CUSTOMER_SUPPORT_BOZORAKA', 'ROLE_CUSTOMER_SUPPORT_MOBPAY'],
                    pageTitle: 'profile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/profile/profile-ticket-orders.html',
                        controller: 'ProfileTicketOrdersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Profile', function ($stateParams, Profile) {
                        return Profile.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Profile', Profile)
        .factory('CustomerStatusLogs', CustomerStatusLogs)
        .factory('ProfileChangePhone', ProfileChangePhone)
        .factory('ProfileIdByPhone', ProfileIdByPhone)
        .factory('CustomerTransferLimit', CustomerTransferLimit);

    Profile.$inject = ['$resource', 'DateUtils'];

    function Profile($resource, DateUtils) {
        var resourceUrl = 'api/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryByPhone': {method: 'GET', isArray: true, url: 'api/profiles/phone'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    CustomerStatusLogs.$inject = ['$resource'];

    function CustomerStatusLogs($resource) {
        var resourceUrl = 'api/customer-status-logs';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileChangePhone.$inject = ['$resource'];

    function ProfileChangePhone($resource) {
        var resourceUrl = 'api/customers/change-phone';
        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        })

    }

    ProfileIdByPhone.$inject = ['$resource'];

    function ProfileIdByPhone ($resource) {
        var resourceUrl =  'api/profiles/id/phone/:phoneNumber';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false}
        });
    }

    CustomerTransferLimit.$inject = ['$resource'];

    function CustomerTransferLimit ($resource) {
        var resourceUrl =  'api/customers/:id/transfer-limit';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET'}
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ProfileSearch', ProfileSearch);

    ProfileSearch.$inject = ['$resource'];

    function ProfileSearch($resource) {
        var resourceUrl = 'api/_search/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$http', '$scope', '$state', '$translate', 'Profile', 'ProfileSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DataUtils'];

    function ProfileController($http, $scope, $state, $translate, Profile, ProfileSearch, ParseLinks, AlertService, paginationConstants, pagingParams, DataUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.excel = excel;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getCurrencyNameForClient = DataUtils.getCurrencyNameForClient;
        vm.searchQuery = {
            field: pagingParams.field,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            status: pagingParams.status,
            passportNumber: pagingParams.passportNumber
        };

        initDatePicker();

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll() {
            Profile.query({
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                customerStatus: vm.searchQuery.status,
                valueString1: vm.searchQuery.passportNumber,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.profiles = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                status: vm.searchQuery.status,
                passportNumber: vm.searchQuery.passportNumber,
                firstRun: false
            });
        }

        function search(searchQuery) {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });

            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.searchQuery = {
                field: null,
                fromDate: null,
                toDate: null,
                status: "UNKNOWN"
            };
            vm.transition();
        }

        function excel() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            var data = "field=" + (!vm.searchQuery.field ? "" : vm.searchQuery.field) + "&status=" + vm.searchQuery.status + "&passportNumber=" + (!vm.searchQuery.passportNumber ? "" : vm.searchQuery.passportNumber) + "&fromDate=" + vm.searchQuery.fromDate + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/profile-stats-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'users-profile.xlsx');
            }).error(function () {
            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('DepositProfileRedirectController', DepositProfileRedirectController);

    DepositProfileRedirectController.$inject = ['$stateParams', '$location', 'ProfileIdByPhone'];

    function DepositProfileRedirectController($stateParams, $location, ProfileIdByPhone) {


        ProfileIdByPhone.get({phoneNumber: $stateParams.phone}, onSuccess);

        function onSuccess(data) {
            $location.path("profile/" + data.profileId);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDialogController', PlayIntegrityLogDialogController);

    PlayIntegrityLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.playIntegrityLog.id !== null) {
                PlayIntegrityLog.update(vm.playIntegrityLog, onSaveSuccess, onSaveError);
            } else {
                PlayIntegrityLog.save(vm.playIntegrityLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:playIntegrityLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDetailController', PlayIntegrityLogDetailController);

    PlayIntegrityLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:playIntegrityLogUpdate', function(event, result) {
            vm.playIntegrityLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDeleteController',PlayIntegrityLogDeleteController);

    PlayIntegrityLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDeleteController($uibModalInstance, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PlayIntegrityLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('play-integrity-log', {
            parent: 'entity',
            url: '/play-integrity-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.playIntegrityLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-logs.html',
                    controller: 'PlayIntegrityLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                endpoint: null,
                appLicensingVerdict: null,
                appRecognitionVerdict: null,
                deviceRecognitionVerdict: null,
                appVersionCode: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null,
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        endpoint: $stateParams.endpoint,
                        appLicensingVerdict: $stateParams.appLicensingVerdict,
                        appRecognitionVerdict: $stateParams.appRecognitionVerdict,
                        deviceRecognitionVerdict: $stateParams.deviceRecognitionVerdict,
                        appVersionCode: $stateParams.appVersionCode,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('playIntegrityLog');
                    $translatePartialLoader.addPart('playIntegrityStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('play-integrity-log-detail', {
            parent: 'play-integrity-log',
            url: '/play-integrity-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.playIntegrityLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-detail.html',
                    controller: 'PlayIntegrityLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('playIntegrityLog');
                    $translatePartialLoader.addPart('playIntegrityStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PlayIntegrityLog', function($stateParams, PlayIntegrityLog) {
                    return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'play-integrity-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('play-integrity-log-detail.edit', {
            parent: 'play-integrity-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('play-integrity-log.new', {
            parent: 'play-integrity-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                endpoint: null,
                                uuid: null,
                                phone: null,
                                nonce: null,
                                integrityToken: null,
                                responseJson: null,
                                status: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('play-integrity-log');
                });
            }]
        })
        .state('play-integrity-log.edit', {
            parent: 'play-integrity-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('play-integrity-log.delete', {
            parent: 'play-integrity-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-delete-dialog.html',
                    controller: 'PlayIntegrityLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('PlayIntegrityLog', PlayIntegrityLog);

    PlayIntegrityLog.$inject = ['$resource', 'DateUtils'];

    function PlayIntegrityLog ($resource, DateUtils) {
        var resourceUrl =  'api/play-integrity-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogController', PlayIntegrityLogController);

    PlayIntegrityLogController.$inject = ['$state', 'DataUtils', 'PlayIntegrityLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PlayIntegrityLogController($state, DataUtils, PlayIntegrityLog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.getShortJson = getShortJson;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.searchQuery = {
            phone: pagingParams.phone,
            status: pagingParams.status,
            endpoint: pagingParams.endpoint,
            appLicensingVerdict: pagingParams.appLicensingVerdict,
            appRecognitionVerdict: pagingParams.appRecognitionVerdict,
            deviceRecognitionVerdict: pagingParams.deviceRecognitionVerdict,
            appVersionCode: pagingParams.appVersionCode,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setDate(vm.searchQuery.from.getDate() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.searchQuery = {
                phone: null,
                endpoint: null,
                appLicensingVerdict: null,
                appRecognitionVerdict: null,
                deviceRecognitionVerdict: null,
                appVersionCode: null,
                status: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        initDatePicker();
        loadAll();

        function loadAll () {
            getDateTimeFromPicker();
            PlayIntegrityLog.query({
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                appLicensingVerdict: vm.searchQuery.appLicensingVerdict,
                appRecognitionVerdict: vm.searchQuery.appRecognitionVerdict,
                deviceRecognitionVerdict: vm.searchQuery.deviceRecognitionVerdict,
                appVersionCode: vm.searchQuery.appVersionCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.playIntegrityLogs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                appLicensingVerdict: vm.searchQuery.appLicensingVerdict,
                appRecognitionVerdict: vm.searchQuery.appRecognitionVerdict,
                deviceRecognitionVerdict: vm.searchQuery.deviceRecognitionVerdict,
                appVersionCode: vm.searchQuery.appVersionCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                search: vm.currentSearch
            });
        }

        function getShortJson(responseString) {
            if (responseString === null) {
                return "";
            }
            var responseJson = JSON.parse(responseString);
            var result = "";
            if (responseJson.tokenPayloadExternal !== undefined && responseJson.tokenPayloadExternal.accountDetails !== undefined && responseJson.tokenPayloadExternal.accountDetails.appLicensingVerdict !== undefined) {
                result = result + "appLicensingVerdict:" + responseJson.tokenPayloadExternal.accountDetails.appLicensingVerdict;
            }
            if (responseJson.tokenPayloadExternal !== undefined && responseJson.tokenPayloadExternal.appIntegrity !== undefined && responseJson.tokenPayloadExternal.appIntegrity.appRecognitionVerdict !== undefined) {
                result = result + " appRecognitionVerdict:" + responseJson.tokenPayloadExternal.appIntegrity.appRecognitionVerdict;
            }
            if (responseJson.tokenPayloadExternal !== undefined && responseJson.tokenPayloadExternal.deviceIntegrity !== undefined && responseJson.tokenPayloadExternal.deviceIntegrity.deviceRecognitionVerdict !== undefined) {
                result = result + " deviceRecognitionVerdict:" + responseJson.tokenPayloadExternal.deviceIntegrity.deviceRecognitionVerdict[0];
            }
            return result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDialogController', PaynetModeDialogController);

    PaynetModeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaynetMode'];

    function PaynetModeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paynetMode.id !== null) {
                PaynetMode.update(vm.paynetMode, onSaveSuccess, onSaveError);
            } else {
                PaynetMode.save(vm.paynetMode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:paynetModeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastEdited = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDetailController', PaynetModeDetailController);

    PaynetModeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaynetMode'];

    function PaynetModeDetailController($scope, $rootScope, $stateParams, previousState, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:paynetModeUpdate', function(event, result) {
            vm.paynetMode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDeleteController',PaynetModeDeleteController);

    PaynetModeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaynetMode'];

    function PaynetModeDeleteController($uibModalInstance, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PaynetMode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paynet-mode', {
            parent: 'entity',
            url: '/paynet-mode',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'paynetMode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paynet-mode/paynet-modes.html',
                    controller: 'PaynetModeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paynetMode');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paynet-mode-detail', {
            parent: 'entity',
            url: '/paynet-mode/{id}',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.paynetMode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paynet-mode/paynet-mode-detail.html',
                    controller: 'PaynetModeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paynetMode');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('transactionMode');
                    $translatePartialLoader.addPart('transactionMode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PaynetMode', function($stateParams, PaynetMode) {
                    return PaynetMode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'paynet-mode',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('paynet-mode-detail.edit', {
            parent: 'paynet-mode-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paynet-mode/paynet-mode-dialog.html',
                    controller: 'PaynetModeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaynetMode', function(PaynetMode) {
                            return PaynetMode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paynet-mode.new', {
            parent: 'paynet-mode',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paynet-mode/paynet-mode-dialog.html',
                    controller: 'PaynetModeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paynetMode: null,
                                cardphoneMode: null,
                                mangoIntCardMode: null,
                                lastEdited: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paynet-mode', null, { reload: 'paynet-mode' });
                }, function() {
                    $state.go('paynet-mode');
                });
            }]
        })
        .state('paynet-mode.edit', {
            parent: 'paynet-mode',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paynet-mode/paynet-mode-dialog.html',
                    controller: 'PaynetModeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaynetMode', function(PaynetMode) {
                            return PaynetMode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paynet-mode', null, { reload: 'paynet-mode' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paynet-mode.delete', {
            parent: 'paynet-mode',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paynet-mode/paynet-mode-delete-dialog.html',
                    controller: 'PaynetModeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PaynetMode', function(PaynetMode) {
                            return PaynetMode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paynet-mode', null, { reload: 'paynet-mode' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('PaynetMode', PaynetMode);

    PaynetMode.$inject = ['$resource', 'DateUtils'];

    function PaynetMode ($resource, DateUtils) {
        var resourceUrl =  'api/paynet-modes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    CardPrefixConfig.$inject = ['$resource', 'DateUtils'];

    function CardPrefixConfig ($resource, DateUtils) {
        var resourceUrl =  'api/card-prefix-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('PaynetModeSearch', PaynetModeSearch);

    PaynetModeSearch.$inject = ['$resource'];

    function PaynetModeSearch($resource) {
        var resourceUrl =  'api/_search/paynet-modes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeController', PaynetModeController);

    PaynetModeController.$inject = ['$scope', '$state', 'PaynetMode', 'PaynetModeSearch', 'Config'];

    function PaynetModeController($scope, $state, PaynetMode, PaynetModeSearch, Config) {
        var vm = this;

        vm.paymentModes = [];
        vm.allConfigs = {};
        vm.allPaymentModes = {};
        vm.paynetMode = null;
        vm.save = save;
        vm.loadAll = loadAll;
        vm.saveConfig = saveConfig;

        vm.modes = [
            {value: 'AUTO', text: 'AUTO'},
            {value: 'MANUAL', text: 'MANUAL'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.ruTelGateways = [
            {value: 'VSEPLATEZHI', text: 'VSEPLATEZHI'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.tkbModes = [
            {value: 'ENABLED', text: 'ENABLED'},
            {value: 'UZCARD', text: 'UZCARD'},
            {value: 'HUMO', text: 'HUMO'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.uniredGateways = [
            {value: 'ALL', text: 'ALL'},
            {value: 'TKB', text: 'TKB'},
            {value: 'TKB_IN_BOTH', text: 'TKB_IN_BOTH'},
            {value: 'MTS', text: 'MTS'},
            {value: 'PAYGINE', text: 'PAYGINE'},
            {value: 'SBP', text: 'SBP'}
        ];

        vm.uniredpaymentModes = [
            {value: 'ENABLED', text: 'ENABLED'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.linkedCards = [
            {value: 'TKB', text: 'TKB'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.unlinkedCards = [
            {value: 'TKB', text: 'TKB'},
            {value: 'MTS', text: 'MTS'},
            {value: 'PAYGINE', text: 'PAYGINE'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.savedCards = [
            {value: 'PAYGINE', text: 'PAYGINE'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.visaDirects = [
            {value: 'PAYGINE', text: 'PAYGINE'},
            {value: 'TKB', text: 'TKB'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.bankApps = [
            {value: 'SBP', text: 'SBP'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        vm.checkCards = [
            {value: 'TKB', text: 'TKB'},
            {value: 'MTS', text: 'MTS'},
            {value: 'PAYGINE', text: 'PAYGINE'},
            {value: 'SBP', text: 'SBP'},
            {value: 'DISABLED', text: 'DISABLED'}
        ];

        loadAll();

        function loadAll() {
            PaynetMode.query(function (result) {
                vm.paymentModes = result;
                for (var i = 0; i < vm.paymentModes.length; i++) {
                    vm.allPaymentModes[vm.paymentModes[i].name] = vm.paymentModes[i];
                }
            });

            Config.query(function (result) {
                vm.configs = result;
                for (var i = 0; i < vm.configs.length; i++) {
                    vm.allConfigs[vm.configs[i].name] = vm.configs[i];
                }
            });
        }

        function save(name) {
            vm.isSaving = true;
            if (vm.allPaymentModes[name].id !== null) {
                PaynetMode.update(vm.allPaymentModes[name], onSaveSuccess, onSaveError);
            } else {
                PaynetMode.save(vm.allPaymentModes[name], onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            loadAll();
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function saveConfig(name) {
            vm.isSaving = true;
            if (vm.allConfigs[name].id !== null) {
                Config.update(vm.allConfigs[name], onSaveSuccess, onSaveError);
            } else {
                Config.save(vm.allConfigs[name], onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PassengerDialogController', PassengerDialogController);

    PassengerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Passenger', 'Customer', 'TicketPayment'];

    function PassengerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Passenger, Customer, TicketPayment) {
        var vm = this;

        vm.passenger = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();
        vm.ticketpayments = TicketPayment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.passenger.id !== null) {
                Passenger.update(vm.passenger, onSaveSuccess, onSaveError);
            } else {
                Passenger.save(vm.passenger, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:passengerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;
        vm.datePickerOpenStatus.documentExpire = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PassengerDetailController', PassengerDetailController);

    PassengerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Passenger', 'Customer', 'TicketPayment'];

    function PassengerDetailController($scope, $rootScope, $stateParams, previousState, entity, Passenger, Customer, TicketPayment) {
        var vm = this;

        vm.passenger = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:passengerUpdate', function(event, result) {
            vm.passenger = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PassengerDeleteController',PassengerDeleteController);

    PassengerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Passenger'];

    function PassengerDeleteController($uibModalInstance, entity, Passenger) {
        var vm = this;

        vm.passenger = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Passenger.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('passenger', {
            parent: 'entity',
            url: '/passenger?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.passenger.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/passenger/passengers.html',
                    controller: 'PassengerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('passenger');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('passenger-detail', {
            parent: 'passenger',
            url: '/passenger/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.passenger.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/passenger/passenger-detail.html',
                    controller: 'PassengerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('passenger');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Passenger', function($stateParams, Passenger) {
                    return Passenger.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'passenger',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('passenger-detail.edit', {
            parent: 'passenger-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/passenger/passenger-dialog.html',
                    controller: 'PassengerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Passenger', function(Passenger) {
                            return Passenger.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('passenger.new', {
            parent: 'passenger',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/passenger/passenger-dialog.html',
                    controller: 'PassengerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                middleName: null,
                                age: null,
                                birthDate: null,
                                documentType: null,
                                documentNumber: null,
                                documentExpire: null,
                                gender: null,
                                citizen: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('passenger', null, { reload: 'passenger' });
                }, function() {
                    $state.go('passenger');
                });
            }]
        })
        .state('passenger.edit', {
            parent: 'passenger',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/passenger/passenger-dialog.html',
                    controller: 'PassengerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Passenger', function(Passenger) {
                            return Passenger.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('passenger', null, { reload: 'passenger' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('passenger.delete', {
            parent: 'passenger',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/passenger/passenger-delete-dialog.html',
                    controller: 'PassengerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Passenger', function(Passenger) {
                            return Passenger.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('passenger', null, { reload: 'passenger' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Passenger', Passenger);

    Passenger.$inject = ['$resource', 'DateUtils'];

    function Passenger ($resource, DateUtils) {
        var resourceUrl =  'api/passengers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
                        data.documentExpire = DateUtils.convertLocalDateFromServer(data.documentExpire);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.documentExpire = DateUtils.convertLocalDateToServer(copy.documentExpire);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.documentExpire = DateUtils.convertLocalDateToServer(copy.documentExpire);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PassengerController', PassengerController);

    PassengerController.$inject = ['$state', 'Passenger', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PassengerController($state, Passenger, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Passenger.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.passengers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NotificationDialogController', NotificationDialogController);

    NotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Notification', 'AllNews', '$translate', 'SentNotifications'];

    function NotificationDialogController($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Notification, AllNews, $translate, SentNotifications) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.lang = $translate.use();
        vm.news = AllNews.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.notification.shouldOverride == null || vm.notification.shouldOverride == undefined){
                vm.notification.shouldOverride = false;
            }
            if (vm.notification.id !== null) {
                Notification.update(vm.notification, onSaveSuccess, onSaveError);
            } else {
                Notification.save(vm.notification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:notificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pushDate = false;
        vm.datePickerOpenStatus.expiryDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.setData = function ($file) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        if (vm.notification.bannerUrl == null || vm.notification.bannerUrl == undefined) {
                            vm.notification.bannerUrl = $file.name;
                        }
                        vm.notification.data = base64Data;
                        vm.notification.dataContentType = $file.type;

                    });
                });
            }
        };

        vm.isChecked = function (event) {
            if (event) {
                SentNotifications.query({}, function (data) {
                    vm.notifications = data;
                });
            } else {
                vm.notifications = null;
            }
        };

        vm.selectedNotification = function (notification) {
            Notification.get({id: notification.id}, function (data) {
                data.id = null;
                data.shouldOverride = true;
                vm.notification = data;
            });

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NotificationDetailController', NotificationDetailController);

    NotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Notification', 'News'];

    function NotificationDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Notification, News) {
        var vm = this;

        vm.notification = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:notificationUpdate', function(event, result) {
            vm.notification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NotificationDeleteController',NotificationDeleteController);

    NotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Notification'];

    function NotificationDeleteController($uibModalInstance, entity, Notification) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Notification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification', {
            parent: 'entity',
            url: '/notification?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'global.menu.events.notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification/notifications.html',
                    controller: 'NotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('notification-detail', {
            parent: 'notification',
            url: '/notification/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.notification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification/notification-detail.html',
                    controller: 'NotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Notification', function($stateParams, Notification) {
                    return Notification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('notification-detail.edit', {
            parent: 'notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification.new', {
            parent: 'notification',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                message: null,
                                bannerUrl: null,
                                topic: null,
                                shouldOverride: null,
                                collapseKey: null,
                                pushDate: null,
                                expiryDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('notification');
                });
            }]
        })
        .state('notification.edit', {
            parent: 'notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification.delete', {
            parent: 'notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-delete-dialog.html',
                    controller: 'NotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Notification', Notification)
        .factory('SentNotifications', SentNotifications);

    Notification.$inject = ['$resource', 'DateUtils'];

    function Notification ($resource, DateUtils) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pushDate = DateUtils.convertDateTimeFromServer(data.pushDate);
                        data.expiryDate = DateUtils.convertDateTimeFromServer(data.expiryDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    SentNotifications.$inject = ['$resource'];

    function SentNotifications ($resource) {
        var resourceUrl =  'api/sent-notifications';
        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('NotificationSearch', NotificationSearch);

    NotificationSearch.$inject = ['$resource'];

    function NotificationSearch($resource) {
        var resourceUrl =  'api/_search/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NotificationController', NotificationController);

    NotificationController.$inject = ['$state', 'DataUtils', 'Notification', 'NotificationSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function NotificationController($state, DataUtils, Notification, NotificationSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                NotificationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Notification.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notifications = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'DataUtils', 'entity', 'News'];

    function NewsDialogController($timeout, $scope, $uibModalInstance, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.isAppsOnForNews = isAppsOnForNews;

        editorOptions();
        toggleSwitchApps();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            getSwitchedOnAppsValue();
            if (vm.news.id !== null) {
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pubDate = false;
        vm.datePickerOpenStatus.lastEdited = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function editorOptions() {
            $scope.options = {
                height: 400,
                toolbar: [
                    ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                    ['color', ['color']],
                    ['fontsize', ['fontsize']],
                    ['picture', ['picture']],
                    ['video', ['video']],
                    ['fontface', ['fontname']],
                    ['insert', ['link']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['height', ['height']]
                ]
            };
        }

        function isAppsOnForNews(lang) {
            if (lang === "uz")
                return vm.payGramUzb;
            else if (lang === "en")
                return vm.payGramEng;
            else if (lang === "ru")
                return vm.payGramRus;
            else if (lang === "tj")
                return vm.payGramTj;
        }

        function toggleSwitchApps() {
            vm.payGramUzb = toggleSwitchForApp(2);

            vm.payGramEng = toggleSwitchForApp(16);

            vm.payGramRus = toggleSwitchForApp(128);

            vm.payGramTj = toggleSwitchForApp(512);
        }

        function toggleSwitchForApp(value) {
            return (vm.news.shouldDisplay & value) > 0;
        }

        function getSwitchedOnAppsValue() {
            vm.news.shouldDisplay = 0;
            sumShouldDisplay(vm.payGramUzb, 2);

            sumShouldDisplay(vm.payGramEng, 16);

            sumShouldDisplay(vm.payGramRus, 128);

            sumShouldDisplay(vm.payGramTj, 512);
        }

        function sumShouldDisplay(isAppOn, value) {
            if (isAppOn) {
                vm.news.shouldDisplay += value;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NewsDetailController', NewsDetailController);

    NewsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'News'];

    function NewsDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:newsUpdate', function(event, result) {
            vm.news = result;
        });


        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NewsDeleteController',NewsDeleteController);

    NewsDeleteController.$inject = ['$uibModalInstance', 'entity', 'News'];

    function NewsDeleteController($uibModalInstance, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            News.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('news', {
            parent: 'entity',
            url: '/news?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'global.menu.events.news'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('news-detail', {
            parent: 'news',
            url: '/news/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.news.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news-detail.html',
                    controller: 'NewsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'News', function($stateParams, News) {
                    return News.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('news-detail.edit', {
            parent: 'news-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.new', {
            parent: 'news',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                slug: null,
                                description: null,
                                pubDate: null,
                                lastEdited: null,
                                numberOfViews: null,
                                descriptionEn: null,
                                descriptionRu: null,
                                descriptionTj: null,
                                titleEn: null,
                                titleRu: null,
                                titleTj: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('news');
                });
            }]
        })
        .state('news.edit', {
            parent: 'news',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.delete', {
            parent: 'news',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-delete-dialog.html',
                    controller: 'NewsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('News', News)
        .factory('AllNews', AllNews);

    News.$inject = ['$resource', 'DateUtils'];

    function News ($resource, DateUtils) {
        var resourceUrl =  'api/news/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pubDate = DateUtils.convertDateTimeFromServer(data.pubDate);
                        data.lastEdited = DateUtils.convertDateTimeFromServer(data.lastEdited);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    AllNews.$inject = ['$resource'];

    function AllNews ($resource) {
        var resourceUrl =  'api/all-news';
        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('NewsSearch', NewsSearch);

    NewsSearch.$inject = ['$resource'];

    function NewsSearch($resource) {
        var resourceUrl =  'api/_search/news/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$state', 'DataUtils', 'News', 'NewsSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$translate', '$rootScope'];

    function NewsController($state, DataUtils, News, NewsSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $translate, $rootScope) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.lang = $translate.use();

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                NewsSearch.query({
                    language: vm.lang,
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                News.query({
                    language: vm.lang,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.news = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        var unsubscribe = $rootScope.$on('translateChanged', function (event, lang) {
            vm.lang = lang;
            loadAll();
        });
        $rootScope.$on('$destroy', unsubscribe);

    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDialogController', MyIDDialogController);

    MyIDDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MyID', 'Customer'];

    function MyIDDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MyID, Customer) {
        var vm = this;

        vm.myID = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.customers = Customer.query();
        vm.onIssuedDateChange = onIssuedDateChange;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.myID.id !== null) {
                MyID.update(vm.myID, onSaveSuccess, onSaveError);
            } else {
                MyID.save(vm.myID, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:myIDUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;
        vm.datePickerOpenStatus.issuedDate = false;
        vm.datePickerOpenStatus.expiryDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function onIssuedDateChange() {
            if (vm.myID.issuedDate) {
                const issued = new Date(vm.myID.issuedDate);
                const expiry = new Date(issued);
                expiry.setFullYear(expiry.getFullYear() + 10);
                expiry.setDate(expiry.getDate() - 1);
                vm.myID.expiryDate = expiry;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDetailController', MyIDDetailController);

    MyIDDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MyID', 'Customer'];

    function MyIDDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MyID, Customer) {
        var vm = this;

        vm.myID = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:myIDUpdate', function(event, result) {
            vm.myID = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDeleteController',MyIDDeleteController);

    MyIDDeleteController.$inject = ['$uibModalInstance', 'entity', 'MyID'];

    function MyIDDeleteController($uibModalInstance, entity, MyID) {
        var vm = this;

        vm.myID = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MyID.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('my-id', {
                parent: 'entity',
                url: '/my-id?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.myID.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/my-id/my-ids.html',
                        controller: 'MyIDController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    userPhone: null,
                    documentNumber: null,
                    firstName: null,
                    lastName: null,
                    blocked: null,
                    fromDate: null,
                    toDate: null,
                    from: null,
                    to: null,
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            userPhone: $stateParams.userPhone,
                            documentNumber: $stateParams.documentNumber,
                            firstName: $stateParams.firstName,
                            lastName: $stateParams.lastName,
                            blocked: $stateParams.blocked,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            from: $stateParams.from,
                            to: $stateParams.to
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myID');
                        $translatePartialLoader.addPart('tkbCard');
                        $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('my-id-detail', {
                parent: 'my-id',
                url: '/my-id/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.myID.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/my-id/my-id-detail.html',
                        controller: 'MyIDDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myID');
                        $translatePartialLoader.addPart('gender');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyID', function ($stateParams, MyID) {
                        return MyID.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'my-id',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('my-id-detail.edit', {
                parent: 'my-id-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-id/my-id-dialog.html',
                        controller: 'MyIDDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MyID', function (MyID) {
                                return MyID.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('my-id.new', {
                parent: 'my-id',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-id/my-id-dialog.html',
                        controller: 'MyIDDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    firstName: null,
                                    lastName: null,
                                    middleName: null,
                                    birthDate: new Date('1990-01-01'),
                                    gender: 'U',
                                    documentNumber: null,
                                    pinfl: null,
                                    issuedDate: new Date('2020-01-01'),
                                    expiryDate: new Date('2030-01-01'),
                                    birthPlace: 'Uzbekistan',
                                    permanentAddress: null,
                                    photoUrl: null,
                                    rawJson: null,
                                    deleted: false,
                                    createdBy: null,
                                    createdDate: null,
                                    lastModifiedBy: null,
                                    lastModifiedDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('my-id', null, {reload: 'my-id'});
                    }, function () {
                        $state.go('my-id');
                    });
                }]
            })
            .state('my-id.edit', {
                parent: 'my-id',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-id/my-id-dialog.html',
                        controller: 'MyIDDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MyID', function (MyID) {
                                return MyID.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('my-id', null, {reload: 'my-id'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('my-id.delete', {
                parent: 'my-id',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-id/my-id-delete-dialog.html',
                        controller: 'MyIDDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MyID', function (MyID) {
                                return MyID.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('my-id', null, {reload: 'my-id'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('MyID', MyID);

    MyID.$inject = ['$resource', 'DateUtils'];

    function MyID ($resource, DateUtils) {
        var resourceUrl =  'api/my-ids/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
                        data.issuedDate = DateUtils.convertLocalDateFromServer(data.issuedDate);
                        data.expiryDate = DateUtils.convertLocalDateFromServer(data.expiryDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.issuedDate = DateUtils.convertLocalDateToServer(copy.issuedDate);
                    copy.expiryDate = DateUtils.convertLocalDateToServer(copy.expiryDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.issuedDate = DateUtils.convertLocalDateToServer(copy.issuedDate);
                    copy.expiryDate = DateUtils.convertLocalDateToServer(copy.expiryDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDController', MyIDController);

    MyIDController.$inject = ['$state', '$window', 'DataUtils', 'MyID', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function MyIDController($state, $window, DataUtils, MyID, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.search = search;
        vm.clear = clear;
        vm.openProfile = openProfile;
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            documentNumber: pagingParams.documentNumber,
            firstName: pagingParams.firstName,
            lastName: pagingParams.lastName,
            blocked: pagingParams.blocked,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        loadAll();

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                documentNumber: null,
                firstName: null,
                lastName: null,
                blocked: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            vm.transition();
        }
        function loadAll () {
            MyID.query({
                userPhone: vm.searchQuery.userPhone,
                documentNumber: vm.searchQuery.documentNumber,
                firstName: vm.searchQuery.firstName,
                lastName: vm.searchQuery.lastName,
                blocked: vm.searchQuery.blocked,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.myIDS = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                documentNumber: vm.searchQuery.documentNumber,
                firstName: vm.searchQuery.firstName,
                lastName: vm.searchQuery.lastName,
                blocked: vm.searchQuery.blocked,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDialogController', LanguageLocalizationDialogController);

    LanguageLocalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.languageLocalization.id !== null) {
                LanguageLocalization.update(vm.languageLocalization, onSaveSuccess, onSaveError);
            } else {
                LanguageLocalization.save(vm.languageLocalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:languageLocalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDetailController', LanguageLocalizationDetailController);

    LanguageLocalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:languageLocalizationUpdate', function(event, result) {
            vm.languageLocalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDeleteController',LanguageLocalizationDeleteController);

    LanguageLocalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDeleteController($uibModalInstance, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LanguageLocalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('language-localization', {
            parent: 'entity',
            url: '/language-localization?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.languageLocalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language-localization/language-localizations.html',
                    controller: 'LanguageLocalizationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                code: null,
                messageRu: null,
                messageUz: null,
                messageEn: null,
                firstRun: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        code: $stateParams.code,
                        messageRu: $stateParams.messageRu,
                        messageUz: $stateParams.messageUz,
                        messageEn: $stateParams.messageEn,
                        firstRun: $stateParams.firstRun
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('languageLocalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('language-localization.edit', {
            parent: 'language-localization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language-localization/language-localization-dialog.html',
                    controller: 'LanguageLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LanguageLocalization', function(LanguageLocalization) {
                            return LanguageLocalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language-localization', null, { reload: 'language-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language-localization.new', {
            parent: 'language-localization',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language-localization/language-localization-dialog.html',
                    controller: 'LanguageLocalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                messageRu: null,
                                messageUz: null,
                                messageEn: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('language-localization', null, { reload: 'language-localization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('LanguageLocalization', LanguageLocalization);

    LanguageLocalization.$inject = ['$resource', 'DateUtils'];

    function LanguageLocalization ($resource, DateUtils) {
        var resourceUrl =  'api/language-localizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationController', LanguageLocalizationController);

    LanguageLocalizationController.$inject = ['$state', 'LanguageLocalization', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function LanguageLocalizationController($state, LanguageLocalization, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            code: pagingParams.code,
            messageRu: pagingParams.messageRu,
            messageUz: pagingParams.messageUz,
            messageEn: pagingParams.messageEn
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            LanguageLocalization.query({
                code: pagingParams.code,
                messageRu: pagingParams.messageRu,
                messageUz: pagingParams.messageUz,
                messageEn: pagingParams.messageEn,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.languageLocalizations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                code: vm.searchQuery.code,
                messageRu: vm.searchQuery.messageRu,
                messageUz: vm.searchQuery.messageUz,
                messageEn: vm.searchQuery.messageEn,
                firstRun: false
            });
        }
        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                code: null,
                messageRu: null,
                messageUz: null,
                messageEn: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDialogController', ImageStorageDialogController);

    ImageStorageDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'DataUtils', 'entity', 'ImageStorage'];

    function ImageStorageDialogController ($timeout, $scope, $uibModalInstance, DataUtils, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.imageStorage.id !== null) {
                ImageStorage.update(vm.imageStorage, onSaveSuccess, onSaveError);
            } else {
                ImageStorage.save(vm.imageStorage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:imageStorageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, imageStorage) {
            vm.imageStorage.name = $file.name;
            if (vm.imageStorage.name.length > 50) {
                vm.imageStorage.name = vm.imageStorage.name.substring(vm.imageStorage.name.length - 50);
            }
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        imageStorage.data = base64Data;
                        imageStorage.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDetailController', ImageStorageDetailController);

    ImageStorageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ImageStorage'];

    function ImageStorageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:imageStorageUpdate', function(event, result) {
            vm.imageStorage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDeleteController',ImageStorageDeleteController);

    ImageStorageDeleteController.$inject = ['$uibModalInstance', 'entity', 'ImageStorage'];

    function ImageStorageDeleteController($uibModalInstance, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ImageStorage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('image-storage', {
            parent: 'entity',
            url: '/image-storage?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER'],
                pageTitle: 'global.menu.events.imagesUpload'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/image-storage/image-storages.html',
                    controller: 'ImageStorageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('imageStorage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('image-storage-detail', {
            parent: 'entity',
            url: '/image-storage/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.imageStorage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/image-storage/image-storage-detail.html',
                    controller: 'ImageStorageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('imageStorage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ImageStorage', function($stateParams, ImageStorage) {
                    return ImageStorage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'image-storage',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('image-storage-detail.edit', {
            parent: 'image-storage-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image-storage/image-storage-dialog.html',
                    controller: 'ImageStorageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImageStorage', function(ImageStorage) {
                            return ImageStorage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('image-storage.new', {
            parent: 'image-storage',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image-storage/image-storage-dialog.html',
                    controller: 'ImageStorageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                data: null,
                                dataContentType: null,
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('image-storage', null, { reload: 'image-storage' });
                }, function() {
                    $state.go('image-storage');
                });
            }]
        })
        .state('image-storage.edit', {
            parent: 'image-storage',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image-storage/image-storage-dialog.html',
                    controller: 'ImageStorageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImageStorage', function(ImageStorage) {
                            return ImageStorage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('image-storage', null, { reload: 'image-storage' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('image-storage.delete', {
            parent: 'image-storage',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image-storage/image-storage-delete-dialog.html',
                    controller: 'ImageStorageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ImageStorage', function(ImageStorage) {
                            return ImageStorage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('image-storage', null, { reload: 'image-storage' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ImageStorage', ImageStorage);

    ImageStorage.$inject = ['$resource'];

    function ImageStorage ($resource) {
        var resourceUrl =  'api/image-storages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ImageStorageSearch', ImageStorageSearch);

    ImageStorageSearch.$inject = ['$resource'];

    function ImageStorageSearch($resource) {
        var resourceUrl =  'api/_search/image-storages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageController', ImageStorageController);

    ImageStorageController.$inject = ['$scope', '$state', 'DataUtils', 'ImageStorage', 'ImageStorageSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DEBUG_INFO_ENABLED'];

    function ImageStorageController ($scope, $state, DataUtils, ImageStorage, ImageStorageSearch, ParseLinks, AlertService, paginationConstants, pagingParams, DEBUG_INFO_ENABLED) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        getBaseUrl();
        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ImageStorageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ImageStorage.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.imageStorages = data;
                vm.page = pagingParams.page;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }
        function getBaseUrl() {
            if (DEBUG_INFO_ENABLED) {
                vm.location = location.origin;
            }
            else {
                vm.location = 'https://admin.apextech.uz';
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('gateway-diagnostics', {
                parent: 'entity',
                url: '/gateway-diagnostics',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.configuration.gateway.diagnostics'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gateway-diagnostics/gateway-diagnostics.html',
                        controller: 'GatewayDiagnosticsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tkbTransfer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('GatewayDiagnosticsController', GatewayDiagnosticsController);

    GatewayDiagnosticsController.$inject = ['$scope', '$state', 'TkbTransfer'];

    function GatewayDiagnosticsController($scope, $state, TkbTransfer) {
        var vm = this;

        vm.search = search;
        vm.onChangeMethod = onChangeMethod;
        vm.copyRequest = copyRequest;
        vm.copyResponse = copyResponse;
        vm.serviceInfoId = "11628";
        vm.serviceId = "11629";
        vm.transferAmount = 3000;
        vm.paymentAmount = 100000;
        vm.searchQuery = {
            merchant: 'GLOBIZ',
            gateway: 'TKB',
            method: "checkCardReceipt",
            referenceId: null,
            externalId: null,
            serviceId: "11629",
            account: "977580843",
            cardNumber: "8600312905180812",
            visaCardNumber: "4278320021072383",
            amount: 3000,
            margin: 'true',
            receiverFirstName: 'KHAMIDULLO',
            receiverLastName: 'PIRMATOV'
        }

        function search() {
            TkbTransfer.getGatewayDiagnostics({
                merchant: vm.searchQuery.merchant,
                gateway: vm.searchQuery.gateway,
                method: vm.searchQuery.method,
                referenceId: vm.searchQuery.referenceId,
                externalId: vm.searchQuery.externalId,
                serviceId: vm.searchQuery.serviceId,
                account: vm.searchQuery.account,
                cardNumber: vm.searchQuery.cardNumber,
                visaCardNumber: vm.searchQuery.visaCardNumber,
                amount: vm.searchQuery.amount,
                margin: vm.searchQuery.margin,
                receiverFirstName: vm.searchQuery.receiverFirstName,
                receiverLastName: vm.searchQuery.receiverLastName
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.request = data.requestBody;
                vm.response = data.responseBody;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function onChangeMethod() {
            vm.searchQuery.amount = (vm.searchQuery.method === 'createTransfer' || vm.searchQuery.method === 'createTransferVisa') ? vm.transferAmount : vm.paymentAmount;
            vm.searchQuery.serviceId = vm.searchQuery.method === 'getPaymentInformation' ? vm.serviceInfoId : vm.serviceId;
        }

         function copyRequest() {
            var jsonElement = document.getElementById("requestJson");

            if (jsonElement) {
                var range = document.createRange();
                range.selectNode(jsonElement);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                try {
                    document.execCommand("copy");
                    AlertService.success("JSON copied successfully");
                } catch (err) {
                    AlertService.error("Error coping JSON");
                }

                window.getSelection().removeAllRanges();
            }
        }

        function copyResponse() {
            var jsonElement = document.getElementById("responseJson");

            if (jsonElement) {
                var range = document.createRange();
                range.selectNode(jsonElement);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                try {
                    document.execCommand("copy");
                    AlertService.success("JSON copied successfully");
                } catch (err) {
                    AlertService.error("Error coping JSON");
                }
                window.getSelection().removeAllRanges();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDialogController', FirebaseTokenDialogController);

    FirebaseTokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FirebaseToken', 'Customer'];

    function FirebaseTokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FirebaseToken, Customer) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.firebaseToken.id !== null) {
                FirebaseToken.update(vm.firebaseToken, onSaveSuccess, onSaveError);
            } else {
                FirebaseToken.save(vm.firebaseToken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:firebaseTokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDetailController', FirebaseTokenDetailController);

    FirebaseTokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FirebaseToken', 'Customer'];

    function FirebaseTokenDetailController($scope, $rootScope, $stateParams, previousState, entity, FirebaseToken, Customer) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:firebaseTokenUpdate', function(event, result) {
            vm.firebaseToken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDeleteController',FirebaseTokenDeleteController);

    FirebaseTokenDeleteController.$inject = ['$uibModalInstance', 'entity', 'FirebaseToken'];

    function FirebaseTokenDeleteController($uibModalInstance, entity, FirebaseToken) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FirebaseToken.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('firebase-token', {
            parent: 'entity',
            url: '/firebase-token?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.firebaseToken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/firebase-token/firebase-tokens.html',
                    controller: 'FirebaseTokenController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firebaseToken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('firebase-token-detail', {
            parent: 'firebase-token',
            url: '/firebase-token/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.firebaseToken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/firebase-token/firebase-token-detail.html',
                    controller: 'FirebaseTokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firebaseToken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FirebaseToken', function($stateParams, FirebaseToken) {
                    return FirebaseToken.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'firebase-token',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('firebase-token-detail.edit', {
            parent: 'firebase-token-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('firebase-token.new', {
            parent: 'firebase-token',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                language: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('firebase-token');
                });
            }]
        })
        .state('firebase-token.edit', {
            parent: 'firebase-token',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('firebase-token.delete', {
            parent: 'firebase-token',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-delete-dialog.html',
                    controller: 'FirebaseTokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('FirebaseToken', FirebaseToken);

    FirebaseToken.$inject = ['$resource', 'DateUtils'];

    function FirebaseToken ($resource, DateUtils) {
        var resourceUrl =  'api/firebase-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'getByProfile': {method: 'GET', url: 'api/firebase-token/:profileId/languages', isArray: true},
            'getOneByCustomer': {method: 'GET', url: 'api/firebase-token/:customerId/language'},
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenController', FirebaseTokenController);

    FirebaseTokenController.$inject = ['$state', 'FirebaseToken', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FirebaseTokenController($state, FirebaseToken, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            FirebaseToken.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.firebaseTokens = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqDialogController', FaqDialogController);

    FaqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Faq'];

    function FaqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.faq.id !== null) {
                Faq.update(vm.faq, onSaveSuccess, onSaveError);
            } else {
                Faq.save(vm.faq, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:faqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqDetailController', FaqDetailController);

    FaqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Faq'];

    function FaqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:faqUpdate', function(event, result) {
            vm.faq = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqDeleteController',FaqDeleteController);

    FaqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Faq'];

    function FaqDeleteController($uibModalInstance, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Faq.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('faq', {
                parent: 'entity',
                url: '/faq',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.faq.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/faq/faqs.html',
                        controller: 'FaqController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('faq');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('faq-detail', {
                parent: 'faq',
                url: '/faq/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.faq.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/faq/faq-detail.html',
                        controller: 'FaqDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('faq');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Faq', function ($stateParams, Faq) {
                        return Faq.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'faq',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('faq-detail.edit', {
                parent: 'faq-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/faq/faq-dialog.html',
                        controller: 'FaqDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Faq', function (Faq) {
                                return Faq.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('faq.new', {
                parent: 'faq',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/faq/faq-dialog.html',
                        controller: 'FaqDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    question: null,
                                    answer: null,
                                    language: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('faq', null, {reload: 'faq'});
                    }, function () {
                        $state.go('faq');
                    });
                }]
            })
            .state('faq.edit', {
                parent: 'faq',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/faq/faq-dialog.html',
                        controller: 'FaqDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Faq', function (Faq) {
                                return Faq.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('faq', null, {reload: 'faq'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('faq.delete', {
                parent: 'faq',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/faq/faq-delete-dialog.html',
                        controller: 'FaqDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Faq', function (Faq) {
                                return Faq.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('faq', null, {reload: 'faq'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Faq', Faq);

    Faq.$inject = ['$resource'];

    function Faq ($resource) {
        var resourceUrl =  'api/faqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['DataUtils', 'Faq'];

    function FaqController(DataUtils, Faq) {

        var vm = this;

        vm.faqsInUz = [];
        vm.faqsInEn = [];
        vm.faqsInRu = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Faq.query({
                lang: 'uz',
            }, function (result) {
                vm.faqsInUz = result;
            });

            Faq.query({
                lang: 'en',
            }, function (result) {
                vm.faqsInEn = result;
            });

            Faq.query({
                lang: 'ru',
            }, function (result) {
                vm.faqsInRu = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDialogController', ExchangerateDialogController);

    ExchangerateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Exchangerate'];

    function ExchangerateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.exchangerate.id !== null) {
                Exchangerate.update(vm.exchangerate, onSaveSuccess, onSaveError);
            } else {
                Exchangerate.save(vm.exchangerate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:exchangerateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pubDate = false;
        vm.datePickerOpenStatus.lastEdited = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDetailController', ExchangerateDetailController);

    ExchangerateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Exchangerate'];

    function ExchangerateDetailController($scope, $rootScope, $stateParams, previousState, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:exchangerateUpdate', function(event, result) {
            vm.exchangerate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDeleteController',ExchangerateDeleteController);

    ExchangerateDeleteController.$inject = ['$uibModalInstance', 'entity', 'Exchangerate'];

    function ExchangerateDeleteController($uibModalInstance, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Exchangerate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('exchangerate', {
            parent: 'entity',
            url: '/exchangerate?page&sort&search',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'exchangerate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exchangerate/exchangerates.html',
                    controller: 'ExchangerateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exchangerate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('exchangerate-detail', {
            parent: 'entity',
            url: '/exchangerate/{id}',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.exchangerate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exchangerate/exchangerate-detail.html',
                    controller: 'ExchangerateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exchangerate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Exchangerate', function($stateParams, Exchangerate) {
                    return Exchangerate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'exchangerate',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('exchangerate-detail.edit', {
            parent: 'exchangerate-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('exchangerate.new', {
            parent: 'exchangerate',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                usdToKrw: null,
                                usdToUzs: null,
                                krwToUzs: null,
                                mileagePercentageRate: null,
                                euroDivisor: null,
                                yahooEurToUsd: null,
                                yahooUsdToKrw: null,
                                yahooUsdToUzs: null,
                                mangoPaynetRate: null,
                                mangoSpecialPrice: null,
                                pubDate: null,
                                lastEdited: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('exchangerate');
                });
            }]
        })
        .state('exchangerate.edit', {
            parent: 'exchangerate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('exchangerate.delete', {
            parent: 'exchangerate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-delete-dialog.html',
                    controller: 'ExchangerateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Exchangerate', Exchangerate);

    Exchangerate.$inject = ['$resource', 'DateUtils'];

    function Exchangerate ($resource, DateUtils) {
        var resourceUrl =  'api/exchangerates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pubDate = DateUtils.convertDateTimeFromServer(data.pubDate);
                        data.lastEdited = DateUtils.convertDateTimeFromServer(data.lastEdited);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ExchangerateSearch', ExchangerateSearch);

    ExchangerateSearch.$inject = ['$resource'];

    function ExchangerateSearch($resource) {
        var resourceUrl =  'api/_search/exchangerates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateController', ExchangerateController);

    ExchangerateController.$inject = ['$scope', '$state', 'Exchangerate', 'AlertService'];

    function ExchangerateController ($scope, $state, Exchangerate, AlertService) {
        var vm = this;

        vm.save = save;
        vm.loadAll = loadAll;
        vm.exchangerate = null;
        vm.exchangeRates = {};

        loadAll();

        function loadAll () {
            Exchangerate.query({
                page: 0,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.exchangerates = data;
                for (var i = 0; i < data.length; i++) {
                    vm.exchangeRates[data[i].name] = data[i];
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function save (name) {
            vm.isSaving = true;
            if (vm.exchangeRates[name].id !== null) {
                Exchangerate.update(vm.exchangeRates[name], onSaveSuccess, onSaveError);
            } else {
                Exchangerate.save(vm.exchangeRates[name], onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.exchangeRates[result.name] = result;
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-status-log', {
            parent: 'entity',
            url: '/customer-status-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.customerStatusLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-status-log/customer-status-logs.html',
                    controller: 'CustomerStatusLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                changeReason: ''
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        changeReason: $stateParams.changeReason
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CustomerStatusLog', CustomerStatusLog);

    CustomerStatusLog.$inject = ['$resource'];

    function CustomerStatusLog ($resource) {
        var resourceUrl =  'api/customer-status-logs/all';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerStatusLogController', CustomerStatusLogController);

    CustomerStatusLogController.$inject = ['$state', '$window', 'CustomerStatusLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function CustomerStatusLogController($state, $window, CustomerStatusLog, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.clear = clear;
        vm.openProfile = openProfile;
        vm.searchQuery = {
            phone: pagingParams.phone,
            status: pagingParams.status,
            changeReason: pagingParams.changeReason
        };
        loadAll();

        function loadAll () {
            CustomerStatusLog.query({
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                changeReason: (vm.searchQuery.changeReason === null ? '' : vm.searchQuery.changeReason),
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerStatusLogs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                changeReason: vm.searchQuery.changeReason
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                phone: null,
                status: null,
                changeReason: ''
            };
            vm.transition();
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url, '_blank');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDialogController', CustomerNotificationDialogController);

    CustomerNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerNotification', 'Customer'];

    function CustomerNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerNotification, Customer) {
        var vm = this;

        vm.customerNotification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customerNotification.id !== null) {
                CustomerNotification.update(vm.customerNotification, onSaveSuccess, onSaveError);
            } else {
                CustomerNotification.save(vm.customerNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:customerNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pushDate = false;
        vm.datePickerOpenStatus.expiryDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDetailController', CustomerNotificationDetailController);

    CustomerNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomerNotification', 'Customer'];

    function CustomerNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomerNotification, Customer) {
        var vm = this;

        vm.customerNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:customerNotificationUpdate', function(event, result) {
            vm.customerNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDeleteController',CustomerNotificationDeleteController);

    CustomerNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerNotification'];

    function CustomerNotificationDeleteController($uibModalInstance, entity, CustomerNotification) {
        var vm = this;

        vm.customerNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomerNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-notification', {
            parent: 'entity',
            url: '/customer-notification?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.customerNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-notification/customer-notifications.html',
                    controller: 'CustomerNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: "",
                langKey: null,
                eventType: null,
                status: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        phone: $stateParams.phone,
                        langKey: $stateParams.langKey,
                        clients: $stateParams.clients,
                        eventType: $stateParams.eventType,
                        status: $stateParams.status,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerNotification');
                    $translatePartialLoader.addPart('notificationStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-notification-detail', {
            parent: 'customer-notification',
            url: '/customer-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.customerNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-notification/customer-notification-detail.html',
                    controller: 'CustomerNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerNotification');
                    $translatePartialLoader.addPart('notificationStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerNotification', function($stateParams, CustomerNotification) {
                    return CustomerNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-notification-detail.edit', {
            parent: 'customer-notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-notification.new', {
            parent: 'customer-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                message: null,
                                language: null,
                                collapseKey: null,
                                eventType: null,
                                url: null,
                                readStatus: null,
                                status: null,
                                deleted: null,
                                pushDate: null,
                                expiryDate: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('customer-notification');
                });
            }]
        })
        .state('customer-notification.edit', {
            parent: 'customer-notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-notification.delete', {
            parent: 'customer-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-delete-dialog.html',
                    controller: 'CustomerNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CustomerNotification', CustomerNotification);

    CustomerNotification.$inject = ['$resource', 'DateUtils'];

    function CustomerNotification ($resource, DateUtils) {
        var resourceUrl =  'api/customer-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pushDate = DateUtils.convertDateTimeFromServer(data.pushDate);
                        data.expiryDate = DateUtils.convertDateTimeFromServer(data.expiryDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationController', CustomerNotificationController);

    CustomerNotificationController.$inject = ['$state', '$filter', 'CustomerNotification', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomerNotificationController($state, $filter, CustomerNotification, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;


        vm.search = search;
        vm.clear = clear;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            phone: pagingParams.phone,
            langKey: pagingParams.langKey,
            eventType: pagingParams.eventType,
            status: pagingParams.status,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        initDatePicker();
        loadAll();

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll () {
            CustomerNotification.query({
                phone: vm.searchQuery.phone,
                langKey: vm.searchQuery.langKey,
                eventType: vm.searchQuery.eventType,
                status: vm.searchQuery.status,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerNotifications = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                phone: vm.searchQuery.phone,
                langKey: vm.searchQuery.langKey,
                eventType: vm.searchQuery.eventType,
                status: vm.searchQuery.status,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                phone: "",
                langKey: null,
                eventType: null,
                status: null,
                fromDate: null,
                toDate: null
            };
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Customer', 'Bank'];

    function CustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Customer, Bank) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.banks = Bank.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastLogin = false;
        vm.datePickerOpenStatus.joined = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Customer', 'Bank'];

    function CustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, Customer, Bank) {
        var vm = this;

        vm.customer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:customerUpdate', function(event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerDeleteController',CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'entity',
            url: '/customer?page&sort&search',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customers.html',
                    controller: 'CustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('customerStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-detail', {
            parent: 'entity',
            url: '/customer/{id}',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.customer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-detail.html',
                    controller: 'CustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('customerStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customer', function($stateParams, Customer) {
                    return Customer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-detail.edit', {
            parent: 'customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.new', {
            parent: 'customer',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                password: null,
                                lastLogin: null,
                                isSuperuser: false,
                                phone: null,
                                joined: null,
                                isActive: false,
                                isAdmin: false,
                                isStaff: false,
                                rawPassword: null,
                                fullName: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('customer');
                });
            }]
        })
        .state('customer.edit', {
            parent: 'customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.delete', {
            parent: 'customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                    controller: 'CustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils'];

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                        data.joined = DateUtils.convertDateTimeFromServer(data.joined);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource'];

    function CustomerSearch($resource) {
        var resourceUrl =  'api/_search/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['$scope', '$state', 'Customer', 'CustomerSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomerController ($scope, $state, Customer, CustomerSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Customer.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ConfigDialogController', ConfigDialogController);

    ConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Config'];

    function ConfigDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.config.id !== null) {
                Config.update(vm.config, onSaveSuccess, onSaveError);
            } else {
                Config.save(vm.config, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:configUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ConfigDetailController', ConfigDetailController);

    ConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Config'];

    function ConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:configUpdate', function (event, result) {
            vm.config = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ConfigDeleteController',ConfigDeleteController);

    ConfigDeleteController.$inject = ['$uibModalInstance', 'entity', 'Config'];

    function ConfigDeleteController($uibModalInstance, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Config.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('config', {
                parent: 'entity',
                url: '/config',
                data: {
                    authorities: ['ROLE_MANAGER'],
                    pageTitle: 'global.menu.configuration.service.rates'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/config/configs.html',
                        controller: 'ConfigController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('config');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('config-detail', {
                parent: 'config',
                url: '/config/{id}',
                data: {
                    authorities: ['ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.config.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/config/config-detail.html',
                        controller: 'ConfigDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('config');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Config', function ($stateParams, Config) {
                        return Config.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'config',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('config-detail.edit', {
                parent: 'config-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/config/config-dialog.html',
                        controller: 'ConfigDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Config', function (Config) {
                                return Config.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('config.new', {
                parent: 'config',
                url: '/new',
                data: {
                    authorities: ['ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/config/config-dialog.html',
                        controller: 'ConfigDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    name: null,
                                    value: null,
                                    valueString: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('config', null, {reload: 'config'});
                    }, function () {
                        $state.go('config');
                    });
                }]
            })
            .state('config.edit', {
                parent: 'config',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/config/config-dialog.html',
                        controller: 'ConfigDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Config', function (Config) {
                                return Config.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('config', null, {reload: 'config'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('config.delete', {
                parent: 'config',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/config/config-delete-dialog.html',
                        controller: 'ConfigDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Config', function (Config) {
                                return Config.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('config', null, {reload: 'config'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('config.view', {
                parent: 'config',
                url: '/view',
                data: {
                    authorities: ['ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.config.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/config/configs-view.html',
                        controller: 'ConfigController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('config');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('app-version-codes', {
                parent: 'entity',
                url: '/app-version-codes',
                data: {
                    authorities: ['ROLE_MANAGER'],
                    pageTitle: 'global.menu.configuration.version.codes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/config/app-version-codes.html',
                        controller: 'ConfigController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('config');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Config', Config);

    Config.$inject = ['$resource'];

    function Config ($resource) {
        var resourceUrl =  'api/configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ConfigController', ConfigController);

    ConfigController.$inject = ['Config'];

    function ConfigController(Config) {

        var vm = this;
        vm.save = save;

        vm.configs = [];
        vm.allConfigs = {}

        loadAll();

        function loadAll() {
            Config.query(function (result) {
                vm.configs = result;
                for (var i = 0; i < vm.configs.length; i++) {
                    vm.allConfigs[vm.configs[i].name] = vm.configs[i];
                }
                vm.searchQuery = null;
            });
        }

        function save(name) {
            vm.isSaving = true;
            if (vm.allConfigs[name].id !== null) {
                Config.update(vm.allConfigs[name], onSaveSuccess, onSaveError);
            } else {
                Config.save(vm.allConfigs[name], onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            loadAll();
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDialogController', ChatMessageDialogController);

    ChatMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ChatMessage', 'Chat'];

    function ChatMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ChatMessage, Chat) {
        var vm = this;

        vm.chatMessage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.chats = Chat.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.chatMessage.id !== null) {
                ChatMessage.update(vm.chatMessage, onSaveSuccess, onSaveError);
            } else {
                ChatMessage.save(vm.chatMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:chatMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDetailController', ChatMessageDetailController);

    ChatMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ChatMessage', 'Chat'];

    function ChatMessageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ChatMessage, Chat) {
        var vm = this;

        vm.chatMessage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:chatMessageUpdate', function(event, result) {
            vm.chatMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDeleteController',ChatMessageDeleteController);

    ChatMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChatMessage'];

    function ChatMessageDeleteController($uibModalInstance, entity, ChatMessage) {
        var vm = this;

        vm.chatMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ChatMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(id);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('chat-message', {
            parent: 'entity',
            url: '/chat-message?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.chatMessage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat-message/chat-messages.html',
                    controller: 'ChatMessageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chatMessage');
                    $translatePartialLoader.addPart('deliveredStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('chat-message-detail', {
            parent: 'chat-message',
            url: '/chat-message/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.chatMessage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat-message/chat-message-detail.html',
                    controller: 'ChatMessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chatMessage');
                    $translatePartialLoader.addPart('deliveredStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChatMessage', function($stateParams, ChatMessage) {
                    return ChatMessage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'chat-message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('chat-message-detail.edit', {
            parent: 'chat-message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat-message.new', {
            parent: 'chat-message',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                imageUrl: null,
                                readStatus: false,
                                solved: false,
                                replyMessageId: null,
                                telegramMessageId: null,
                                deliveredStatus: null,
                                errorMessage: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('chat-message');
                });
            }]
        })
        .state('chat-message.edit', {
            parent: 'chat-message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-dialog.html',
                    controller: 'ChatMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat-message.delete', {
            parent: 'chat-message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat-message/chat-message-delete-dialog.html',
                    controller: 'ChatMessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChatMessage', function(ChatMessage) {
                            return ChatMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat-message', null, { reload: 'chat-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ChatMessage', ChatMessage);

    ChatMessage.$inject = ['$resource', 'DateUtils'];

    function ChatMessage ($resource, DateUtils) {
        var resourceUrl =  'api/chat-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageController', ChatMessageController);

    ChatMessageController.$inject = ['$state', 'DataUtils', 'ChatMessage', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ChatMessageController($state, DataUtils, ChatMessage, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            ChatMessage.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.chatMessages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatDialogController', ChatDialogController);

    ChatDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Chat', 'ChatMessage', 'Customer'];

    function ChatDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Chat, ChatMessage, Customer) {
        var vm = this;

        vm.chat = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.chatmessages = ChatMessage.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.chat.id !== null) {
                Chat.update(vm.chat, onSaveSuccess, onSaveError);
            } else {
                Chat.save(vm.chat, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:chatUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatDetailController', ChatDetailController);

    ChatDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Chat', 'ChatMessage', 'Customer'];

    function ChatDetailController($scope, $rootScope, $stateParams, previousState, entity, Chat, ChatMessage, Customer) {
        var vm = this;

        vm.chat = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:chatUpdate', function(event, result) {
            vm.chat = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatDeleteController',ChatDeleteController);

    ChatDeleteController.$inject = ['$uibModalInstance', 'entity', 'Chat'];

    function ChatDeleteController($uibModalInstance, entity, Chat) {
        var vm = this;

        vm.chat = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Chat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatCustomersModalController', ChatCustomersModalController);

    ChatCustomersModalController.$inject = ['$uibModalInstance', 'Profile', '$timeout'];

    function ChatCustomersModalController($uibModalInstance, Profile, $timeout) {
        var vm = this;

        vm.customers = [];
        vm.itemsPerPage = 10;
        vm.page = 0;
        vm.customerPhone = "";

        vm.loadCustomers = loadCustomers;
        vm.selectCustomer = selectCustomer;
        vm.cancel = cancel;

        var searchTimeout;

        function loadCustomers() {
            if (searchTimeout) {
                $timeout.cancel(searchTimeout);
            }

            searchTimeout = $timeout(function () {
                if (vm.customerPhone.length > 2) {
                    Profile.queryByPhone({
                        field: vm.customerPhone,
                        page: vm.page,
                        size: vm.itemsPerPage,
                    }, function (response) {
                        vm.customers = response;
                        angular.forEach(vm.customers, function (customer) {
                            customer.avatar = 'content/images/avatar_profile.png'
                        })
                    }, function (error) {
                        AlertService.error('Error loading messages');
                    });
                }
            }, 1500);
        }

        function selectCustomer(customer) {
            $uibModalInstance.close(customer);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('chat', {
            parent: 'entity',
            url: '/chat/{chatId}?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.chat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat/chats.html',
                    controller: 'ChatController',
                    controllerAs: 'vm'
                }
            },
            params: {
                chatId: {
                    value: null,
                    squash: true
                },
                page: {
                    value: '1',
                    squash: true
                },
                pageChatMessage: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'createdDate,asc',
                    squash: true
                },
                sortChatMessage: {
                    value: 'createdDate,asc',
                    squash: true
                },
                replied: null,
                solved: null,
                field: null

            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        chatId: $stateParams.chatId,
                        page: PaginationUtil.parsePage($stateParams.page),
                        pageChatMessage: PaginationUtil.parsePage($stateParams.pageChatMessage),
                        sort: $stateParams.sort,
                        sortChatMessage: $stateParams.sortChatMessage,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        replied: $stateParams.replied,
                        solved: $stateParams.solved,
                        field: $stateParams.field
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chat');
                    $translatePartialLoader.addPart('chatMessage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('chat-detail', {
            parent: 'chat',
            url: '/chat/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.chat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/chat/chat-detail.html',
                    controller: 'ChatDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('chat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Chat', function($stateParams, Chat) {
                    return Chat.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'chat',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('chat-detail.edit', {
            parent: 'chat-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat/chat-dialog.html',
                    controller: 'ChatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Chat', function(Chat) {
                            return Chat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat.new', {
            parent: 'chat',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat/chat-dialog.html',
                    controller: 'ChatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sessionToken: null,
                                solved: false,
                                replied: false,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('chat', null, { reload: 'chat' });
                }, function() {
                    $state.go('chat');
                });
            }]
        })
        .state('chat.edit', {
            parent: 'chat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat/chat-dialog.html',
                    controller: 'ChatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Chat', function(Chat) {
                            return Chat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat', null, { reload: 'chat' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('chat.delete', {
            parent: 'chat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/chat/chat-delete-dialog.html',
                    controller: 'ChatDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Chat', function(Chat) {
                            return Chat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('chat', null, { reload: 'chat' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Chat', Chat)
        .factory('ChatMessage', ChatMessage);


    Chat.$inject = ['$resource', 'DateUtils'];

    function Chat ($resource, DateUtils) {
        var resourceUrl =  'api/chats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'getByCustomerId': { method: 'GET', url: 'api/chats/customer/:customerId'}
        });
    }

    ChatMessage.$inject = ['$resource', 'DateUtils'];

    function ChatMessage ($resource, DateUtils) {
        var resourceUrl =  'api/chat-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'getByChatId': {method: 'GET', url: 'api/chat-messages/chat/:chatId', isArray: true},
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatController', ChatController);

    ChatController.$inject = ['$timeout', '$uibModal', '$state', '$stateParams', '$window', 'Chat', 'ChatMessage', 'Profile', 'FirebaseToken', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function ChatController($timeout, $uibModal, $state, $stateParams, $window, Chat, ChatMessage, Profile, FirebaseToken, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;

        vm.chats = [];
        vm.selectedChat = null;
        vm.chatMessages = [];
        vm.newMessage = '';
        vm.getRepliedMessageContent = getRepliedMessageContent;
        vm.getRepliedMessageImage = getRepliedMessageImage;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 10;
        vm.page = 0;
        vm.pageChatMessage = 0;
        vm.lastPage = false;
        vm.lastMessagesPage = false;
        vm.loading = false;
        vm.isMessagesLoading = false;
        vm.showModal = false;
        vm.modalImageUrl = "";
        vm.unsolvedOnly = null;
        vm.unrepliedOnly = null;
        vm.customerPhone = null;
        vm.showCustomerModal = false;
        vm.customers = [];
        vm.profileLanguage = null;
        vm.messageId = null;
        vm.isEditing = false;
        vm.messageForEdit = null;
        vm.textAreaHeight = 0;

        vm.loadMore = loadMore;
        vm.loadByChatQuery = loadByChatQuery;
        vm.clear = clear;
        vm.selectChat = selectChat;
        vm.sendMessage = sendMessage;
        vm.openProfile = openProfile;
        vm.toggleOptions = toggleOptions;
        vm.toggleChatOptions = toggleChatOptions;
        vm.openImage = openImage;
        vm.closeImage = closeImage;
        vm.applyFilters = applyFilters;
        vm.openCustomerModal = openCustomerModal;
        vm.startNewChat = startNewChat;
        vm.deleteMessage = deleteMessage;
        vm.editMessage = editMessage;
        vm.cancelEditing = cancelEditing;
        vm.saveMessage = saveMessage;
        vm.saveAsReplied = saveAsReplied;

        vm.searchQuery = {
            chatId: pagingParams.chatId,
            field: pagingParams.field,
            solved: pagingParams.solved,
            replied: pagingParams.replied,
        };

        function loadByChatQuery() {
            vm.page = 0;
            vm.lastPage = false;
            vm.loading = false;
            vm.chats = [];
            Chat.query({
                chatId: vm.searchQuery.chatId,
                field: vm.searchQuery.field,
                solved: vm.searchQuery.solved,
                replied: vm.searchQuery.replied,
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, function (response) {
                vm.chats = response;
                vm.chats.forEach(function (chat) {
                    chat.avatar = 'content/images/avatar_profile.png'
                })

                $timeout(function () {
                    var chatList = document.querySelector('.chat-list-container');
                    if (chatList && chatList.scrollHeight === chatList.clientHeight) {
                        vm.loadMore();
                    }
                }, 0);
            }, function (error) {
                AlertService.error('Error loading messages');
            });
            vm.page++;
        }

        function loadMore() {
            if (vm.lastPage || vm.loading) {
                return null;
            } else {
                vm.loading = true;
                loadNext();
            }
        }

        function loadNext() {
            Chat.query({
                chatId: vm.searchQuery.chatId,
                field: vm.searchQuery.field,
                solved: vm.searchQuery.solved,
                replied: vm.searchQuery.replied,
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError)
        }

        function sort() {
            const result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page++;
            const result = data;

            if (result == null || result.length < 10) {
                vm.lastPage = true;
            }
            angular.forEach(result, function (chat) {
                vm.chats.push(chat);
            });
            vm.loading = false;
            vm.chats.forEach(function (chat) {
                chat.avatar = 'content/images/avatar_profile.png'
            })

            $timeout(function () {
                var chatList = document.querySelector('.chat-list-container');
                if (chatList && chatList.scrollHeight === chatList.clientHeight) {
                    vm.loadMore();
                }
            }, 0);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getRepliedMessageContent(replyMessageId){
            var repliedMessage = null;
            angular.forEach(vm.chatMessages, function (message){
                if (message.id === replyMessageId) {
                    repliedMessage = message;
                }
            })
            return repliedMessage ? repliedMessage.content : '[Message not found]';
        }

        function getRepliedMessageImage(replyMessageId){
            var repliedMessage = null;
            angular.forEach(vm.chatMessages, function (message){
                if (message.id === replyMessageId) {
                    repliedMessage = message;
                }
            })
            return repliedMessage ? repliedMessage.imageUrl : null;
        }

        if ($stateParams.chatId) {
            Chat.get({ id: $stateParams.chatId }, function(chat) {
                vm.selectedChat = chat;
                vm.selectedChat.avatar = 'content/images/avatar_profile.png';
                selectChat(chat);
            });
        }

        function selectChat(chat) {
            vm.isMessagesLoading = true;
            cancelEditing()
            vm.chatMessages = [];
            getCustomerLanguage(chat.customerId);
            vm.selectedChat = chat;
            vm.searchQuery.chatId = chat.id
            ChatMessage.getByChatId({
                chatId: vm.searchQuery.chatId,
                page: vm.pageChatMessage,
                size: vm.itemsPerPage,
                sort: pagingParams.sortChatMessage
            }, function (response) {
                vm.chatMessages = response;
                $state.go('chat', {chatId: chat.id}, {notify: false});
                setTimeout(function () {
                    enableClipboard();
                }, 0);
                vm.isMessagesLoading = false;
                scrollToBottom();
            }, function (error) {
                vm.isMessagesLoading = false;
                AlertService.error('Error loading messages');
            });
        }

        function toggleOptions(message, $event) {
            vm.messageId = message.id;
            vm.chatMessages.forEach(function (msg) {
                if (msg !== message) {
                    msg.showOptions = false;
                }
            });
            message.showOptions = !message.showOptions;
            $event.stopPropagation();
        }

        vm.closeOptions = function () {
            vm.messageId = null;
        }

        vm.saveAsUnsolved = function (message) {
            message.solved = !message.solved;
            vm.messageId = null;
            ChatMessage.update(message, onSaveSuccess, onSaveError);
        }

        function deleteMessage(message) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/chat-message/chat-message-delete-dialog.html',
                controller: 'ChatMessageDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: message
                }
            });
            modalInstance.result.then(function (deletedMessageId) {
                if (deletedMessageId) {
                    var newMessages = [];
                    angular.forEach(vm.chatMessages, function (msg) {
                        if (msg.id !== deletedMessageId) {
                            newMessages.push(msg);
                        }
                    });
                    vm.chatMessages = newMessages;
                }
            });
        }

        function editMessage(message) {
            vm.isEditing = true;
            vm.newMessage = message.content;
            vm.messageForEdit = message;
            var lines = vm.newMessage.split("\n");
            if (lines.length > 3) {
                vm.textAreaHeight = lines.length * 23;
            } else {
                vm.textAreaHeight = lines.length * 28;
            }

            $timeout(function() {
                angular.element(document.querySelector(".edit-text-area")).focus();
            }, 100);
        }

        function cancelEditing() {
            vm.isEditing = false;
            vm.newMessage = '';
            vm.messageForEdit = null;
        }

        function saveMessage() {
            if (!vm.selectedChat || !vm.newMessage.trim()) return;
            var message = {
                id: vm.messageForEdit.id,
                content: vm.newMessage,
                readStatus: vm.messageForEdit.readStatus,
                fromCustomer: vm.messageForEdit.fromCustomer,
                solved: vm.messageForEdit.solved,
                deliveredStatus: vm.messageForEdit.deliveredStatus,
                chatId: vm.messageForEdit.chatId,
            };

            ChatMessage.update(message, onSuccess, onError);

            function onSuccess(response) {
                vm.newMessage = '';
                vm.isEditing = false;
                angular.forEach(vm.chatMessages, function (message) {
                    if(message.id === vm.messageForEdit.id){
                        message.content = response.content;
                    }
                });
            }

            function onError() {
                vm.newMessage = '';
                vm.isEditing = false;
                window.alert("Error sending message");
            }
        }

        function onSaveSuccess (message) {
            angular.forEach(vm.chats, function (chat) {
                if (chat.id === message.chatId) {
                    chat.solved = message.solved;
                }
            });
            loadByChatQuery();
        }

        function onSaveError () {
            AlertService.error('Error loading messages');
        }

        function sendMessage() {
            if (!vm.selectedChat || !vm.newMessage.trim()) return;

            var message = {
                content: vm.newMessage,
                readStatus: false,
                fromCustomer: false,
                solved: true,
                deliveredStatus: 'PENDING',
                chatId: vm.selectedChat.id,
            };

            ChatMessage.save(message, function(response) {
                vm.chatMessages.push(response);
                vm.newMessage = '';
                scrollToBottom();
            }, function(error) {
                AlertService.error('Error sending message');
            });
        }

        function scrollToBottom() {
            $timeout(function () {
                const chatContainer = angular.element(document.querySelector(".chat-messages"));
                if (angular.isDefined(chatContainer)) {
                    chatContainer[0].scrollTo({
                        top: chatContainer[0].scrollHeight,
                        behavior: "smooth"
                    });
                }
            },0);
        }

        function loadPage() {
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                chatId: vm.searchQuery.chatId,
                field: vm.searchQuery.field,
                solved: vm.searchQuery.solved,
                replied: vm.searchQuery.replied,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function clear() {
            vm.links = null;
            vm.predicate = 'id';
            vm.searchQuery = {
                field: null,
                solved: null,
            };
            vm.transition();
            loadByChatQuery();
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                $state.go('profile-detail', {id: data.profileId});
            }
        }

        function openImage(imageUrl) {
            vm.modalImageUrl = imageUrl;
            vm.showModal = true;
        }

        function closeImage() {
            vm.showModal = false;
            vm.modalImageUrl = "";
        }

        var searchTimeout;

        function applyFilters() {
            if (vm.unsolvedOnly) {
                vm.searchQuery.solved = false;
            } else {
                vm.searchQuery.solved = null;
            }
            if (vm.unrepliedOnly) {
                vm.searchQuery.replied = false;
            } else {
                vm.searchQuery.replied = null;
            }
            if (searchTimeout) {
                $timeout.cancel(searchTimeout);
            }
            searchTimeout = $timeout(function () {
                vm.loadByChatQuery();
            }, 1500);
        }

        function openCustomerModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/chat/chat-customers-dialog.html',
                controller: 'ChatCustomersModalController',
                controllerAs: 'vm',
                backdrop: 'static',
            });

            modalInstance.result.then(function (selectedCustomer) {
                getCustomerLanguage(selectedCustomer.id);
                vm.startNewChat(selectedCustomer);
            });
        }

        function getCustomerLanguage(customerId) {
            FirebaseToken.getOneByCustomer({customerId: customerId}, onSuccess, onError);

            function onSuccess(data) {
                vm.profileLanguage = data.language;
            }

            function onError(data) {
                vm.profileLanguage = null;
            }
        }

        function startNewChat(customer) {
            const newChat = {
                customerPhone: customer.customerPhone,
                solved: true,
                replied: true,
            }
            Chat.save((newChat), function (response) {
                selectChat(response);
                vm.selectedChat.customerPhone = customer.customerPhone
                vm.selectedChat.avatar = 'content/images/avatar_profile.png';
                $state.go('chat', { chatId: response.id }, { notify: false });
                var exists = false;
                angular.forEach(vm.chats, function (chat) {
                    if(chat.id === response.id) exists = true;
                })
                if(!exists){
                    vm.chats.unshift(response);
                }
            }, function () {
                AlertService.error("Error creating new chat");
            });
        }

        function toggleChatOptions($event) {
            vm.selectedChat.showOptions = !vm.selectedChat.showOptions;
            $event.stopPropagation();
        }

        vm.closeChatOptions = function () {
            vm.selectedChat.showOptions = false
        }

        function saveAsReplied(){
            vm.selectedChat.replied = true;
            Chat.update(vm.selectedChat, onSuccess, onError);

            function onSuccess() {
                loadByChatQuery();
            }

            function onError () {
                AlertService.error('Error loading messages');
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDialogController', CardPrefixConfigDialogController);

    CardPrefixConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.cardPrefixes = [];
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.checkDuplicatePrefix = checkDuplicatePrefix;

        if (!vm.cardPrefixConfig.id) {
            vm.cardPrefixConfig.isActive = true;
        }

        loadAll();

        function loadAll () {
            vm.cardPrefixes = [];
            vm.allCardPrefixStatus = true;
            CardPrefixConfig.query(function (result) {
                angular.forEach(result, function (res) {
                    var cardPrefix = {
                        id: res.id,
                        prefix: res.prefix,
                        cardType: res.cardType,
                        isActive: res.isActive,
                        lastModifiedDate: res.lastModifiedDate,
                        lastModifiedBy: res.lastModifiedBy
                    };
                    vm.cardPrefixes.push(cardPrefix);
                    if (!res.isActive) {
                        vm.allCardPrefixStatus = false;
                    }
                    vm.filteredCardPrefixes = angular.copy(result);
                });
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cardPrefixConfig.id !== null) {
                CardPrefixConfig.update(vm.cardPrefixConfig, onSaveSuccess, onSaveError);
            } else {
                CardPrefixConfig.save(vm.cardPrefixConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:cardPrefixConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function checkDuplicatePrefix() {
            if (!vm.cardPrefixConfig.prefix || !vm.cardPrefixes) return;

            var existing = vm.cardPrefixes.find(function (cardPrefix) {
                return cardPrefix.prefix === vm.cardPrefixConfig.prefix && cardPrefix.id !== vm.cardPrefixConfig.id;
            });

            vm.isDuplicatePrefix = !!existing;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDetailController', CardPrefixConfigDetailController);

    CardPrefixConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:cardPrefixConfigUpdate', function(event, result) {
            vm.cardPrefixConfig = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDeleteController',CardPrefixConfigDeleteController);

    CardPrefixConfigDeleteController.$inject = ['$uibModalInstance', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDeleteController($uibModalInstance, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CardPrefixConfig.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('card-prefix-config', {
            parent: 'entity',
            url: '/card-prefix-config?page&sort&search',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.cardPrefixConfig.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-configs.html',
                    controller: 'CardPrefixConfigController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cardPrefixConfig');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('card-prefix-config-detail', {
            parent: 'card-prefix-config',
            url: '/card-prefix-config/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.cardPrefixConfig.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-detail.html',
                    controller: 'CardPrefixConfigDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cardPrefixConfig');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CardPrefixConfig', function($stateParams, CardPrefixConfig) {
                    return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'card-prefix-config',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('card-prefix-config-detail.edit', {
            parent: 'card-prefix-config-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('card-prefix-config.new', {
            parent: 'card-prefix-config',
            url: '/new',
            data: {
                authorities: ['ROLE_USER', 'ROLE_MANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                prefix: null,
                                cardType: null,
                                isActive: false,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('card-prefix-config');
                });
            }]
        })
        .state('card-prefix-config.edit', {
            parent: 'card-prefix-config',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-dialog.html',
                    controller: 'CardPrefixConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('card-prefix-config.delete', {
            parent: 'card-prefix-config',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/card-prefix-config/card-prefix-config-delete-dialog.html',
                    controller: 'CardPrefixConfigDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CardPrefixConfig', function(CardPrefixConfig) {
                            return CardPrefixConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('card-prefix-config', null, { reload: 'card-prefix-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CardPrefixConfig', CardPrefixConfig);

    CardPrefixConfig.$inject = ['$resource', 'DateUtils'];

    function CardPrefixConfig ($resource, DateUtils) {
        var resourceUrl =  'api/card-prefix-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'updateAll': { url: 'api/card-prefix-configs/update-all', method: 'PUT', isArray: true }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigController', CardPrefixConfigController);

    CardPrefixConfigController.$inject = ['$state', '$timeout', 'CardPrefixConfig', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CardPrefixConfigController($state, $timeout, CardPrefixConfig, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.allCardPrefixStatus = false;
        vm.cardPrefixes = [];
        vm.filteredCardPrefixes = [];
        vm.cardTypes = ['UZCARD', 'HUMO', 'VISA', 'MASTERCARD', 'UNIONPAY', 'MAESTRO'];
        vm.selectedCardType = '';
        vm.saveCardPrefix = saveCardPrefix;
        vm.saveAllCardPrefixes = saveAllCardPrefixes;
        vm.saveFilteredCardPrefixes = saveFilteredCardPrefixes;
        vm.updateFilteredCardPrefixes = updateFilteredCardPrefixes;

        loadAll();

        function loadAll () {
            vm.cardPrefixes = [];
            vm.allCardPrefixStatus = true;
            CardPrefixConfig.query(function (result) {
                angular.forEach(result, function (res) {
                    var cardPrefix = {
                        id: res.id,
                        prefix: res.prefix,
                        cardType: res.cardType,
                        isActive: res.isActive,
                        lastModifiedDate: res.lastModifiedDate,
                        lastModifiedBy: res.lastModifiedBy
                    };
                    vm.cardPrefixes.push(cardPrefix);
                    if (!res.isActive) {
                        vm.allCardPrefixStatus = false;
                    }
                });
                vm.filteredCardPrefixes = angular.copy(result);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function saveCardPrefix(cardPrefix) {
            vm.isSaving = true;
            if (cardPrefix.id !== null) {
                CardPrefixConfig.update(cardPrefix, onSuccess, onSaveError);
            } else {
                CardPrefixConfig.save(cardPrefix, onSuccess, onSaveError);
            }
        }

        function onSuccess() {
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function saveAllCardPrefixes() {
            vm.isSaving = true;
            CardPrefixConfig.updateAll(vm.allCardPrefixStatus, onSuccessUpdateStatus, onSaveError);
        }

        function onSuccessUpdateStatus(result) {
            vm.isSaving = false;
            vm.cardPrefixes = result;

            angular.forEach(result, function (cardPrefix) {
                if (cardPrefix.isActive === false) {
                    vm.allCardPrefixStatus = false;
                }
            });
        }

        function saveFilteredCardPrefixes() {
            angular.forEach(vm.filteredCardPrefixes, function(cardPrefixConfig) {
                cardPrefixConfig.isActive = vm.allCardPrefixStatus;
                vm.saveCardPrefix(cardPrefixConfig);
            });
        }

        function updateFilteredCardPrefixes() {
            if (!vm.selectedCardType) {
                vm.filteredCardPrefixes = angular.copy(vm.cardPrefixes);
            } else {
                vm.filteredCardPrefixes = vm.cardPrefixes.filter(function (filteredCardPrefix) {
                    return filteredCardPrefix.cardType === vm.selectedCardType;
                });
            }
            vm.allCardPrefixStatus = vm.filteredCardPrefixes.every(function (filteredCardPrefix) {
                return filteredCardPrefix.isActive === true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationDialogController', BotNotificationDialogController);

    BotNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BotNotification'];

    function BotNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BotNotification) {
        var vm = this;

        vm.botNotification = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.botNotification.id !== null) {
                BotNotification.update(vm.botNotification, onSaveSuccess, onSaveError);
            } else {
                BotNotification.save(vm.botNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:botNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationDetailController', BotNotificationDetailController);

    BotNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BotNotification'];

    function BotNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, BotNotification) {
        var vm = this;

        vm.botNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:botNotificationUpdate', function(event, result) {
            vm.botNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationDeleteController',BotNotificationDeleteController);

    BotNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'BotNotification'];

    function BotNotificationDeleteController($uibModalInstance, entity, BotNotification) {
        var vm = this;

        vm.botNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BotNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bot-notification', {
            parent: 'entity',
            url: '/bot-notification?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.botNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bot-notification/bot-notifications.html',
                    controller: 'BotNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('botNotification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bot-notification-detail', {
            parent: 'bot-notification',
            url: '/bot-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.botNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bot-notification/bot-notification-detail.html',
                    controller: 'BotNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('botNotification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BotNotification', function($stateParams, BotNotification) {
                    return BotNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bot-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('bot-notification-detail.edit', {
            parent: 'bot-notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bot-notification.new', {
            parent: 'bot-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                message: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('bot-notification');
                });
            }]
        })
        .state('bot-notification.edit', {
            parent: 'bot-notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bot-notification.delete', {
            parent: 'bot-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-delete-dialog.html',
                    controller: 'BotNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('BotNotification', BotNotification);

    BotNotification.$inject = ['$resource'];

    function BotNotification ($resource) {
        var resourceUrl =  'api/bot-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BotNotificationController', BotNotificationController);

    BotNotificationController.$inject = ['$state', 'BotNotification', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BotNotificationController($state, BotNotification, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            BotNotification.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.botNotifications = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageDialogController', BannerImageDialogController);

    BannerImageDialogController.$inject = ['$timeout', '$scope', 'DataUtils', '$uibModalInstance', '$q', 'entity', 'BannerImage', 'ImageStorage'];

    function BannerImageDialogController ($timeout, $scope, DataUtils, $uibModalInstance, $q, entity, BannerImage, ImageStorage) {
        var vm = this;

        vm.bannerImage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bannerImage.id !== null) {
                BannerImage.update(vm.bannerImage, onSaveSuccess, onSaveError);
            } else {
                BannerImage.save(vm.bannerImage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:bannerImageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setData = function ($file) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.bannerImage.imageStorageName = $file.name;
                        vm.bannerImage.data = base64Data;
                        vm.bannerImage.dataContentType = $file.type;

                    });
                });
            }
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageDetailController', BannerImageDetailController);

    BannerImageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BannerImage', 'ImageStorage'];

    function BannerImageDetailController($scope, $rootScope, $stateParams, previousState, entity, BannerImage, ImageStorage) {
        var vm = this;

        vm.bannerImage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:bannerImageUpdate', function(event, result) {
            vm.bannerImage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageDeleteController',BannerImageDeleteController);

    BannerImageDeleteController.$inject = ['$uibModalInstance', 'entity', 'BannerImage'];

    function BannerImageDeleteController($uibModalInstance, entity, BannerImage) {
        var vm = this;

        vm.bannerImage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BannerImage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('banner-image', {
            parent: 'entity',
            url: '/banner-image?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.bannerImage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/banner-image/banner-images.html',
                    controller: 'BannerImageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                filterLang: 'all'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        filterLang: $stateParams.filterLang
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bannerImage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('banner-image-detail', {
            parent: 'banner-image',
            url: '/banner-image/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.bannerImage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/banner-image/banner-image-detail.html',
                    controller: 'BannerImageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bannerImage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BannerImage', function($stateParams, BannerImage) {
                    return BannerImage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'banner-image',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('banner-image-detail.edit', {
            parent: 'banner-image-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/banner-image/banner-image-dialog.html',
                    controller: 'BannerImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BannerImage', function(BannerImage) {
                            return BannerImage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('banner-image.new', {
            parent: 'banner-image',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/banner-image/banner-image-dialog.html',
                    controller: 'BannerImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sortOrder: null,
                                status: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('banner-image', null, { reload: 'banner-image' });
                }, function() {
                    $state.go('banner-image');
                });
            }]
        })
        .state('banner-image.edit', {
            parent: 'banner-image',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/banner-image/banner-image-dialog.html',
                    controller: 'BannerImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BannerImage', function(BannerImage) {
                            return BannerImage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('banner-image', null, { reload: 'banner-image' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('banner-image.delete', {
            parent: 'banner-image',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/banner-image/banner-image-delete-dialog.html',
                    controller: 'BannerImageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BannerImage', function(BannerImage) {
                            return BannerImage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('banner-image', null, { reload: 'banner-image' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('BannerImage', BannerImage);

    BannerImage.$inject = ['$resource'];

    function BannerImage ($resource) {
        var resourceUrl =  'api/banner-images/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageController', BannerImageController);

    BannerImageController.$inject = ['$state', 'BannerImage', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BannerImageController($state, BannerImage, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterData = filterData;
        vm.filterLang = pagingParams.filterLang;

        loadAll();

        function loadAll () {
            BannerImage.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                appLang: vm.filterLang,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bannerImages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                filterLang: vm.filterLang
            });
        }

        function filterData() {
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogDialogController', AppAttestLogDialogController);

    AppAttestLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'AppAttestLog'];

    function AppAttestLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, AppAttestLog) {
        var vm = this;

        vm.appAttestLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appAttestLog.id !== null) {
                AppAttestLog.update(vm.appAttestLog, onSaveSuccess, onSaveError);
            } else {
                AppAttestLog.save(vm.appAttestLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:appAttestLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPublicKeyData = function ($file, appAttestLog) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAttestLog.publicKeyData = base64Data;
                        appAttestLog.publicKeyDataContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogDetailController', AppAttestLogDetailController);

    AppAttestLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AppAttestLog'];

    function AppAttestLogDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AppAttestLog) {
        var vm = this;

        vm.appAttestLog = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:appAttestLogUpdate', function(event, result) {
            vm.appAttestLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('app-attest-log', {
            parent: 'entity',
            url: '/app-attest-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.appAttestLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-attest-log/app-attest-logs.html',
                    controller: 'AppAttestLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                endpoint: null,
                errorCode: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null,
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        endpoint: $stateParams.endpoint,
                        errorCode: $stateParams.errorCode,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAttestLog');
                    $translatePartialLoader.addPart('appAttestStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('app-attest-log-detail', {
            parent: 'app-attest-log',
            url: '/app-attest-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.appAttestLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-detail.html',
                    controller: 'AppAttestLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAttestLog');
                    $translatePartialLoader.addPart('appAttestStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppAttestLog', function($stateParams, AppAttestLog) {
                    return AppAttestLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'app-attest-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('app-attest-log-detail.edit', {
            parent: 'app-attest-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-attest-log.new', {
            parent: 'app-attest-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                keyId: null,
                                challenge: null,
                                phone: null,
                                endpoint: null,
                                requestBodyJson: null,
                                appVersionCode: null,
                                signCount: null,
                                responseJson: null,
                                publicKeyData: null,
                                publicKeyDataContentType: null,
                                status: null,
                                errorCode: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('app-attest-log');
                });
            }]
        })
        .state('app-attest-log.edit', {
            parent: 'app-attest-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-attest-log.delete', {
            parent: 'app-attest-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-delete-dialog.html',
                    controller: 'AppAttestLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('AppAttestLog', AppAttestLog);

    AppAttestLog.$inject = ['$resource', 'DateUtils'];

    function AppAttestLog ($resource, DateUtils) {
        var resourceUrl =  'api/app-attest-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogController', AppAttestLogController);

    AppAttestLogController.$inject = ['$state', 'DataUtils', 'AppAttestLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AppAttestLogController($state, DataUtils, AppAttestLog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.searchQuery = {
            phone: pagingParams.phone,
            status: pagingParams.status,
            endpoint: pagingParams.endpoint,
            errorCode: pagingParams.errorCode,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setMonth(vm.searchQuery.from.getMonth() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.searchQuery = {
                phone: null,
                endpoint: null,
                errorCode: null,
                status: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        initDatePicker();
        loadAll();

        function loadAll() {
            getDateTimeFromPicker();
            AppAttestLog.query({
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                errorCode: vm.searchQuery.errorCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.appAttestLogs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                phone: vm.searchQuery.phone,
                status: vm.searchQuery.status,
                endpoint: vm.searchQuery.endpoint,
                errorCode: vm.searchQuery.errorCode,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                search: vm.currentSearch
            });
        }

        loadAll();
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function () {
    'use strict';

    angular.module('bozorakaAdminApp')
        .directive('transactionStatus', transactionStatus);

    var statuses = {
        SUCCESS: {
            name: 'global.transaction.status.success',
            style: 'btn btn-xs green-seagreen'
        },
        INPROGRESS: {
            name: 'global.transaction.status.inprogress',
            style: 'btn btn-xs yellow-saffron'
        },
        FAILURE: {
            name: 'global.transaction.status.failure',
            style: 'btn btn-xs red-mint'
        },
        WAITING_FOR_PAYMENT: {
            name: 'global.transaction.status.waitingForPayment',
            style: 'btn btn-xs yellow-casablanca'
        }
    };

    function transactionStatus() {
        var directive = {
            restrict: 'EA',
            controller: TransactionStatusController,
            controllerAs: 'vm',
            bindToController: true,
            template: '<a class="{{vm.style}}" style="pointer-events: none">' +
            '{{vm.name | translate}}' +
            '</a>',
            scope: {
                status: '<'
            }
        };

        return directive;
    }

    function TransactionStatusController() {
        var vm = this;

        setStatus();

        function setStatus() {
            var status = statuses[vm.status];
            vm.name = status.name;
            vm.style = status.style;
        }
    }
})();

(function () {
    'use strict';

    angular.module('bozorakaAdminApp')
        .directive('transactionService', transactionService);

    var services = {
        SERVICE_CHANGE_BALANCE: {
            name: 'Balance',
            style: 'btn grey-cascade btn-xs'
        },
        SERVICE_UZB_PHONE: {
            name: 'UzTel',
            style: 'btn green-meadow btn-xs'
        },
        SERVICE_UZB_INTERNET: {
            name: 'UzInt',
            style: 'btn red-sunglo btn-xs'
        },
        SERVICE_KOR_PHONE: {
            name: 'PreCall',
            style: 'btn blue-madison btn-xs'
        },
        SERVICE_KOR_CARDPHONE_VOICE: {
            name: 'PreCall',
            style: 'btn blue-madison btn-xs'
        },
        SERVICE_KOR_CARDPHONE_INTERNET: {
            name: 'PreData',
            style: 'btn yellow-crusta btn-xs'
        },
        SERVICE_KOR_INTL_CARD: {
            name: 'IntCard',
            style: 'btn blue-hoki btn-xs'
        },
        SERVICE_VOIP: {
            name: 'VoIP',
            style: 'btn purple-plum btn-xs'
        },
        SERVICE_VOIP_UZTEL: {
            name: 'VoIP UzTel',
            style: 'btn purple-plum btn-xs'
        },
        SERVICE_MARKET: {
            name: 'Market',
            style: 'btn yellow-gold btn-xs'
        },
        SERVICE_RUS_PHONE: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_KAZ_PHONE: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_KGZ_PHONE: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_TJK_PHONE: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_UKR_PHONE: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_ARM_PHONE: {
            name: 'AmTel',
            style: 'btn purple-studio btn-xs'
        },
        SERVICE_MYS_PHONE: {
            name: 'MysTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_NPL_PHONE: {
            name: 'NplTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_MMR_PHONE: {
            name: 'MmrTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_IDN_PHONE: {
            name: 'IdnTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_VIE_PHONE: {
            name: 'VieTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_KHM_PHONE: {
            name: 'KhmTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_THA_PHONE: {
            name: 'ThaTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_BGD_PHONE: {
            name: 'BgdTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_LKA_PHONE: {
            name: 'LkaTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_PHL_PHONE: {
            name: 'PhlTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_IND_PHONE: {
            name: 'IndTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_PAK_PHONE: {
            name: 'PakTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_SGP_PHONE: {
            name: 'SgpTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_CHN_PHONE: {
            name: 'ChnTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_TUR_PHONE: {
            name: 'TurTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_THIS_BONUS: {
            name: 'ThisBonus',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_PAYFORM_KAZ_TELE2: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_PAYFORM_KAZ_BEELINE: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_PAYFORM_KAZ_KCELL: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_PAYFORM_KAZ_ALTEL: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_PAYFORM_KAZ_ACTIV: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_PAYFORM_KGZ_BEELINE: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_PAYFORM_KGZ_MEGACOM: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_PAYFORM_KGZ_NURTELECOM: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_PAYFORM_TJK_BEELINE: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_PAYFORM_TJK_MEGAFON: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_PAYFORM_TJK_VAVILONMOBILE: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_PAYFORM_TJK_INDIGO: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_PAYFORM_RUS_BEELINE: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_PAYFORM_RUS_MEGAFON: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_PAYFORM_RUS_MTC: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_PAYFORM_RUS_TELE2: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_PAYFORM_UKR_MTC: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_PAYFORM_UKR_KYEVSTAR: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_PAYFORM_UKR_LIFE: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_HERMES_KAZ_TELE2: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_HERMES_KAZ_BEELINE: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_HERMES_KAZ_KCELL: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_HERMES_KAZ_ALTEL: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_HERMES_KAZ_ACTIV: {
            name: 'KzTel',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_HERMES_KGZ_BEELINE: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_HERMES_KGZ_MEGACOM: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_HERMES_KGZ_NURTELECOM: {
            name: 'KgTel',
            style: 'btn red-thunderbird btn-xs'
        },
        SERVICE_HERMES_TJK_BEELINE: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_HERMES_TJK_MEGAFON: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_HERMES_TJK_VAVILON_MOBILE: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_HERMES_TJK_INDIGO: {
            name: 'TjTel',
            style: 'btn green-seagreen btn-xs'
        },
        SERVICE_HERMES_RUS_BEELINE: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_HERMES_RUS_MEGAFON: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_HERMES_RUS_MTC: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_HERMES_RUS_TELE2: {
            name: 'RuTel',
            style: 'btn yellow-saffron btn-xs'
        },
        SERVICE_HERMES_UKR_MTC: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_HERMES_UKR_KYEVSTAR: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_HERMES_UKR_LIFE: {
            name: 'UkTel',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_OK_CASH: {
            name: 'OkCash',
            style: 'btn btn-warning btn-xs'
        },
        SERVICE_UZB_UTILITY: {
            name: 'UzbUtil',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_KASH_PAYNET: {
            name: 'Paynet',
            style: 'btn green-meadow btn-xs'
        },
        SERVICE_PAYMENT: {
            name: 'Payment',
            style: 'btn green-meadow btn-xs'
        },
        SERVICE_HERMES_PAYMENT: {
            name: 'Hermes',
            style: 'btn green-meadow btn-xs'
        },
        SERVICE_EXPRESS_PAY: {
            name: 'ExpressPay',
            style: 'btn green-sharp btn-xs'
        },
        SERVICE_MOBILNIK: {
            name: 'Mobilnik',
            style: 'btn blue-steel btn-xs'
        },
        SERVICE_UNKNOWN: {
            name: '',
            style: 'display-none'
        }
    };

    function transactionService() {

        var template = '<button type="button" class="{{vm.style}}" style="pointer-events: none">' +
            '{{vm.name}}' +
            '</button>';

        var directive = {
            restrict: 'EA',
            template: template,
            controller: TransactionServiceController,
            controllerAs: 'vm',
            scope: {
                type: '<'
            },
            bindToController: true
        };

        return directive;
    }

    function TransactionServiceController() {
        var vm = this;

        setService();

        function setService() {
            if (vm.type === undefined) {
                vm.type = 'SERVICE_UNKNOWN';
            }
            var service = services[vm.type];
            vm.name = service.name;
            vm.style = service.style;
        }
    }
})();

(function () {
    'use strict';

    angular.module('bozorakaAdminApp')
        .directive('transactionMode', transactionMode);

    var modes = {
        MANUAL: {
            name: 'M',
            style: 'btn yellow-mint btn-xs'
        },
        AUTO: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        AUTO_010PAY: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        AUTO_MANGO: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        AUTO_UPAY: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        AUTO_KASH: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        AUTO_KASH_PAY: {
            name: 'A',
            style: 'btn purple-sharp btn-xs'
        },
        DISABLED: {
            name: 'D',
            style: 'btn grey-salsa btn-xs'
        },
        IDLE: {
            name: 'I',
            style: 'btn grey-salsa btn-xs'
        }
    };

    function transactionMode() {
        var directive = {
            restrict: 'EA',
            controller: TransactionModeController,
            controllerAs: 'vm',
            bindToController: true,
            template: '<button type="button" class="{{vm.style}}" style="pointer-events: none">' +
            '{{vm.name | translate}}' +
            '</button>',
            scope: {
                mode: '<'
            }
        };

        return directive;
    }

    function TransactionModeController() {
        var vm = this;

        setMode();

        function setMode() {
            var mode = modes[vm.mode];
            vm.name = mode.name;
            vm.style = mode.style;
        }
    }
})();

(function () {
    'use strict';

    angular.module('bozorakaAdminApp')
        .directive('transactionGateway', transactionGateway);

    var gateways = {
        yandex: {
            name: 'Yandex',
            style: 'btn yellow-mint btn-xs'
        },
        paynet: {
            name: 'Paynet',
            style: 'btn btn-xs green-seagreen'
        },
        vse_platezhi: {
            name: 'Vse Platezhi',
            style: 'btn btn-xs yellow-casablanca'
        },
        hermes: {
            name: 'Hermes',
            style: 'btn purple-sharp btn-xs'
        },
        tkb: {
            name: 'TKB',
            style: 'btn btn-xs yellow-casablanca'
        },
        undefined: {
            name: 'Undefined',
            style: 'btn btn-xs red-mint'
        }
    };

    function transactionGateway() {
        var directive = {
            restrict: 'EA',
            controller: TransactionGatewayController,
            controllerAs: 'vm',
            bindToController: true,
            template: '<button type="button" class="{{vm.style}}" style="pointer-events: none">' +
                '{{vm.name}}' +
                '</button>',
            scope: {
                gateway: '<'
            }
        };

        return directive;
    }

    function TransactionGatewayController() {
        var vm = this;

        setGateway();

        function setGateway() {
            var gateway = gateways[vm.gateway];
            if (gateway === undefined) {
                if (!vm.gateway) {
                    gateway = gateways[undefined];
                } else {
                    gateway = {
                        name: vm.gateway,
                        style: 'btn btn-xs red-mint'
                    }
                }
            }
            vm.name = gateway.name;
            vm.style = gateway.style;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('bozorakaAdminApp')
        .directive('serviceSelection', serviceSelection);

    var services = {
        UNKNOWN: 'ALL',
        SERVICE_KASH_PAYNET: 'Paynet',
        SERVICE_PAYMENT: 'Payment',
        SERVICE_HERMES_PAYMENT: 'Hermes',
        SERVICE_UZB_PHONE: 'UzTel',
        SERVICE_UZB_INTERNET: 'UzInt',
        SERVICE_VOIP: 'VoIP',
        SERVICE_RUS_PHONE: 'RuTel',
        SERVICE_KAZ_PHONE: 'KzTel',
        SERVICE_KGZ_PHONE: 'KgTel',
        SERVICE_TJK_PHONE: 'TjTel',
        SERVICE_UKR_PHONE: 'UkTel',
        SERVICE_ARM_PHONE: 'AmTel',
        SERVICE_OK_CASH: 'OkCash',
        SERVICE_UZB_UTILITY: 'UzbUtil',
        SERVICE_EXPRESS_PAY: 'ExpressPay',
        SERVICE_MOBILNIK: 'Mobilnik'
    };

    function serviceSelection() {
        var template =
            '<select class="form-control" name="serviceType" ng-model="vm.searchQuery.serviceType">' +
                '<option value=""></option>' +
            '<option ng-repeat="(key, value) in ownVm.serviceMap" value="{{key}}">{{value}}</option>' +
            '</select>'

        var directive = {
            restrict: 'EA',
            template: template,
            controller: ServiceSelectionController,
            controllerAs: 'ownVm',
            bindToController: true
        };

        return directive;
    }

    ServiceSelectionController.$inject = ['Principal'];

    function ServiceSelectionController(Principal) {
        var ownVm = this;
        ownVm.serviceMap = {};
        if (Principal.hasAnyAuthority(['ROLE_CUSTOMER_SUPPORT_PAYGRAM'])) {
            addServices([
                'UNKNOWN',
                'SERVICE_UZB_PHONE',
                'SERVICE_UZB_INTERNET',
                'SERVICE_KASH_PAYNET',
                'SERVICE_PAYMENT',
                'SERVICE_HERMES_PAYMENT',
                'SERVICE_VOIP',
                'SERVICE_RUS_PHONE',
                'SERVICE_KAZ_PHONE',
                'SERVICE_KGZ_PHONE',
                'SERVICE_TJK_PHONE',
                'SERVICE_UKR_PHONE',
                'SERVICE_OK_CASH',
                'SERVICE_EXPRESS_PAY',
                'SERVICE_MOBILNIK'
            ]);
        } else if (Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER'])) {
            // Remove or comment allServices, if you want to add ROLES manually
            var allServices = Object.keys(services);
            addServices(allServices);
        }

        function addServices(serviceKeys) {
            for (var i = 0; i < serviceKeys.length; i++) {
                var serviceKey = serviceKeys[i];
                ownVm.serviceMap[serviceKey] = services[serviceKey];
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('phoneNumber', phoneNumber);

    function phoneNumber() {
        return phoneNumberFilter;

        function phoneNumberFilter(phoneNumber) {
            if (phoneNumber.startsWith('010')) {
                return formatKoreanPhoneNumber(phoneNumber);
            } else if (phoneNumber.startsWith('m010')) {
                phoneNumber = phoneNumber.substring(1, 12);
                return formatKoreanPhoneNumber(phoneNumber);
            } else if (phoneNumber.startsWith('7')) {
                return formatRussianPhoneNumber(phoneNumber);
            }
            return phoneNumber;
        }

        function formatRussianPhoneNumber(phoneNumber) {
            return phoneNumber.substring(0, 1) + '-'
                + phoneNumber.substring(1, 4) + '-'
                + phoneNumber.substring(4, 7) + '-'
                + phoneNumber.substring(7, 9) + '-'
                + phoneNumber.substring(9, 11);
        }

        function formatKoreanPhoneNumber(phoneNumber) {
            return phoneNumber.substring(0, 3) + '-'
                + phoneNumber.substring(3, 7) + '-'
                + phoneNumber.substring(7, 11) + ''
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('bozorakaAdminApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('handledTime', handledTime);

    function handledTime() {
        return handledTimeFilter;

        function handledTimeFilter(date) {
            if (!isNaN(date)) {
                var time = moment.duration(date);
                var formattedTime = "";

                if (time.days() > 0) {
                    formattedTime += time.days() + "days ";
                }

                if (time.hours() > 0) {
                    formattedTime += ((time.hours() >= 10) ? time.hours() : "0" + time.hours()) + ":";
                }

                formattedTime += ((time.minutes() >= 10) ? time.minutes() : "0" + time.minutes()) + ":";
                formattedTime += (time.seconds() >= 10) ? time.seconds() : "0" + time.seconds();
                return formattedTime;
            } else {
                return "NaN";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat,
            transactionDateDifference: transactionDateDifference,
            currentTimestamp:currentTimestamp,
            currentDate:currentDate,
            converterDateFormat:converterDateFormat,
            converterDateTimeFormat:converterDateTimeFormat,
            currentDateFirstMonth:converterDateFirstMonth,
            addDate:addDate
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }

        function transactionDateDifference(transaction) {
            return moment(transaction.approvalDate).diff(moment(transaction.pubDate));
        }
        function currentTimestamp() {
            return moment().format("YYYYMMDDHHmmss");
        }
        function currentDate() {
            return moment().format("YYYY-MM-DD");
        }
        function converterDateFormat(date) {
            return moment(date).format('YYYY-MM-DD')
        }

        function converterDateTimeFormat(date) {
            return moment(date).format('YYYY-MM-DD HH:mm')
        }

        function converterDateFirstMonth() {
            return moment().format("MM/DD/YYYY");
        }

        function addDate(date, day) {
            return moment(date).add(day, 'days').format("MM/DD/YYYY")
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window', '$filter', '$sce'];

    function DataUtils($window, $filter, $sce) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            getDirectAmount: getDirectAmount,
            getDeductedAmount: getDeductedAmount,
            getSentAmount: getSentAmount,
            getResponse: getResponse,
            renderToHtml: renderToHtml,
            getCurrencyNameForClient: getCurrencyNameForClient,
            getCurrencySymbolForClient: getCurrencySymbolForClient
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function getDirectAmount(transaction) {
            var number = $filter('number');
            var currency = getCurrencyNameForClient(transaction.customerClient);
            if (transaction.localCurrency != null){
                currency = transaction.localCurrency;
            }
            return number(transaction.directAmount == null ? 0 : transaction.directAmount) + ' ' + currency;
        }

        function getDeductedAmount(transaction) {
            var number = $filter('number');
            var currency = getCurrencyNameForClient(transaction.customerClient);
            if (transaction.localCurrency != null){
                currency = transaction.localCurrency;
            }
            return number(transaction.amount) + ' ' + currency;
        }

        function getCurrencyNameForClient(customerClient) {
            var currency = 'ruble';
            if (customerClient == 'paygram_global') {
                currency = 'dollar';
            }
            return currency;
        }

        function getSentAmount(transaction) {
            var number = $filter('number');
            if (transaction.serviceCurrency != null){
                return number(transaction.amountInSom) + " " + transaction.serviceCurrency;
            } else if (transaction.gateway === 'vse_platezhi') {
                return number(transaction.amountInSom) + " ruble";
            } else if (transaction.serviceType == 'SERVICE_UZB_PHONE'
                || transaction.serviceType == 'SERVICE_UZB_INTERNET'
                || transaction.serviceType == 'SERVICE_UZB_UTILITY'
                || transaction.serviceType == 'SERVICE_KASH_PAYNET') {
                return number(transaction.amountInSom) + " so'm";
            } else if (transaction.serviceType == 'SERVICE_VOIP') {
                return number(transaction.voipEuro) + " euro";
            } else if (transaction.serviceType == 'SERVICE_VOIP_UZTEL') {
                return number(transaction.amountInSom) + " dollar";
            } else if (transaction.serviceType == 'SERVICE_RUS_PHONE') {
                return number(transaction.amountInSom) + (transaction.client == "010pay" ? " dollar" : " ruble");
            } else if (transaction.serviceType == 'SERVICE_KAZ_PHONE'
                || transaction.serviceType == 'SERVICE_KGZ_PHONE'
                || transaction.serviceType == 'SERVICE_TJK_PHONE'
                || transaction.serviceType == 'SERVICE_UKR_PHONE'
                || transaction.serviceType == 'SERVICE_ARM_PHONE'
                || transaction.serviceType == 'SERVICE_OK_CASH'
                || transaction.serviceType == 'SERVICE_EXPRESS_PAY'
                || transaction.serviceType == 'SERVICE_MOBILNIK') {
                return number(transaction.amountInSom) + " ruble";
            } else if (transaction.serviceType == 'SERVICE_PAYFORM_KAZ_TELE2'
                || transaction.serviceType == 'SERVICE_PAYFORM_KAZ_BEELINE'
                || transaction.serviceType == 'SERVICE_PAYFORM_KAZ_KCELL'
                || transaction.serviceType == 'SERVICE_PAYFORM_KAZ_ALTEL'
                || transaction.serviceType == 'SERVICE_PAYFORM_KAZ_ACTIV'
                || transaction.serviceType == 'SERVICE_PAYFORM_TJK_BEELINE'
                || transaction.serviceType == 'SERVICE_PAYFORM_TJK_MEGAFON'
                || transaction.serviceType == 'SERVICE_PAYFORM_TJK_INDIGO'
                || transaction.serviceType == 'SERVICE_PAYFORM_TJK_VAVILONMOBILE'
                || transaction.serviceType == 'SERVICE_PAYFORM_KGZ_BEELINE'
                || transaction.serviceType == 'SERVICE_PAYFORM_KGZ_NURTELECOM'
                || transaction.serviceType == 'SERVICE_PAYFORM_KGZ_MEGACOM'
                || transaction.serviceType == 'SERVICE_PAYFORM_RUS_MTC'
                || transaction.serviceType == 'SERVICE_PAYFORM_RUS_BEELINE'
                || transaction.serviceType == 'SERVICE_PAYFORM_RUS_MEGAFON'
                || transaction.serviceType == 'SERVICE_PAYFORM_RUS_TELE2'
                || transaction.serviceType == 'SERVICE_PAYFORM_UKR_MTC'
                || transaction.serviceType == 'SERVICE_PAYFORM_UKR_KYEVSTAR'
                || transaction.serviceType == 'SERVICE_PAYFORM_UKR_LIFE') {
                return number(transaction.amountInSom) + " dollar";
            } else if (transaction.serviceType == 'SERVICE_OK_CASH') {
                return number(transaction.amountInSom) + " rouble";
            } else if (transaction.serviceType == 'SERVICE_MYS_PHONE'
                || transaction.serviceType == 'SERVICE_NPL_PHONE'
                || transaction.serviceType == 'SERVICE_MMR_PHONE'
                || transaction.serviceType == 'SERVICE_IDN_PHONE'
                || transaction.serviceType == 'SERVICE_VIE_PHONE'
                || transaction.serviceType == 'SERVICE_KHM_PHONE'
                || transaction.serviceType == 'SERVICE_THA_PHONE'
                || transaction.serviceType == 'SERVICE_BGD_PHONE'
                || transaction.serviceType == 'SERVICE_LKA_PHONE'
                || transaction.serviceType == 'SERVICE_PHL_PHONE'
                || transaction.serviceType == 'SERVICE_IND_PHONE'
                || transaction.serviceType == 'SERVICE_PAK_PHONE'
                || transaction.serviceType == 'SERVICE_SGP_PHONE'
                || transaction.serviceType == 'SERVICE_CHN_PHONE'
                || transaction.serviceType == 'SERVICE_TUR_PHONE') {
                return number(transaction.amountInSom) + (transaction.status == 'SUCCESS' ? " dollar" : "");
            } else if (transaction.serviceType == 'SERVICE_THIS_BONUS') {
                return number(transaction.amountInSom) + " won";
            } else {
                return number(transaction.amount + transaction.usedMileage) + " " + getCurrencyNameForClient(transaction.customerClient);
            }
        }

        function getResponse(transaction) {
            var response = "";

            if (transaction.serviceType == 'SERVICE_UZB_PHONE'
                || transaction.serviceType == 'SERVICE_UZB_INTERNET'
                || transaction.serviceType == 'SERVICE_THIS_BONUS'
                || transaction.serviceType == 'SERVICE_VOIP_UZTEL'
                || transaction.serviceType == 'SERVICE_UZB_UTILITY'
                || transaction.serviceType == 'SERVICE_KASH_PAYNET') {
                response = transaction.autoModeResponse;
            } else if (transaction.serviceType == 'SERVICE_KOR_CARDPHONE_VOICE') {
                if (transaction.mangoAutoModeResponse != null) {
                    response = "Mango auto response: " + transaction.mangoAutoModeResponse;
                }
                if (transaction.thePayAutoModeResponse != null) {
                    response += "       010Pay auto response: " + transaction.thePayAutoModeResponse;
                }
            } else if (transaction.serviceType == 'SERVICE_KOR_INTL_CARD') {
                if (transaction.description.toLowerCase().indexOf('this') != -1) {
                    response = transaction.autoModeResponse;
                } else if (transaction.description.toLowerCase().indexOf('the+') != -1
                    || transaction.description.toLowerCase().indexOf('00301') != -1) {
                    response = transaction.thePayAutoModeResponse;
                } else {
                    response = transaction.mangoAutoModeResponse;
                }
            } else if (transaction.serviceType == 'SERVICE_VOIP') {
                response = transaction.yandexProcessPaymentResponse;
            } else {
                if (transaction.yandexRequestPaymentResponse != null) {
                    response += "Request payment response: " + transaction.yandexRequestPaymentResponse;
                }
                if (transaction.yandexProcessPaymentResponse != null) {
                    response += "       Process payment response: " + transaction.yandexProcessPaymentResponse;
                }
                if (transaction.autoModeResponse != null) {
                    response = transaction.autoModeResponse;
                }
            }

            return response;
        }

        function renderToHtml(value) {
            return $sce.trustAsHtml(value);
        }

        function getCurrencySymbolForClient(client) {
            if (client == null || client == undefined) {
                return '';
            }
            if (client == 'bozoraka' || client == 'mobpay') {
                return 'fa fa-won';
            } else if (client == 'immigrant') {
                return 'fa fa-rub'
            } else if (client == 'paygram_global') {
                return 'fa fa-dollar'
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

// (function() {
//     'use strict';
//
//     angular
//         .module('bozorakaAdminApp')
//         .controller('LoginController', LoginController);
//
//     LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];
//
//     function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
//         var vm = this;
//
//         vm.authenticationError = false;
//         vm.cancel = cancel;
//         vm.credentials = {};
//         vm.login = login;
//         vm.password = null;
//         vm.register = register;
//         vm.rememberMe = true;
//         vm.requestResetPassword = requestResetPassword;
//         vm.username = null;
//
//         $timeout(function (){angular.element('#username').focus();});
//
//         function cancel () {
//             vm.credentials = {
//                 username: null,
//                 password: null,
//                 rememberMe: true
//             };
//             vm.authenticationError = false;
//             $uibModalInstance.dismiss('cancel');
//         }
//
//         function login (event) {
//             event.preventDefault();
//             Auth.login({
//                 username: vm.username,
//                 password: vm.password,
//                 rememberMe: vm.rememberMe
//             }).then(function () {
//                 vm.authenticationError = false;
//                 $uibModalInstance.close();
//                 if ($state.current.name === 'register' || $state.current.name === 'activate' ||
//                     $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
//                     $state.go('home');
//                 }
//
//                 $rootScope.$broadcast('authenticationSuccess');
//
//                 // previousState was set in the authExpiredInterceptor before being redirected to login modal.
//                 // since login is successful, go to stored previousState and clear previousState
//                 if (Auth.getPreviousState()) {
//                     var previousState = Auth.getPreviousState();
//                     Auth.resetPreviousState();
//                     $state.go(previousState.name, previousState.params);
//                 }
//             }).catch(function () {
//                 vm.authenticationError = true;
//             });
//         }
//
//         function register () {
//             $uibModalInstance.dismiss('cancel');
//             $state.go('register');
//         }
//
//         function requestResetPassword () {
//             $uibModalInstance.dismiss('cancel');
//             $state.go('requestReset');
//         }
//     }
// })();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('ADMIN_NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'uz': 'Ўзбекча',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$scope'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $scope) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
        vm.currentLanguage = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        JhiLanguageService.getCurrent().then(function (language) {
            vm.currentLanguage = language;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            vm.currentLanguage = languageKey;
            $scope.$emit('translateChanged', languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'ru'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><span>{{ alert.msg }}</span></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('bozorakaAdminApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('bozorakaAdminApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant(fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 3000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><span ng-bind-html="alert.msg"></span></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('bozorakaAdminApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('bozorakaAdminApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            } else if (response.status === 403) {
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(false);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$location', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $location, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
                          Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (!Principal.isIdentityResolved()) {
                    Principal.identity(true).then(function (account) {
                        if (!Principal.isAuthenticated()) {
                            var url = $location.url();
                            if (url !== '/login') {
                                $window.location.href = '/#/login';
                                $window.location.reload();
                            }
                        }
                    });
                } else if (!Principal.isAuthenticated()) {
                    var url = $location.url();
                    if (url !== '/login') {
                        $window.location.href = '/#/login';
                        $window.location.reload();
                    }
                } else if (Principal.isAuthenticated() && !Principal.isGoogleAuthEnabled()) {
                    var gAuthUrl = $location.url();
                    if (gAuthUrl !== '/google-auth') {
                        $window.location.href = '/#/google-auth';
                        $window.location.reload();
                    }
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
                Layout.setAngularJsSidebarMenuActiveLink('match', null, $state); // activate selected link in the sidebar menu
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 7;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        $translateProvider.storagePrefix('ADMIN_');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('ADMIN_NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('bozoraka-admin-');
        $sessionStorageProvider.setKeyPrefix('bozoraka-admin-');
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'HeaderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppController', AppController);

    AppController.$inject = ['$scope', '$location', '$state', '$translatePartialLoader', '$translate', 'Principal'];

    function AppController($scope, $location, $state, $translatePartialLoader, $translate, Principal) {
        $scope.loginCss = "";

        getAccount();

        function getAccount() {
            Principal.identity(true).then(function (account) {
                $scope.isAuthenticated = Principal.isAuthenticated();
                $scope.isGoogleAuthEnabled = Principal.isGoogleAuthEnabled();
                if (!$scope.isGoogleAuthEnabled) {
                    $state.go('google-auth');
                }
                if (!$scope.isAuthenticated) {
                    $scope.loginCss = "login";
                    $translatePartialLoader.addPart('login');
                    $translate.refresh();
                    $state.go('login');
                }
            });
        }
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('bozorakaAdminApp')
        .constant('VERSION', "0.2.45-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management.new', {
                parent: 'user-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    login: null,
                                    password: null,
                                    firstName: null,
                                    lastName: null,
                                    email: null,
                                    phone: null,
                                    activated: true,
                                    langKey: null,
                                    createdBy: null,
                                    createdDate: null,
                                    lastModifiedBy: null,
                                    lastModifiedDate: null,
                                    resetDate: null,
                                    resetKey: null,
                                    authorities: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER_SUPPORT_PAYGRAM'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.setTfaActive = setTfaActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function setTfaActive (user, tfaActive) {
            user.tfaActive = tfaActive;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
            setTimeout(function () {
                enableClipboard();
            }, 0);
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, tfaActive: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('bozorakaAdminApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        }).state('settings.disable-tfa', {
            parent: 'settings',
            url: '/settings/disable-tfa',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/layouts/google-auth/google-auth-dialog.html',
                    controller: 'GoogleAuthDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'User'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, User) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                phone: account.phone,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                tfaActive: account.tfaActive,
                tfaQrUrl: account.tfaQrUrl,
                tfaSecretKey: account.tfaSecretKey
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['$location', '$window', 'Auth', 'Principal'];

    function PasswordController ($location, $window, Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    logout();
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function logout() {
            $location.path('/login').replace();
            Auth.logout();
            $window.location.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('bozorakaAdminApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<jhi-alert></jhi-alert><div has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><div class="row"><div class="col-md-12"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light"><div class="portlet-body"><div class="row"><div class="col-md-6"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light"><div class="portlet-title"><div class="caption"><i class="icon-share font-dark hide"></i> <span class="caption-subject font-dark bold uppercase" data-translate="dashboard.russiaSmsAccount">Russia SMS account</span></div></div><div class="portlet-body"><div class="row"><div class="col-md-5"><div class="dashboard-stat2 bg-grey-cararra bg-font-grey-cararra bordered" style="height: 141px"><div class="display"><div class="number"><h3 class="font-green-sharp"><span data-counter="counterup">{{vm.smsRussiaLimit.total_limit}}</span> <small class="font-green-sharp"><i class="fa fa-envelope-o"></i></small></h3><small data-translate="dashboard.dailySms">Daily SMS</small></div><div class="icon"><i class="icon-pie-chart"></i></div></div><div class="progress-info"><div class="progress"><span style="width: {{vm.getUsedSmsPercentage(vm.smsRussiaLimit.used_today)}}%" class="progress-bar progress-bar-success green-sharp"><span class="sr-only">{{vm.getUsedSms(vm.smsRussiaLimit.used_today)}}% progress</span></span></div><div class="status"><div class="status-title" data-translate="dashboard.used">used</div><div class="status-number">{{vm.smsRussiaLimit.used_today}}</div></div></div></div></div><div class="col-md-7"><!-- BEGIN WIDGET THUMB --><div class="widget-thumb bg-grey-cararra bg-font-grey-cararra text-uppercase margin-bottom-20 bordered" style="height: 141px"><h4 class="widget-thumb-heading" data-translate="dashboard.currentBalance">Current Balance</h4><div class="widget-thumb-wrap"><i class="widget-thumb-icon bg-green fa fa-ruble"></i><div class="widget-thumb-body"><span class="widget-thumb-subtitle">RUB</span> <span class="widget-thumb-body-stat" style="font-size: 26px">{{vm.smsRussiaBalance.balance | number}}</span></div></div></div><!-- END WIDGET THUMB --></div></div></div></div></div></div><div class="col-md-6"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light"><div class="portlet-title"><div class="caption"><i class="icon-share font-dark hide"></i> <span class="caption-subject font-dark bold uppercase">Exchange rate</span></div></div><div class="row"><div class="col-md-6"><div class="portlet-body"><div><table class="table table-striped table-bordered table-hover order-column" style="height: 141px"><tbody><tr><td>1,000 RUB</td><td>{{(1000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr><tr><td>5,000 RUB</td><td>{{(5000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr><tr><td>10,000 RUB</td><td>{{(10000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr></tbody></table></div></div></div><div class="col-md-6"><div class="portlet-body"><div><table class="table table-striped table-bordered table-hover order-column" style="height: 141px"><tbody><tr><td>15,000 RUB</td><td>{{(15000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr><tr><td>20,000 RUB</td><td>{{(20000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr><tr><td>50,000 RUB</td><td>{{(50000 * vm.allConfigs[\'p2p_rub_to_uzs_with_margin\'].value) | number}} UZS</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light bordered"><div class="portlet-body"><div class="row"><div class="col-md-4"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="icon-share font-dark hide"></i> <span class="caption-subject font-dark bold uppercase">New users</span></div></div><div class="portlet-body"><div><table class="table table-striped table-bordered table-hover order-column"><thead><tr><th>Date</th><th>Count</th><th>T</th><th>P</th></tr></thead><tbody><tr ng-repeat="newCustomer in vm.newCustomers | limitTo:(vm.newCustomers.length-1) "><td>{{newCustomer.date}}</td><td ng-if="vm.newCustomers[$index+1].count > newCustomer.count"><span class="badge badge-danger">{{newCustomer.count}}</span></td><td ng-if="vm.newCustomers[$index+1].count <= newCustomer.count"><span class="badge" style="background: #1BBC9B">{{newCustomer.count}}</span></td><td ng-if="vm.findTransferNewUsersByDate(newCustomer.date) === 0 || vm.findTransferNewUsersByDate(vm.newCustomers[$index+1].date) > vm.findTransferNewUsersByDate(newCustomer.date)"><span class="badge badge-danger">{{vm.findTransferNewUsersByDate(newCustomer.date)}}</span></td><td ng-if="vm.findTransferNewUsersByDate(newCustomer.date) !== 0 && vm.findTransferNewUsersByDate(vm.newCustomers[$index+1].date) <= vm.findTransferNewUsersByDate(newCustomer.date)"><span class="badge" style="background: #1BBC9B">{{vm.findTransferNewUsersByDate(newCustomer.date)}}</span></td><td ng-if="vm.findPaymentNewUsersByDate(newCustomer.date) === 0 || vm.findPaymentNewUsersByDate(vm.newCustomers[$index+1].date) > vm.findPaymentNewUsersByDate(newCustomer.date)"><span class="badge badge-danger">{{vm.findPaymentNewUsersByDate(newCustomer.date)}}</span></td><td ng-if="vm.findPaymentNewUsersByDate(newCustomer.date) !== 0 && vm.findPaymentNewUsersByDate(vm.newCustomers[$index+1].date) <= vm.findPaymentNewUsersByDate(newCustomer.date)"><span class="badge" style="background: #1BBC9B">{{vm.findPaymentNewUsersByDate(newCustomer.date)}}</span></td></tr></tbody></table></div></div></div></div></div><div class="col-md-4"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="icon-share font-dark hide"></i> <span class="caption-subject font-dark bold uppercase">Total transfers</span></div></div><div class="portlet-body"><div><table class="table table-striped table-bordered table-hover order-column"><thead><tr><th>Date</th><th>Count</th></tr></thead><tbody><tr ng-repeat="transfer in vm.transfers | limitTo: (vm.transfers.length-1) "><td>{{transfer.date}}</td><td ng-if="vm.transfers[$index+1].count > transfer.count"><span class="badge badge-danger">{{transfer.count}}</span></td><td ng-if="vm.transfers[$index+1].count <= transfer.count"><span class="badge" style="background: #1BBC9B">{{transfer.count}}</span></td></tr></tbody></table></div></div></div></div></div><div class="col-md-4"><div class="col-lg-12 col-xs-12 col-sm-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="icon-share font-dark hide"></i> <span class="caption-subject font-dark bold uppercase">Total payments</span></div></div><div class="portlet-body"><div><table class="table table-striped table-bordered table-hover order-column"><thead><tr><th>Date</th><th>Count</th></tr></thead><tbody><tr ng-repeat="payment in vm.payments | limitTo: (vm.payments.length-1) "><td>{{payment.date}}</td><td ng-if="vm.payments[$index+1].count > payment.count"><span class="badge badge-danger">{{payment.count}}</span></td><td ng-if="vm.payments[$index+1].count <= payment.count"><span class="badge" style="background: #1BBC9B">{{payment.count}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div></div><div class="row" has-any-authority="ROLE_CUSTOMER_SUPPORT_PAYGRAM"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-wrench font-dark"></i> <span class="caption-subject bold uppercase">under construction</span></div></div><div class="portlet-body">This page is under construction. Please check back soon.</div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<h2 class="page-title" data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="icon-equalizer font-green-haze"></i> <span class="caption-subject font-green-haze bold uppercase" data-translate="settings.subtitle">Authorized user</span></div></div><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><div class="portlet-body form"><!-- BEGIN FORM--><form name="form" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="form-group"><label class="col-md-3 control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><div class="col-md-4"><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><div class="col-md-4"><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="email" data-translate="global.form.email">E-mail</label><div class="col-md-4"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="phone" data-translate="settings.form.phone">Phone #</label><div class="col-md-4"><input type="text" class="form-control" id="phone" name="phone" ng-model="vm.settingsAccount.phone" required><div ng-show="form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="langKey" data-translate="settings.form.language">Language</label><div class="col-md-4"><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="settings.form.tfa">2FA</label><div class="col-md-4"><img ng-if="vm.settingsAccount.tfaActive && vm.settingsAccount.tfaQrUrl != null" ng-src="{{vm.settingsAccount.tfaQrUrl}}" width="200px" height="200px"><br><p><a ui-sref="settings.disable-tfa" class="btn btn-outline red btn-sm">Disable</a></p></div></div></div><div class="form-actions"><div class="row"><div class="col-md-offset-3 col-md-4"><button type="submit" ng-disabled="form.$invalid" class="btn green-haze" data-translate="settings.form.button">Save</button></div></div></div></form><!-- END FORM--></div></div></div></div><!--<div>--><!--<div class="row">--><!--<div class="col-md-8 col-md-offset-2">--><!--<h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User--><!--settings for [<b>{{vm.settingsAccount.login}}</b>]</h2>--><!--<div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success">--><!--<strong>Settings saved!</strong>--><!--</div>--><!--<jhi-alert-error></jhi-alert-error>--><!--<form name="form" role="form" novalidate ng-submit="vm.save()" show-validation>--><!--<div class="form-group">--><!--<label class="control-label" for="firstName" data-translate="settings.form.firstname">First--><!--Name</label>--><!--<input type="text" class="form-control" id="firstName" name="firstName"--><!--placeholder="{{\'settings.form.firstname.placeholder\' | translate}}"--><!--ng-model="vm.settingsAccount.firstName" ng-minlength=1 ng-maxlength=50 required--><!--maxlength="50">--><!--<div ng-show="form.firstName.$dirty && form.firstName.$invalid">--><!--<p class="help-block"--><!--ng-show="form.firstName.$error.required"--><!--data-translate="settings.messages.validate.firstname.required">--><!--Your first name is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.firstName.$error.minlength"--><!--data-translate="settings.messages.validate.firstname.minlength">--><!--Your first name is required to be at least 1 character.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.firstName.$error.maxlength"--><!--data-translate="settings.messages.validate.firstname.maxlength">--><!--Your first name cannot be longer than 50 characters.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="lastName" data-translate="settings.form.lastname">Last--><!--Name</label>--><!--<input type="text" class="form-control" id="lastName" name="lastName"--><!--placeholder="{{\'settings.form.lastname.placeholder\' | translate}}"--><!--ng-model="vm.settingsAccount.lastName" ng-minlength=1 ng-maxlength=50 required--><!--maxlength="50">--><!--<div ng-show="form.lastName.$dirty && form.lastName.$invalid">--><!--<p class="help-block"--><!--ng-show="form.lastName.$error.required"--><!--data-translate="settings.messages.validate.lastname.required">--><!--Your last name is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.lastName.$error.minlength"--><!--data-translate="settings.messages.validate.lastname.minlength">--><!--Your last name is required to be at least 1 character.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.lastName.$error.maxlength"--><!--data-translate="settings.messages.validate.lastname.maxlength">--><!--Your last name cannot be longer than 50 characters.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" for="email" data-translate="global.form.email">E-mail</label>--><!--<input type="email" class="form-control" id="email" name="email"--><!--placeholder="{{\'global.form.email.placeholder\' | translate}}"--><!--ng-model="vm.settingsAccount.email" ng-minlength=5 ng-maxlength=100 required maxlength="100">--><!--<div ng-show="form.email.$dirty && form.email.$invalid">--><!--<p class="help-block"--><!--ng-show="form.email.$error.required"--><!--data-translate="global.messages.validate.email.required">--><!--Your e-mail is required.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">--><!--Your e-mail is invalid.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.email.$error.minlength"--><!--data-translate="global.messages.validate.email.minlength">--><!--Your e-mail is required to be at least 5 characters.--><!--</p>--><!--<p class="help-block"--><!--ng-show="form.email.$error.maxlength"--><!--data-translate="global.messages.validate.email.maxlength">--><!--Your e-mail cannot be longer than 100 characters.--><!--</p>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="langKey" data-translate="settings.form.language">Language</label>--><!--<select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey"--><!--ng-controller="JhiLanguageController as languageVm"--><!--ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>--><!--</div>--><!--<button type="submit" ng-disabled="form.$invalid" class="btn btn-primary"--><!--data-translate="settings.form.button">Save--><!--</button>--><!--</form>--><!--</div>--><!--</div>--><!--</div>-->');
$templateCache.put('app/account/password/password.html','<h2 class="page-title" data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="icon-equalizer font-green-haze"></i> <span class="caption-subject font-green-haze bold uppercase" data-translate="password.subtitle">Change password</span></div></div><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="portlet-body form"><form class="form-horizontal" name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="col-md-3 control-label" for="password" data-translate="global.form.newpassword">New password</label><div class="col-md-4"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="form-group"><label class="col-md-3 control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><div class="col-md-4"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="form-actions"><div class="row"><div class="col-md-offset-3 col-md-4"><button type="submit" ng-disabled="form.$invalid" class="btn green-haze" data-translate="password.form.button">Save</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">Password</label><input type="password" class="form-control" id="password" name="password" ng-model="vm.user.password"></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.phone">Phone #</label><input type="text" class="form-control" name="phone" ng-model="vm.user.phone" required><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label for="tfaActive">Two Factor Authentication Status</label><br><input ng-disabled="vm.user.id === null" type="checkbox" id="tfaActive" name="tfaActive" ng-model="vm.user.tfaActive"> <span data-translate="userManagement.enabled">Enabled</span></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn green-haze"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-user-following font-dark"></i> <span class="caption-subject bold uppercase" data-translate="userManagement.home.title">Authorized users</span></div></div><div class="portlet-body"><div class="table-toolbar"><div class="row"><div class="col-md-6"><div class="btn-group"><button class="btn btn-primary" ui-sref="user-management.new"><i class="fa fa-plus"></i> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="userManagement.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th>2FA Status</th><th>2FA QR Code</th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td><span class="label label-danger" ng-click="vm.setTfaActive(user, true)" ng-show="!user.tfaActive" data-translate="userManagement.disabled" style="cursor: pointer">Disabled</span> <span class="label label-success" ng-click="vm.setTfaActive(user, false)" ng-show="user.tfaActive" data-translate="userManagement.enabled" style="cursor: pointer">Enabled</span></td><td><a href="javascript:;" class="btn btn-small blue mt-clipboard" ng-show="user.tfaQrUrl != null" data-clipboard-action="copy" style="margin: 0px" data-clipboard-text="{{user.tfaQrUrl}}" title="You can copy url"><i class="icon-note"></i> Copy Url</a></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-left"><div class="btn-group flex-btn-group-container"><!--<button type="submit"--><!--ui-sref="user-management-detail({login:user.login})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span>--><!--</button>--> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><!-- END EXAMPLE TABLE PORTLET--></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/layouts/google-auth/google-auth-dialog.html','<form name="gauthDisable" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictLabel">Turn 2FA off?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><h4>Turning off two-factor authentication means your account may be more vulnerable to compromise. Are you sure to turn it off?</h4><label for="password">Enter your Immigrant Admin password to verify yourself:</label><div class="input-group text-center" id="password-group"><div class="input-icon"><i class="fa fa-lock fa-fw"></i> <input id="password" class="form-control" type="password" ng-model="vm.userPassword" placeholder="User password"></div></div><div class="clearfix"></div><p ng-if="vm.passwordStatus === -1"></p><p class="text-success" ng-if="vm.passwordStatus === 1">Two-factor authentication is turned off.</p><p class="text-danger" ng-if="vm.passwordStatus === 0">Password is incorrect. Please, check and re-enter your password</p></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.isSaving" class="btn btn-primary">&nbsp;Turn off</button></div></form>');
$templateCache.put('app/layouts/google-auth/google-auth.html','<div ng-cloak><div class="container text-center" style="margin-top: 50px"><div class="col-md-offset-2 col-md-8 col-xs-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="fa fa-qrcode font-green-sharp"></i> <span class="caption-subject font-green-sharp bold uppercase" data-translate="googleAuth.title">Two factor authentication set up</span></div><div class="actions"><span data-translate="googleAuth.steps.step">Step </span>{{vm.step}} <span data-translate="googleAuth.steps.of">of </span>4</div></div><div class="portlet-body"><p class="text-right" ng-controller="JhiLanguageController as languageVm"><a href="" ng-if="languageVm.currentLanguage == \'ru\'" ng-click="languageVm.changeLanguage(\'en\');"><img alt="" style="vertical-align: baseline" src="content/images/en.png"> English </a><a href="" ng-if="languageVm.currentLanguage == \'en\'" ng-click="languageVm.changeLanguage(\'ru\');"><img alt="" style="vertical-align: baseline" src="content/images/ru.png"> \u0420\u0443\u0441\u0441\u043A\u0438\u0439</a></p><div class="mt-element-step hidden-sm hidden-xs"><div class="row step-line"><div class="col-xs-3 mt-step-col first {{vm.stepStyle(1)}}"><div class="mt-step-number bg-white">1</div><div class="mt-step-title uppercase font-grey-cascade" data-translate="googleAuth.steps.step1">Enable</div><div class="mt-step-content font-grey-cascade" data-translate="googleAuth.steps.desc1">Two factor authentication</div></div><div class="col-md-3 mt-step-col {{vm.stepStyle(2)}}"><div class="mt-step-number bg-white">2</div><div class="mt-step-title uppercase font-grey-cascade" data-translate="googleAuth.steps.step2">Scan</div><div class="mt-step-content font-grey-cascade" data-translate="googleAuth.steps.desc2">Generated QR code</div></div><div class="col-xs-3 mt-step-col {{vm.stepStyle(3)}}"><div class="mt-step-number bg-white">3</div><div class="mt-step-title uppercase font-grey-cascade" data-translate="googleAuth.steps.step3">Verify</div><div class="mt-step-content font-grey-cascade" data-translate="googleAuth.steps.desc3">Your one time password</div></div><div class="col-xs-3 mt-step-col last {{vm.stepStyle(4)}}"><div class="mt-step-number bg-white">4</div><div class="mt-step-title uppercase font-grey-cascade" data-translate="googleAuth.steps.step4">Save</div><div class="mt-step-content font-grey-cascade" data-translate="googleAuth.steps.desc4">and start working.</div></div></div></div><div id="step_1" ng-if="vm.step === 1"><p data-translate="googleAuth.info.disabledText">Seems you have disabled two-factor authentication. Please, enable it in order to using admin panel.</p><div class="well"><p class="h3" data-translate="googleAuth.info.state">2FA state</p><div class="btn-group btn-group-circle"><button type="button" ng-click="vm.changeTfaState(false)" class="btn btn-outline red btn-sm {{!vm.isTfaEnabled() ? \'active\' : \'\'}}"><span data-translate="googleAuth.info.disabled">Disabled</span></button> <button type="button" ng-click="vm.changeTfaState(true)" class="btn btn-outline green btn-sm {{vm.isTfaEnabled() ? \'active\' : \'\'}}"><span data-translate="googleAuth.info.enabled">Enable</span></button></div><div ng-if="vm.tfaNewStateEnabled" class="text-justify"><form id="passwordForm" ng-submit="vm.verifyPassword()"><p>&nbsp;</p><label for="password-group" data-translate="googleAuth.info.enterPassword">Enter your Immigrant Admin password to verify yourself:</label><div class="input-group" id="password-group"><div class="input-icon"><i class="fa fa-lock fa-fw"></i> <input class="form-control" type="password" ng-model="vm.userPassword" placeholder="{{\'googleAuth.info.password\' | translate}}"></div><span class="input-group-btn"><button type="button" class="btn btn-success {{vm.verifyingPassword ? \'disabled\' : \'\'}}" id="verifyPasswordBtn" ng-click="vm.verifyPassword()">{{\'googleAuth.info.verifyBtn\' | translate}}</button></span></div><p ng-if="vm.passwordStatus === -1">&nbsp;</p><p class="text-success" ng-if="vm.passwordStatus === 1" data-translate="googleAuth.info.correctPassword">Password is correct. You can proceed</p><p class="text-danger" ng-if="vm.passwordStatus === 0" data-translate="googleAuth.info.incorrectPassword">Password is incorrect. Please, check and re-enter your password</p></form></div></div><p class="text-justify" data-translate="googleAuth.info.app">You can use a compatible authentication app (e.g., Google Authenticator) to get an authentication code when you log in to Immigrant Admin. We\'ll walk you through linking the app to your Immigrant Admin account.</p><p data-translate="googleAuth.info.appLink">Here is links to Google Authenticator for <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"><i class="fa fa-android"></i> Android </a>and <a href="https://apps.apple.com/us/app/google-authenticator/id388497605"><i class="fa fa-apple"></i> iOS</a></p></div><div id="step_2" ng-if="vm.step === 2"><p data-translate="googleAuth.info.openAuthApp">Open the authentication app on your mobile device to link it to your Immigrant Admin account. When the app prompts you, scan the following QR code with your camera.</p><div ng-if="vm.loadingAuthKeys" class="loading-message loading-message-boxed"><img src="/content/images/loading.gif"><span data-translate="googleAuth.info.loading">&nbsp;&nbsp;LOADING...</span></div><img ng-if="!vm.loadingAuthKeys" ng-src="{{vm.tfaQrUrl}}" height="256px" width="256px" alt="error occurred"><h3>{{vm.tfaSecretKey}}</h3></div><div id="step_3" ng-if="vm.step === 3"><p class="h3" data-translate="googleAuth.info.tryAuthCode">Try the authentication code now</p><p class="text-justify" data-translate="googleAuth.info.tryDesc">From the authentication app, get a code and enter it below to complete the verification process.</p><div class="well"><form id="otpForm" ng-submit="vm.verifyTfa()"><div class="input-group"><div class="input-icon"><i class="fa fa-qrcode fa-fw"></i> <input class="form-control" type="number" name="otp" ng-model="vm.oneTimePassword" placeholder="{{\'googleAuth.info.verificationCode\' | translate}}"></div><span class="input-group-btn"><button type="button" class="btn btn-success" id="verifyBtn" ng-click="vm.verifyTfa()">{{\'googleAuth.info.verifyBtn\' | translate}}</button></span></div></form></div><p ng-if="vm.tfaVerifiedMessage === -1">&nbsp;</p><p ng-if="vm.tfaVerifiedMessage === 1" class="text-success text-justify" data-translate="googleAuth.info.correctVerification">You have set Google Authenticator correctly. Now you can proceed to final step.</p><p ng-if="vm.tfaVerifiedMessage === 0" class="text-danger text-justify" data-translate="googleAuth.info.inCorrectVerification">One time passwords did not match! Please check correctness or rescan QR code from previous step.</p></div><div id="step_4" ng-if="vm.step === 4"><h3 data-translate="googleAuth.info.almostDone">Almost done</h3><p data-translate="googleAuth.info.almostDoneDesc">Your two-factor authentication option will be saved after you click Save button. Then, you will be logged out and prompt to log in again.</p></div><hr><ul class="pager"><li class="pull-left" ng-if="vm.step === 1"><a ng-click="vm.logout()">{{\'googleAuth.footer.logout\' | translate}} <i class="fa fa-sign-out"></i></a> {{\'googleAuth.footer.ifOtherUser\' | translate}} <code>{{vm.userName}}</code></li><li class="previous" ng-if="vm.step > 1"><a href="javascript:;" class="btn blue" ng-click="vm.back()"><i class="fa fa-angle-left"></i> {{\'googleAuth.footer.back\' | translate}}</a></li><li class="next" ng-if="vm.step < 4"><a href="javascript:;" class="btn blue {{!vm.isNextEnabled() ? \'disabled\' : \'\'}}" ng-click="vm.next()">{{\'googleAuth.footer.next\' | translate}} <i class="fa fa-angle-right"></i></a></li><li class="next" ng-if="vm.step === 4"><a href="javascript:;" class="btn green-jungle {{vm.isSaving ? \'disabled\' : \'\'}}" ng-click="vm.save()">{{\'googleAuth.footer.save\' | translate}} <i class="fa fa-save"></i></a></li></ul></div></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/header/header.html','<div class="page-header navbar navbar-fixed-top"><!-- BEGIN HEADER INNER --><div class="page-header-inner"><!-- BEGIN LOGO --><div class="page-logo"><a ui-sref="dashboard"><!--<img src="content/images/logo.png" alt="logo" class="logo-default" />--><h4 class="logo-default" style="color: #fff;font-weight: 500!important"><span data-translate="global.title">Immigrant Admin</span></h4></a><div class="menu-toggler sidebar-toggler"><span></span></div></div><!-- END LOGO --><!-- BEGIN RESPONSIVE MENU TOGGLER --> <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse"><span></span> </a><!-- END RESPONSIVE MENU TOGGLER --><!-- BEGIN TOP NAVIGATION MENU --><div class="top-menu" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav pull-right"><!-- BEGIN USER LOGIN DROPDOWN --><li class="dropdown dropdown-user"><a href="javascript:;" class="dropdown-toggle" dropdown-menu-hover data-toggle="dropdown" data-close-others="true"><img alt="" class="img-circle" src="content/images/avatar.png"> <span class="username username-hide-on-mobiletitle" data-translate="global.menu.account.main">Account</span> <i class="fa fa-angle-down"></i></a><ul class="dropdown-menu dropdown-menu-default"><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings"><i class="icon-settings"></i> <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password"><i class="icon-lock"></i> <span data-translate="global.menu.account.password">Password</span></a></li><li class="divider" ng-switch-when="true"></li><li ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><i class="icon-logout"></i> <span data-translate="global.menu.account.logout">Sign out</span></a></li></ul></li><!-- END USER LOGIN DROPDOWN --><!-- BEGIN LANGUAGE BAR --><li class="dropdown dropdown-language" ng-controller="JhiLanguageController as languageVm"><a href="javascript:;" class="dropdown-toggle" dropdown-menu-hover data-toggle="dropdown" data-close-others="true"><img alt="" src="content/images/en.png" ng-if="languageVm.currentLanguage == \'en\'"> <img alt="" src="content/images/ru.png" ng-if="languageVm.currentLanguage == \'ru\'"> <img alt="" src="content/images/uz.png" ng-if="languageVm.currentLanguage == \'uz\'"> <span class="langname">{{languageVm.currentLanguage | findLanguageFromKey}}</span> <i class="fa fa-angle-down"></i></a><ul class="dropdown-menu dropdown-menu-default" ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();"><img alt="" src="content/images/en.png" ng-if="language == \'en\'"> <img alt="" src="content/images/ru.png" ng-if="language == \'ru\'"> <img alt="" src="content/images/uz.png" ng-if="language == \'uz\'"> {{language | findLanguageFromKey}}</a></li></ul></li><!-- END LANGUAGE BAR --></ul></div><!-- END TOP NAVIGATION MENU --></div><!-- END HEADER INNER --></div>');
$templateCache.put('app/layouts/login/login.html','<!-- BEGIN LOGO --><div class="logo"><span class="form-title"><span data-translate="global.title">Immigrant Admin</span></span></div><!-- END LOGO --><div class="content"><!-- BEGIN LOGIN FORM --><form class="login-form" role="form" ng-if="!vm.isOtpRequired" ng-submit="vm.login($event)"><div class="form-title"><span class="form-title" data-translate="login.title">Welcome.</span> <span class="form-subtitle" data-translate="login.subtitle">Please login.</span></div><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div class="form-group"><!--ie8, ie9 does not support html5 placeholder, so we just show field title for that--><label class="control-label visible-ie8 visible-ie9" data-translate="global.form.username">Login</label><input class="form-control form-control-solid placeholder-no-fix" type="text" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label class="control-label visible-ie8 visible-ie9" data-translate="login.form.password">Password</label><input class="form-control form-control-solid placeholder-no-fix" type="password" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-actions"><button type="submit" class="btn red btn-block uppercase" data-translate="login.form.button">Sign in</button></div><div class="form-actions"><div class="pull-left"><label class="rememberme mt-checkbox mt-checkbox-outline"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> {{\'login.form.rememberme\' | translate}} <span></span></label></div><div class="pull-right forget-password-block"><a href="javascript:;" id="forget-password" class="forget-password">{{\'login.password.forgot\' | translate}}</a></div></div></form><!-- END LOGIN FORM --><!-- BEGIN VERIFICATION FORM --><form class="login-form" role="form" ng-if="vm.isOtpRequired" ng-submit="vm.login($event)"><div class="form-title"><!--<span class="form-title" data-translate="login.title">Welcome.</span>--> <span class="form-subtitle" data-translate="login.verifyTitle">Please verify</span></div><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.verification"><strong>Failed to sign in!</strong> Please check your verification code and try again.</div><div class="form-group"><label class="control-label visible-ie8 visible-ie9">One-Time-Password</label><input class="form-control form-control-solid placeholder-no-fix" type="number" id="otp" ng-model="vm.otp"></div><div class="form-actions"><button type="submit" class="btn green-dark btn-block uppercase" data-translate="login.form.verify">Verify</button></div></form><!-- END VERIFICATION FORM --></div>');
$templateCache.put('app/layouts/sidebar/sidebar.html','<div class="page-sidebar-wrapper"><div class="page-sidebar navbar-collapse collapse" ng-switch="vm.isAuthenticated()"><!-- BEGIN SIDEBAR MENU --><ul class="page-sidebar-menu" data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200" ng-switch-when="true"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="home"><i class="icon-home"></i> <span class="title" data-translate="global.menu.dashboard">Dashboard</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="tkb-transfer"><i class="icon-refresh"></i> <span class="title" data-translate="global.menu.transfers">Transfers</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="transaction"><i class="icon-list"></i> <span class="title" data-translate="global.menu.payments">Payments</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="tkb-card"><i class="icon-credit-card"></i> <span class="title" data-translate="global.menu.senderCards">Sender cards</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="uzb-card"><i class="fa fa-credit-card"></i> <span class="title" data-translate="global.menu.receiverCards">Receiver cards</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ui-sref="profile"><i class="icon-people"></i> <span class="title" data-translate="global.menu.user.information">User information</span></a></li><li class="nav-item" has-any-authority="ROLE_MERCHANT"><a ui-sref="merchant"><i class="icon-user"></i> <span class="title" data-translate="global.menu.user.information">User information</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="customer-status-log"><i class="icon-user"></i> <span class="title" data-translate="global.menu.user.statusLog">User status log</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="play-integrity-log"><i class="icon-shield"></i> <span class="title" data-translate="global.menu.playIntegrityLog">Play integrity log</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="app-attest-log"><i class="glyphicon-apple"></i> <span class="title" data-translate="global.menu.appAttestLog">App attest log</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="my-id"><i class="icon-user-following"></i> <span class="title" data-translate="global.menu.myIDLog">MyID log</span></a></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="fa fa-database"></i> <span class="title" data-translate="global.menu.deposits.main">Deposits</span> <span class="arrow"></span></a><ul class="sub-menu"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="vp-payment"><i class="fa fa-credit-card"></i> <span class="title" data-translate="global.menu.deposits.vpPayment">VP payment</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="tkb-payment"><i class="icon-credit-card"></i> <span class="title" data-translate="global.menu.deposits.uniredPayment">Unired Payment</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="ticket-payment"><i class="icon-plane"></i> <span class="title" data-translate="global.menu.deposits.ticketPayment">Ticket Payment</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="ticket-order"><i class="icon-plane"></i> <span class="title">My Safar Tickets</span></a></li></ul></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="icon-chart"></i> <span class="title" data-translate="global.menu.statistics">Statistics</span> <span class="arrow"></span></a><ul class="sub-menu"><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --><li ui-sref-active="active"><a ui-sref="stats-partner"><i class="fa fa-support"></i> <span class="title" data-translate="global.menu.reconciliation">Reconciliation</span></a></li><li ui-sref-active="active"><a ui-sref="stats-daily"><i class="fa fa-calendar"></i> <span class="title" data-translate="global.menu.statistics.daily">Daily Statistics</span></a></li><li ui-sref-active="active"><a ui-sref="stats-weekly"><i class="fa fa-calendar-check-o"></i> <span class="title" data-translate="global.menu.statistics.weekly">Weekly Statistics</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="stats-periodical"><i class="fa fa-calendar-o"></i> <span class="title" data-translate="global.menu.statistics.periodical">Periodical Statistics</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="stats-monthly-balance"><i class="fa fa-calendar-plus-o"></i> <span class="title" data-translate="global.menu.statistics.monthly">Monthly Balance</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="stats-profit"><i class="fa fa-calendar"></i> <span class="title" data-translate="global.menu.statistics.profit">Profit</span></a></li><li ui-sref-active="active"><a ui-sref="stats-transfer-sender"><i class="fa fa-support"></i> <span class="title" data-translate="global.menu.statistics.transferSenderCount">Transfer Sender Count</span></a></li><li ui-sref-active="active"><a ui-sref="stats-transfer-receiver"><i class="fa fa-credit-card"></i> <span class="title" data-translate="global.menu.statistics.transferReceiverCount">Transfer Receiver Count</span></a></li><li ui-sref-active="active"><a ui-sref="stats-my-id"><i class="icon-user-following"></i> <span class="title" data-translate="global.menu.statistics.myIDCount">MyID Count</span></a></li></ul></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="icon-feed"></i> <span class="title" data-translate="global.menu.events.main">Events</span> <span class="arrow"></span></a><ul class="sub-menu"><li ui-sref-active="active"><a ui-sref="image-storage"><i class="fa fa-cloud-upload"></i> <span class="title" data-translate="global.menu.events.imagesUpload">Images upload</span></a></li><li ui-sref-active="active"><a ui-sref="banner-image"><i class="fa fa-image"></i> <span class="title" data-translate="global.menu.entities.bannerImage">Banner Images</span></a></li><li ui-sref-active="active"><a ui-sref="news"><i class="fa fa-newspaper-o"></i> <span class="title" data-translate="global.menu.events.news">News</span></a></li><li ui-sref-active="active"><a ui-sref="notification"><i class="fa fa-bell-o"></i> <span class="title" data-translate="global.menu.events.notifications">Notifications</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="customer-notification"><i class="glyphicon glyphicon-bell"></i> <span class="title" data-translate="global.menu.events.customerNotifications">Personal Notifications</span></a></li></ul></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="fa fa-product-hunt"></i> <span class="title" data-translate="global.menu.paynet.main">Paynet services</span> <span class="arrow"></span></a><ul class="sub-menu"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="provider-country"><i class="fa fa-flag"></i> <span class="title" data-translate="global.menu.paynet.country">Countries</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="provider-category"><i class="fa fa-server"></i> <span class="title" data-translate="global.menu.paynet.category">Categories</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="provider"><i class="fa fa-list-alt"></i> <span class="title" data-translate="global.menu.paynet.provider">Providers</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="provider-segment"><i class="fa fa-gg"></i> <span class="title" data-translate="global.menu.paynet.service">Services</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="segment-field"><i class="fa fa-wpforms"></i> <span class="title" data-translate="global.menu.paynet.field">Fields</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="segment-field-option"><i class="fa fa-expand"></i> <span class="title" data-translate="global.menu.paynet.option">Options</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="language-localization"><i class="fa fa-language"></i> <span class="title" data-translate="global.menu.paynet.localization">Translations</span></a></li></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="icon-grid"></i> <span class="title" data-translate="global.menu.configuration.main">Configuration</span> <span class="arrow"></span></a><ul class="sub-menu"><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --><li ui-sref-active="active"><a ui-sref="config"><i class="icon-equalizer"></i> <span class="title" data-translate="global.menu.configuration.service.commission">Service commission</span></a></li><li ui-sref-active="active"><a ui-sref="exchangerate"><i class="icon-wallet"></i> <span class="title" data-translate="global.menu.configuration.exchange.rates">Exchange rates</span></a></li><li ui-sref-active="active"><a ui-sref="app-version-codes"><i class="icon-wrench"></i> <span class="title" data-translate="global.menu.configuration.version.codes">App version codes</span></a></li><li ui-sref-active="active"><a ui-sref="gateway-diagnostics"><i class="icon-directions"></i> <span class="title" data-translate="global.menu.configuration.gateway.diagnostics">Gateway diagnostics</span></a></li><li ui-sref-active="active"><a ui-sref="paynet-mode"><i class="icon-anchor"></i> <span class="title" data-translate="global.menu.configuration.modes">Modes</span></a></li><li ui-sref-active="active"><a ui-sref="card-prefix-config"><i class="fa fa-credit-card"></i> <span class="title" data-translate="global.menu.configuration.cardPrefixConfig">Card Prefix Config</span></a></li></ul></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="#" class="nav-link nav-toggle"><i class="fa fa-handshake-o"></i> <span class="title" data-translate="global.menu.support">Support</span> <span class="arrow"></span></a><ul class="sub-menu"><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ui-sref="chat"><i class="fa fa-comments-o"></i> <span class="title" data-translate="global.menu.chat">Chat</span></a></li><li ui-sref-active="active"><a ui-sref="faq"><i class="fa fa-question-circle"></i> <span class="title">Questions</span></a></li></ul></li><li class="nav-item" has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a href="javascript:;" class="nav-link nav-toggle"><i class="icon-trophy"></i> <span class="title" data-translate="global.menu.admin.main">Admin</span> <span class="arrow"></span></a><ul class="sub-menu"><li ui-sref-active="active"><a ui-sref="user-management"><i class="icon-user-following"></i> <span class="title" data-translate="global.menu.admin.userManagement">Access management</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-configuration"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="audits"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="logs"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="docs"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul><!-- END SIDEBAR MENU --></div></div>');
$templateCache.put('app/entities/app-attest-log/app-attest-log-detail.html','<div><h2><span data-translate="bozorakaAdminApp.appAttestLog.detail.title">App Attest Log</span> {{vm.appAttestLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.appAttestLog.keyId">Key Id</span></dt><dd><span>{{vm.appAttestLog.keyId}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.challenge">Challenge</span></dt><dd><span>{{vm.appAttestLog.challenge}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.phone">Phone</span></dt><dd><span>{{vm.appAttestLog.phone}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.endpoint">Endpoint</span></dt><dd><span>{{vm.appAttestLog.endpoint}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.requestBodyJson">Request Body Json</span></dt><dd><span>{{vm.appAttestLog.requestBodyJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.appVersionCode">App Version Code</span></dt><dd><span>{{vm.appAttestLog.appVersionCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.signCount">Sign Count</span></dt><dd><span>{{vm.appAttestLog.signCount}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.responseJson">Response Json</span></dt><dd><span>{{vm.appAttestLog.responseJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.publicKeyData">Public Key Data</span></dt><dd><div ng-if="vm.appAttestLog.publicKeyData"><a ng-click="vm.openFile(vm.appAttestLog.publicKeyDataContentType, vm.appAttestLog.publicKeyData)" data-translate="entity.action.open">open</a> {{vm.appAttestLog.publicKeyDataContentType}}, {{vm.byteSize(vm.appAttestLog.publicKeyData)}}</div></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.AppAttestStatus.\' + vm.appAttestLog.status}}">{{vm.appAttestLog.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.errorCode">Error Code</span></dt><dd><span>{{vm.appAttestLog.errorCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.createdBy">Created By</span></dt><dd><span>{{vm.appAttestLog.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.createdDate">Created Date</span></dt><dd><span>{{vm.appAttestLog.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.appAttestLog.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.appAttestLog.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.appAttestLog.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="app-attest-log-detail.edit({id:vm.appAttestLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/app-attest-log/app-attest-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAppAttestLogLabel" data-translate="bozorakaAdminApp.appAttestLog.home.createOrEditLabel">Create or edit a App Attest Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.appAttestLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.appAttestLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.keyId" for="field_keyId">Key Id</label><input type="text" class="form-control" name="keyId" id="field_keyId" ng-model="vm.appAttestLog.keyId" ng-maxlength="100"><div ng-show="editForm.keyId.$invalid"><p class="help-block" ng-show="editForm.keyId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.challenge" for="field_challenge">Challenge</label><input type="text" class="form-control" name="challenge" id="field_challenge" ng-model="vm.appAttestLog.challenge" required ng-maxlength="50"><div ng-show="editForm.challenge.$invalid"><p class="help-block" ng-show="editForm.challenge.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.challenge.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.appAttestLog.phone" ng-maxlength="11"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">This field cannot be longer than 11 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.endpoint" for="field_endpoint">Endpoint</label><input type="text" class="form-control" name="endpoint" id="field_endpoint" ng-model="vm.appAttestLog.endpoint" ng-maxlength="12"><div ng-show="editForm.endpoint.$invalid"><p class="help-block" ng-show="editForm.endpoint.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.requestBodyJson" for="field_requestBodyJson">Request Body Json</label><textarea class="form-control" name="requestBodyJson" id="field_requestBodyJson" ng-model="vm.appAttestLog.requestBodyJson"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.appVersionCode" for="field_appVersionCode">App Version Code</label><input type="number" class="form-control" name="appVersionCode" id="field_appVersionCode" ng-model="vm.appAttestLog.appVersionCode" required><div ng-show="editForm.appVersionCode.$invalid"><p class="help-block" ng-show="editForm.appVersionCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.appVersionCode.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.signCount" for="field_signCount">Sign Count</label><input type="number" class="form-control" name="signCount" id="field_signCount" ng-model="vm.appAttestLog.signCount"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.responseJson" for="field_responseJson">Response Json</label><textarea class="form-control" name="responseJson" id="field_responseJson" ng-model="vm.appAttestLog.responseJson"></textarea></div><div class="form-group" ngf-drop ngf-change="vm.setPublicKeyData($file, vm.appAttestLog)"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.publicKeyData" for="field_publicKeyData">Public Key Data</label><div><div ng-if="vm.appAttestLog.publicKeyData" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.appAttestLog.publicKeyDataContentType, vm.appAttestLog.publicKeyData)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.appAttestLog.publicKeyDataContentType}}, {{vm.byteSize(vm.appAttestLog.publicKeyData)}}</span> <button type="button" ng-click="vm.appAttestLog.publicKeyData=null;vm.appAttestLog.publicKeyDataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPublicKeyData($file, vm.appAttestLog)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="publicKeyData" id="field_publicKeyData" ng-model="vm.appAttestLog.publicKeyData"> <input type="hidden" class="form-control" name="publicKeyDataContentType" id="field_publicKeyDataContentType" ng-model="vm.appAttestLog.publicKeyDataContentType"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.appAttestLog.status" id="field_status"><option value="CREATED" data-translate="bozorakaAdminApp.AppAttestStatus.CREATED">CREATED</option><option value="ATTESTED" data-translate="bozorakaAdminApp.AppAttestStatus.ATTESTED">ATTESTED</option><option value="VERIFIED" data-translate="bozorakaAdminApp.AppAttestStatus.VERIFIED">VERIFIED</option><option value="FAILED" data-translate="bozorakaAdminApp.AppAttestStatus.FAILED">FAILED</option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.errorCode" for="field_errorCode">Error Code</label><input type="text" class="form-control" name="errorCode" id="field_errorCode" ng-model="vm.appAttestLog.errorCode" ng-maxlength="50"><div ng-show="editForm.errorCode.$invalid"><p class="help-block" ng-show="editForm.errorCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.appAttestLog.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.appAttestLog.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.appAttestLog.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.appAttestLog.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.appAttestLog.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/app-attest-log/app-attest-logs.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.appAttestLog.home.title">App Attest Logs</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.phone"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label">Endpoint</label><select class="form-control" ng-model="vm.searchQuery.endpoint"><option value class selected="selected"></option><option value="login">LOGIN</option><option value="transfer">TRANSFER</option><option value="attestation">ATTESTATION</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="CREATED">CREATED</option><option value="ATTESTED">ATTESTED</option><option value="VERIFIED">VERIFIED</option><option value="FAILED">FAILED</option></select></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">Error code</label><select class="form-control" ng-model="vm.searchQuery.errorCode"><option value class selected="selected"></option><option value="APP_ID_MISMATCH">APP_ID_MISMATCH</option><option value="RECEIPT_TOO_OLD">RECEIPT_TOO_OLD</option><option value="VALIDATION_NULL">VALIDATION_NULL</option><option value="ATTESTATION_NOT_FOUND">ATTESTATION_NOT_FOUND</option><option value="ATTESTATION_NOT_ATTESTED">ATTESTATION_NOT_ATTESTED</option><option value="INVALID_SIGNATURE">INVALID_SIGNATURE</option><option value="INVALID_CHALLENGE">INVALID_CHALLENGE</option><option value="AUTHENTICATOR_DATA_INVALID">AUTHENTICATOR_DATA_INVALID</option><option value="INTERNAL_ERROR">INTERNAL_ERROR</option></select></div></div><div class="col-md-8"><div class="form-group"><label class="control-label">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="bozorakaAdminApp.appAttestLog.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endpoint"><span data-translate="bozorakaAdminApp.appAttestLog.endpoint">Endpoint</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="keyId"><span data-translate="bozorakaAdminApp.appAttestLog.keyId">Key Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="challenge"><span data-translate="bozorakaAdminApp.appAttestLog.challenge">Challenge</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="appVersionCode"><span data-translate="bozorakaAdminApp.appAttestLog.appVersionCode">App Version Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="signCount"><span data-translate="bozorakaAdminApp.appAttestLog.signCount">Sign Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.appAttestLog.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="errorCode"><span data-translate="bozorakaAdminApp.appAttestLog.errorCode">Error Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.appAttestLog.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.appAttestLog.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="appAttestLog in vm.appAttestLogs track by appAttestLog.id"><td><a ui-sref="play-integrity-log-detail({id:appAttestLog.id})">{{appAttestLog.id}}</a></td><td><span>{{(appAttestLog.phone === null) ? \'\' : appAttestLog.phone | phoneNumber}}</span></td><td><span class="label label-sm label-info" ng-if="appAttestLog.endpoint == \'login\'">{{appAttestLog.endpoint}} </span><span class="label label-sm label-success" ng-if="appAttestLog.endpoint == \'transfer\'">{{appAttestLog.endpoint}} </span><span class="label label-sm label-warning" ng-if="appAttestLog.endpoint == \'attestation\'">{{appAttestLog.endpoint}}</span></td><td class="text-left">{{appAttestLog.keyId}}</td><td class="text-left">{{appAttestLog.challenge}}</td><td class="text-left">{{appAttestLog.appVersionCode}}</td><td class="text-left">{{appAttestLog.signCount}}</td><td class="text-left"><span class="label label-sm label-success" ng-if="appAttestLog.status == \'ATTESTED\'">{{appAttestLog.status}} </span><span class="label label-sm label-success" ng-if="appAttestLog.status == \'VERIFIED\'">{{appAttestLog.status}} </span><span class="label label-sm label-danger" ng-if="appAttestLog.status == \'FAILED\'">{{appAttestLog.status}} </span><span class="label label-sm label-warning" ng-if="appAttestLog.status == \'CREATED\'">{{appAttestLog.status}}</span></td><td class="text-left">{{appAttestLog.errorCode}}</td><td>{{appAttestLog.createdDate | date:\'medium\'}}</td><td>{{appAttestLog.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/banner-image/banner-image-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.bannerImage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.bannerImage.delete.question" translate-values="{id: \'{{vm.bannerImage.id}}\'}">Are you sure you want to delete this Banner Image?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/banner-image/banner-image-detail.html','<div><h2><span data-translate="bozorakaAdminApp.bannerImage.detail.title">Banner Image</span> {{vm.bannerImage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.bannerImage.sortOrder">Sort Order</span></dt><dd><span>{{vm.bannerImage.sortOrder}}</span></dd><dt><span data-translate="bozorakaAdminApp.bannerImage.status">Status</span></dt><dd><span>{{vm.bannerImage.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.bannerImage.imageStorage">Image Storage</span></dt><dd><a ui-sref="image-storage-detail({id:vm.bannerImage.imageStorageId})">{{vm.bannerImage.imageStorageName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="banner-image-detail.edit({id:vm.bannerImage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/banner-image/banner-image-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBannerImageLabel" data-translate="bozorakaAdminApp.bannerImage.home.createOrEditLabel">Create or edit a Banner Image</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.bannerImage.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.bannerImage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.bannerImage.sortOrder" for="field_sortOrder">Sort Order</label><input type="number" class="form-control" name="sortOrder" id="field_sortOrder" ng-model="vm.bannerImage.sortOrder" required><div ng-show="editForm.sortOrder.$invalid"><p class="help-block" ng-show="editForm.sortOrder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sortOrder.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.bannerImage.status" for="field_status">Status</label><select class="form-control" ng-model="vm.bannerImage.status" name="status" id="field_status"><option value="true" ng-selected="vm.bannerImage.status">ENABLED</option><option value="false" ng-selected="!vm.bannerImage.status">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.bannerImage.lang" for="field_lang">Language</label><select class="form-control" ng-model="vm.bannerImage.lang" name="lang" id="field_lang" required><option value="ru">Russian</option><option value="en">English</option><option value="uz">Uzbek</option><option value="tg">Tajik</option></select><div ng-show="editForm.lang.$invalid"><p class="help-block" ng-show="editForm.lang.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.bannerImage.url" for="field_url">URL</label><input class="form-control" ng-model="vm.bannerImage.url" name="url" id="field_url"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.bannerImage.imageStorage">Banner</label><div><div><img src="api/download/{{vm.bannerImage.imageUrl}}" style="height: 300px" ; ng-if="vm.bannerImage.data == null"> <img data-ng-src="{{\'data:\' + vm.bannerImage.dataContentType + \';base64,\' + vm.bannerImage.data}}" style="height: 300px" ng-if="vm.bannerImage.data != null" name="imageStorage"><div ng-if="vm.bannerImage.data" class="help-block clearfix"><button type="button" ng-click="vm.bannerImage.data=null;vm.bannerImage.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" style="margin-top:  10px" ngf-change="vm.setData($file)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div></div></div><div ng-show="editForm.imageStorage.$invalid"><p class="help-block" ng-show="editForm.imageStorage.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/banner-image/banner-images.html','<div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="glyphicon glyphicon-tasks font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.bannerImage.home.title">Banner Images</span></div></div><div class="portlet-body"><div class="table-toolbar"><div class="row"><div class="col-md-6"><div class="btn-group"><button class="btn btn-primary" ui-sref="banner-image.new"><i class="fa fa-plus"></i> <span class="hidden-xs" data-translate="bozorakaAdminApp.bannerImage.home.createLabel">Create new Banner Image</span></button></div></div><div class="col-md-6"><div class="row"><div class="col-md-6 col-md-offset-6"><select class="form-control" name="lang" ng-model="vm.filterLang" ng-change="vm.filterData()"><option value="all">All languages</option><option value="uz">Uzbek</option><option value="ru">Russian</option><option value="en">English</option><option value="tg">Tajik</option></select></div></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" class="text-center"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imageStorageName" class="text-center"><span data-translate="bozorakaAdminApp.bannerImage.imageStorage">Image Storage</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url" class="text-center"><span data-translate="bozorakaAdminApp.bannerImage.url">URL</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lang" class="text-center"><span data-translate="bozorakaAdminApp.bannerImage.lang">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status" class="text-center"><span data-translate="bozorakaAdminApp.bannerImage.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sortOrder" class="text-center"><span data-translate="bozorakaAdminApp.bannerImage.sortOrder">Sort Order</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="bannerImage in vm.bannerImages track by bannerImage.id"><td class="text-center">{{bannerImage.id}}</td><td class="text-center"><a ui-sref="banner-image.edit({id:bannerImage.id})"><img src="api/download/{{bannerImage.imageUrl}}" width="auto" height="100px"></a></td><td class="text-center"><a class="btn btn-primary" target="_blank" ng-if="bannerImage.url != null" href="{{bannerImage.url}}">Link</a></td><td class="text-center">{{bannerImage.lang}}</td><td class="text-center"><a ng-if="bannerImage.status" class="btn btn-xs green-meadow">ENABLED </a><a ng-if="!bannerImage.status" class="btn btn-xs red-mint">DISABLED</a></td><td class="text-center">{{bannerImage.sortOrder}}</td><td class="text-center"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="banner-image.delete({id:bannerImage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/card-prefix-config/card-prefix-config-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cardPrefixConfig.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.cardPrefixConfig.delete.question" translate-values="{id: \'{{vm.cardPrefixConfig.id}}\'}">Are you sure you want to delete this Card Prefix Config?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/card-prefix-config/card-prefix-config-detail.html','<div><h2><span data-translate="bozorakaAdminApp.cardPrefixConfig.detail.title">Card Prefix Config</span> {{vm.cardPrefixConfig.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.prefix">Prefix</span></dt><dd><span>{{vm.cardPrefixConfig.prefix}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.cardType">Card Type</span></dt><dd><span>{{vm.cardPrefixConfig.cardType}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.isActive">Is Active</span></dt><dd><span>{{vm.cardPrefixConfig.isActive}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.createdBy">Created By</span></dt><dd><span>{{vm.cardPrefixConfig.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.createdDate">Created Date</span></dt><dd><span>{{vm.cardPrefixConfig.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.cardPrefixConfig.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.cardPrefixConfig.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.cardPrefixConfig.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="card-prefix-config-detail.edit({id:vm.cardPrefixConfig.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/card-prefix-config/card-prefix-config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCardPrefixConfigLabel" data-translate="bozorakaAdminApp.cardPrefixConfig.home.createOrEditLabel">Create or edit a Card Prefix Config</h4></div><div class="modal-body" style="min-height: 110px"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cardPrefixConfig.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cardPrefixConfig.id" readonly="readonly"></div><div class="form-group"><div class="col-md-5"><label class="control-label" data-translate="bozorakaAdminApp.cardPrefixConfig.prefix" for="field_prefix">Prefix</label><input type="text" class="form-control" name="prefix" id="field_prefix" ng-model="vm.cardPrefixConfig.prefix" required ng-maxlength="6" ng-change="vm.checkDuplicatePrefix()"><div ng-show="editForm.prefix.$invalid || vm.isDuplicatePrefix"><p class="help-block" ng-show="vm.isDuplicatePrefix">This prefix already exists.</p><p class="help-block" ng-show="editForm.prefix.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.prefix.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="col-md-5"><label class="control-label" data-translate="bozorakaAdminApp.cardPrefixConfig.cardType" for="field_cardType">Card Type</label><select class="form-control" name="cardType" id="field_cardType" ng-model="vm.cardPrefixConfig.cardType" required><option value="" disabled="disabled" selected="selected"></option><option value="UZCARD">UZCARD</option><option value="HUMO">HUMO</option><option value="VISA">VISA</option><option value="MASTERCARD">MASTERCARD</option><option value="UNIONPAY">UNIONPAY</option><option value="MAESTRO">MAESTRO</option></select><div ng-show="editForm.cardType.$invalid"><p class="help-block" ng-show="editForm.cardType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-2"><label class="control-label" data-translate="bozorakaAdminApp.cardPrefixConfig.isActive" for="field_isActive">Active</label><br><label class="switch"><input type="checkbox" id="field_isActive" ng-model="vm.cardPrefixConfig.isActive" ng-true-value="true" ng-false-value="false"> <span class="slider round"></span></label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.isDuplicatePrefix" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/card-prefix-config/card-prefix-configs.html','<div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="fa fa-credit-card"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.cardPrefixConfig.home.title">Receiver card modes</span></div><div class="pull-right"><button class="btn btn-primary" ui-sref="card-prefix-config.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.cardPrefixConfig.home.createLabel">Create new Card Prefix Config</span></button></div></div><div class="portlet-body"><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><label for="cardTypeFilter"><strong>Card type</strong></label><select class="form-control" id="cardTypeFilter" ng-model="vm.selectedCardType" ng-change="vm.updateFilteredCardPrefixes()"><option value="">ALL</option><option ng-repeat="type in vm.cardTypes" value="{{type}}">{{type}}</option></select></div></div><div class="row"><div class="col-md-12"><table id="user" class="table table-bordered table-striped" style="margin-bottom: 0"><thead><tr><th style="width:13%"><div style="margin-bottom: 29px"><span>Prefix</span></div></th><th style="width:13%"><div style="margin-bottom: 29px"><span>Card type</span></div></th><th style="width:14%; text-align: center"><span>Active</span><br><label class="switch"><input type="checkbox" ng-model="vm.allCardPrefixStatus" ng-true-value="true" ng-false-value="false" ng-change="vm.saveFilteredCardPrefixes()"> <span class="slider round"></span></label></th><th style="width:40%;text-align: center"><div style="margin-bottom: 29px"><span>Last modified by</span></div></th><th style="width:20%;text-align: center"><div style="margin-bottom: 29px"><span>Last modified date</span></div></th></tr></thead><tbody><tr ng-repeat="cardPrefix in vm.filteredCardPrefixes | orderBy : [\'prefix\']"><td>{{cardPrefix.prefix}}</td><td>{{cardPrefix.cardType}}</td><td style="text-align: center"><label class="switch"><input type="checkbox" ng-model="cardPrefix.isActive" ng-true-value="true" ng-false-value="false" ng-change="vm.saveCardPrefix(cardPrefix)"> <span class="slider round"></span></label></td><td style="width:40%; text-align: center">{{cardPrefix.lastModifiedBy}}</td><td style="width:40%; text-align: center">{{cardPrefix.lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/bot-notification/bot-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.botNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.botNotification.delete.question" translate-values="{id: \'{{vm.botNotification.id}}\'}">Are you sure you want to delete this Bot Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/bot-notification/bot-notification-detail.html','<div><h2><span data-translate="bozorakaAdminApp.botNotification.detail.title">Bot Notification</span> {{vm.botNotification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.botNotification.message">Message</span></dt><dd><span>{{vm.botNotification.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.botNotification.status">Status</span></dt><dd><span>{{vm.botNotification.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="bot-notification-detail.edit({id:vm.botNotification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/bot-notification/bot-notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBotNotificationLabel" data-translate="bozorakaAdminApp.botNotification.home.createOrEditLabel">Create or edit a Bot Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.botNotification.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.botNotification.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.botNotification.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.botNotification.message" ng-maxlength="1000"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.botNotification.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.botNotification.status" ng-maxlength="20"><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/bot-notification/bot-notifications.html','<div><h2 data-translate="bozorakaAdminApp.botNotification.home.title">Bot Notifications</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="bot-notification.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.botNotification.home.createLabel">Create new Bot Notification</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="message"><span data-translate="bozorakaAdminApp.botNotification.message">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.botNotification.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="botNotification in vm.botNotifications track by botNotification.id"><td><a ui-sref="bot-notification-detail({id:botNotification.id})">{{botNotification.id}}</a></td><td>{{botNotification.message}}</td><td>{{botNotification.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="bot-notification-detail({id:botNotification.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="bot-notification.edit({id:botNotification.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="bot-notification.delete({id:botNotification.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/chat/chat-customers-dialog.html','<div class="customer-modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">New chat</h4></div><div class="modal-body"><div class="modal-input"><input type="text" class="customer-search-input rounded-4" placeholder="Phone #" ng-model="vm.customerPhone" ng-change="vm.loadCustomers()" autofocus></div><ul class="customer-list"><li ng-repeat="customer in vm.customers" ng-click="vm.selectCustomer(customer)"><img ng-src="{{ customer.avatar }}" class="chat-sidebar-avatar rounded"><div class="customer-info"><span class="customer-sidebar-title">{{ customer.customerPhone | phoneNumber }}</span> <span class="customer-sidebar-title text-muted">{{ customer.customerFullName }}</span></div></li></ul></div></div>');
$templateCache.put('app/entities/chat/chat-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.chat.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.chat.delete.question" translate-values="{id: \'{{vm.chat.id}}\'}">Are you sure you want to delete this Chat?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/chat/chat-detail.html','<div><h2><span data-translate="bozorakaAdminApp.chat.detail.title">Chat</span> {{vm.chat.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.chat.sessionToken">Session Token</span></dt><dd><span>{{vm.chat.sessionToken}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.solved">Solved</span></dt><dd><span>{{vm.chat.solved}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.replied">Replied</span></dt><dd><span>{{vm.chat.replied}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.createdBy">Created By</span></dt><dd><span>{{vm.chat.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.createdDate">Created Date</span></dt><dd><span>{{vm.chat.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.chat.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.chat.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.chat.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.chat.customerId})">{{vm.chat.customerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="chat-detail.edit({id:vm.chat.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/chat/chat-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChatLabel" data-translate="bozorakaAdminApp.chat.home.createOrEditLabel">Create or edit a Chat</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.chat.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chat.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.sessionToken" for="field_sessionToken">Session Token</label><input type="text" class="form-control" name="sessionToken" id="field_sessionToken" ng-model="vm.chat.sessionToken"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.solved" for="field_solved">Solved</label><input type="checkbox" name="solved" id="field_solved" ng-model="vm.chat.solved"><div ng-show="editForm.solved.$invalid"><p class="help-block" ng-show="editForm.solved.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.replied" for="field_replied">Replied</label><input type="checkbox" name="replied" id="field_replied" ng-model="vm.chat.replied"><div ng-show="editForm.replied.$invalid"><p class="help-block" ng-show="editForm.replied.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.chat.createdBy" required ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.chat.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.chat.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chat.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.chat.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.chat.customer" for="field_customer">Customer</label><select class="form-control" id="field_customer" name="customer" ng-model="vm.chat.customerId" ng-options="customer.id as customer.id for customer in vm.customers"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/chat/chats.html','<div class="chat-page" ng-click="vm.closeChatOptions()" style="margin: -25px -20px -10px -20px"><div class="chat-header"><div class="chat-title font-dark"><h4 class="bold uppercase"><i class="fa fa-comments-o font-dark" style="margin-right: 5px"></i>Support</h4></div></div><div class="chat-container row"><div class="chat-sidebar custom-sidebar"><div class="search-bar"><input class="rounded-4" type="text" placeholder="Phone # / Chat ID # / Message" ng-model="vm.searchQuery.field" ng-change="vm.applyFilters()"><div class="new-chat"><button class="btn btn-primary rounded-4" ng-click="vm.openCustomerModal()"><i class="fa fa-edit"></i></button></div></div><div class="filter-options"><label style="user-select: none"><input type="checkbox" ng-model="vm.unsolvedOnly" ng-change="vm.applyFilters()"> Unsolved Only</label><label style="user-select: none"><input type="checkbox" ng-model="vm.unrepliedOnly" ng-change="vm.applyFilters()"> Unreplied Only</label></div><div class="chat-list-container"><div infinite-scroll="vm.loadMore()" infinite-scroll-distance="1" infinite-scroll-parent="true"><ul><li ng-repeat="chat in vm.chats" ng-click="vm.selectChat(chat)" ng-class="{\'active-chat\': vm.selectedChat && vm.selectedChat.id === chat.id}"><img ng-src="{{ chat.avatar }}" class="chat-sidebar-avatar rounded"><div class="chat-info"><span class="chat-sidebar-title" ng-if="chat.customerPhone">{{ chat.customerPhone | phoneNumber }} <img ng-if="chat.customerVerified" src="/content/images/blue-tick.png" style="margin-bottom: 3px" width="16" height="16"> </span><span class="chat-sidebar-title" ng-if="!chat.customerPhone">Unregistered ({{ chat.createdDate | date:\'short\'}})</span> <span class="chat-sidebar-title text-muted" ng-if="chat.lastMessage">{{ chat.lastMessage.length > 40 ? (chat.lastMessage | limitTo:40) + \'...\' : chat.lastMessage }}</span></div><div class="chat-list-container-item"><span class="bold">#{{chat.id}}</span> <span class="chat-time">{{ chat.lastMessageDate | date:\'short\' }}</span> <span class="rounded badge badge-danger bold" ng-if="!chat.solved">unsolved</span></div></li></ul></div></div><div class="loading-spinner" ng-if="vm.loading">Loading...</div></div><div class="chat-content custom-content" ng-if="vm.selectedChat"><div class="chat-header"><img ng-src="{{vm.selectedChat.avatar}}" class="chat-avatar rounded"><div class="chat-title"><span><a ng-if="vm.selectedChat.customerPhone" id="phone-{{vm.selectedChat.customerPhone}}" href="javascript:;" ng-click="vm.openProfile(vm.selectedChat.customerPhone)">{{ vm.selectedChat.customerPhone | phoneNumber }}</a> <span ng-if="vm.selectedChat.customerPhone" class="text-muted mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#phone-{{vm.selectedChat.customerPhone}}" title="You can copy phone number"><i style="font-size: 13px; margin-left: 2px" class="fa fa-copy"></i> </span></span><a ng-if="!vm.selectedChat.customerPhone" href="javascript:;" ng-click="vm.openProfile(vm.selectedChat.customerPhone)">Unregistered ({{ vm.selectedChat.createdDate | date:\'short\'}})</a> <span class="message-time text-muted">Created date: {{ vm.selectedChat.createdDate | date:\'short\' }}</span></div><div ng-if="!vm.selectedChat.replied" class="chat-option" ng-click="vm.toggleChatOptions($event)"><i class="fa fa-ellipsis-h text-muted"></i><div class="chat-dropdown rounded-4" ng-if="!vm.selectedChat.replied && vm.selectedChat.showOptions"><ul><li ng-if="vm.selectedChat.showOptions" ng-click="vm.saveAsReplied()"><i class="fa fa-reply"></i>Mark as replied</li></ul></div></div></div><div class="chat-messages-container" ng-style="{\'padding-bottom\': vm.textAreaHeight && vm.isEditing ? (vm.textAreaHeight <= 28 ? vm.textAreaHeight + 67 : vm.textAreaHeight + 50) : \'45px\' }"><div class="chat-messages" id="chatMessages" ng-click="vm.closeOptions()"><div class="no-messages-placeholder rounded" ng-if="vm.chatMessages.length === 0 && !vm.isMessagesLoading"><span ng-switch="vm.profileLanguage"><span class="no-chat-token-text" ng-switch-when="uz" data-translate="bozorakaAdminApp.chat.chatPlaceholder.uz">This user prefers to receive messages in Uzbek.</span> <span class="no-chat-token-text" ng-switch-when="ru" data-translate="bozorakaAdminApp.chat.chatPlaceholder.ru">This user prefers to receive messages in Russian.</span> <span class="no-chat-token-text" ng-switch-when="en" data-translate="bozorakaAdminApp.chat.chatPlaceholder.en">This user prefers to receive messages in English.</span> <span class="no-messages-text" ng-switch-default data-translate="bozorakaAdminApp.chat.chatPlaceholder.default">This user does not have a firebase token, the user may not be able to receive your message notification!</span></span></div><div class="loading-overlay" ng-if="vm.isMessagesLoading"><div class="spinner"></div></div><div ng-repeat="message in vm.chatMessages"><div ng-class="{\'sent\': !message.fromCustomer, \'received\': message.fromCustomer}" class="message"><div class="message-content rounded-4"><div class="message-option" ng-click="vm.toggleOptions(message, $event)"><i class="fa fa-ellipsis-h text-muted"></i><div class="message-dropdown rounded-4" ng-if="message.fromCustomer && message.id === vm.messageId && message.showOptions"><ul><li ng-click="vm.saveAsUnsolved(message)"><i class="fa fa-check-square-o"></i>{{ message.solved ? \'Mark as unsolved\' : \'Mark as solved\' }}</li><li ng-click="vm.deleteMessage(message)"><i class="fa fa-trash-o"></i>Delete</li></ul></div><div class="send-message-dropdown rounded-4" ng-if="message.id === vm.messageId && !message.fromCustomer && message.showOptions"><ul><li ng-click="vm.deleteMessage(message)"><i class="fa fa-trash-o"></i>Delete</li><li ng-click="vm.editMessage(message)"><i class="fa fa-pencil"></i>Edit</li></ul></div></div><div class="message reply rounded-4" ng-if="message.replyMessageId"><img ng-if="vm.getRepliedMessageImage(message.replyMessageId) !== null" class="reply-image" ng-src="{{ vm.getRepliedMessageImage(message.replyMessageId) }}"> <span>{{ vm.getRepliedMessageContent(message.replyMessageId) > 40 ? (vm.getRepliedMessageContent(message.replyMessageId) | limitTo:40 + \'...\') : (vm.getRepliedMessageContent(message.replyMessageId)) }}</span></div><div class="message-image" ng-if="message.imageUrl"><img ng-src="{{ message.imageUrl }}" ng-click="vm.openImage(message.imageUrl)"></div><div class="image-modal" ng-if="vm.showModal" ng-click="vm.closeImage()"><span class="close-modal" ng-click="vm.closeImage()">&times;</span><div class="image-modal-content" ng-click="$event.stopPropagation()"><img ng-src="{{ vm.modalImageUrl }}" class="full-image"></div></div><div class="message-text">{{ message.content }}</div><div class="message-detail text-muted"><div class="message-status"><span class="unread-messages rounded badge" style="margin: 1px 0 0 -2px; padding: 3px 7px 3px 7px" ng-if="!message.solved">!</span> <i class="fa" ng-if="!message.readStatus && !message.fromCustomer" ng-class="{\'fa-check\': !message.readStatus }"></i> <i class="fa" ng-if="message.readStatus && !message.fromCustomer" ng-class="{\'fa-eye\': message.readStatus }"></i></div><span class="message-time">{{ message.createdDate | date:\'short\' }} <i ng-if="message.appVersionCode.indexOf(\'iOS\') === 0" class="fa fa-apple" style="margin-left: 2px" title="{{ message.appVersionCode }}"></i> <i ng-if="message.appVersionCode.indexOf(\'pA\') === 0" class="fa fa-android text-green-600" title="{{ message.appVersionCode }}"></i> </span><span ng-if="!message.fromCustomer" class="message-owner">{{ message.createdBy }}</span></div></div></div></div></div><div class="input-area"><div class="editing-area" ng-if="vm.isEditing"><div class="editing-icon"><i class="fa fa-pencil"></i></div><div class="editing-text"><div><span class="title">Editing</span></div><div><span>{{vm.messageForEdit.content.length > 120 ? (vm.messageForEdit.content | limitTo:120) + \'...\' : vm.messageForEdit.content}}</span></div></div><div class="cancel-editing"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancelEditing()">&times;</button></div></div><div class="chat-input" ng-if="!vm.isEditing"><textarea ng-model="vm.newMessage" placeholder="Type your message..." ng-keyup="(($event.keyCode === 13 && !$event.shiftKey) ? vm.sendMessage() : null)"></textarea><button class="btn btn-primary" ng-click="vm.sendMessage()" ng-disabled="!vm.newMessage">Send</button></div><div class="chat-input" ng-if="vm.isEditing"><textarea class="edit-text-area" ng-model="vm.newMessage" ng-style="{\'height\': vm.textAreaHeight ? vm.textAreaHeight : \'20px\'}" placeholder="Type your message..." ng-keyup="(($event.keyCode === 13 && !$event.shiftKey) ? vm.saveMessage() : null)">\n\n                        </textarea><button class="btn btn-success" ng-click="vm.saveMessage()"><i class="fa fa-check"></i></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/chat-message/chat-message-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.chatMessage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.chatMessage.delete.question" translate-values="{id: \'{{vm.chatMessage.id}}\'}">Are you sure you want to delete this Chat Message?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/chat-message/chat-message-detail.html','<div><h2><span data-translate="bozorakaAdminApp.chatMessage.detail.title">Chat Message</span> {{vm.chatMessage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.chatMessage.content">Content</span></dt><dd><span>{{vm.chatMessage.content}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.imageUrl">Image Url</span></dt><dd><span>{{vm.chatMessage.imageUrl}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.readStatus">Read Status</span></dt><dd><span>{{vm.chatMessage.readStatus}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.solved">Solved</span></dt><dd><span>{{vm.chatMessage.solved}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.replyMessageId">Reply Message Id</span></dt><dd><span>{{vm.chatMessage.replyMessageId}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.telegramMessageId">Telegram Message Id</span></dt><dd><span>{{vm.chatMessage.telegramMessageId}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.deliveredStatus">Delivered Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.DeliveredStatus.\' + vm.chatMessage.deliveredStatus}}">{{vm.chatMessage.deliveredStatus}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.errorMessage">Error Message</span></dt><dd><span>{{vm.chatMessage.errorMessage}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.createdBy">Created By</span></dt><dd><span>{{vm.chatMessage.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.createdDate">Created Date</span></dt><dd><span>{{vm.chatMessage.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.chatMessage.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.chatMessage.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.chatMessage.chat">Chat</span></dt><dd><a ui-sref="chat-detail({id:vm.chatMessage.chatId})">{{vm.chatMessage.chatId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="chat-message-detail.edit({id:vm.chatMessage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/chat-message/chat-message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChatMessageLabel" data-translate="bozorakaAdminApp.chatMessage.home.createOrEditLabel">Create or edit a Chat Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.chatMessage.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chatMessage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.chatMessage.content" ng-maxlength="2000"><div ng-show="editForm.content.$invalid"><p class="help-block" ng-show="editForm.content.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.imageUrl" for="field_imageUrl">Image Url</label><input type="text" class="form-control" name="imageUrl" id="field_imageUrl" ng-model="vm.chatMessage.imageUrl" ng-maxlength="500"><div ng-show="editForm.imageUrl.$invalid"><p class="help-block" ng-show="editForm.imageUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.readStatus" for="field_readStatus">Read Status</label><input type="checkbox" name="readStatus" id="field_readStatus" ng-model="vm.chatMessage.readStatus"><div ng-show="editForm.readStatus.$invalid"><p class="help-block" ng-show="editForm.readStatus.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.solved" for="field_solved">Solved</label><input type="checkbox" name="solved" id="field_solved" ng-model="vm.chatMessage.solved"><div ng-show="editForm.solved.$invalid"><p class="help-block" ng-show="editForm.solved.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.replyMessageId" for="field_replyMessageId">Reply Message Id</label><input type="number" class="form-control" name="replyMessageId" id="field_replyMessageId" ng-model="vm.chatMessage.replyMessageId"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.telegramMessageId" for="field_telegramMessageId">Telegram Message Id</label><input type="number" class="form-control" name="telegramMessageId" id="field_telegramMessageId" ng-model="vm.chatMessage.telegramMessageId"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.deliveredStatus" for="field_deliveredStatus">Delivered Status</label><select class="form-control" name="deliveredStatus" ng-model="vm.chatMessage.deliveredStatus" id="field_deliveredStatus"><option value="PENDING" data-translate="bozorakaAdminApp.DeliveredStatus.PENDING">PENDING</option><option value="SUCCESS" data-translate="bozorakaAdminApp.DeliveredStatus.SUCCESS">SUCCESS</option><option value="FAILURE" data-translate="bozorakaAdminApp.DeliveredStatus.FAILURE">FAILURE</option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.errorMessage" for="field_errorMessage">Error Message</label><textarea class="form-control" name="errorMessage" id="field_errorMessage" ng-model="vm.chatMessage.errorMessage"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.chatMessage.createdBy" required ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.chatMessage.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.chatMessage.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.chatMessage.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.chatMessage.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.chatMessage.chat" for="field_chat">Chat</label><select class="form-control" id="field_chat" name="chat" ng-model="vm.chatMessage.chatId" ng-options="chat.id as chat.id for chat in vm.chats"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/chat-message/chat-messages.html','<div><h2 data-translate="bozorakaAdminApp.chatMessage.home.title">Chat Messages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="chat-message.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.chatMessage.home.createLabel">Create new Chat Message</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="bozorakaAdminApp.chatMessage.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imageUrl"><span data-translate="bozorakaAdminApp.chatMessage.imageUrl">Image Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="readStatus"><span data-translate="bozorakaAdminApp.chatMessage.readStatus">Read Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="solved"><span data-translate="bozorakaAdminApp.chatMessage.solved">Solved</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="replyMessageId"><span data-translate="bozorakaAdminApp.chatMessage.replyMessageId">Reply Message Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telegramMessageId"><span data-translate="bozorakaAdminApp.chatMessage.telegramMessageId">Telegram Message Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="deliveredStatus"><span data-translate="bozorakaAdminApp.chatMessage.deliveredStatus">Delivered Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="errorMessage"><span data-translate="bozorakaAdminApp.chatMessage.errorMessage">Error Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdBy"><span data-translate="bozorakaAdminApp.chatMessage.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.chatMessage.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="bozorakaAdminApp.chatMessage.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.chatMessage.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="chatId"><span data-translate="bozorakaAdminApp.chatMessage.chat">Chat</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="chatMessage in vm.chatMessages track by chatMessage.id"><td><a ui-sref="chat-message-detail({id:chatMessage.id})">{{chatMessage.id}}</a></td><td>{{chatMessage.content}}</td><td>{{chatMessage.imageUrl}}</td><td>{{chatMessage.readStatus}}</td><td>{{chatMessage.solved}}</td><td>{{chatMessage.replyMessageId}}</td><td>{{chatMessage.telegramMessageId}}</td><td data-translate="{{\'bozorakaAdminApp.DeliveredStatus.\' + chatMessage.deliveredStatus}}">{{chatMessage.deliveredStatus}}</td><td>{{chatMessage.errorMessage}}</td><td>{{chatMessage.createdBy}}</td><td>{{chatMessage.createdDate | date:\'medium\'}}</td><td>{{chatMessage.lastModifiedBy}}</td><td>{{chatMessage.lastModifiedDate | date:\'medium\'}}</td><td><a ui-sref="chat-detail({id:chatMessage.chatId})">{{chatMessage.chatId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="chat-message-detail({id:chatMessage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="chat-message.edit({id:chatMessage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="chat-message.delete({id:chatMessage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/config/app-version-codes.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-wrench font-dark"></i> <span class="caption-subject bold uppercase">APP VERSION CODES</span></div></div><div class="portlet-body"><div class="row"><div class="col-md-12"><table id="user" class="table table-bordered table-striped"><tbody><tr><td style="width:40%" colspan="4"><label class="tile-body"><b>PayGram</b></label></td></tr><tr><td style="width:40%">{{vm.allConfigs[\'android_version_code\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'android_version_code\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'android_version_code\')">{{vm.allConfigs[\'android_version_code\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'android_version_code\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'android_version_code\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{vm.allConfigs[\'ios_version_code\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'ios_version_code\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'ios_version_code\')">{{vm.allConfigs[\'ios_version_code\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'ios_version_code\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'ios_version_code\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/config/config-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.config.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.config.delete.question" translate-values="{id: \'{{vm.config.id}}\'}">Are you sure you want to delete this Config?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/config/config-detail.html','<div><h2><span data-translate="bozorakaAdminApp.config.detail.title">Config</span> {{vm.config.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.config.title">Title</span></dt><dd><span>{{vm.config.title}}</span></dd><dt><span data-translate="bozorakaAdminApp.config.name">Name</span></dt><dd><span>{{vm.config.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.config.value">Value</span></dt><dd><span>{{vm.config.value}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="config-detail.edit({id:vm.config.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/config/config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConfigLabel" data-translate="bozorakaAdminApp.config.home.createOrEditLabel">Create or edit a Config</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.config.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.config.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.config.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.config.title" ng-maxlength="50"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.config.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.config.name" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.config.value" for="field_value">Value</label><input type="number" class="form-control" name="value" id="field_value" ng-model="vm.config.value"></div><div class="form-group"><label class="control-label" for="field_valueString">Value String</label><input type="text" class="form-control" name="valueString" id="field_valueString" ng-model="vm.config.valueString" ng-maxlength="100"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/config/configs-view.html','<div><h2 data-translate="bozorakaAdminApp.config.home.title">Configs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="config.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.config.home.createLabel">Create new Config</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="bozorakaAdminApp.config.title">Title</span></th><th><span data-translate="bozorakaAdminApp.config.name">Name</span></th><th><span data-translate="bozorakaAdminApp.config.value">Value</span></th><th></th></tr></thead><tbody><tr ng-repeat="config in vm.configs track by config.id"><td><a ui-sref="config-detail({id:config.id})">{{config.id}}</a></td><td>{{config.title}}</td><td>{{config.name}}</td><td>{{config.value}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="config-detail({id:config.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="config.edit({id:config.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="config.delete({id:config.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/config/configs.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-equalizer font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.configuration.service.commission">Service commission</span></div></div><div class="portlet-body"><div class="row"><div class="col-md-12"><table id="user" class="table table-bordered table-striped"><thead><tr><th><b>Money Transfer (P2P) Commission</b></th><th style="text-align: center" colspan="2">TKB</th><th style="text-align: center" colspan="2">MTS</th><th style="text-align: center" colspan="2">PAYGINE</th><th style="text-align: center" colspan="2">SBP</th></tr></thead><tbody><tr><td><b>{{vm.allConfigs[\'p2p_max_amount_10\'].title}}</b></td><td><a href="#" editable-number="vm.allConfigs[\'p2p_max_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_max_amount_10\')">{{vm.allConfigs[\'p2p_max_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_max_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_max_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_max_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_max_amount_10\')">{{vm.allConfigs[\'p2p_mts_max_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_max_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_max_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_max_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_max_amount_10\')">{{vm.allConfigs[\'p2p_paygine_max_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_max_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_max_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_max_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_max_amount_10\')">{{vm.allConfigs[\'p2p_sbp_max_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_max_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_max_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_tkb_commission_amount_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_tkb_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_tkb_commission_amount_10\')">{{vm.allConfigs[\'p2p_tkb_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_tkb_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_tkb_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_tkb_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_tkb_commission_amount_10\')">{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_tkb_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_tkb_commission_amount_10\')">{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_tkb_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_tkb_commission_amount_10\')">{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_ub_commission_amount_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_ub_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_ub_commission_amount_10\')">{{vm.allConfigs[\'p2p_ub_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_ub_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_ub_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_ub_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_ub_commission_amount_10\')">{{vm.allConfigs[\'p2p_mts_ub_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_ub_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_ub_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_ub_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_ub_commission_amount_10\')">{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_ub_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_ub_commission_amount_10\')">{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_sp_commission_amount_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sp_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sp_commission_amount_10\')">{{vm.allConfigs[\'p2p_sp_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sp_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sp_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_sp_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_sp_commission_amount_10\')">{{vm.allConfigs[\'p2p_mts_sp_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_sp_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_sp_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_sp_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_sp_commission_amount_10\')">{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_sp_commission_amount_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_sp_commission_amount_10\')">{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_tkb_commission_rate_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_tkb_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_tkb_commission_rate_10\')">{{vm.allConfigs[\'p2p_tkb_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_tkb_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_tkb_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_tkb_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_tkb_commission_rate_10\')">{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_tkb_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_tkb_commission_rate_10\')">{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_tkb_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_tkb_commission_rate_10\')">{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_ub_commission_rate_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_ub_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_ub_commission_rate_10\')">{{vm.allConfigs[\'p2p_ub_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_ub_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_ub_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_ub_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_ub_commission_rate_10\')">{{vm.allConfigs[\'p2p_mts_ub_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_ub_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_ub_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_ub_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_ub_commission_rate_10\')">{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_ub_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_ub_commission_rate_10\')">{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_sp_commission_rate_10\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sp_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sp_commission_rate_10\')">{{vm.allConfigs[\'p2p_sp_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sp_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sp_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_sp_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_sp_commission_rate_10\')">{{vm.allConfigs[\'p2p_mts_sp_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_sp_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_sp_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_sp_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_sp_commission_rate_10\')">{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_sp_commission_rate_10\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_sp_commission_rate_10\')">{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_10\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_10\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_10\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td><b>{{vm.allConfigs[\'p2p_max_amount_20\'].title}}</b></td><td><a href="#" editable-number="vm.allConfigs[\'p2p_max_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_max_amount_20\')">{{vm.allConfigs[\'p2p_max_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_max_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_max_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_max_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_max_amount_20\')">{{vm.allConfigs[\'p2p_mts_max_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_max_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_max_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_max_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_max_amount_20\')">{{vm.allConfigs[\'p2p_paygine_max_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_max_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_max_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_max_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_max_amount_20\')">{{vm.allConfigs[\'p2p_sbp_max_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_max_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_max_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_tkb_commission_amount_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_tkb_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_tkb_commission_amount_20\')">{{vm.allConfigs[\'p2p_tkb_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_tkb_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_tkb_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_tkb_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_tkb_commission_amount_20\')">{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_tkb_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_tkb_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_tkb_commission_amount_20\')">{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_tkb_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_tkb_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_tkb_commission_amount_20\')">{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_tkb_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_ub_commission_amount_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_ub_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_ub_commission_amount_20\')">{{vm.allConfigs[\'p2p_ub_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_ub_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_ub_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_ub_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_ub_commission_amount_20\')">{{vm.allConfigs[\'p2p_mts_ub_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_ub_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_ub_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_ub_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_ub_commission_amount_20\')">{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_ub_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_ub_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_ub_commission_amount_20\')">{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_ub_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_sp_commission_amount_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sp_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sp_commission_amount_20\')">{{vm.allConfigs[\'p2p_sp_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sp_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sp_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_sp_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_sp_commission_amount_20\')">{{vm.allConfigs[\'p2p_mts_sp_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_sp_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_sp_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_sp_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_sp_commission_amount_20\')">{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_sp_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_sp_commission_amount_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_sp_commission_amount_20\')">{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_sp_commission_amount_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_tkb_commission_rate_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_tkb_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_tkb_commission_rate_20\')">{{vm.allConfigs[\'p2p_tkb_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_tkb_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_tkb_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_tkb_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_tkb_commission_rate_20\')">{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_tkb_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_tkb_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_tkb_commission_rate_20\')">{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_tkb_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_tkb_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_tkb_commission_rate_20\')">{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_tkb_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_ub_commission_rate_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_ub_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_ub_commission_rate_20\')">{{vm.allConfigs[\'p2p_ub_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_ub_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_ub_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_ub_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_ub_commission_rate_20\')">{{vm.allConfigs[\'p2p_mts_ub_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_ub_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_ub_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_ub_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_ub_commission_rate_20\')">{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_ub_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_ub_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_ub_commission_rate_20\')">{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_ub_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_sp_commission_rate_20\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sp_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sp_commission_rate_20\')">{{vm.allConfigs[\'p2p_sp_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sp_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sp_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_sp_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_sp_commission_rate_20\')">{{vm.allConfigs[\'p2p_mts_sp_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_sp_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_sp_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_sp_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_sp_commission_rate_20\')">{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_sp_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_sp_commission_rate_20\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_sp_commission_rate_20\')">{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_20\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_20\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_sp_commission_rate_20\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td><b>{{vm.allConfigs[\'p2p_default_max_amount\'].title}}</b></td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_max_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_max_amount\')">{{vm.allConfigs[\'p2p_default_max_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_max_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_max_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_max_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_max_amount\')">{{vm.allConfigs[\'p2p_mts_default_max_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_max_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_max_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_max_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_max_amount\')">{{vm.allConfigs[\'p2p_paygine_default_max_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_max_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_max_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_max_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_max_amount\')">{{vm.allConfigs[\'p2p_sbp_default_max_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_max_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_max_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_tkb_commission_amount\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_tkb_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_tkb_commission_amount\')">{{vm.allConfigs[\'p2p_default_tkb_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_tkb_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_tkb_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_tkb_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_tkb_commission_amount\')">{{vm.allConfigs[\'p2p_mts_default_tkb_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_tkb_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_tkb_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_tkb_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_tkb_commission_amount\')">{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_tkb_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_tkb_commission_amount\')">{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_ub_commission_amount\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_ub_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_ub_commission_amount\')">{{vm.allConfigs[\'p2p_default_ub_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_ub_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_ub_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_ub_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_ub_commission_amount\')">{{vm.allConfigs[\'p2p_mts_default_ub_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_ub_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_ub_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_ub_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_ub_commission_amount\')">{{vm.allConfigs[\'p2p_paygine_default_ub_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_ub_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_ub_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_ub_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_ub_commission_amount\')">{{vm.allConfigs[\'p2p_sbp_default_ub_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_ub_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_ub_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_sp_commission_amount\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_sp_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_sp_commission_amount\')">{{vm.allConfigs[\'p2p_default_sp_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_sp_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_sp_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_sp_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_sp_commission_amount\')">{{vm.allConfigs[\'p2p_mts_default_sp_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_sp_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_sp_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_sp_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_sp_commission_amount\')">{{vm.allConfigs[\'p2p_paygine_default_sp_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_sp_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_sp_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_sp_commission_amount\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_sp_commission_amount\')">{{vm.allConfigs[\'p2p_sbp_default_sp_commission_amount\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_sp_commission_amount\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_sp_commission_amount\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_tkb_commission_rate\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_tkb_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_tkb_commission_rate\')">{{vm.allConfigs[\'p2p_default_tkb_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_tkb_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_tkb_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_tkb_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_tkb_commission_rate\')">{{vm.allConfigs[\'p2p_mts_default_tkb_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_tkb_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_tkb_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_tkb_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_tkb_commission_rate\')">{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_tkb_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_tkb_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_tkb_commission_rate\')">{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_tkb_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_ub_commission_rate\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_ub_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_ub_commission_rate\')">{{vm.allConfigs[\'p2p_default_ub_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_ub_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_ub_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_ub_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_ub_commission_rate\')">{{vm.allConfigs[\'p2p_mts_default_ub_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_ub_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_ub_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_ub_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_ub_commission_rate\')">{{vm.allConfigs[\'p2p_paygine_default_ub_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_ub_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_ub_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_ub_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_ub_commission_rate\')">{{vm.allConfigs[\'p2p_sbp_default_ub_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_ub_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_ub_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'p2p_default_sp_commission_rate\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_default_sp_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_default_sp_commission_rate\')">{{vm.allConfigs[\'p2p_default_sp_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_default_sp_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_default_sp_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_mts_default_sp_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_mts_default_sp_commission_rate\')">{{vm.allConfigs[\'p2p_mts_default_sp_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_mts_default_sp_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_mts_default_sp_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_paygine_default_sp_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_paygine_default_sp_commission_rate\')">{{vm.allConfigs[\'p2p_paygine_default_sp_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_paygine_default_sp_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_paygine_default_sp_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td><a href="#" editable-number="vm.allConfigs[\'p2p_sbp_default_sp_commission_rate\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'p2p_sbp_default_sp_commission_rate\')">{{vm.allConfigs[\'p2p_sbp_default_sp_commission_rate\'].value}}</a></td><td style="text-align: center">{{vm.allConfigs[\'p2p_sbp_default_sp_commission_rate\'].lastModifiedBy}}<br>{{vm.allConfigs[\'p2p_sbp_default_sp_commission_rate\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/customer/customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.customer.delete.question" translate-values="{id: \'{{vm.customer.id}}\'}">Are you sure you want to delete this Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customer/customer-detail.html','<div><h2><span data-translate="bozorakaAdminApp.customer.detail.title">Customer</span> {{vm.customer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.customer.password">Password</span></dt><dd><span>{{vm.customer.password}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.lastLogin">Last Login</span></dt><dd><span>{{vm.customer.lastLogin | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.isSuperuser">Is Superuser</span></dt><dd><span>{{vm.customer.isSuperuser}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.phone">Phone</span></dt><dd><span>{{vm.customer.phone}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.joined">Joined</span></dt><dd><span>{{vm.customer.joined | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.isActive">Is Active</span></dt><dd><span>{{vm.customer.isActive}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.isAdmin">Is Admin</span></dt><dd><span>{{vm.customer.isAdmin}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.isStaff">Is Staff</span></dt><dd><span>{{vm.customer.isStaff}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.rawPassword">Raw Password</span></dt><dd><span>{{vm.customer.rawPassword}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.fullName">Full Name</span></dt><dd><span>{{vm.customer.fullName}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.bankId">Bank Id</span></dt><dd><span>{{vm.customer.bankId}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.CustomerStatus.\' + vm.customer.status}}">{{vm.customer.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.customer.bank">Bank</span></dt><dd><a ui-sref="bank-detail({id:vm.customer.bankId})">{{vm.customer.bankEnglishName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="customer-detail.edit({id:vm.customer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/customer/customer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerLabel" data-translate="bozorakaAdminApp.customer.home.createOrEditLabel">Create or edit a Customer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.password" for="field_password">Password</label><input type="text" class="form-control" name="password" id="field_password" ng-model="vm.customer.password" required><div ng-show="editForm.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.lastLogin" for="field_lastLogin">Last Login</label><div class="input-group"><input id="field_lastLogin" type="text" class="form-control" name="lastLogin" datetime-picker="{{dateformat}}" ng-model="vm.customer.lastLogin" is-open="vm.datePickerOpenStatus.lastLogin"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastLogin\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.isSuperuser" for="field_isSuperuser">Is Superuser</label><input type="checkbox" class="form-control" name="isSuperuser" id="field_isSuperuser" ng-model="vm.customer.isSuperuser"><div ng-show="editForm.isSuperuser.$invalid"><p class="help-block" ng-show="editForm.isSuperuser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.customer.phone" required><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.joined" for="field_joined">Joined</label><div class="input-group"><input id="field_joined" type="text" class="form-control" name="joined" datetime-picker="{{dateformat}}" ng-model="vm.customer.joined" is-open="vm.datePickerOpenStatus.joined" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'joined\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.joined.$invalid"><p class="help-block" ng-show="editForm.joined.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.joined.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.isActive" for="field_isActive">Is Active</label><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.customer.isActive"><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.isAdmin" for="field_isAdmin">Is Admin</label><input type="checkbox" class="form-control" name="isAdmin" id="field_isAdmin" ng-model="vm.customer.isAdmin"><div ng-show="editForm.isAdmin.$invalid"><p class="help-block" ng-show="editForm.isAdmin.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.isStaff" for="field_isStaff">Is Staff</label><input type="checkbox" class="form-control" name="isStaff" id="field_isStaff" ng-model="vm.customer.isStaff"><div ng-show="editForm.isStaff.$invalid"><p class="help-block" ng-show="editForm.isStaff.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.rawPassword" for="field_rawPassword">Raw Password</label><input type="text" class="form-control" name="rawPassword" id="field_rawPassword" ng-model="vm.customer.rawPassword" required><div ng-show="editForm.rawPassword.$invalid"><p class="help-block" ng-show="editForm.rawPassword.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.fullName" for="field_fullName">Full Name</label><input type="text" class="form-control" name="fullName" id="field_fullName" ng-model="vm.customer.fullName" required><div ng-show="editForm.fullName.$invalid"><p class="help-block" ng-show="editForm.fullName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.bankId" for="field_bankId">Bank Id</label><input type="number" class="form-control" name="bankId" id="field_bankId" ng-model="vm.customer.bankId" required><div ng-show="editForm.bankId.$invalid"><p class="help-block" ng-show="editForm.bankId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bankId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customer.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.customer.status" id="field_status" required><option value="ACTIVE" data-translate="bozorakaAdminApp.CustomerStatus.ACTIVE">ACTIVE</option><option value="DEACTIVATED" data-translate="bozorakaAdminApp.CustomerStatus.DEACTIVATED">DEACTIVATED</option><option value="BANNED" data-translate="bozorakaAdminApp.CustomerStatus.BANNED">BANNED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.customer.bank" for="field_bank">Bank</label><select class="form-control" id="field_bank" name="bank" ng-model="vm.customer.bankId" ng-options="bank.id as bank.englishName for bank in vm.banks" required><option value=""></option></select></div><div ng-show="editForm.bank.$invalid"><p class="help-block" ng-show="editForm.bank.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/customer/customers.html','<div><h2 data-translate="bozorakaAdminApp.customer.home.title">Customers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="customer.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="bozorakaAdminApp.customer.home.createLabel">Create new Customer</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'bozorakaAdminApp.customer.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="password"><span data-translate="bozorakaAdminApp.customer.password">Password</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastLogin"><span data-translate="bozorakaAdminApp.customer.lastLogin">Last Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isSuperuser"><span data-translate="bozorakaAdminApp.customer.isSuperuser">Is Superuser</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="bozorakaAdminApp.customer.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="joined"><span data-translate="bozorakaAdminApp.customer.joined">Joined</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isActive"><span data-translate="bozorakaAdminApp.customer.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isAdmin"><span data-translate="bozorakaAdminApp.customer.isAdmin">Is Admin</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isStaff"><span data-translate="bozorakaAdminApp.customer.isStaff">Is Staff</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rawPassword"><span data-translate="bozorakaAdminApp.customer.rawPassword">Raw Password</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fullName"><span data-translate="bozorakaAdminApp.customer.fullName">Full Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bankId"><span data-translate="bozorakaAdminApp.customer.bankId">Bank Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.customer.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bankEnglishName"><span data-translate="bozorakaAdminApp.customer.bank">Bank</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td><a ui-sref="customer-detail({id:customer.id})">{{customer.id}}</a></td><td>{{customer.password}}</td><td>{{customer.lastLogin | date:\'medium\'}}</td><td>{{customer.isSuperuser}}</td><td>{{customer.phone}}</td><td>{{customer.joined | date:\'medium\'}}</td><td>{{customer.isActive}}</td><td>{{customer.isAdmin}}</td><td>{{customer.isStaff}}</td><td>{{customer.rawPassword}}</td><td>{{customer.fullName}}</td><td>{{customer.bankId}}</td><td data-translate="{{\'bozorakaAdminApp.CustomerStatus.\' + customer.status}}">{{customer.status}}</td><td><a ui-sref="bank-detail({id:customer.bankId})">{{customer.bankEnglishName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="customer-detail({id:customer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="customer.edit({id:customer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="customer.delete({id:customer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/customer-status-log/customer-status-logs.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope">User Status Logs</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.phone"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="ACTIVE">ACTIVE</option><option value="DEACTIVATED">DEACTIVATED</option><option value="BANNED">BANNED</option><option value="REACTIVATED">REACTIVATED</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label">Reason</label><input type="text" class="form-control" ng-model="vm.searchQuery.changeReason"></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="phone"><span>User Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="changeReason"><span>Reason</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Modified Date</span></th><th><span>Modified By</span></th></tr></thead><tbody><tr ng-repeat="customerStatusLog in vm.customerStatusLogs track by customerStatusLog.id"><td><a href="javascript:;" ng-click="vm.openProfile(customerStatusLog.phone)">{{customerStatusLog.phone | phoneNumber}}</a></td><td><span class="label label-sm label-success" ng-if="customerStatusLog.status == \'ACTIVE\'">{{customerStatusLog.status}} </span><span class="label label-sm label-warning" ng-if="customerStatusLog.status == \'DEACTIVATED\'">{{customerStatusLog.status}} </span><span class="label label-sm label-danger" ng-if="customerStatusLog.status == \'BANNED\'">{{customerStatusLog.status}} </span><span class="label label-sm label-info" ng-if="customerStatusLog.status == \'REACTIVATED\'">{{customerStatusLog.status}}</span></td><td>{{customerStatusLog.changeReason}}</td><td>{{customerStatusLog.lastModifiedDate | date:\'medium\'}}</td><td>{{customerStatusLog.lastModifiedBy}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/customer-notification/customer-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customerNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.customerNotification.delete.question" translate-values="{id: \'{{vm.customerNotification.id}}\'}">Are you sure you want to delete this Customer Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customer-notification/customer-notification-detail.html','<div><h2><span data-translate="bozorakaAdminApp.customerNotification.detail.title">Customer Notification</span> {{vm.customerNotification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.customerNotification.title">Title</span></dt><dd><span>{{vm.customerNotification.title}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.message">Message</span></dt><dd><span>{{vm.customerNotification.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.language">Language</span></dt><dd><span>{{vm.customerNotification.language}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.collapseKey">Collapse Key</span></dt><dd><span>{{vm.customerNotification.collapseKey}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.eventType">Event Type</span></dt><dd><span>{{vm.customerNotification.eventType}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.url">Url</span></dt><dd><span>{{vm.customerNotification.url}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.readStatus">Read Status</span></dt><dd><span>{{vm.customerNotification.readStatus}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.NotificationStatus.\' + vm.customerNotification.status}}">{{vm.customerNotification.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.deleted">Deleted</span></dt><dd><span>{{vm.customerNotification.deleted}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.pushDate">Push Date</span></dt><dd><span>{{vm.customerNotification.pushDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.expiryDate">Expiry Date</span></dt><dd><span>{{vm.customerNotification.expiryDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.createdBy">Created By</span></dt><dd><span>{{vm.customerNotification.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.createdDate">Created Date</span></dt><dd><span>{{vm.customerNotification.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.customerNotification.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.customerNotification.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.customerNotification.customerId})">{{vm.customerNotification.customerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="customer-notification-detail.edit({id:vm.customerNotification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/customer-notification/customer-notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerNotificationLabel" data-translate="bozorakaAdminApp.customerNotification.home.createOrEditLabel">Create or edit a Customer Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customerNotification.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customerNotification.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.customerNotification.title" required ng-maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.customerNotification.message" required><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.customerNotification.language" required ng-maxlength="2"><div ng-show="editForm.language.$invalid"><p class="help-block" ng-show="editForm.language.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.language.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.collapseKey" for="field_collapseKey">Collapse Key</label><input type="text" class="form-control" name="collapseKey" id="field_collapseKey" ng-model="vm.customerNotification.collapseKey" required><div ng-show="editForm.collapseKey.$invalid"><p class="help-block" ng-show="editForm.collapseKey.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.eventType" for="field_eventType">Event Type</label><input type="text" class="form-control" name="eventType" id="field_eventType" ng-model="vm.customerNotification.eventType"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.customerNotification.url"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.readStatus" for="field_readStatus">Read Status</label><input type="checkbox" name="readStatus" id="field_readStatus" ng-model="vm.customerNotification.readStatus"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.customerNotification.status" id="field_status"><option value="PENDING" data-translate="bozorakaAdminApp.NotificationStatus.PENDING">PENDING</option><option value="PREPARING" data-translate="bozorakaAdminApp.NotificationStatus.PREPARING">PREPARING</option><option value="SUCCESS" data-translate="bozorakaAdminApp.NotificationStatus.SUCCESS">SUCCESS</option><option value="FAILURE" data-translate="bozorakaAdminApp.NotificationStatus.FAILURE">FAILURE</option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.deleted" for="field_deleted">Deleted</label><input type="checkbox" name="deleted" id="field_deleted" ng-model="vm.customerNotification.deleted"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.pushDate" for="field_pushDate">Push Date</label><div class="input-group"><input id="field_pushDate" type="text" class="form-control" name="pushDate" datetime-picker="{{dateformat}}" ng-model="vm.customerNotification.pushDate" is-open="vm.datePickerOpenStatus.pushDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'pushDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.pushDate.$invalid"><p class="help-block" ng-show="editForm.pushDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pushDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.expiryDate" for="field_expiryDate">Expiry Date</label><div class="input-group"><input id="field_expiryDate" type="text" class="form-control" name="expiryDate" datetime-picker="{{dateformat}}" ng-model="vm.customerNotification.expiryDate" is-open="vm.datePickerOpenStatus.expiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.customerNotification.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.customerNotification.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.customerNotification.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.customerNotification.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.customerNotification.customer" for="field_customer">Customer</label><select class="form-control" id="field_customer" name="customer" ng-model="vm.customerNotification.customerId" ng-options="customer.id as customer.id for customer in vm.customers" required></select></div><div ng-show="editForm.customer.$invalid"><p class="help-block" ng-show="editForm.customer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/customer-notification/customer-notifications.html','<div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="glyphicon glyphicon-bell"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.customerNotification.home.title">Personal Notifications</span></div><div class="pull-right"></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-2"><div class="form-group"><label class="control-label">Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.phone" placeholder="Phone"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Language</label><select class="form-control" ng-model="vm.searchQuery.langKey" id="language"><option value="" class selected="selected"></option><option value="uz">\u040E\u0437\u0431\u0435\u043A\u0447\u0430</option><option value="en">English</option><option value="ru">\u0420\u0443\u0441\u0441\u043A\u0438\u0439</option><option value="tj">T\u043E\u04B7\u0438\u043A\u04E3</option></select></div></div><div class="col-md-4"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label">Event Type</label><select class="form-control" name="eventType" ng-model="vm.searchQuery.eventType"><option value="" class selected="selected"></option><option value="MESSAGE">MESSAGE</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label">Status</label><select class="form-control" name="status" ng-model="vm.searchQuery.status"><option value="" class selected="selected"></option><option value="PENDING">PENDING</option><option value="SUCCESS">SUCCESS</option><option value="FAILURE">FAILURE</option></select></div></div></div></div><div class="col-md-4"><div class="form-group"><label class="control-label">Push Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from"> <span class="input-group-addon">to </span><input type="text" class="form-control" name="to"></div></div></div><!--/span--></div><!--/row--></div><div class="form-actions"><div class="col-md-offset-10"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customerId"><span data-translate="bozorakaAdminApp.customerNotification.customer">Customer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="bozorakaAdminApp.customerNotification.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="message"><span data-translate="bozorakaAdminApp.customerNotification.message">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="bozorakaAdminApp.customerNotification.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="collapseKey"><span data-translate="bozorakaAdminApp.customerNotification.collapseKey">Collapse Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="eventType"><span data-translate="bozorakaAdminApp.customerNotification.eventType">Event Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url"><span data-translate="bozorakaAdminApp.customerNotification.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="readStatus"><span data-translate="bozorakaAdminApp.customerNotification.readStatus">Read Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.customerNotification.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pushDate"><span data-translate="bozorakaAdminApp.customerNotification.pushDate">Push Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expiryDate"><span data-translate="bozorakaAdminApp.customerNotification.expiryDate">Expiry Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.customerNotification.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.customerNotification.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="customerNotification in vm.customerNotifications track by customerNotification.id"><td><a ui-sref="customer-notification-detail({id:customerNotification.id})">{{customerNotification.id}}</a></td><td class="text-nowrap"><a ng-if="customerNotification.customerId !== null" href="javascript:;" ui-sref="profile.phone({phone:customerNotification.customerPhone})" target="_blank">{{customerNotification.customerPhone | phoneNumber}}</a></td><td>{{customerNotification.title}}</td><td>{{customerNotification.message}}</td><td><button type="button" class="btn red-sunglo btn-xs" ng-if="customerNotification.language == \'en\'" style="pointer-events: none">English</button> <button type="button" class="btn blue-madison btn-xs" ng-if="customerNotification.language == \'ru\'" style="pointer-events: none">Russian</button> <button type="button" class="btn green-meadow btn-xs" ng-if="customerNotification.language == \'uz\'" style="pointer-events: none">Uzbek</button> <button type="button" class="btn yellow-crusta btn-xs" ng-if="customerNotification.language == \'tj\'" style="pointer-events: none">T\u043E\u04B7\u0438\u043A\u04E3</button></td><td>{{customerNotification.collapseKey}}</td><td>{{customerNotification.eventType}}</td><td>{{customerNotification.url}}</td><td><span class="glyphicon glyphicon-check" style="color: #1c8f5f" ng-if="customerNotification.readStatus === true"></span> <span class="glyphicon glyphicon-remove" style="color: red" ng-if="customerNotification.readStatus === false"></span></td><td><button type="button" class="btn btn-xs yellow-saffron" ng-if="customerNotification.status == \'PENDING\'" style="pointer-events: none">{{customerNotification.status}}</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="customerNotification.status == \'PREPARING\'" style="pointer-events: none">{{customerNotification.status}}</button> <button type="button" class="btn green-meadow btn-xs" ng-if="customerNotification.status == \'SUCCESS\'" style="pointer-events: none">{{customerNotification.status}}</button> <button type="button" class="btn red-sunglo btn-xs" ng-if="customerNotification.status == \'FAILURE\'" style="pointer-events: none">{{customerNotification.status}}</button></td><td>{{customerNotification.pushDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{customerNotification.expiryDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{customerNotification.createdBy}}<br>{{customerNotification.createdDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{customerNotification.lastModifiedBy}}<br>{{customerNotification.lastModifiedDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="customer-notification.delete({id:customerNotification.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/exchangerate/exchangerate-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.exchangerate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.exchangerate.delete.question" translate-values="{id: \'{{vm.exchangerate.id}}\'}">Are you sure you want to delete this Exchangerate?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/exchangerate/exchangerate-detail.html','<div><h2><span data-translate="bozorakaAdminApp.exchangerate.detail.title">Exchangerate</span> {{vm.exchangerate.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.exchangerate.usdToKrw">Usd To Krw</span></dt><dd><span>{{vm.exchangerate.usdToKrw}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.usdToUzs">Usd To Uzs</span></dt><dd><span>{{vm.exchangerate.usdToUzs}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.krwToUzs">Krw To Uzs</span></dt><dd><span>{{vm.exchangerate.krwToUzs}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.mileagePercentageRate">Mileage Percentage Rate</span></dt><dd><span>{{vm.exchangerate.mileagePercentageRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.euroDivisor">Euro Divisor</span></dt><dd><span>{{vm.exchangerate.euroDivisor}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.yahooEurToUsd">Yahoo Eur To Usd</span></dt><dd><span>{{vm.exchangerate.yahooEurToUsd}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.yahooUsdToKrw">Yahoo Usd To Krw</span></dt><dd><span>{{vm.exchangerate.yahooUsdToKrw}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.yahooUsdToUzs">Yahoo Usd To Uzs</span></dt><dd><span>{{vm.exchangerate.yahooUsdToUzs}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.mangoPaynetRate">Mango Paynet Rate</span></dt><dd><span>{{vm.exchangerate.mangoPaynetRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.mangoSpecialPrice">Mango Special Price</span></dt><dd><span>{{vm.exchangerate.mangoSpecialPrice}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.pubDate">Pub Date</span></dt><dd><span>{{vm.exchangerate.pubDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.exchangerate.lastEdited">Last Edited</span></dt><dd><span>{{vm.exchangerate.lastEdited | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="exchangerate-detail.edit({id:vm.exchangerate.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/exchangerate/exchangerate-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExchangerateLabel" data-translate="bozorakaAdminApp.exchangerate.home.createOrEditLabel">Create or edit a Exchangerate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.exchangerate.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.exchangerate.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.exchangerate.name" ng-maxlength="50" readonly="readonly"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.exchangerate.title" ng-maxlength="50"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.exchangerate.value"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/exchangerate/exchangerates.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-wallet font-dark"></i> <span class="caption-subject bold uppercase" data-translate="exchangerate.home.title">Exchange rates</span></div></div><div class="portlet-body"><div class="row"><div class="col-md-12"><table id="user" class="table table-bordered table-striped"><thead><tr><th>Mode Name</th><th style="text-align: center">Value</th><th style="text-align: center">Last modified by</th><th style="text-align: center">Last modified date</th></tr></thead><tbody><tr><td style="width:40%">{{ vm.exchangeRates[\'usd_to_uzs\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'usd_to_uzs\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'usd_to_uzs\')">{{ vm.exchangeRates["usd_to_uzs"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'usd_to_uzs\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'usd_to_uzs\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'rub_to_vp_rub\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'rub_to_vp_rub\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'rub_to_vp_rub\')">{{ vm.exchangeRates["rub_to_vp_rub"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'rub_to_vp_rub\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'rub_to_vp_rub\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%" colspan="4"><label class="tile-body"><b>Yahoo</b></label></td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_eur_to_usd\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_eur_to_usd\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_eur_to_usd\')">{{ vm.exchangeRates["yahoo_eur_to_usd"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_eur_to_usd\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_eur_to_usd\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_usd_to_uzs\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_usd_to_uzs\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_usd_to_uzs\')">{{ vm.exchangeRates["yahoo_usd_to_uzs"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_usd_to_uzs\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_usd_to_uzs\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_usd_to_rub\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_usd_to_rub\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_usd_to_rub\')">{{ vm.exchangeRates["yahoo_usd_to_rub"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_usd_to_rub\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_usd_to_rub\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_eur_to_rub\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_eur_to_rub\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_eur_to_rub\')">{{ vm.exchangeRates["yahoo_eur_to_rub"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_eur_to_rub\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_eur_to_rub\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_rub_to_tjs\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_rub_to_tjs\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_rub_to_tjs\')">{{ vm.exchangeRates["yahoo_rub_to_tjs"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_rub_to_tjs\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_rub_to_tjs\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td style="width:40%">{{ vm.exchangeRates[\'yahoo_rub_to_uzs\'].title }}</td><td><a href="#" editable-number="vm.exchangeRates[\'yahoo_rub_to_uzs\'].value" e-min="0" e-step="any" e-required onaftersave="vm.save(\'yahoo_rub_to_uzs\')">{{ vm.exchangeRates["yahoo_rub_to_uzs"].value }}</a></td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_rub_to_uzs\'].lastModifiedBy}}</td><td style="width:20%; text-align: center">{{vm.exchangeRates[\'yahoo_rub_to_uzs\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/faq/faq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.faq.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.faq.delete.question" translate-values="{id: \'{{vm.faq.id}}\'}">Are you sure you want to delete this Faq?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/faq/faq-detail.html','<div><h2><span data-translate="bozorakaAdminApp.faq.detail.title">Faq</span> {{vm.faq.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.faq.question">Question</span></dt><dd><span>{{vm.faq.question}}</span></dd><dt><span data-translate="bozorakaAdminApp.faq.answer">Answer</span></dt><dd><span>{{vm.faq.answer}}</span></dd><dt><span data-translate="bozorakaAdminApp.faq.language">Language</span></dt><dd><span>{{vm.faq.language}}</span></dd><dt><span>Sort order</span></dt><dd><span>{{vm.faq.sortOrder}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="faq-detail.edit({id:vm.faq.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/faq/faq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFaqLabel" data-translate="bozorakaAdminApp.faq.home.createOrEditLabel">Create or edit a Faq</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.faq.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.faq.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.faq.question" for="field_question">Question</label><input type="text" class="form-control" name="question" id="field_question" ng-model="vm.faq.question" required ng-maxlength="255"><div ng-show="editForm.question.$invalid"><p class="help-block" ng-show="editForm.question.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.question.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.faq.answer" for="field_answer">Answer</label><textarea class="form-control" name="answer" id="field_answer" ng-model="vm.faq.answer" required></textarea><div ng-show="editForm.answer.$invalid"><p class="help-block" ng-show="editForm.answer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.faq.language" for="field_language">Language</label><select name="language" id="field_language" class="form-control" ng-model="vm.faq.language" required><option value="uz">\u040E\u0437\u0431\u0435\u043A\u0447\u0430</option><option value="en">English</option><option value="ru">\u0420\u0443\u0441\u0441\u043A\u0438\u0439</option></select><div ng-show="editForm.language.$invalid"><p class="help-block" ng-show="editForm.language.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.language.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_position">Sort order</label><input name="position" id="field_position" type="number" class="form-control" ng-model="vm.faq.position" required><div ng-show="editForm.position.$invalid"><p class="help-block" ng-show="editForm.position.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/faq/faqs.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="glyphicon glyphicon-question-sign font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.faq.home.title">Frequently asked questions</span></div></div><div class="container-fluid"><div class="row text-right"><div class="col-xs-12 no-padding-left"><button class="btn btn-primary" ui-sref="faq.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.faq.home.createLabel">Create new Faq</span></button></div></div></div><div class="portlet-body"><div class="tabbable-custom"><ul class="nav nav-tabs"><li class="active"><a href="javascript;" data-target="#tab_uz" data-toggle="tab" aria-expanded="true">UZ</a></li><li class=""><a href="javascript;" data-target="#tab_en" data-toggle="tab" aria-expanded="false">EN</a></li><li class=""><a href="javascript;" data-target="#tab_ru" data-toggle="tab" aria-expanded="false">RU</a></li></ul><div class="tab-content"><div class="tab-pane active" id="tab_uz"><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span>No</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.question">Question</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.answer">Answer</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.position">Position</span></th><th class="text-center"><span>Action</span></th></tr></thead><tbody><tr ng-repeat="faq in vm.faqsInUz track by $index" class="text-center"><td>{{$index+1}}</td><td>{{faq.question}}</td><td>{{faq.answer}}</td><td>{{faq.position}}</td><td has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq.edit({id:faq.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="faq.delete({id:faq.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table></div></div><div class="tab-pane" id="tab_en"><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span>No</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.question">Question</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.answer">Answer</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.position">Position</span></th><th class="text-center"><span>Action</span></th></tr></thead><tbody><tr ng-repeat="faq in vm.faqsInEn track by $index" class="text-center"><td>{{$index+1}}</td><td>{{faq.question}}</td><td>{{faq.answer}}</td><td>{{faq.position}}</td><td has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq.edit({id:faq.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="faq.delete({id:faq.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table></div></div><div class="tab-pane" id="tab_ru"><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span>No</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.question">Question</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.answer">Answer</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.faq.position">Position</span></th><th class="text-center"><span>Action</span></th></tr></thead><tbody><tr ng-repeat="faq in vm.faqsInRu track by $index" class="text-center"><td>{{$index+1}}</td><td>{{faq.question}}</td><td>{{faq.answer}}</td><td>{{faq.position}}</td><td has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq.edit({id:faq.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="faq.delete({id:faq.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down ng-scope" data-translate="entity.action.delete">Delete</span></button></div>F</td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/firebase-token/firebase-token-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.firebaseToken.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.firebaseToken.delete.question" translate-values="{id: \'{{vm.firebaseToken.id}}\'}">Are you sure you want to delete this Firebase Token?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/firebase-token/firebase-token-detail.html','<div><h2><span data-translate="bozorakaAdminApp.firebaseToken.detail.title">Firebase Token</span> {{vm.firebaseToken.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.firebaseToken.value">Value</span></dt><dd><span>{{vm.firebaseToken.value}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.language">Language</span></dt><dd><span>{{vm.firebaseToken.language}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.createdBy">Created By</span></dt><dd><span>{{vm.firebaseToken.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.createdDate">Created Date</span></dt><dd><span>{{vm.firebaseToken.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.firebaseToken.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.firebaseToken.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.firebaseToken.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.firebaseToken.customerId})">{{vm.firebaseToken.customerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="firebase-token-detail.edit({id:vm.firebaseToken.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/firebase-token/firebase-token-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFirebaseTokenLabel" data-translate="bozorakaAdminApp.firebaseToken.home.createOrEditLabel">Create or edit a Firebase Token</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.firebaseToken.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.firebaseToken.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.firebaseToken.value" required ng-maxlength="255"><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.value.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.language" for="field_language">Language</label><input type="text" class="form-control" name="language" id="field_language" ng-model="vm.firebaseToken.language" required ng-maxlength="2"><div ng-show="editForm.language.$invalid"><p class="help-block" ng-show="editForm.language.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.language.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.firebaseToken.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.firebaseToken.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.firebaseToken.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.firebaseToken.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.firebaseToken.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.firebaseToken.customer" for="field_customer">Customer</label><select class="form-control" id="field_customer" name="customer" ng-model="vm.firebaseToken.customerId" ng-options="customer.id as customer.id for customer in vm.customers" required></select></div><div ng-show="editForm.customer.$invalid"><p class="help-block" ng-show="editForm.customer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/firebase-token/firebase-tokens.html','<div><h2 data-translate="bozorakaAdminApp.firebaseToken.home.title">Firebase Tokens</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="firebase-token.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.firebaseToken.home.createLabel">Create new Firebase Token</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="bozorakaAdminApp.firebaseToken.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="language"><span data-translate="bozorakaAdminApp.firebaseToken.language">Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdBy"><span data-translate="bozorakaAdminApp.firebaseToken.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.firebaseToken.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="bozorakaAdminApp.firebaseToken.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.firebaseToken.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customerId"><span data-translate="bozorakaAdminApp.firebaseToken.customer">Customer</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="firebaseToken in vm.firebaseTokens track by firebaseToken.id"><td><a ui-sref="firebase-token-detail({id:firebaseToken.id})">{{firebaseToken.id}}</a></td><td>{{firebaseToken.value}}</td><td>{{firebaseToken.language}}</td><td>{{firebaseToken.createdBy}}</td><td>{{firebaseToken.createdDate | date:\'medium\'}}</td><td>{{firebaseToken.lastModifiedBy}}</td><td>{{firebaseToken.lastModifiedDate | date:\'medium\'}}</td><td><a ui-sref="customer-detail({id:firebaseToken.customerId})">{{firebaseToken.customerId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="firebase-token-detail({id:firebaseToken.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="firebase-token.edit({id:firebaseToken.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="firebase-token.delete({id:firebaseToken.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/gateway-diagnostics/gateway-diagnostics.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-directions font-dark"></i> <span class="caption-subject bold uppercase ng-scope">Gateway diagnostics</span></div></div><div class="portlet-body"><div class="row portlet light bg-inverse" style="margin-inline: 15px"><div class="col-md-4 col-xs-12 col-sm-12" style="padding: 20px"><div class="portlet-body form"><b>Parameters</b><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.merchant">Merchant</label><select class="form-control" ng-model="vm.searchQuery.merchant"><option value="GLOBIZ">GLOBIZ</option><option value="APEXTECH">APEXTECH</option></select></div></div><div class="col-md-12"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.gateway">Gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value="TKB">TKB</option><option value="MTS">MTS</option><option value="PAYGINE">PAYGINE</option><option value="SBP">SBP</option></select></div></div><div class="col-md-12" ng-if="vm.searchQuery.gateway === \'TKB\'"><div class="form-group"><label class="control-label">Method</label><select class="form-control" ng-model="vm.searchQuery.method" ng-change="vm.onChangeMethod()"><option value="login">Login</option><option value="addCard">Add sender card</option><option value="removeCard">Remove sender card</option><option value="checkCardState">Sender card state</option><option value="getCommissionAndRate">Get commission</option><option value="checkCardReceipt">Recipient card state</option><option value="createTransfer">Create transfer</option><option value="getTransferState">Get transfer state</option><option value="confirmTransfer">Confirm transfer</option><option value="createPayment">Create payment</option><option value="getPaymentState">Get payment state</option><option value="confirmPayment">Confirm payment</option><option value="getPaymentInformation">Get payment information</option><option value="resetToken">Reset token</option></select></div></div><div class="col-md-12" ng-if="vm.searchQuery.gateway === \'MTS\' || vm.searchQuery.gateway === \'SBP\'"><div class="form-group"><label class="control-label">Method</label><select class="form-control" ng-model="vm.searchQuery.method"><option value="login">Login</option><option value="getCommissionAndRate">Get commission</option><option value="checkCardReceipt">Recipient card state</option><option value="createTransfer">Create transfer</option><option value="getTransferState">Get transfer state</option><option value="confirmTransfer">Confirm transfer</option><option value="createPayment">Create payment</option><option value="getPaymentState">Get payment state</option><option value="confirmPayment">Confirm payment</option><option value="getPaymentInformation">Get payment information</option><option value="resetToken">Reset token</option></select></div></div><div class="col-md-12" ng-if="vm.searchQuery.gateway === \'PAYGINE\'"><div class="form-group"><label class="control-label">Method</label><select class="form-control" ng-model="vm.searchQuery.method"><option value="login">Login</option><option value="getCommissionAndRate">Get commission</option><option value="checkCardReceipt">Recipient card state</option><option value="createTransfer">Create transfer</option><option value="createTransferVisa">Create transfer VISA</option><option value="getTransferState">Get transfer state</option><option value="confirmTransfer">Confirm transfer</option><option value="resetToken">Reset token</option></select></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'removeCard\' || vm.searchQuery.method === \'createTransfer\' || vm.searchQuery.method === \'createPayment\'"><div class="form-group"><label class="control-label">Reference ID</label><input type="text" class="form-control" ng-model="vm.searchQuery.referenceId"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'checkCardState\' || vm.searchQuery.method === \'getTransferState\' || vm.searchQuery.method === \'confirmTransfer\' || vm.searchQuery.method === \'getPaymentState\' || vm.searchQuery.method === \'confirmPayment\'"><div class="form-group"><label class="control-label">External ID</label><input type="text" class="form-control" ng-model="vm.searchQuery.externalId"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'getPaymentInformation\' || vm.searchQuery.method === \'createPayment\'"><div class="form-group"><label class="control-label">Service ID</label><input type="text" class="form-control" ng-model="vm.searchQuery.serviceId"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'checkCardReceipt\' || vm.searchQuery.method === \'createTransfer\'"><div class="form-group"><label class="control-label">Card number</label><input type="text" class="form-control" ng-model="vm.searchQuery.cardNumber" placeholder="Card Number"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createTransferVisa\'"><div class="form-group"><label class="control-label">Card number</label><input type="text" class="form-control" ng-model="vm.searchQuery.visaCardNumber" placeholder="Card Number"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createTransferVisa\'"><div class="form-group"><label class="control-label">Receiver first name</label><input type="text" class="form-control" ng-model="vm.searchQuery.receiverFirstName"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createTransferVisa\'"><div class="form-group"><label class="control-label">Receiver last name</label><input type="text" class="form-control" ng-model="vm.searchQuery.receiverLastName"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createPayment\' || vm.searchQuery.method === \'getPaymentInformation\'"><div class="form-group"><label class="control-label">Account</label><input type="text" class="form-control" ng-model="vm.searchQuery.account" placeholder="{{\'bozorakaAdminApp.tkbTransfer.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createPayment\'"><div class="form-group"><label class="control-label">Amount UZS</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'createTransfer\' || vm.searchQuery.method === \'createTransferVisa\'"><div class="form-group"><label class="control-label">Amount RUB</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount"></div></div><div class="col-md-12" ng-if="vm.searchQuery.method === \'getCommissionAndRate\' || vm.searchQuery.method === \'createTransfer\'"><div class="form-group"><label class="control-label">With margin</label><select class="form-control" ng-model="vm.searchQuery.margin"><option value="true">TRUE</option><option value="false">FALSE</option></select></div></div></div><div class="row"><div class="form-actions right" style="margin-right: 10px; border: 0"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-send"></i> Send</button></div></div></div></form></div></div><div class="col-md-4 col-xs-12 col-sm-12" style="padding: 20px"><div class="card" ng-if="vm.request"><b>Request</b><div class="card-body" style="display: flex; justify-content: space-between; background-color: #f5f5f5; border: 1px solid #ccc"><pre id="requestJson" style="border: 0" class="bg-light p-3">{{ vm.request | json }}</pre><a href="javascript:;" class="green mt-clipboard pull-right" ng-click="vm.copyRequest()" title="You can copy json"><i class="fa fa-copy position-absolute" style="font-size: 18px; color: #8a8a8a; top: 10px; right: 10px; cursor: pointer; padding: 10px"></i></a></div></div></div><div class="col-md-4 col-xs-12 col-sm-12" style="padding: 20px"><div class="card" ng-if="vm.response"><b>Response</b><div class="card-body" style="display: flex; justify-content: space-between; background-color: #f5f5f5; border: 1px solid #ccc"><pre id="responseJson" style="border: 0" class="bg-light p-3">{{ vm.response | json }}</pre><a href="javascript:;" class="green mt-clipboard pull-right" ng-click="vm.copyResponse()" title="You can copy json"><i class="fa fa-copy position-absolute" style="font-size: 18px; color: #8a8a8a; top: 10px; right: 10px; cursor: pointer; padding: 10px"></i></a></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/image-storage/image-storage-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.imageStorage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.imageStorage.delete.question" translate-values="{id: \'{{vm.imageStorage.id}}\'}">Are you sure you want to delete this Image Storage?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/image-storage/image-storage-detail.html','<div><h2><span data-translate="bozorakaAdminApp.imageStorage.detail.title">Image Storage</span> {{vm.imageStorage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.imageStorage.name">Name</span></dt><dd><span>{{vm.imageStorage.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.imageStorage.data">Data</span></dt><dd><div ng-if="vm.imageStorage.data"><a ng-click="vm.openFile(vm.imageStorage.dataContentType, vm.imageStorage.data)"><img data-ng-src="{{\'data:\' + vm.imageStorage.dataContentType + \';base64,\' + vm.imageStorage.data}}" style="max-width: 100%" alt="imageStorage image"> </a>{{vm.imageStorage.dataContentType}}, {{vm.byteSize(vm.imageStorage.data)}}</div></dd><dt><span data-translate="bozorakaAdminApp.imageStorage.sortOrder">Sort Order</span></dt><dd><span>{{vm.imageStorage.sortOrder}}</span></dd><dt><span data-translate="bozorakaAdminApp.imageStorage.product">Product</span></dt><dd><a ui-sref="product-detail({id:vm.imageStorage.productId})">{{vm.imageStorage.productNameUzb}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="image-storage-detail.edit({id:vm.imageStorage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/image-storage/image-storage-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImageStorageLabel" data-translate="bozorakaAdminApp.imageStorage.home.createOrEditLabel">Create or edit a Image Storage</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.imageStorage.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.imageStorage.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.imageStorage)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="bozorakaAdminApp.imageStorage.data" for="field_data">Data</label><div><img data-ng-src="{{\'data:\' + vm.imageStorage.dataContentType + \';base64,\' + vm.imageStorage.data}}" style="max-height: 100px" ng-if="vm.imageStorage.data" alt="imageStorage image"><div ng-if="vm.imageStorage.data" class="help-block clearfix"><span class="pull-left">{{vm.imageStorage.dataContentType}}, {{vm.byteSize(vm.imageStorage.data)}}</span> <button type="button" ng-click="vm.imageStorage.data=null;vm.imageStorage.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.imageStorage)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.imageStorage.data" required> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.imageStorage.dataContentType"><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/image-storage/image-storages.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="glyphicon glyphicon-tasks font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.imageStorage.home.createLabel">Image Storage</span></div></div><div class="portlet-body"><div class="table-toolbar"><div class="row"><div class="col-md-6"><div class="btn-group"><button class="btn btn-primary" ui-sref="image-storage.new"><i class="fa fa-plus"></i> <span class="hidden-xs" data-translate="bozorakaAdminApp.imageStorage.home.createLabel">Create new Image</span></button></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span></th><th jh-sort-by="name"><span data-translate="bozorakaAdminApp.imageStorage.name">Name</span></th><th jh-sort-by="data"><span>Image</span></th><th jh-sort-by="url"><span>Url</span></th><th>Action</th></tr></thead><tbody><tr ng-repeat="imageStorage in vm.imageStorages track by imageStorage.id"><td>{{imageStorage.id}}</td><td>{{imageStorage.name}}</td><td class="text-center"><img src="api/download/{{imageStorage.imageUrl}}" width="auto" height="60px"> <span ng-if="imageStorage.data">{{imageStorage.dataContentType}}</span></td><td><a id="mt{{imageStorage.id}}" target="_blank" href="api/download/{{imageStorage.imageUrl}}" id="copyAhref">{{vm.location}}/api/download/{{imageStorage.imageUrl}}</a></td><td class="text-right"><div class="flex-btn-group-container"><a href="javascript:;" class="btn green mt-clipboard" data-clipboard-action="copy" style="margin: 0px" data-clipboard-target="#mt{{imageStorage.id}}" title="You can copy url"><i class="icon-note"></i> Copy Url</a> <button type="submit" ui-sref="image-storage.delete({id:imageStorage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/language-localization/language-localization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.languageLocalization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.languageLocalization.delete.question" translate-values="{id: \'{{vm.languageLocalization.id}}\'}">Are you sure you want to delete this Language Localization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/language-localization/language-localization-detail.html','<div><h2><span data-translate="bozorakaAdminApp.languageLocalization.detail.title">Language Localization</span> {{vm.languageLocalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.languageLocalization.code">Code</span></dt><dd><span>{{vm.languageLocalization.code}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.messageRu">Message Ru</span></dt><dd><span>{{vm.languageLocalization.messageRu}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.messageUz">Message Uz</span></dt><dd><span>{{vm.languageLocalization.messageUz}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.messageEn">Message En</span></dt><dd><span>{{vm.languageLocalization.messageEn}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.createdBy">Created By</span></dt><dd><span>{{vm.languageLocalization.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.createdDate">Created Date</span></dt><dd><span>{{vm.languageLocalization.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.languageLocalization.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.languageLocalization.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.languageLocalization.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="language-localization-detail.edit({id:vm.languageLocalization.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/language-localization/language-localization-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLanguageLocalizationLabel" data-translate="bozorakaAdminApp.languageLocalization.home.createOrEditLabel">Create or edit a Language Localization</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.languageLocalization.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.languageLocalization.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.languageLocalization.code" required ng-maxlength="150" ng-readonly="vm.languageLocalization.id != null"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageRu" for="field_messageRu">Message Ru</label><textarea class="form-control" name="messageRu" id="field_messageRu" ng-model="vm.languageLocalization.messageRu" ng-maxlength="255"></textarea><div ng-show="editForm.messageRu.$invalid"><p class="help-block" ng-show="editForm.messageRu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageUz" for="field_messageUz">Message Uz</label><textarea class="form-control" name="messageUz" id="field_messageUz" ng-model="vm.languageLocalization.messageUz" ng-maxlength="255"></textarea><div ng-show="editForm.messageUz.$invalid"><p class="help-block" ng-show="editForm.messageUz.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageEn" for="field_messageEn">Message En</label><textarea class="form-control" name="messageEn" id="field_messageEn" ng-model="vm.languageLocalization.messageEn" ng-maxlength="255"></textarea><div ng-show="editForm.messageEn.$invalid"><p class="help-block" ng-show="editForm.messageEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/language-localization/language-localizations.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.languageLocalization.home.title">Language Localizations</span></div><div class="pull-right"><button type="button" ui-sref="language-localization.new" class="btn btn-success ng-binding"><i class="fa fa-plus"></i> New</button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.code">Code</label><input type="text" class="form-control" ng-model="vm.searchQuery.code" placeholder="{{ \'bozorakaAdminApp.languageLocalization.code\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageRu">Message Ru</label><input type="text" class="form-control" ng-model="vm.searchQuery.messageRu" placeholder="{{ \'bozorakaAdminApp.languageLocalization.messageRu\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageUz">Message Uz</label><input type="text" class="form-control" ng-model="vm.searchQuery.messageUz" placeholder="{{ \'bozorakaAdminApp.languageLocalization.messageUz\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.languageLocalization.messageEn">Message En</label><input type="text" class="form-control" ng-model="vm.searchQuery.messageEn" placeholder="{{ \'bozorakaAdminApp.languageLocalization.messageEn\' | translate}}"></div></div></div><div class="pull-right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div><br></div></form></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center" jh-sort-by="code"><span data-translate="bozorakaAdminApp.languageLocalization.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="messageRu"><span data-translate="bozorakaAdminApp.languageLocalization.messageRu">Message Ru</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="messageUz"><span data-translate="bozorakaAdminApp.languageLocalization.messageUz">Message Uz</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="messageEn"><span data-translate="bozorakaAdminApp.languageLocalization.messageEn">Message En</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.languageLocalization.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="languageLocalization in vm.languageLocalizations track by languageLocalization.id"><td><a ui-sref="language-localization.edit({id:languageLocalization.id})">{{languageLocalization.code}}</a></td><td>{{languageLocalization.messageRu}}</td><td>{{languageLocalization.messageUz}}</td><td>{{languageLocalization.messageEn}}</td><td>{{languageLocalization.lastModifiedBy}}<br>{{languageLocalization.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/notification/notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.notification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.notification.delete.question" translate-values="{id: \'{{vm.notification.id}}\'}">Are you sure you want to delete this Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/notification/notification-detail.html','<div><h2><span data-translate="bozorakaAdminApp.notification.detail.title">Notification</span> {{vm.notification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.notification.title">Title</span></dt><dd><span>{{vm.notification.title}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.message">Message</span></dt><dd><span>{{vm.notification.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.bannerUrl">Banner Url</span></dt><dd><span>{{vm.notification.bannerUrl}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.topic">Topic</span></dt><dd><span>{{vm.notification.topic}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.shouldOverride">Should Override</span></dt><dd><span>{{vm.notification.shouldOverride}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.collapseKey">Collapse Key</span></dt><dd><span>{{vm.notification.collapseKey}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.pushDate">Push Date</span></dt><dd><span>{{vm.notification.pushDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.expiryDate">Expiry Date</span></dt><dd><span>{{vm.notification.expiryDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.notification.news">News</span></dt><dd><a ui-sref="news-detail({id:vm.notification.newsId})">{{vm.notification.newsTitle}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="notification-detail.edit({id:vm.notification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/notification/notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNotificationLabel" data-translate="bozorakaAdminApp.notification.home.createOrEditLabel">Create or edit a Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.notification.id"><label class="col-md-3 text-right" for="id" data-translate="global.field.id">ID</label><div class="col-md-9"><input type="text" class="form-control" id="id" name="id" ng-model="vm.notification.id" readonly="readonly"></div></div><div class="form-group"><label class="control-label col-md-3 text-right" data-translate="bozorakaAdminApp.notification.shouldOverride">Should override</label><div class="col-md-9"><label class="mt-checkbox margin-bottom-10"><input type="checkbox" name="shouldOverride" ng-change="vm.isChecked(vm.notification.shouldOverride)" ng-model="vm.notification.shouldOverride"> <span></span></label></div></div><div class="form-group" ng-if="vm.notifications != null"><label class="control-label col-md-3 text-right">Select notification</label><div class="col-md-9"><select class="form-control" ng-model="vm.notificationChange" ng-change="vm.selectedNotification(vm.notificationChange)" id="select_notification" ng-options="notification as notification.title for notification in vm.notifications"></select></div></div><div class="form-group"><label class="col-md-3 text-right" data-translate="bozorakaAdminApp.notification.title">Title</label><div class="col-md-9"><input type="text" class="form-control" name="title" ng-model="vm.notification.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 text-right" data-translate="bozorakaAdminApp.notification.url">URL</label><div class="col-md-9"><input type="url" class="form-control" name="url" ng-model="vm.notification.url" maxlength="255"></div></div><div class="form-group"><label class="col-md-3 text-right" data-translate="bozorakaAdminApp.notification.message">Message</label><div class="col-md-9"><textarea class="form-control" name="message" ng-model="vm.notification.message" required></textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="control-label col-md-3" data-translate="bozorakaAdminApp.notification.bannerUrl">Banner</label><div class="col-md-9"><div><img src="api/download/{{vm.notification.bannerUrl}}" style="height: 300px; width: 600px" ng-if="vm.notification.data == null"> <img data-ng-src="{{\'data:\' + vm.notification.dataContentType + \';base64,\' + vm.notification.data}}" style="height: 300px; width: 600px" ng-if="vm.notification.data != null"><div ng-if="vm.notification.data" class="help-block clearfix"><button type="button" ng-click="vm.notification.data=null;vm.notification.dataContentType=null;vm.notification.banner=null " class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" style="margin-top:  10px" ngf-change="vm.setData($file)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="bannerUrl" id="field_banner" ng-model="vm.notification.bannerUrl"></div></div><div class="form-group"><label class="control-label col-md-3" data-translate="bozorakaAdminApp.notification.topic" for="field_topic">Topic</label><div class="col-md-9"><select class="form-control" id="field_topic" name="topic" ng-model="vm.notification.topic"><option value="uz">Uzbek</option><option value="ru">Russian</option><option value="en">English</option><option value="tg">Tajik</option></select><div ng-show="editForm.topic.$invalid"><p class="help-block" ng-show="editForm.topic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.topic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div></div><div class="form-group"><label class="control-label col-md-3" data-translate="bozorakaAdminApp.notification.pushDate" for="field_pushDate">Push Date</label><div class="col-md-9"><div class="input-group"><input id="field_pushDate" type="text" class="form-control" name="pushDate" datetime-picker="{{dateformat}}" ng-model="vm.notification.pushDate" is-open="vm.datePickerOpenStatus.pushDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'pushDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.pushDate.$invalid"><p class="help-block" ng-show="editForm.pushDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pushDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div></div><div class="form-group"><label class="control-label col-md-3" data-translate="bozorakaAdminApp.notification.expiryDate" for="field_expiryDate">Expiry Date</label><div class="col-md-9"><div class="input-group"><input id="field_expiryDate" type="text" class="form-control" name="expiryDate" datetime-picker="{{dateformat}}" ng-model="vm.notification.expiryDate" is-open="vm.datePickerOpenStatus.expiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/notification/notifications.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="fa fa-bell-o font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.notification.home.title">Notifications</span></div></div><div class="portlet-body"><div class="table-toolbar"><div class="row"><div class="col-md-6"><div class="btn-group"><button class="btn btn-primary" ui-sref="notification.new"><i class="fa fa-plus"></i> <span class="hidden-xs" data-translate="bozorakaAdminApp.notification.home.createLabel">Create new Notification</span></button></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="bozorakaAdminApp.notification.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url"><span data-translate="bozorakaAdminApp.notification.url">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="topic"><span data-translate="bozorakaAdminApp.notification.topic">Topic</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="newsTitle"><span data-translate="bozorakaAdminApp.notification.news">News</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="newsTitle"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pushDate"><span data-translate="bozorakaAdminApp.notification.pushDate">Push Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pushDate"><span data-translate="bozorakaAdminApp.notification.createDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pushDate"><span data-translate="bozorakaAdminApp.notification.createBy">Create By</span> <span class="glyphicon glyphicon-sort"></span></th><th>Action</th></tr></thead><tbody><tr ng-repeat="notification in vm.notifications track by notification.id"><td>{{notification.id}}</td><td>{{notification.title}}</td><td>{{notification.url}}</td><td><button type="button" class="btn green-meadow btn-xs" ng-if="notification.topic == \'uz\'" style="pointer-events: none">Uzbek</button> <button type="button" class="btn blue-madison btn-xs" ng-if="notification.topic == \'ru\'" style="pointer-events: none">Russian</button> <button type="button" class="btn red-sunglo btn-xs" ng-if="notification.topic == \'en\'" style="pointer-events: none">English</button> <button type="button" class="btn blue-chambray btn-xs" ng-if="notification.topic == \'tg\'" style="pointer-events: none">Tajik</button></td><td><a ui-sref="news.edit({id:notification.newsId})">{{notification.newsTitle}}</a></td><td><button type="button" class="btn btn-xs yellow-saffron" ng-if="notification.status == \'PENDING\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="notification.status == \'PREPARING\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn green-meadow btn-xs" ng-if="notification.status == \'SUCCESS\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn red-sunglo btn-xs" ng-if="notification.status == \'FAILURE\'" style="pointer-events: none">{{notification.status}}</button></td><td>{{notification.pushDate | date:\'medium\'}}</td><td>{{notification.createdDate | date:\'medium\'}}</td><td>{{notification.createdBy}}</td><td class="text-right"><div class="btn-group flex-btn-group-container" ng-if="notification.editable"><button type="submit" ui-sref="notification.edit({id:notification.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button></div></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><!-- END EXAMPLE TABLE PORTLET--></div></div>');
$templateCache.put('app/entities/my-id/my-id-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.myID.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.myID.delete.question" translate-values="{id: \'{{vm.myID.id}}\'}">Are you sure you want to delete this My ID?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/my-id/my-id-detail.html','<div><h2><span data-translate="bozorakaAdminApp.myID.detail.title">My ID</span> {{vm.myID.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.myID.firstName">First Name</span></dt><dd><span>{{vm.myID.firstName}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.lastName">Last Name</span></dt><dd><span>{{vm.myID.lastName}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.middleName">Middle Name</span></dt><dd><span>{{vm.myID.middleName}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.birthDate">Birth Date</span></dt><dd><span>{{vm.myID.birthDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.gender">Gender</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.Gender.\' + vm.myID.gender}}">{{vm.myID.gender}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.documentNumber">Document Number</span></dt><dd><span>{{vm.myID.documentNumber}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.pinfl">Pinfl</span></dt><dd><span>{{vm.myID.pinfl}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.issuedDate">Issued Date</span></dt><dd><span>{{vm.myID.issuedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.expiryDate">Expiry Date</span></dt><dd><span>{{vm.myID.expiryDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.birthPlace">Birth Place</span></dt><dd><span>{{vm.myID.birthPlace}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.permanentAddress">Permanent Address</span></dt><dd><span>{{vm.myID.permanentAddress}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.photoUrl">Photo Url</span></dt><dd><span>{{vm.myID.photoUrl}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.rawJson">Raw Json</span></dt><dd><span>{{vm.myID.rawJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.deleted">Deleted</span></dt><dd><span>{{vm.myID.deleted}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.createdBy">Created By</span></dt><dd><span>{{vm.myID.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.createdDate">Created Date</span></dt><dd><span>{{vm.myID.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.myID.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.myID.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.myID.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.myID.customerId})">{{vm.myID.customerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="my-id-detail.edit({id:vm.myID.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/my-id/my-id-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMyIDLabel">Create a My ID</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row" style="gap: 10px"><div class="form-group col-md-10" ng-show="vm.myID.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.myID.id" readonly="readonly"></div><div class="form-group col-md-2" ng-show="vm.myID.id"><label class="control-label" for="field_blocked">Blocked</label><input style="width: 15px; margin: 0 10px 0" type="checkbox" class="form-control" name="blocked" id="field_blocked" ng-model="vm.myID.blocked"></div></div><div class="row"><div class="form-group col-md-4"><label for="field_customer" data-translate="bozorakaAdminApp.myID.customerPhone">Customer Phone</label><input type="text" class="form-control" name="customerPhone" id="field_customer" ng-model="vm.myID.customerPhone" ng-maxlength="20"></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.documentNumber" for="field_documentNumber">Document Number</label><input type="text" class="form-control" name="documentNumber" id="field_documentNumber" ng-model="vm.myID.documentNumber" ng-change="vm.myID.documentNumber = vm.myID.documentNumber.toUpperCase()" style="text-transform: uppercase" required ng-maxlength="10"><div ng-show="editForm.documentNumber.$invalid"><p class="help-block" ng-show="editForm.documentNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.pinfl" for="field_pinfl">Pinfl</label><input type="text" class="form-control" name="pinfl" id="field_pinfl" ng-model="vm.myID.pinfl" ng-minlength="1" inputmode="numeric" onkeypress="return event.charCode >= 48 && event.charCode <= 57"><div ng-show="editForm.pinfl.$invalid"><p class="help-block" ng-show="editForm.pinfl.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pinfl.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field cannot be longer than 1 characters.</p></div></div></div><div class="row"><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.myID.firstName" required ng-maxlength="200" ng-change="vm.myID.firstName = vm.myID.firstName && vm.myID.firstName.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.myID.lastName" required ng-maxlength="200" ng-change="vm.myID.lastName = vm.myID.lastName && vm.myID.lastName.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.middleName" for="field_middleName">Middle Name</label><input type="text" class="form-control" name="middleName" id="field_middleName" ng-model="vm.myID.middleName" ng-maxlength="200" ng-change="vm.myID.middleName = vm.myID.middleName && vm.myID.middleName.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.middleName.$invalid"><p class="help-block" ng-show="editForm.middleName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div><div class="row"><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.birthDate" for="field_birthDate">Birth Date</label><div class="input-group"><input id="field_birthDate" type="text" class="form-control" name="birthDate" uib-datepicker-popup="dd.MM.yyyy" ng-model="vm.myID.birthDate" is-open="vm.datePickerOpenStatus.birthDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.birthDate.$invalid"><p class="help-block" ng-show="editForm.birthDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.gender" for="field_gender">Gender</label><select class="form-control" name="gender" ng-model="vm.myID.gender" id="field_gender" required><option value="F">Female</option><option value="M">Male</option><option value="U">Unset</option></select><div ng-show="editForm.gender.$invalid"><p class="help-block" ng-show="editForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.birthPlace" for="field_birthPlace">Birth Place</label><input type="text" class="form-control" name="birthPlace" id="field_birthPlace" ng-model="vm.myID.birthPlace" ng-maxlength="200" ng-change="vm.myID.birthPlace = vm.myID.birthPlace && vm.myID.birthPlace.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.birthPlace.$invalid"><p class="help-block" ng-show="editForm.birthPlace.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div><div class="row"><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.issuedDate" for="field_issuedDate">Issued Date</label><div class="input-group"><input id="field_issuedDate" type="text" class="form-control" name="issuedDate" uib-datepicker-popup="dd.MM.yyyy" ng-model="vm.myID.issuedDate" is-open="vm.datePickerOpenStatus.issuedDate" ng-change="vm.onIssuedDateChange()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'issuedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.expiryDate" for="field_expiryDate">Expiry Date</label><div class="input-group"><input id="field_expiryDate" type="text" class="form-control" name="expiryDate" uib-datepicker-popup="dd.MM.yyyy" ng-model="vm.myID.expiryDate" ng-pattern="/^\\d{2}\\.\\d{2}\\.\\d{4}$/" is-open="vm.datePickerOpenStatus.expiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="bozorakaAdminApp.myID.permanentAddress" for="field_permanentAddress">Permanent Address</label><input type="text" class="form-control" name="permanentAddress" id="field_permanentAddress" ng-model="vm.myID.permanentAddress" ng-maxlength="200" ng-change="vm.myID.permanentAddress = vm.myID.permanentAddress && vm.myID.permanentAddress.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.permanentAddress.$invalid"><p class="help-block" ng-show="editForm.permanentAddress.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/my-id/my-ids.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="row"><div class="portlet-title col-md-6"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.myID.home.title">MyID</span></div></div><div class="col-md-6"><button type="button" ui-sref="my-id.new" class="btn btn-success ng-binding pull-right"><i class="fa fa-plus"></i> New</button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="User Phone"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Passport Number</label><input type="text" class="form-control" ng-model="vm.searchQuery.documentNumber" placeholder="Passport Number"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.firstName" placeholder="First Name"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Last Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.lastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">State</label><select class="form-control" ng-model="vm.searchQuery.blocked"><option value="">ALL</option><option value="true">Blocked</option><option value="false">Unblocked</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.date">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customerId">User<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName">Full Name<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthDate"><span data-translate="bozorakaAdminApp.myID.birthDate">Birth Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender"><span data-translate="bozorakaAdminApp.myID.gender">Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentNumber">Passport N <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pinfl"><span data-translate="bozorakaAdminApp.myID.pinfl">Pinfl</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="issuedDate"><span data-translate="bozorakaAdminApp.myID.issuedDate">Issued Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expiryDate"><span data-translate="bozorakaAdminApp.myID.expiryDate">Expiry Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthPlace"><span data-translate="bozorakaAdminApp.myID.birthPlace">Birth Place</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="permanentAddress"><span data-translate="bozorakaAdminApp.myID.permanentAddress">Permanent Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="deleted"><span data-translate="bozorakaAdminApp.myID.deleted">Deleted</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.myID.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="bozorakaAdminApp.myID.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="myID in vm.myIDS track by myID.id"><td><a ui-sref="my-id-detail({id:myID.id})">{{myID.id}}</a></td><td class="text-nowrap"><a href="javascript:;" ng-click="vm.openProfile(myID.customerPhone)">{{myID.customerPhone | phoneNumber}}</a></td><td>{{myID.firstName + \' \' + myID.lastName + \' \' + (myID.middleName === null ? \'\' : myID.middleName)}}</td><td>{{myID.birthDate | date:\'mediumDate\'}}</td><td><span class="label label-success" ng-if="myID.gender === \'M\'">Male</span> <span class="label label-danger" ng-if="myID.gender=== \'F\'">Female</span> <span class="label label-warning" ng-if="myID.gender === \'U\'">Unset</span></td><td><div style="display: flex; align-items: center; justify-content: center; text-wrap: nowrap">{{myID.documentNumber}} <i ng-if="myID.blocked" class="icon-ban font-red" style="font-weight: bold; margin-left: 4px"></i></div></td><td>{{myID.pinfl}}</td><td>{{myID.issuedDate | date:\'mediumDate\'}}</td><td>{{myID.expiryDate | date:\'mediumDate\'}}</td><td>{{myID.birthPlace}}</td><td>{{myID.permanentAddress}}</td><td><span class="label label-success" ng-if="myID.deleted === false">Active</span> <span class="label label-danger" ng-if="myID.deleted === true">Deleted</span></td><td>{{myID.createdDate | date:\'medium\'}}</td><td>{{ myID.lastModifiedBy + \' \' + (myID.lastModifiedDate | date:\'medium\')}}</td><td class="text-right"><button type="submit" ui-sref="my-id.delete({id:myID.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr></tbody></table></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/news/news-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.news.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.news.delete.question" translate-values="{id: \'{{vm.news.id}}\'}">Are you sure you want to delete this News?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/news/news-detail.html','<div><h2><span data-translate="bozorakaAdminApp.news.detail.title">News</span> {{vm.news.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.news.title">Title</span></dt><dd><span>{{vm.news.title}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.slug">Slug</span></dt><dd><span>{{vm.news.slug}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.description">Description</span></dt><dd><span>{{vm.news.description}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.pubDate">Pub Date</span></dt><dd><span>{{vm.news.pubDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.lastEdited">Last Edited</span></dt><dd><span>{{vm.news.lastEdited | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.numberOfViews">Number Of Views</span></dt><dd><span>{{vm.news.numberOfViews}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.descriptionEn">Description En</span></dt><dd><span>{{vm.news.descriptionEn}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.descriptionRu">Description Ru</span></dt><dd><span>{{vm.news.descriptionRu}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.titleEn">Title En</span></dt><dd><span>{{vm.news.titleEn}}</span></dd><dt><span data-translate="bozorakaAdminApp.news.titleRu">Title Ru</span></dt><dd><span>{{vm.news.titleRu}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="news-detail.edit({id:vm.news.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/news/news-dialog.html','<!--<jhi-alert></jhi-alert>--><div class="row"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-basket"></i> <span class="caption-subject bold uppercase">Create or edit a News</span></div><div class="float-tight"><span class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span>&times;</span></span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--> <input type="hidden" class="form-control" id="id" name="id" ng-model="vm.news.id" readonly="readonly"><div class="portlet-body"><div class="tabbable-custom"><ul class="nav nav-tabs"><li class="active"><a href="javascript;" data-target="#tab_uz" data-toggle="tab" aria-expanded="true">UZ</a></li><li class=""><a href="javascript;" data-target="#tab_5_2" data-toggle="tab" aria-expanded="false">EN</a></li><li class=""><a href="javascript;" data-target="#tab_5_3" data-toggle="tab" aria-expanded="false">RU</a></li><li class=""><a href="javascript;" data-target="#tab_5_4" data-toggle="tab" aria-expanded="false">TJ</a></li></ul><div class="tab-content"><div class="tab-pane active" id="tab_uz"><div class="row margin-bottom-10"><label class="col-md-3 control-label">Show</label><div class="col-md-3"><input bs-switch ng-model="vm.payGramUzb" type="checkbox" switch-active="true" switch-size="small" switch-animate="true"></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'uz\')? \'*\' : \'\'}} </span>Title</label><div class="col-md-9"><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.news.title" ng-required="vm.isAppsOnForNews(\'uz\')"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'uz\')? \'*\' : \'\'}} </span>Description</label><div class="col-md-9"><summernote class="form-control" config="options" name="description" id="description" rows="10" ng-model="vm.news.description" ng-required="vm.isAppsOnForNews(\'uz\')"></summernote><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="tab-pane" id="tab_5_2"><div class="row margin-bottom-10"><label class="col-md-3 control-label">Show</label><div class="col-md-3"><input bs-switch ng-model="vm.payGramEng" type="checkbox" switch-active="true" switch-size="small" switch-animate="true"></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'en\')? \'*\' : \'\'}} </span>Title</label><div class="col-md-9"><input type="text" class="form-control" name="titleEn" id="field_titleEn" ng-model="vm.news.titleEn" ng-required="vm.isAppsOnForNews(\'en\')"><div ng-show="editForm.titleEn.$invalid"><p class="help-block" ng-show="editForm.titleEn.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'en\')? \'*\' : \'\'}} </span>Description</label><div class="col-md-9"><summernote class="form-control" config="options" name="descriptionEn" id="field_descriptionEn" rows="10" ng-model="vm.news.descriptionEn" ng-required="vm.isAppsOnForNews(\'en\')"></summernote><div ng-show="editForm.descriptionEn.$invalid"><p class="help-block" ng-show="editForm.descriptionEn.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="tab-pane" id="tab_5_3"><div class="row margin-bottom-10"><label class="col-md-3 control-label">Show</label><div class="col-md-3"><input bs-switch ng-model="vm.payGramRus" type="checkbox" switch-active="true" switch-size="small" switch-animate="true"></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'ru\')? \'*\' : \'\'}} </span>Title</label><div class="col-md-9"><input type="text" class="form-control" name="titleRu" id="field_titleRu" ng-model="vm.news.titleRu" ng-required="vm.isAppsOnForNews(\'ru\')"><div ng-show="editForm.titleRu.$invalid"><p class="help-block" ng-show="editForm.titleRu.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'ru\')? \'*\' : \'\'}} </span>Description</label><div class="col-md-9"><summernote class="form-control" config="options" name="descriptionRu" id="field_descriptionRu" rows="10" ng-model="vm.news.descriptionRu" ng-required="vm.isAppsOnForNews(\'ru\')"></summernote><div ng-show="editForm.descriptionRu.$invalid"><p class="help-block" ng-show="editForm.descriptionRu.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="tab-pane" id="tab_5_4"><div class="row margin-bottom-10"><label class="col-md-3 control-label">Show</label><div class="col-md-3"><input bs-switch ng-model="vm.payGramTj" type="checkbox" switch-active="true" switch-size="small" switch-animate="true"></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'tj\')? \'*\' : \'\'}} </span>Title</label><div class="col-md-9"><input type="text" class="form-control" name="titleTj" id="field_titleTj" ng-model="vm.news.titleTj" ng-required="vm.isAppsOnForNews(\'tj\')"><div ng-show="editForm.titleTj.$invalid"><p class="help-block" ng-show="editForm.titleTj.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span class="required" aria-required="true">{{vm.isAppsOnForNews(\'tj\')? \'*\' : \'\'}} </span>Description</label><div class="col-md-9"><summernote class="form-control" config="options" name="descriptionTj" id="field_descriptionTj" rows="10" ng-model="vm.news.descriptionTj" ng-required="vm.isAppsOnForNews(\'tj\')"></summernote><div ng-show="editForm.descriptionTj.$invalid"><p class="help-block" ng-show="editForm.descriptionTj.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></div></div></div></form></div>');
$templateCache.put('app/entities/news/news.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="glyphicon glyphicon-tasks font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.news.home.title">News</span></div></div><div class="portlet-body"><div class="table-toolbar"><div class="row"><div class="col-md-6"><div class="btn-group"><button class="btn btn-primary" ui-sref="news.new"><i class="fa fa-plus"></i> <span class="hidden-xs" data-translate="bozorakaAdminApp.news.home.createLabel">Create News</span></button></div></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span data-translate="global.field.id">ID</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.news.title">Title</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.news.pubDate">Pub Date</span></th><th class="text-center"><span data-translate="bozorakaAdminApp.news.lastEdited">Last Edited</span></th><th jh-sort-by="numberOfViews"><span data-translate="bozorakaAdminApp.news.numberOfViews">Views</span></th><th class="text-center"><span>Action</span></th></tr></thead><tbody><tr ng-repeat="news in vm.news track by news.id"><td>{{news.id}}</td><td>{{news.mainTitle}}</td><td>{{news.pubDate | date:\'medium\'}}</td><td>{{news.lastEdited | date:\'medium\'}}</td><td>{{news.numberOfViews}}</td><td class="text-right" width="150px"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="news.edit({id:news.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="news.delete({id:news.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/paynet-mode/paynet-mode-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.paynetMode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.paynetMode.delete.question" translate-values="{id: \'{{vm.paynetMode.id}}\'}">Are you sure you want to delete this Paynet Mode?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paynet-mode/paynet-mode-detail.html','<div><h2><span data-translate="bozorakaAdminApp.paynetMode.detail.title">Paynet Mode</span> {{vm.paynetMode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.paynetMode.paynetMode">Paynet Mode</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.TransactionMode.\' + vm.paynetMode.paynetMode}}">{{vm.paynetMode.paynetMode}}</span></dd><dt><span data-translate="bozorakaAdminApp.paynetMode.cardphoneMode">Cardphone Mode</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.TransactionMode.\' + vm.paynetMode.cardphoneMode}}">{{vm.paynetMode.cardphoneMode}}</span></dd><dt><span data-translate="bozorakaAdminApp.paynetMode.mangoIntCardMode">Mango Int Card Mode</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.TransactionMode.\' + vm.paynetMode.mangoIntCardMode}}">{{vm.paynetMode.mangoIntCardMode}}</span></dd><dt><span data-translate="bozorakaAdminApp.paynetMode.lastEdited">Last Edited</span></dt><dd><span>{{vm.paynetMode.lastEdited | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="paynet-mode-detail.edit({id:vm.paynetMode.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/paynet-mode/paynet-mode-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaynetModeLabel">Create or edit a Paynet Mode</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.paynetMode.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.paynetMode.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.paynetMode.title" ng-maxlength="50"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.paynetMode.name" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.paynetMode.value"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paynet-mode/paynet-modes.html','<jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-anchor font-dark"></i> <span class="caption-subject bold uppercase" data-translate="paynetMode.home.title">Modes</span></div></div><div class="portlet-body"><div class="row"><div class="col-md-12"><table id="user" class="table table-bordered table-striped"><thead><tr><th style="width:20%">Mode Name</th><th style="width:20%;text-align: center">Value</th><th style="width:20%;text-align: center">Last modified by</th><th style="width:40%;text-align: center">Last modified date</th></tr></thead><tbody><tr><td colspan="4"><label class="tile-body"><b>Russia</b></label></td></tr><tr><td>{{vm.allConfigs[\'sent_sms_limit\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'sent_sms_limit\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'sent_sms_limit\')">{{vm.allConfigs[\'sent_sms_limit\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'sent_sms_limit\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'sent_sms_limit\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'check_sms_period\'].title}}</td><td><a href="#" editable-number="vm.allConfigs[\'check_sms_period\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'check_sms_period\')">{{vm.allConfigs[\'check_sms_period\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'check_sms_period\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'check_sms_period\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Payment gateways</b></label></td></tr><tr><td>Payments</td><td><a href="#" editable-select="vm.allPaymentModes[\'tkb_payment_mode\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'tkb_payment_mode\')">{{vm.allPaymentModes[\'tkb_payment_mode\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'tkb_payment_mode\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'tkb_payment_mode\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Payment gateway</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_payment_gateway\'].value" e-ng-options="m.value as m.text for m in vm.uniredGateways" e-required onaftersave="vm.save(\'unired_payment_gateway\')">{{vm.allPaymentModes[\'unired_payment_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_payment_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_payment_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>P2P</b></label></td></tr><tr><td>Linked card</td><td style="width: 20%"><a href="#" editable-select="vm.allPaymentModes[\'unired_linked_card_gateway\'].value" e-ng-options="m.value as m.text for m in vm.linkedCards" e-required onaftersave="vm.save(\'unired_linked_card_gateway\')">{{vm.allPaymentModes[\'unired_linked_card_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_linked_card_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_linked_card_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Unlinked card</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_unlinked_card_gateway\'].value" e-ng-options="m.value as m.text for m in vm.unlinkedCards" e-required onaftersave="vm.save(\'unired_unlinked_card_gateway\')">{{vm.allPaymentModes[\'unired_unlinked_card_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_unlinked_card_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_unlinked_card_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Saved card</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_saved_card_gateway\'].value" e-ng-options="m.value as m.text for m in vm.savedCards" e-required onaftersave="vm.save(\'unired_saved_card_gateway\')">{{vm.allPaymentModes[\'unired_saved_card_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_saved_card_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_saved_card_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Bank app</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_bank_app_gateway\'].value" e-ng-options="m.value as m.text for m in vm.bankApps" e-required onaftersave="vm.save(\'unired_bank_app_gateway\')">{{vm.allPaymentModes[\'unired_bank_app_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_bank_app_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_bank_app_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>VISA direct</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_visa_direct_gateway\'].value" e-ng-options="m.value as m.text for m in vm.visaDirects" e-required onaftersave="vm.save(\'unired_visa_direct_gateway\')">{{vm.allPaymentModes[\'unired_visa_direct_gateway\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_visa_direct_gateway\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_visa_direct_gateway\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Check receiver</td><td><a href="#" editable-select="vm.allPaymentModes[\'unired_check_receiver\'].value" e-ng-options="m.value as m.text for m in vm.checkCards" e-required onaftersave="vm.save(\'unired_check_receiver\')">{{vm.allPaymentModes[\'unired_check_receiver\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_check_receiver\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'unired_check_receiver\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Play Integrity</b></label></td></tr><tr><td>Login</td><td><a href="#" editable-select="vm.allPaymentModes[\'play_integrity_login\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'play_integrity_login\')">{{vm.allPaymentModes[\'play_integrity_login\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'play_integrity_login\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'play_integrity_login\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Transfer</td><td><a href="#" editable-select="vm.allPaymentModes[\'play_integrity_transfer\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'play_integrity_transfer\')">{{vm.allPaymentModes[\'play_integrity_transfer\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'play_integrity_transfer\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'play_integrity_transfer\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>App Integrity</b></label></td></tr><tr><td>Login</td><td><a href="#" editable-select="vm.allPaymentModes[\'app_attest_login\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'app_attest_login\')">{{vm.allPaymentModes[\'app_attest_login\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'app_attest_login\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'app_attest_login\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>Transfer</td><td><a href="#" editable-select="vm.allPaymentModes[\'app_attest_transfer\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'app_attest_transfer\')">{{vm.allPaymentModes[\'app_attest_transfer\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'app_attest_transfer\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'app_attest_transfer\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Application GeoIP Restriction</b></label></td></tr><tr><td>Geo IP restriction</td><td><a href="#" editable-select="vm.allPaymentModes[\'geo_ip_restriction\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'geo_ip_restriction\')">{{vm.allPaymentModes[\'geo_ip_restriction\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'geo_ip_restriction\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'geo_ip_restriction\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Payment state checker</b></label></td></tr><tr><td>TKB</td><td><a href="#" editable-select="vm.allPaymentModes[\'payment_tkb_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'payment_tkb_checker\')">{{vm.allPaymentModes[\'payment_tkb_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_tkb_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_tkb_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>MTS</td><td><a href="#" editable-select="vm.allPaymentModes[\'payment_mts_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'payment_mts_checker\')">{{vm.allPaymentModes[\'payment_mts_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_mts_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_mts_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>PAYGINE</td><td><a href="#" editable-select="vm.allPaymentModes[\'payment_paygine_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'payment_paygine_checker\')">{{vm.allPaymentModes[\'payment_paygine_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_paygine_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_paygine_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>SBP</td><td><a href="#" editable-select="vm.allPaymentModes[\'payment_sbp_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'payment_sbp_checker\')">{{vm.allPaymentModes[\'payment_sbp_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_sbp_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'payment_sbp_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>P2P state checker</b></label></td></tr><tr><td>TKB</td><td><a href="#" editable-select="vm.allPaymentModes[\'p2p_tkb_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'p2p_tkb_checker\')">{{vm.allPaymentModes[\'p2p_tkb_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_tkb_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_tkb_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>MTS</td><td><a href="#" editable-select="vm.allPaymentModes[\'p2p_mts_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'p2p_mts_checker\')">{{vm.allPaymentModes[\'p2p_mts_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_mts_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_mts_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>PAYGINE</td><td><a href="#" editable-select="vm.allPaymentModes[\'p2p_paygine_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'p2p_paygine_checker\')">{{vm.allPaymentModes[\'p2p_paygine_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_paygine_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_paygine_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>SBP</td><td><a href="#" editable-select="vm.allPaymentModes[\'p2p_sbp_checker\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'p2p_sbp_checker\')">{{vm.allPaymentModes[\'p2p_sbp_checker\'].value}}</a></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_sbp_checker\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'p2p_sbp_checker\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Unverified customer</b></label></td></tr><tr><td>{{vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].title}}</td><td><div class="row"><div class="col-md-6 custom-config"><a href="#" editable-number="vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'unverified_customer_daily_transfer_count_limit\')">{{vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].value}}</a></div><div class="col-md-6"><a href="#" editable-select="vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].valueString" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.saveConfig(\'unverified_customer_daily_transfer_count_limit\')">{{vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].valueString}}</a></div></div></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'unverified_customer_daily_transfer_count_limit\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].title}}</td><td><div class="row"><div class="col-md-6 custom-config"><a href="#" editable-number="vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'unverified_customer_monthly_transfer_amount_limit\')">{{vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].value}}</a></div><div class="col-md-6"><a href="#" editable-select="vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].valueString" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.saveConfig(\'unverified_customer_monthly_transfer_amount_limit\')">{{vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].valueString}}</a></div></div></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'unverified_customer_monthly_transfer_amount_limit\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Verified customer</b></label></td></tr><tr><td>{{vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].title}}</td><td><div class="row"><div class="col-md-6 custom-config"><a href="#" editable-number="vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'verified_customer_daily_transfer_count_limit\')">{{vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].value}}</a></div><div class="col-md-6"><a href="#" editable-select="vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].valueString" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.saveConfig(\'verified_customer_daily_transfer_count_limit\')">{{vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].valueString}}</a></div></div></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'verified_customer_daily_transfer_count_limit\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].title}}</td><td><div class="row"><div class="col-md-6 custom-config"><a href="#" editable-number="vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].value" e-min="0" e-step="any" e-required onaftersave="vm.saveConfig(\'verified_customer_monthly_transfer_amount_limit\')">{{vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].value}}</a></div><div class="col-md-6"><a href="#" editable-select="vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].valueString" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.saveConfig(\'verified_customer_monthly_transfer_amount_limit\')">{{vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].valueString}}</a></div></div></td><td style="width:40%; text-align: center">{{vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allConfigs[\'verified_customer_monthly_transfer_amount_limit\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td colspan="4"><label class="tile-body"><b>Ticket payment</b></label></td></tr><tr><td>{{vm.allPaymentModes[\'ticket_payment_mode\'].title}}</td><td><div class="row"><div class="col-md-6"><a href="#" editable-select="vm.allPaymentModes[\'ticket_payment_mode\'].value" e-ng-options="m.value as m.text for m in vm.uniredpaymentModes" e-required onaftersave="vm.save(\'ticket_payment_mode\')">{{vm.allPaymentModes[\'ticket_payment_mode\'].value}}</a></div></div></td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'ticket_payment_mode\'].lastModifiedBy}}</td><td style="width:40%; text-align: center">{{vm.allPaymentModes[\'ticket_payment_mode\'].lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/passenger/passenger-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.passenger.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.passenger.delete.question" translate-values="{id: \'{{vm.passenger.id}}\'}">Are you sure you want to delete this Passenger?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/passenger/passenger-detail.html','<div><h2><span data-translate="bozorakaAdminApp.passenger.detail.title">Passenger</span> {{vm.passenger.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.passenger.firstName">First Name</span></dt><dd><span>{{vm.passenger.firstName}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.lastName">Last Name</span></dt><dd><span>{{vm.passenger.lastName}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.middleName">Middle Name</span></dt><dd><span>{{vm.passenger.middleName}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.age">Age</span></dt><dd><span>{{vm.passenger.age}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.birthDate">Birth Date</span></dt><dd><span>{{vm.passenger.birthDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.documentType">Document Type</span></dt><dd><span>{{vm.passenger.documentType}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.documentNumber">Document Number</span></dt><dd><span>{{vm.passenger.documentNumber}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.documentExpire">Document Expire</span></dt><dd><span>{{vm.passenger.documentExpire | date:\'mediumDate\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.gender">Gender</span></dt><dd><span>{{vm.passenger.gender}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.citizen">Citizen</span></dt><dd><span>{{vm.passenger.citizen}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.createdBy">Created By</span></dt><dd><span>{{vm.passenger.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.createdDate">Created Date</span></dt><dd><span>{{vm.passenger.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.passenger.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.passenger.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.passenger.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.passenger.customerId})">{{vm.passenger.customerId}}</a></dd><dt><span data-translate="bozorakaAdminApp.passenger.ticketPayment">Ticket Payment</span></dt><dd><a ui-sref="ticket-payment-detail({id:vm.passenger.ticketPaymentId})">{{vm.passenger.ticketPaymentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="passenger-detail.edit({id:vm.passenger.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/passenger/passenger-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPassengerLabel" data-translate="bozorakaAdminApp.passenger.home.createOrEditLabel">Create or edit a Passenger</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.passenger.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.passenger.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.passenger.firstName" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.passenger.lastName" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.middleName" for="field_middleName">Middle Name</label><input type="text" class="form-control" name="middleName" id="field_middleName" ng-model="vm.passenger.middleName" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.middleName.$invalid"><p class="help-block" ng-show="editForm.middleName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.middleName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.middleName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.age" for="field_age">Age</label><input type="text" class="form-control" name="age" id="field_age" ng-model="vm.passenger.age" required ng-minlength="3" ng-maxlength="5"><div ng-show="editForm.age.$invalid"><p class="help-block" ng-show="editForm.age.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.age.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.age.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="5">This field cannot be longer than 5 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.birthDate" for="field_birthDate">Birth Date</label><div class="input-group"><input id="field_birthDate" type="text" class="form-control" name="birthDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.passenger.birthDate" is-open="vm.datePickerOpenStatus.birthDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.birthDate.$invalid"><p class="help-block" ng-show="editForm.birthDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.documentType" for="field_documentType">Document Type</label><input type="text" class="form-control" name="documentType" id="field_documentType" ng-model="vm.passenger.documentType" required><div ng-show="editForm.documentType.$invalid"><p class="help-block" ng-show="editForm.documentType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.documentNumber" for="field_documentNumber">Document Number</label><input type="text" class="form-control" name="documentNumber" id="field_documentNumber" ng-model="vm.passenger.documentNumber" required ng-maxlength="10"><div ng-show="editForm.documentNumber.$invalid"><p class="help-block" ng-show="editForm.documentNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.documentExpire" for="field_documentExpire">Document Expire</label><div class="input-group"><input id="field_documentExpire" type="text" class="form-control" name="documentExpire" uib-datepicker-popup="{{dateformat}}" ng-model="vm.passenger.documentExpire" is-open="vm.datePickerOpenStatus.documentExpire" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'documentExpire\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.documentExpire.$invalid"><p class="help-block" ng-show="editForm.documentExpire.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.gender" for="field_gender">Gender</label><input type="text" class="form-control" name="gender" id="field_gender" ng-model="vm.passenger.gender" required><div ng-show="editForm.gender.$invalid"><p class="help-block" ng-show="editForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.citizen" for="field_citizen">Citizen</label><input type="text" class="form-control" name="citizen" id="field_citizen" ng-model="vm.passenger.citizen" required ng-minlength="2" ng-maxlength="2"><div ng-show="editForm.citizen.$invalid"><p class="help-block" ng-show="editForm.citizen.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.citizen.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.citizen.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.passenger.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.passenger.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.passenger.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.passenger.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.passenger.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.passenger.customer" for="field_customer">Customer</label><select class="form-control" id="field_customer" name="customer" ng-model="vm.passenger.customerId" ng-options="customer.id as customer.id for customer in vm.customers"><option value=""></option></select></div><div class="form-group"><label data-translate="bozorakaAdminApp.passenger.ticketPayment" for="field_ticketPayment">Ticket Payment</label><select class="form-control" id="field_ticketPayment" name="ticketPayment" ng-model="vm.passenger.ticketPaymentId" ng-options="ticketPayment.id as ticketPayment.id for ticketPayment in vm.ticketpayments"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/passenger/passengers.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-refresh font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.passenger.home.title">Passengers</span></div></div><div class="portlet-body"><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span data-translate="bozorakaAdminApp.passenger.firstName">First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span data-translate="bozorakaAdminApp.passenger.lastName">Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="middleName"><span data-translate="bozorakaAdminApp.passenger.middleName">Middle Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthDate"><span data-translate="bozorakaAdminApp.passenger.birthDate">Birth Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentType"><span data-translate="bozorakaAdminApp.passenger.documentType">Document Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentNumber"><span data-translate="bozorakaAdminApp.passenger.documentNumber">Document Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentExpire"><span data-translate="bozorakaAdminApp.passenger.documentExpire">Document Expire</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender"><span data-translate="bozorakaAdminApp.passenger.gender">Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="citizen"><span data-translate="bozorakaAdminApp.passenger.citizen">Citizen</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.passenger.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.passenger.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticketPaymentId"><span data-translate="bozorakaAdminApp.passenger.ticketPayment">Ticket Payment</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="passenger in vm.passengers track by passenger.id"><td><a ui-sref="passenger-detail({id:passenger.id})">{{passenger.id}}</a></td><td>{{passenger.firstName}}</td><td>{{passenger.lastName}}</td><td>{{passenger.middleName}}</td><td>{{passenger.birthDate | date:\'mediumDate\'}}</td><td>{{passenger.documentType}}</td><td>{{passenger.documentNumber}}</td><td>{{passenger.documentExpire | date:\'mediumDate\'}}</td><td>{{passenger.gender}}</td><td>{{passenger.citizen}}</td><td>{{passenger.createdBy}}<br>{{passenger.createdDate | date:\'medium\'}}</td><td>{{passenger.lastModifiedBy}}<br>{{passenger.lastModifiedDate | date:\'medium\'}}</td><td><a ui-sref="ticket-payment-detail({id:passenger.ticketPaymentId})">{{passenger.ticketPaymentId}}</a></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/provider/provider-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.provider.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.provider.delete.question" translate-values="{id: \'{{vm.provider.id}}\'}">Are you sure you want to delete this Provider?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider/provider-detail.html','<div><h2><span data-translate="bozorakaAdminApp.provider.detail.title">Provider</span> {{vm.provider.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.provider.name">Name</span></dt><dd><span>{{vm.provider.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.logo">Logo</span></dt><dd><span>{{vm.provider.logo}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.gateway">Gateway</span></dt><dd><span>{{vm.provider.gateway}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.ProviderStatus.\' + vm.provider.status}}">{{vm.provider.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.kashProviderId">Kash Provider Id</span></dt><dd><span>{{vm.provider.kashProviderId}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.position">Position</span></dt><dd><span>{{vm.provider.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.createdBy">Created By</span></dt><dd><span>{{vm.provider.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.createdDate">Created Date</span></dt><dd><span>{{vm.provider.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.provider.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.provider.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.provider.providerCategory">Provider Category</span></dt><dd><a ui-sref="provider-category-detail({id:vm.provider.providerCategoryId})">{{vm.provider.providerCategoryName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-detail.edit({id:vm.provider.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider/provider-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProviderLabel" data-translate="bozorakaAdminApp.provider.home.createOrEditLabel">Create or edit a Provider</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.nameLocal" for="field_name">Name (localization key)</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.provider.name" required ng-maxlength="150" ng-readonly="vm.provider.id != null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.logo" for="field_logo">Logo</label><input type="text" class="form-control" name="logo" id="field_logo" ng-model="vm.provider.logo" required><div ng-show="editForm.logo.$invalid"><p class="help-block" ng-show="editForm.logo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.provider.providerCategory" for="field_providerCategory">Provider Category</label><select class="form-control" id="field_providerCategory" ng-model="vm.provider.providerCategoryId" ng-options="category.id as category.name for category in vm.providerCategories"><option value=""></option></select><div ng-show="editForm.providerCategory.$invalid"><p class="help-block" ng-show="editForm.providerCategory.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.gateway" for="field_gateway">Gateway</label><select class="form-control" name="gateway" ng-model="vm.provider.gateway" id="field_gateway" required ng-disabled="null != vm.provider.id"><option value="tkb">TKB</option><option value="vse_platezhi">Vse Platezhi</option></select><div ng-show="editForm.gateway.$invalid"><p class="help-block" ng-show="editForm.gateway.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.gateway.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.kashProviderId" for="field_kashProviderId">Kash Provider Id</label><input type="number" class="form-control" name="kashProviderId" id="field_kashProviderId" ng-model="vm.provider.kashProviderId" required><div ng-show="editForm.kashProviderId.$invalid"><p class="help-block" ng-show="editForm.kashProviderId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.kashProviderId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.provider.status" id="field_status" required><option value="ENABLED" data-translate="bozorakaAdminApp.ProviderStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="bozorakaAdminApp.ProviderStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.shouldDisplayName" for="field_shouldDisplayName">Should display name</label><input type="checkbox" name="shouldDisplayName" id="field_shouldDisplayName" ng-model="vm.provider.shouldDisplayName"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.provider.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provider/providers.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.provider.home.title">Providers</span></div><div class="pull-right"><button class="btn btn-primary" ui-sref="provider.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.provider.home.createLabel">Create new Provider</span></button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.name">Provider Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.name" placeholder="{{ \'bozorakaAdminApp.provider.name\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.kashProviderId">Provider Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.providerId" placeholder="{{ \'bozorakaAdminApp.provider.kashProviderId\' | translate}}"></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" for="field_providerCategory" data-translate="bozorakaAdminApp.provider.providerCategory">Category</label><select class="form-control" id="field_providerCategory" name="field_providerCategory" ng-model="vm.searchQuery.categoryId" ng-options="category.id as category.name for category in vm.providerCategories"><option value=""></option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.gateway">Gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value class selected="selected"></option><option value="tkb">TKB</option><option value="vse_platezhi">Vse Platezhi</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.provider.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="ENABLED">ENABLED</option><option value="DISABLED">DISABLED</option></select></div></div></div><div class="pull-right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div><br></div></form></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center" jh-sort-by="logo"><span data-translate="bozorakaAdminApp.provider.logo">Logo</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="name"><span data-translate="bozorakaAdminApp.provider.nameLocal">Name (localization key)</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="kashProviderId"><span data-translate="bozorakaAdminApp.provider.kashProviderId">Kash Provider Id</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="providerCategoryName"><span data-translate="bozorakaAdminApp.provider.providerCategory">Provider Category</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="gateway"><span data-translate="bozorakaAdminApp.provider.gateway">Gateway</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="status"><span data-translate="bozorakaAdminApp.provider.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="shouldDisplayName"><span data-translate="bozorakaAdminApp.provider.shouldDisplayName">Should Display Name</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="position"><span data-translate="bozorakaAdminApp.provider.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.provider.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="provider in vm.providers track by provider.id"><td><img src="{{provider.logo}}" style="max-width: 50px; max-height: 50px"></td><td><a ui-sref="provider.edit({id:provider.id})">{{provider.name}}</a></td><td>{{provider.kashProviderId}}</td><td>{{provider.providerCategoryName}}</td><td><span ng-if="provider.gateway  == \'vse_platezhi\'" class="btn btn-xs green-meadow text-capitalize">{{provider.gateway}}</span> <span ng-if="provider.gateway != \'vse_platezhi\'" class="btn btn-xs yellow-gold text-capitalize">{{provider.gateway}}</span></td><td><span ng-if="provider.status  == \'ENABLED\'" class="btn btn-xs green-meadow">{{provider.status}}</span> <span ng-if="provider.status  == \'DISABLED\'" class="btn btn-xs red-mint">{{provider.status}}</span></td><td><h4 class="text-success" ng-if="provider.shouldDisplayName"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!provider.shouldDisplayName"><i class="fa fa-times"></i></h4></td><td>{{provider.position}}</td><td>{{provider.lastModifiedBy}}<br>{{provider.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/play-integrity-log/play-integrity-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.playIntegrityLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.playIntegrityLog.delete.question" translate-values="{id: \'{{vm.playIntegrityLog.id}}\'}">Are you sure you want to delete this Play Integrity Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/play-integrity-log/play-integrity-log-detail.html','<div><h2><span data-translate="bozorakaAdminApp.playIntegrityLog.detail.title">Play Integrity Log</span> {{vm.playIntegrityLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.endpoint">Endpoint</span></dt><dd><span>{{vm.playIntegrityLog.endpoint}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.uuid">Uuid</span></dt><dd><span>{{vm.playIntegrityLog.uuid}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.phone">Phone</span></dt><dd><span>{{vm.playIntegrityLog.phone}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.nonce">Nonce</span></dt><dd><span>{{vm.playIntegrityLog.nonce}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.integrityToken">Integrity Token</span></dt><dd><span>{{vm.playIntegrityLog.integrityToken}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.responseJson">Response Json</span></dt><dd><span>{{vm.playIntegrityLog.responseJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.PlayIntegrityStatus.\' + vm.playIntegrityLog.status}}">{{vm.playIntegrityLog.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.createdBy">Created By</span></dt><dd><span>{{vm.playIntegrityLog.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.createdDate">Created Date</span></dt><dd><span>{{vm.playIntegrityLog.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.playIntegrityLog.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.playIntegrityLog.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.playIntegrityLog.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="play-integrity-log-detail.edit({id:vm.playIntegrityLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/play-integrity-log/play-integrity-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlayIntegrityLogLabel" data-translate="bozorakaAdminApp.playIntegrityLog.home.createOrEditLabel">Create or edit a Play Integrity Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.playIntegrityLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.playIntegrityLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.endpoint" for="field_endpoint">Endpoint</label><input type="text" class="form-control" name="endpoint" id="field_endpoint" ng-model="vm.playIntegrityLog.endpoint" required ng-maxlength="10"><div ng-show="editForm.endpoint.$invalid"><p class="help-block" ng-show="editForm.endpoint.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.endpoint.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.uuid" for="field_uuid">Uuid</label><input type="text" class="form-control" name="uuid" id="field_uuid" ng-model="vm.playIntegrityLog.uuid" required ng-maxlength="36"><div ng-show="editForm.uuid.$invalid"><p class="help-block" ng-show="editForm.uuid.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.uuid.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="36">This field cannot be longer than 36 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.playIntegrityLog.phone" ng-maxlength="11"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">This field cannot be longer than 11 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.nonce" for="field_nonce">Nonce</label><input type="text" class="form-control" name="nonce" id="field_nonce" ng-model="vm.playIntegrityLog.nonce" ng-maxlength="500"><div ng-show="editForm.nonce.$invalid"><p class="help-block" ng-show="editForm.nonce.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.integrityToken" for="field_integrityToken">Integrity Token</label><input type="text" class="form-control" name="integrityToken" id="field_integrityToken" ng-model="vm.playIntegrityLog.integrityToken" ng-maxlength="1500"><div ng-show="editForm.integrityToken.$invalid"><p class="help-block" ng-show="editForm.integrityToken.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1500">This field cannot be longer than 1500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.responseJson" for="field_responseJson">Response Json</label><textarea class="form-control" name="responseJson" id="field_responseJson" ng-model="vm.playIntegrityLog.responseJson"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.playIntegrityLog.status" id="field_status" required><option value="CREATED" data-translate="bozorakaAdminApp.PlayIntegrityStatus.CREATED">CREATED</option><option value="VERIFIED" data-translate="bozorakaAdminApp.PlayIntegrityStatus.VERIFIED">VERIFIED</option><option value="FAILED" data-translate="bozorakaAdminApp.PlayIntegrityStatus.FAILED">FAILED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.playIntegrityLog.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.playIntegrityLog.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.playIntegrityLog.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.playIntegrityLog.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.playIntegrityLog.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/play-integrity-log/play-integrity-logs.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.playIntegrityLog.home.title">Play Integrity Logs</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.phone"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Endpoint</label><select class="form-control" ng-model="vm.searchQuery.endpoint"><option value class selected="selected"></option><option value="login">LOGIN</option><option value="transfer">TRANSFER</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="VERIFIED">VERIFIED</option><option value="CREATED">CREATED</option><option value="FAILED">FAILED</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">App licensing verdict</label><select class="form-control" ng-model="vm.searchQuery.appLicensingVerdict"><option value class selected="selected"></option><option value="LICENSED">LICENSED</option><option value="UNLICENSED">UNLICENSED</option><option value="UNEVALUATED">UNEVALUATED</option></select></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">App recognition verdict</label><select class="form-control" ng-model="vm.searchQuery.appRecognitionVerdict"><option value class selected="selected"></option><option value="PLAY_RECOGNIZED">PLAY RECOGNIZED</option><option value="UNRECOGNIZED_VERSION">UNRECOGNIZED VERSION</option><option value="UNEVALUATED">UNEVALUATED</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Device recognition verdict</label><select class="form-control" ng-model="vm.searchQuery.deviceRecognitionVerdict"><option value class selected="selected"></option><option value="MEETS_DEVICE_INTEGRITY">MEETS DEVICE INTEGRITY</option><option value="MEETS_VIRTUAL_INTEGRITY">MEETS VIRTUAL INTEGRITY</option><option value="MEETS_BASIC_INTEGRITY">MEETS BASIC INTEGRITY</option><option value="MEETS_STRONG_INTEGRITY">MEETS STRONG INTEGRITY</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="bozorakaAdminApp.playIntegrityLog.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endpoint"><span data-translate="bozorakaAdminApp.playIntegrityLog.endpoint">Endpoint</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>App licensing verdict</span></th><th><span>App recognition verdict</span></th><th><span>Device recognition verdict</span></th><th><span>Version code</span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.playIntegrityLog.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span>Created</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="playIntegrityLog in vm.playIntegrityLogs track by playIntegrityLog.id"><td><a ui-sref="play-integrity-log-detail({id:playIntegrityLog.id})">{{playIntegrityLog.id}}</a></td><td><span>{{(playIntegrityLog.phone === null) ? \'\' : playIntegrityLog.phone | phoneNumber}}</span> <img ng-if="playIntegrityLog.customerVerified" src="/content/images/blue-tick.png" style="margin-left: 3px" width="16" height="16"></td><td><span class="label label-sm label-info" ng-if="playIntegrityLog.endpoint == \'login\'">{{playIntegrityLog.endpoint}} </span><span class="label label-sm label-success" ng-if="playIntegrityLog.endpoint == \'transfer\'">{{playIntegrityLog.endpoint}}</span></td><td class="text-left"><span class="label label-sm label-success" ng-if="playIntegrityLog.appLicensingVerdict == \'LICENSED\'">{{playIntegrityLog.appLicensingVerdict}} </span><span class="label label-sm label-danger" ng-if="playIntegrityLog.appLicensingVerdict == \'UNLICENSED\'">{{playIntegrityLog.appLicensingVerdict}} </span><span class="label label-sm label-warning" ng-if="playIntegrityLog.appLicensingVerdict == \'UNEVALUATED\'">{{playIntegrityLog.appLicensingVerdict}}</span></td><td class="text-left"><span class="label label-sm label-success" ng-if="playIntegrityLog.appRecognitionVerdict == \'PLAY_RECOGNIZED\'">{{playIntegrityLog.appRecognitionVerdict}} </span><span class="label label-sm label-danger" ng-if="playIntegrityLog.appRecognitionVerdict == \'UNRECOGNIZED_VERSION\'">{{playIntegrityLog.appRecognitionVerdict}} </span><span class="label label-sm label-warning" ng-if="playIntegrityLog.appRecognitionVerdict == \'UNEVALUATED\'">{{playIntegrityLog.appRecognitionVerdict}}</span></td><td class="text-left"><span class="label label-sm label-success" ng-if="playIntegrityLog.deviceRecognitionVerdict == \'MEETS_DEVICE_INTEGRITY\'">{{playIntegrityLog.deviceRecognitionVerdict}}</span></td><td class="text-left">{{playIntegrityLog.appVersionCode}}</td><td><span class="label label-sm label-success" ng-if="playIntegrityLog.status == \'VERIFIED\'">{{playIntegrityLog.status}} </span><span class="label label-sm label-warning" ng-if="playIntegrityLog.status == \'CREATED\'">{{playIntegrityLog.status}} </span><span class="label label-sm label-danger" ng-if="playIntegrityLog.status == \'FAILED\'">{{playIntegrityLog.status}}</span></td><td>{{playIntegrityLog.createdDate | date:\'medium\'}}</td><td>{{playIntegrityLog.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/profile/profile-change-phone-dialog.html','<form name="editPhoneForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel">Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Current Phone</label><input type="text" class="form-control" name="totalMileage" value="{{vm.profile.customerPhone | phoneNumber}}" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="profile.detail.phoneNumber">Phone Number</label><input type="text" name="phoneNumber" ng-model="vm.newPhone" class="form-control" required maxlength="11" minlength="11"><div ng-show="editPhoneForm.phoneNumber.$invalid"><p class="help-block" ng-show="editPhoneForm.phoneNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editPhoneForm.phoneNumber.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="11">This field is required to be at least 11 characters.</p><p class="help-block" ng-show="editPhoneForm.phoneNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">This field cannot be longer than 11 characters.</p></div><p class="help-block" ng-show="vm.isValidPhonePrefix()">Phone number should start either with 010 or 7</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editPhoneForm.$invalid || vm.isSaving || vm.isValidPhonePrefix()" class="btn green-haze"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-detail.html','<jhi-alert></jhi-alert><!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="profile" data-translate="profile.home.title">User information</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="profile.detail.title">User details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><!-- BEGIN PROFILE SIDEBAR --><div class="profile-sidebar"><!-- PORTLET MAIN --><div class="portlet light profile-sidebar-portlet"><!-- SIDEBAR USERPIC --><div class="profile-userpic"><img src="content/images/avatar_profile.png" class="img-responsive" alt=""></div><!-- END SIDEBAR USERPIC --><!-- SIDEBAR USER TITLE --><div class="profile-usertitle"><div ng-if="vm.profile.customerVerified" class="verified-message"><img src="/content/images/blue-tick.png" style="margin-left: 3px; margin-bottom: 2px" width="16" height="16"> <span data-translate="profile.detail.verified">Verified</span></div><div ng-if="!vm.profile.customerVerified" class="unverified-message"><i class="fa fa-exclamation-circle"></i> <span data-translate="profile.detail.unverified">Unverified</span></div><div class="profile-usertitle-name">{{vm.profile.customerFullName}}</div><div class="profile-usertitle-job">{{vm.profile.customerPhone | phoneNumber}}</div></div><!-- END SIDEBAR USER TITLE --><!-- SIDEBAR BUTTONS --><div class="profile-userbuttons"><button class="btn btn-circle green btn-sm" ng-if="vm.profile.customerStatus == \'ACTIVE\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle bg-yellow-lemon bg-font-yellow-lemon btn-sm" ng-if="vm.profile.customerStatus == \'DEACTIVATED\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle red btn-sm" ng-if="vm.profile.customerStatus == \'BANNED\'">{{vm.profile.customerStatus}}</button> <button class="label label-sm label-info" ng-if="vm.profile.customerStatus == \'REACTIVATED\'">{{vm.profile.customerStatus}}</button></div><div class="profile-chat" ng-if="vm.customerChat.chatId"><button class="btn btn-primary" ng-click="vm.openChat()"><i class="fa fa-comments-o"></i> Chat</button></div><!-- END SIDEBAR BUTTONS --><!-- SIDEBAR MENU --><div class="profile-usermenu"><ul class="nav"><li class="active"><a ui-sref="profile-detail({id:vm.profile.id})"><i class="icon-home"></i> {{\'profile.detail.menu.generalInfo\' | translate}}</a></li><li><a ui-sref="profile-transaction({id:vm.profile.id})"><i class="icon-settings"></i> {{\'profile.detail.menu.transactions \' | translate}}</a></li><li><a ui-sref="profile-notification({id:vm.profile.id})"><i class="glyphicon glyphicon-bell"></i> {{\'profile.detail.menu.notification \' | translate}}</a></li><li><a ui-sref="profile-transfer-limit({id:vm.profile.id})"><i class="fa fa-line-chart"></i> {{\'profile.detail.menu.limit \' | translate}}</a></li><li><a ui-sref="profile-ticket-orders({id:vm.profile.id})"><i class="fa fa-plane"></i> {{\'profile.detail.menu.tickets \' | translate}}</a></li></ul></div><!-- END MENU --></div><!-- END PORTLET MAIN --></div><!-- END BEGIN PROFILE SIDEBAR --><!-- BEGIN PROFILE CONTENT --><div class="profile-content"><div class="row"><div class="col-md-12"><div class="portlet light"><div class="portlet-title tabbable-line"><div class="caption caption-md"><i class="icon-globe theme-font hide"></i> <span class="caption-subject font-blue-madison bold uppercase" data-translate="profile.detail.profile">Profile</span></div><ul class="nav nav-tabs"><li class="active"><a href="javascript;" data-target="#tab_1_1" data-toggle="tab">My ID</a></li><li><a href="javascript;" data-target="#tab_1_2" data-toggle="tab" data-translate="profile.detail.personalInfo">Personal info</a></li><li><a href="javascript;" data-target="#tab_1_3" data-toggle="tab" ng-click="vm.getCustomerStatusLogsByCustomerId()">Status change log</a></li></ul></div><div class="portlet-body"><div class="tab-content"><!-- PERSONAL INFO TAB --><div class="tab-pane active" id="tab_1_1"><form class="form-horizontal"><div class="form-body"><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.fullName">Full name</label><div class="col-md-4"><input type="text" class="form-control" name="fullName" ng-model="vm.profile.myID.lastName + \' \' +vm.profile.myID.firstName+\' \'+vm.profile.myID.middleName" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Birth date</label><div class="col-md-4"><input type="text" class="form-control" name="birthDate" ng-model="vm.profile.myID.birthDate" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Birth place</label><div class="col-md-4"><input type="text" class="form-control" name="birthPlace" ng-model="vm.profile.myID.birthPlace" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Passport number</label><div class="col-md-4"><input ng-if="!vm.profile.myIDBlocked" type="text" class="form-control" readonly="readonly" ng-model="vm.profile.myID.documentNumber"><div ng-if="vm.profile.myIDBlocked" class="input-group"><input type="text" class="form-control" readonly="readonly" ng-model="vm.profile.myID.documentNumber"> <span class="input-group-addon"><i class="icon-ban font-red" style="font-weight: bold"></i></span></div></div></div><div class="form-group"><label class="col-md-3 control-label">PINFL</label><div class="col-md-4"><input type="text" class="form-control" name="pinfl" ng-model="vm.profile.myID.pinfl" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Issued date</label><div class="col-md-4"><input type="text" class="form-control" name="issuedDate" ng-model="vm.profile.myID.issuedDate" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Expiry date</label><div class="col-md-4"><input type="text" class="form-control" name="expiryDate" ng-model="vm.profile.myID.expiryDate" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label">Address</label><div class="col-md-4"><textarea type="text" class="form-control" name="permanentAddress" readonly="readonly">{{vm.profile.myID.permanentAddress}}</textarea></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.gender.label">Gender</label><div class="col-md-4"><select class="form-control" ng-model="vm.profile.myID.gender" readonly="readonly"><option value="U">{{ \'profile.detail.gender.U\' | translate }}</option><option value="M">{{ \'profile.detail.gender.M\' | translate }}</option><option value="F">{{ \'profile.detail.gender.F\' | translate }}</option></select></div></div></div></form></div><div class="tab-pane" id="tab_1_2"><form name="editProfileForm" role="form" class="form-horizontal" ng-submit="vm.save()" novalidate><div class="form-body"><jhi-alert-error></jhi-alert-error><ng-form name="fullNameForm" show-validation><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.fullName">Full name</label><div ng-if="!vm.profile.customerVerified" class="col-md-4"><input type="text" class="form-control" name="fullName" ng-model="vm.profile.customerFullName" required><div ng-show="editProfileForm.fullName.$invalid"><span class="help-block" ng-show="editProfileForm.fullName.$error.required" data-translate="entity.validation.required">This field is required.</span></div></div><div ng-if="vm.profile.customerVerified" class="col-md-4"><input type="text" class="form-control" name="fullName" ng-model="vm.profile.customerFullName" readonly="readonly"></div></div></ng-form><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.phoneNumber">Phone #</label><div class="col-md-4"><div class="input-group"><input type="text" class="form-control" readonly="readonly" value="{{vm.profile.customerPhone | phoneNumber}}"> <span class="input-group-btn"><button has-any-authority="ROLE_ADMIN, ROLE_MANAGER" class="btn btn-success" type="button" ui-sref="profile-detail.changePhone({id:vm.profile.id})">{{\'entity.action.edit\' | translate}}</button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label">Email</label><div class="col-md-4"><input type="text" class="form-control" readonly="readonly" ng-model="vm.profile.customerEmail"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.joinedDate">Joined date</label><div class="col-md-4"><input type="text" class="form-control" readonly="readonly" value="{{vm.profile.registrationDate | date:\'medium\'}}"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.status">Status</label><div class="col-md-4"><div class="input-group"><input type="text" class="form-control" name="customerStatus" ng-model="vm.profile.customerStatus" readonly="readonly"> <span class="input-group-btn"><button has-any-authority="ROLE_ADMIN, ROLE_MANAGER" ng-disabled="vm.profile.customerStatus == \'REACTIVATED\'" ui-sref="profile-detail.editStatus({id:vm.profile.id})" class="btn btn-success" type="button">{{\'entity.action.edit\' | translate}}</button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.dateOfBirth">Date of birth</label><div class="col-md-4"><input type="date" class="form-control" ng-if="vm.dateOfBirth" ng-model="vm.dateOfBirth"></div></div><div class="form-group"><label class="col-md-3 control-label">Passport number</label><div class="col-md-4"><input type="text" class="form-control" name="documentNumber" ng-model="vm.profile.passportNumber" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="profile.detail.gender.label">Gender</label><div class="col-md-4"><select class="form-control" ng-model="vm.profile.customerGender"><option value="U">{{ \'profile.detail.gender.U\' | translate }}</option><option value="M">{{ \'profile.detail.gender.M\' | translate }}</option><option value="F">{{ \'profile.detail.gender.F\' | translate }}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_allowAnyIp">Allow any IP</label><div class="col-md-4"><label class="switch"><input type="checkbox" id="field_allowAnyIp" ng-model="vm.profile.allowAnyIp" ng-true-value="true" ng-false-value="false"> <span class="slider round"></span></label></div></div></div><div class="form-actions fluid"><div class="row"><div class="col-md-offset-3 col-md-9"><button type="submit" has-any-authority="ROLE_ADMIN, ROLE_MANAGER" ng-disabled="editProfileForm.$invalid || vm.isSaving" class="btn green-haze">{{\'entity.action.save\' | translate}}</button></div></div></div></form></div><div class="tab-pane" id="tab_1_3"><div class="portlet-body"><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr><th>Phone</th><th>Balance</th><th>Bonus</th><th><span data-translate="profile.status">Status</span></th><th>Reason</th><th><span>Modified date</span></th><th><span>Modified By</span></th></tr></thead><tbody><tr ng-repeat="customerStatusLog in vm.customerStatusLogs track by customerStatusLog.id" class="text-center"><td>{{customerStatusLog.phone | phoneNumber}}</td><td>{{customerStatusLog.balance | number}} {{vm.getCurrencyNameForClient(vm.profile.customerClient)}}</td><td>{{customerStatusLog.totalMileage | number}} {{vm.getCurrencyNameForClient(vm.profile.customerClient)}}</td><td><span class="label label-sm label-success" ng-if="customerStatusLog.status == \'ACTIVE\'">{{customerStatusLog.status}} </span><span class="label label-sm label-warning" ng-if="customerStatusLog.status == \'DEACTIVATED\'">{{customerStatusLog.status}} </span><span class="label label-sm label-danger" ng-if="customerStatusLog.status == \'BANNED\'">{{customerStatusLog.status}} </span><span class="label label-sm label-info" ng-if="customerStatusLog.status == \'REACTIVATED\'">{{customerStatusLog.status}}</span></td><td>{{customerStatusLog.changeReason}}</td><td>{{customerStatusLog.lastModifiedDate | date:\'medium\'}}</td><td>{{customerStatusLog.lastModifiedBy}}</td></tr></tbody></table></div></div><!-- END CHANGE PASSWORD TAB --></div></div></div></div></div></div><!-- END PROFILE CONTENT --></div></div></div><!-- END PAGE CONTENT-->');
$templateCache.put('app/entities/profile/profile-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.notification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.customerNotification.delete.question" translate-values="{id: \'{{vm.notification.title}}\'}">Are you sure you want to delete this Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-notification-detail.html','<div><h2><span data-translate="bozorakaAdminApp.customerNotification.detail.title">Customer Notification</span> {{vm.customerNotification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.customerNotification.title">Title</span></dt><dd><span>{{vm.customerNotification.title}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.message">Message</span></dt><dd><span>{{vm.customerNotification.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.language">Language</span></dt><dd><span>{{vm.customerNotification.language}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.collapseKey">Collapse Key</span></dt><dd><span>{{vm.customerNotification.collapseKey}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.eventType">Event Type</span></dt><dd><span>{{vm.customerNotification.eventType}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.url">Url</span></dt><dd><span>{{vm.customerNotification.url}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.readStatus">Read Status</span></dt><dd><span>{{vm.customerNotification.readStatus}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.NotificationStatus.\' + vm.customerNotification.status}}">{{vm.customerNotification.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.deleted">Deleted</span></dt><dd><span>{{vm.customerNotification.deleted}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.pushDate">Push Date</span></dt><dd><span>{{vm.customerNotification.pushDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.expiryDate">Expiry Date</span></dt><dd><span>{{vm.customerNotification.expiryDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.createdBy">Created By</span></dt><dd><span>{{vm.customerNotification.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.createdDate">Created Date</span></dt><dd><span>{{vm.customerNotification.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.customerNotification.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.customerNotification.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.customerNotification.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.customerNotification.customerId})">{{vm.customerNotification.customerId}}</a></dd></dl><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/entities/profile/profile-notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerNotificationLabel" data-translate="bozorakaAdminApp.customerNotification.home.createOrEditLabel">Create or edit a Customer Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.notification.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.notification.id" readonly="readonly"></div><div class="form-group" ng-show="vm.notification.id"><label for="language" data-translate="bozorakaAdminApp.customerNotification.language">Language</label><input type="text" class="form-control" id="language" name="language" value="{{vm.language[vm.notification.language].label}}" readonly="readonly"></div><div class="form-group" ng-show="vm.notification.id === null"><ul class="nav nav-tabs"><li class="{{$first?\'active\':\'\'}}" ng-repeat="language in vm.languages"><a href="javascript;" data-target="#{{language}}" data-toggle="tab" data-toggle="tab">{{vm.language[language].label}}</a></li></ul><div class="tab-content" style="border-width: 1px; border-color: #ddd; border-style: solid; border-top-style: unset"><div class="tab-pane {{$first?\'active\':\'\'}}" id="{{language}}" ng-repeat="language in vm.languages" style="padding-left: 10px; padding-right: 10px"><div><div><input bs-switch ng-model="vm.language[language].check" type="checkbox" switch-active="true" switch-size="small" switch-label="{{vm.language[language].label}}" switch-animate="true"></div><div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.title">Title</label><input ng-readonly="!vm.language[language].check" type="text" class="form-control" ng-model="vm.language[language].title" ng-maxlength="255" ng-required="vm.language[language].check"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.message">Message</label><textarea ng-readonly="!vm.language[language].check" type="text" class="form-control" ng-model="vm.language[language].message" ng-required="vm.language[language].check"></textarea></div></div></div></div></div></div><div class="form-group" ng-show="vm.notification.id"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.notification.title" ng-required="vm.notification.idFi" ng-maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group" ng-show="vm.notification.id"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.message" for="field_message">Message</label><textarea type="text" class="form-control" name="message" id="field_message" ng-model="vm.notification.message" ng-required="vm.notification.id"></textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.notification.url"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.notification.status" id="field_status"><option value="PENDING" data-translate="bozorakaAdminApp.NotificationStatus.PENDING">PENDING</option><option value="SUCCESS" data-translate="bozorakaAdminApp.NotificationStatus.SUCCESS">SUCCESS</option><option value="FAILURE" data-translate="bozorakaAdminApp.NotificationStatus.FAILURE">FAILURE</option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.pushDate" for="field_pushDate">Push Date</label><div class="input-group"><input id="field_pushDate" type="text" class="form-control" name="pushDate" datetime-picker="{{dateformat}}" ng-model="vm.notification.pushDate" is-open="vm.datePickerOpenStatus.pushDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'pushDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.pushDate.$invalid"><p class="help-block" ng-show="editForm.pushDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pushDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.customerNotification.expiryDate" for="field_expiryDate">Expiry Date</label><div class="input-group"><input id="field_expiryDate" type="text" class="form-control" name="expiryDate" datetime-picker="{{dateformat}}" ng-model="vm.notification.expiryDate" is-open="vm.datePickerOpenStatus.expiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-notification.html','<jhi-alert></jhi-alert><!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="profile" data-translate="profile.home.title">User information</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="profile.detail.title">User details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><!-- BEGIN PROFILE SIDEBAR --><div class="profile-sidebar"><!-- PORTLET MAIN --><div class="portlet light profile-sidebar-portlet"><!-- SIDEBAR USERPIC --><div class="profile-userpic"><img src="content/images/avatar_profile.png" class="img-responsive" alt=""></div><!-- END SIDEBAR USERPIC --><!-- SIDEBAR USER TITLE --><div class="profile-usertitle"><div ng-if="vm.profile.myID" class="verified-message"><img src="/content/images/blue-tick.png" style="margin-left: 3px; margin-bottom: 2px" width="16" height="16"> <span data-translate="profile.detail.verified">Verified</span></div><div ng-if="!vm.profile.myID" class="unverified-message"><i class="fa fa-exclamation-circle"></i> <span data-translate="profile.detail.unverified">Unverified</span></div><div class="profile-usertitle-name">{{vm.profile.customerFullName}}</div><div class="profile-usertitle-job">{{vm.profile.customerPhone | phoneNumber}}</div></div><!-- END SIDEBAR USER TITLE --><!-- SIDEBAR BUTTONS --><div class="profile-userbuttons"><button class="btn btn-circle green btn-sm" ng-if="vm.profile.customerStatus == \'ACTIVE\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle bg-yellow-lemon bg-font-yellow-lemon btn-sm" ng-if="vm.profile.customerStatus == \'DEACTIVATED\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle red btn-sm" ng-if="vm.profile.customerStatus == \'BANNED\'">{{vm.profile.customerStatus}}</button> <button class="label label-sm label-info" ng-if="vm.profile.customerStatus == \'REACTIVATED\'">{{vm.profile.customerStatus}}</button></div><!-- END SIDEBAR BUTTONS --><!-- SIDEBAR MENU --><div class="profile-usermenu"><ul class="nav"><li><a ui-sref="profile-detail({id:vm.profile.id})"><i class="icon-home"></i> {{\'profile.detail.menu.generalInfo\' | translate}}</a></li><li><a ui-sref="profile-transaction({id:vm.profile.id})"><i class="icon-settings"></i> {{\'profile.detail.menu.transactions \' | translate}}</a></li><li class="active"><a ui-sref="profile-notification({id:vm.profile.id})"><i class="glyphicon glyphicon-bell"></i> {{\'profile.detail.menu.notification \' | translate}}</a></li><li><a ui-sref="profile-transfer-limit({id:vm.profile.id})"><i class="fa fa-line-chart"></i> {{\'profile.detail.menu.limit \' | translate}}</a></li><li><a ui-sref="profile-ticket-orders({id:vm.profile.id})"><i class="fa fa-plane"></i> {{\'profile.detail.menu.tickets \' | translate}}</a></li></ul></div><!-- END MENU --></div><!-- END PORTLET MAIN --></div><!-- END BEGIN PROFILE SIDEBAR --><!-- BEGIN PROFILE CONTENT --><div class="profile-content"><div class="row"><div class="col-md-12"><div class="portlet light"><div class="tabbable-line tabbable-custom-profile"><div class="portlet-body"><div class="pull-right"><button ng-show="vm.languages.length > 0" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_MARKET_MANAGER, ROLE_CUSTOMER_SUPPORT_BOZORAKA, ROLE_CUSTOMER_SUPPORT_MOBPAY" ui-sref="profile-notification.new" class="btn btn-primary" type="button"><i class="fa fa-plus"></i> {{\'entity.action.add\' | translate}}</button><br><br></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="bozorakaAdminApp.customerNotification.title">Title</span></th><th><span data-translate="bozorakaAdminApp.customerNotification.language">Language</span></th><th><span>Read</span></th><th><span data-translate="bozorakaAdminApp.customerNotification.status">Status</span></th><th><span data-translate="bozorakaAdminApp.customerNotification.pushDate">Push Date</span></th><th><span data-translate="bozorakaAdminApp.customerNotification.expiryDate">Expiry Date</span></th><th><span>Created By</span></th><th><span>Modified By</span></th><th></th></tr></thead><tbody><tr ng-repeat="notification in vm.notifications track by notification.id"><td><a ui-sref="profile-notification.view({notificationId:notification.id})">{{notification.title}}</a></td><td><button type="button" class="btn red-sunglo btn-xs" ng-if="notification.language == \'en\'" style="pointer-events: none">English</button> <button type="button" class="btn blue-madison btn-xs" ng-if="notification.language == \'ru\'" style="pointer-events: none">Russian</button> <button type="button" class="btn green-meadow btn-xs" ng-if="notification.language == \'uz\'" style="pointer-events: none">Uzbek</button> <button type="button" class="btn yellow-crusta btn-xs" ng-if="notification.language == \'tj\'" style="pointer-events: none">T\u043E\u04B7\u0438\u043A\u04E3</button></td><td><span class="glyphicon glyphicon-check" style="color: #1c8f5f" ng-if="notification.readStatus === true"></span> <span class="glyphicon glyphicon-remove" style="color: red" ng-if="notification.readStatus === false"></span></td><td><button type="button" class="btn btn-xs yellow-saffron" ng-if="notification.status == \'PENDING\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="notification.status == \'PREPARING\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn green-meadow btn-xs" ng-if="notification.status == \'SUCCESS\'" style="pointer-events: none">{{notification.status}}</button> <button type="button" class="btn red-sunglo btn-xs" ng-if="notification.status == \'FAILURE\'" style="pointer-events: none">{{notification.status}}</button></td><td>{{notification.pushDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{notification.expiryDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{notification.createdBy}}<br>{{notification.createdDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td>{{notification.lastModifiedBy}}<br>{{notification.lastModifiedDate | date:\'yyyy.MM.dd HH:mm\'}}</td><td class="text-left"><div class="btn-group flex-btn-group-container"><button ng-if="notification.status === \'PENDING\'" type="submit" ui-sref="profile-notification.edit({notificationId:notification.id, customerId:1})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="profile-notification.delete({notificationId:notification.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/profile/profile-status-dialog.html','<form name="editStatusForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel">Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Current status</label><input type="text" class="form-control" name="totalMileage" ng-model="vm.profile.customerStatus" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="profile.form.status">Status</label><select class="form-control" ng-model="vm.customerStatus" name="status" required><option ng-repeat="status in vm.getStatusOptions()" value="{{status}}">{{status}}</option></select><div ng-show="editStatusForm.status.$invalid"><p class="help-block" ng-show="editStatusForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editStatusForm.status.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label">Reason</label><textarea class="form-control" name="reason" required ng-model="vm.reason">\n            </textarea><div ng-show="editForm.reason.$invalid"><p class="help-block" ng-show="editStatusForm.reason.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editStatusForm.reason.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editStatusForm.$invalid || vm.isSaving" class="btn green-haze"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-ticket-orders.html','<jhi-alert></jhi-alert><!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="profile" data-translate="profile.home.title">User information</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="profile.detail.title">User details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><!-- BEGIN PROFILE SIDEBAR --><div class="profile-sidebar"><!-- PORTLET MAIN --><div class="portlet light profile-sidebar-portlet"><!-- SIDEBAR USERPIC --><div class="profile-userpic"><img src="content/images/avatar_profile.png" class="img-responsive" alt=""></div><!-- END SIDEBAR USERPIC --><!-- SIDEBAR USER TITLE --><div class="profile-usertitle"><div ng-if="vm.profile.myID" class="verified-message"><img src="/content/images/blue-tick.png" style="margin-left: 3px; margin-bottom: 2px" width="16" height="16"> <span data-translate="profile.detail.verified">Verified</span></div><div ng-if="!vm.profile.myID" class="unverified-message"><i class="fa fa-exclamation-circle"></i> <span data-translate="profile.detail.unverified">Unverified</span></div><div class="profile-usertitle-name">{{vm.profile.customerFullName}}</div><div class="profile-usertitle-job">{{vm.profile.customerPhone | phoneNumber}}</div></div><!-- END SIDEBAR USER TITLE --><!-- SIDEBAR BUTTONS --><div class="profile-userbuttons"><button class="btn btn-circle green btn-sm" ng-if="vm.profile.customerStatus == \'ACTIVE\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle bg-yellow-lemon bg-font-yellow-lemon btn-sm" ng-if="vm.profile.customerStatus == \'DEACTIVATED\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle red btn-sm" ng-if="vm.profile.customerStatus == \'BANNED\'">{{vm.profile.customerStatus}}</button> <button class="label label-sm label-info" ng-if="vm.profile.customerStatus == \'REACTIVATED\'">{{vm.profile.customerStatus}}</button></div><!-- END SIDEBAR BUTTONS --><!-- SIDEBAR MENU --><div class="profile-usermenu"><ul class="nav"><li><a ui-sref="profile-detail({id:vm.profile.id})"><i class="icon-home"></i> {{\'profile.detail.menu.generalInfo\' | translate}}</a></li><li><a ui-sref="profile-transaction({id:vm.profile.id})"><i class="icon-settings"></i> {{\'profile.detail.menu.transactions \' | translate}}</a></li><li><a ui-sref="profile-notification({id:vm.profile.id})"><i class="glyphicon glyphicon-bell"></i> {{\'profile.detail.menu.notification \' | translate}}</a></li><li><a ui-sref="profile-transfer-limit({id:vm.profile.id})"><i class="fa fa-line-chart"></i> {{\'profile.detail.menu.limit \' | translate}}</a></li><li class="active"><a ui-sref="profile-ticket-orders({id:vm.profile.id})"><i class="fa fa-plane"></i> {{\'profile.detail.menu.tickets \' | translate}}</a></li></ul></div><!-- END MENU --></div><!-- END PORTLET MAIN --></div><!-- END BEGIN PROFILE SIDEBAR --><!-- BEGIN PROFILE CONTENT --><div class="profile-content"><div class="row"><div class="col-md-12"><div class="portlet light"><div class="tabbable-line tabbable-custom-profile"><div class="portlet-body"><!-- FILTER FORM --><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr><th>Order ID</th><th>From</th><th>To</th><th>Provider</th><th>Flight Number</th><th>Class</th><th>Status</th><th>Amount</th><th>Code</th><th>Passengers</th><th>Ordered Date</th><th>Details</th></tr></thead><tbody><tr ng-repeat="ticket in vm.ticketPayments track by ticket.orderId"><td>{{ticket.orderId}}</td><td>{{ticket.fromCity}}<br>({{ticket.fromAirport}})<br>{{ticket.depDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{ticket.toCity}}<br>({{ticket.toAirport}})<br>{{ticket.arrDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{ticket.provider}}<br>{{ticket.jetNumber}}</td><td>{{ticket.flightNumber}}<br><div><i ng-if="ticket.tripType === \'ONE_WAY\'" class="fa fa-long-arrow-right"></i> <i ng-if="ticket.tripType !== \'ONE_WAY\'" class="fa fa-exchange"></i></div></td><td>{{ticket.flightClass}}</td><td><button type="button" class="btn btn-xs green-seagreen" ng-if="ticket.status === \'Ticketed\'" style="pointer-events: none">Ticketed</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="ticket.status !== \'Ticketed\'" style="pointer-events: none">{{ticket.status}}</button></td><td>{{ticket.price | number}}</td><td>{{ticket.code}}</td><td><div ng-repeat="passenger in ticket.passengers track by passenger.id">{{passenger.name.last}} {{passenger.name.first}} {{passenger.name.middle}}<br>{{passenger.document.num}}<hr style="margin: 6px 0" ng-if="!$last"></div></td><td>{{ticket.orderedDate}}</td><td><button type="button" class="btn btn-xs btn-primary" ng-click="vm.openTicketDetails(ticket)"><i class="fa fa-eye"></i> View</button></td></tr><tr ng-if="!vm.loading && (!vm.orders || vm.orders.length === 0)"><td colspan="12" class="text-center text-muted">No data</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" max-size="7" boundary-links="true" rotate="false"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/profile/profile-transaction.html','<!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="profile" data-translate="profile.home.title">User information</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="profile.detail.title">User details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><!-- BEGIN PROFILE SIDEBAR --><div class="profile-sidebar"><!-- PORTLET MAIN --><div class="portlet light profile-sidebar-portlet"><!-- SIDEBAR USERPIC --><div class="profile-userpic"><img src="content/images/avatar_profile.png" class="img-responsive" alt=""></div><!-- END SIDEBAR USERPIC --><!-- SIDEBAR USER TITLE --><div class="profile-usertitle"><div ng-if="vm.profile.myID" class="verified-message"><img src="/content/images/blue-tick.png" style="margin-left: 3px; margin-bottom: 2px" width="16" height="16"> <span data-translate="profile.detail.verified">Verified</span></div><div ng-if="!vm.profile.myID" class="unverified-message"><i class="fa fa-exclamation-circle"></i> <span data-translate="profile.detail.unverified">Unverified</span></div><div class="profile-usertitle-name">{{vm.profile.customerFullName}}</div><div class="profile-usertitle-job">{{vm.profile.customerPhone | phoneNumber}}</div></div><!-- END SIDEBAR USER TITLE --><!-- SIDEBAR BUTTONS --><div class="profile-userbuttons"><button class="btn btn-circle green btn-sm" ng-if="vm.profile.customerStatus == \'ACTIVE\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle bg-yellow-lemon bg-font-yellow-lemon btn-sm" ng-if="vm.profile.customerStatus == \'DEACTIVATED\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle red btn-sm" ng-if="vm.profile.customerStatus == \'BANNED\'">{{vm.profile.customerStatus}}</button> <button class="label label-sm label-info" ng-if="vm.profile.customerStatus == \'REACTIVATED\'">{{vm.profile.customerStatus}}</button></div><!-- END SIDEBAR BUTTONS --><!-- SIDEBAR MENU --><div class="profile-usermenu"><ul class="nav"><li><a ui-sref="profile-detail({id:vm.profile.id})"><i class="icon-home"></i> {{\'profile.detail.menu.generalInfo\' | translate}}</a></li><li class="active"><a ui-sref="profile-transaction({id:vm.profile.id})"><i class="icon-settings"></i> {{\'profile.detail.menu.transactions \' | translate}}</a></li><li><a ui-sref="profile-notification({id:vm.profile.id})"><i class="glyphicon glyphicon-bell"></i> {{\'profile.detail.menu.notification \' | translate}}</a></li><li><a ui-sref="profile-transfer-limit({id:vm.profile.id})"><i class="fa fa-line-chart"></i> {{\'profile.detail.menu.limit \' | translate}}</a></li><li><a ui-sref="profile-ticket-orders({id:vm.profile.id})"><i class="fa fa-plane"></i> {{\'profile.detail.menu.tickets \' | translate}}</a></li></ul></div><!-- END MENU --></div><!-- END PORTLET MAIN --></div><!-- END BEGIN PROFILE SIDEBAR --><!-- BEGIN PROFILE CONTENT --><div class="profile-content"><div class="row"><div class="col-md-12"><div class="portlet light"><div class="tabbable-line tabbable-custom-profile"><ul class="nav nav-tabs"><li ng-class="vm.activeTab == \'tab_1\' ? \'active\' : \'\'"><a href="javascript;" data-target="#tab_1_1" data-toggle="tab" ng-click="vm.activateTab(\'tab_1\')" data-translate="profile.transfers">Transfers</a></li><li ng-class="vm.activeTab == \'tab_2\' ? \'active\' : \'\'"><a href="javascript;" data-target="#tab_1_2" data-toggle="tab" ng-click="vm.activateTab(\'tab_2\')" data-translate="profile.payments">Payments</a></li><li ng-class="vm.activeTab == \'tab_3\' ? \'active\' : \'\'"><a href="javascript;" data-target="#tab_1_3" data-toggle="tab" ng-click="vm.activateTab(\'tab_3\')" data-translate="profile.cards">Cards</a></li><li ng-class="vm.activeTab == \'tab_4\' ? \'active\' : \'\'"><a href="javascript;" data-target="#tab_1_4" data-toggle="tab" ng-click="vm.activateTab(\'tab_4\')" data-translate="profile.receiverCards">Receiver cards</a></li><li ng-class="vm.activeTab == \'tab_5\' ? \'active\' : \'\'"><a href="javascript;" data-target="#tab_1_5" data-toggle="tab" ng-click="vm.activateTab(\'tab_5\')" data-translate="profile.uniredPayment">Unired payment</a></li></ul><div class="tab-content"><div class="tab-pane" ng-class="vm.activeTab == \'tab_1\' ? \'active\' : \'\'" id="tab_1_1"><div class="portlet-body"><div class="row" style="margin-top: -25px;  margin-bottom: -25px"><div class="col-lg-5 col-md-6 col-sm-7 col-xs-12 pull-right"><div class="dashboard-stat2" style="border: 1px solid #4DB3A2"><div class="display" style="margin-bottom: -25px; margin-top: -3px"><div class="number"><h3 class="font-green-dark"><span data-counter="counterup" data-value="{{vm.totalTransferAmount}}">{{vm.totalTransferAmount | number}}</span> <small class="font-green-dark"><i class="{{vm.getCurrencySymbolForClient(vm.profile.customerClient)}}"></i></small></h3><small>TOTAL SUCCESS</small></div><div class="icon"><i class="fa fa-exchange" style="color: #4DB3A2"></i></div></div></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicateTransfer" ascending="vm.reverseTransfer" callback="vm.transitionTransfer()"><th rowspan="2" jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbTransfer.date">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbTransfer.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="merchant"><span data-translate="bozorakaAdminApp.tkbTransfer.merchant">Merchant</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="receiverOwner"><span data-translate="bozorakaAdminApp.tkbTransfer.receiver">Receiver</span> <span class="glyphicon glyphicon-sort"></span></th><th colspan="2">Amount</th><th rowspan="2" jh-sort-by="rate" style="white-space: normal"><span data-translate="bozorakaAdminApp.tkbTransfer.rate">Rate</span> <span class="glyphicon glyphicon-sort"></span></th><th colspan="3">Commission</th><th colspan="2" jh-sort-by="state">State<span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span>Check</span></th><th rowspan="2"><span>Confirm</span></th><th rowspan="2"></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th rowspan="2" jh-sort-by="amountRub">RUB <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="amountUzs">UZS/USD <span class="glyphicon glyphicon-sort"></span></th><th>Bank</th><th>SP</th><th>Total</th><th rowspan="2"><span>Debit</span></th><th rowspan="2"><span>Credit</span></th></tr></thead><tbody><tr ng-repeat="tkbTransfer in vm.transfers track by tkbTransfer.id" class="text-center"><td>{{tkbTransfer.createdDate | date:\'medium\'}}</td><td id="mt{{tkbTransfer.externalId}}" id="copyAhref" style="width: 200px"><a href="javascript:;" class="green mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbTransfer.externalId}}" title="You can copy External ID">{{tkbTransfer.externalId}}</a></td><td><div><span class="btn btn-xs bg-green-seagreen bg-font-green-seagreen" ng-if="tkbTransfer.merchant === \'APEXTECH\'">APEXTECH</span> <span class="btn purple-sharp btn-xs" ng-if="tkbTransfer.merchant === \'GLOBIZ\'">GLOBIZ</span></div><div style="margin-top: 5px"><span>{{tkbTransfer.gateway}}</span></div></td><td><div><span>{{tkbTransfer.receiverOwner}}</span></div><div id="mt{{tkbTransfer.receiverCardNumber}}" id="copyAhref"><a href="javascript:;" class="green mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbTransfer.receiverCardNumber}}" title="You can copy card number"><span>{{tkbTransfer.receiverCardNumber}}</span></a></div></td><td>{{(tkbTransfer.amountRub / 100) | number}}</td><td>{{(tkbTransfer.amountUzs / 100) | number}} {{tkbTransfer.currency}}</td><td>{{tkbTransfer.rate}}</td><td>{{(tkbTransfer.bankFixedCommission + tkbTransfer.bankVariableCommission) | number:2}}</td><td>{{(tkbTransfer.spFixedCommission + tkbTransfer.spVariableCommission) | number:2}}</td><td>{{tkbTransfer.commissionAmount / 100 | number:2}}</td><td><div data-toggle="popover" id="{{tkbTransfer.id}}" ng-click="vm.initPopover($event, tkbTransfer)"><span class="label label-default" ng-if="tkbTransfer.state === 0" style="cursor: pointer">INITIATED </span><span class="label label-success" ng-if="tkbTransfer.state === 3" style="cursor: pointer">SUCCESS </span><span class="label label-danger" ng-if="tkbTransfer.state !== 0 && tkbTransfer.state !== 3" style="cursor: pointer">FAILED:{{tkbTransfer.state}}</span></div></td><td><div data-toggle="popover" id="{{tkbTransfer.id}}-credit" ng-click="vm.initCreditPopover($event, tkbTransfer)"><span class="label label-default" ng-if="tkbTransfer.creditState === 0">CREATED </span><span class="label label-success" ng-if="tkbTransfer.creditState === 4">SUCCESS </span><span class="label label-danger" ng-if="tkbTransfer.creditState !== 0 && tkbTransfer.creditState !== 4">FAILED:{{tkbTransfer.creditState}}</span></div></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.getTransferState(tkbTransfer.externalId)" ng-disabled="tkbTransfer.externalId === null || vm.checkList[tkbTransfer.externalId] === true"><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down" data-translate="entity.action.check"></span></button></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.confirmTransfer(tkbTransfer.externalId)" ng-disabled="vm.checkList[tkbTransfer.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down">Confirm</span></button></td><td><img ng-click="vm.openTransferInfo(tkbTransfer.id)" ng-src="content/images/icon-info.png" alt="Photo" style="width: 20px"></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.pageTransfer" total="vm.queryCountTransfer" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItemsTransfer" items-per-page="vm.itemsPerPage" ng-model="vm.pageTransfer" ng-change="vm.transitionTransfer()"></uib-pagination></div></div></div><div class="tab-pane" ng-class="vm.activeTab == \'tab_2\' ? \'active\' : \'\'" id="tab_1_2"><div class="portlet-body"><div class="row" style="margin-top: -25px;  margin-bottom: -25px"><div class="col-lg-5 col-md-6 col-sm-7 col-xs-12 pull-right"><div class="dashboard-stat2" style="border: 1px solid #4B77BE"><div class="display" style="margin-bottom: -25px; margin-top: -3px"><div class="number"><h3 class="font-blue-steel"><span data-counter="counterup" data-value="{{vm.totalTransactionAmount}}">{{vm.totalTransactionAmount | number}}</span> <small class="font-blue-steel"><i class="{{vm.getCurrencySymbolForClient(vm.profile.customerClient)}}"></i></small></h3><small>TOTAL SUCCESS</small></div><div class="icon"><i class="icon-pie-chart" style="color: #4B77BE"></i></div></div></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicateTranHist" ascending="vm.reverseTranHist" callback="vm.transitionTranHist()"><th>HT</th><th>ID</th><th jh-sort-by="requestNo"><span data-translate="profile.request">Request #</span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mode"><span data-translate="profile.mode">Mode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gateway"><span>Gateway</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="directAmount"><span>Direct</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountInSom"><span data-translate="profile.sent">Sent</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="profile.details">Details</span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="profile.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Agent</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="transaction in vm.transactionHistories track by transaction.id" class="text-center"><td>{{vm.dateDiff(transaction) | handledTime}}</td><td>{{transaction.id}}</td><td><span ng-switch="transaction.serviceType"><a href="javascript:;" ui-sref="order-info-detail({id:transaction.orderInfoId})" ng-switch-when="SERVICE_MARKET"><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a><a href="javascript:;" ui-sref="transaction-detail({id:transaction.id})" ng-switch-default><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a></span></td><td class="text-center"><transaction-mode mode="transaction.mode"></transaction-mode></td><td><transaction-gateway gateway="transaction.gateway"></transaction-gateway></td><td>{{vm.getDirectAmount(transaction)}}</td><td class="text-center">{{vm.getSentAmount(transaction)}}</td><td>{{transaction.description}}</td><td><transaction-status status="transaction.status"></transaction-status></td><td>{{transaction.lastModifiedBy}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.pageTranHist" total="vm.queryCountTranHist" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItemsTranHist" items-per-page="vm.itemsPerPage" ng-model="vm.pageTranHist" ng-change="vm.transitionTranHist()"></uib-pagination></div></div></div><!--tab-pane--><div class="tab-pane" ng-class="vm.activeTab == \'tab_3\' ? \'active\' : \'\'" id="tab_1_3"><div class="portlet-body"><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicateTkbCard" ascending="vm.reverseTkbCard" callback="vm.transitionTkbCard()"><th jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbCard.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceId"><span data-translate="bozorakaAdminApp.tkbCard.referenceId">Reference Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.tkbCard.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span data-translate="bozorakaAdminApp.tkbCard.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provider"><span data-translate="bozorakaAdminApp.tkbCard.provider">Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="state"><span data-translate="bozorakaAdminApp.tkbCard.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gateway"><span>Gateway</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbCard.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tkbCard in vm.tkbCards track by tkbCard.id" class="text-center"><td>{{tkbCard.externalId}}</td><td>{{tkbCard.referenceId}}</td><td>{{tkbCard.number}}</td><td>{{tkbCard.owner}}</td><td>{{tkbCard.provider}}</td><td><span class="label label-default" ng-if="tkbCard.state === 0">INITIATED</span> <span class="label label-info" ng-if="tkbCard.state === 1">IN PROCESS</span> <span class="label label-success" ng-if="tkbCard.state === 5">SUCCESS</span> <span class="label label-danger" ng-if="tkbCard.state === 6">FAILED</span></td><td>{{tkbCard.gateway}}</td><td>{{tkbCard.createdDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.openSenderCardDeleteModal(tkbCard.id)" ng-disabled="tkbCard.referenceId === null"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.pageTkbCard" total="vm.queryCountTkbCard" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItemsTkbCard" items-per-page="vm.itemsPerPage" ng-model="vm.pageTkbCard" ng-change="vm.transitionTkbCard()"></uib-pagination></div></div></div><div class="tab-pane" ng-class="vm.activeTab == \'tab_4\' ? \'active\' : \'\'" id="tab_1_4"><div class="portlet-body"><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span data-translate="bozorakaAdminApp.uzbCard.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.uzbCard.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.uzbCard.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span>Owner Phone </span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isBlocked"><span>Card state</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last modified</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span>Created</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="uzbCard in vm.uzbCards track by uzbCard.id"><td><a ui-sref="uzb-card-detail({id:uzbCard.id})">{{uzbCard.id}}</a></td><td>{{uzbCard.owner}}</td><td>{{uzbCard.number}}</td><td>{{uzbCard.type | uppercase}}</td><td>{{uzbCard.phone}}</td><td><span class="label label-danger" ng-if="uzbCard.isBlocked === true">Blocked</span> <span class="label label-success" ng-if="uzbCard.isBlocked !== true">Unblocked</span></td><td><div>{{uzbCard.lastModifiedBy}}</div><div>{{uzbCard.lastModifiedDate | date:\'medium\'}}</div></td><td><div>{{uzbCard.createdBy }}</div><div>{{uzbCard.createdDate | date:\'medium\'}}</div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.openUzbCardEditModal(uzbCard.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button></div></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.pageUzbCards" total="vm.queryCountUzbCards" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItemsUzbCards" items-per-page="vm.itemsPerPage" ng-model="vm.pageUzbCards" ng-change="vm.transitionUzbCards()"></uib-pagination></div></div></div><div class="tab-pane" ng-class="vm.activeTab == \'tab_5\' ? \'active\' : \'\'" id="tab_1_5"><div class="portlet-body"><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th rowspan="2" jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbPayment.externalId">External Id</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="account"><span data-translate="bozorakaAdminApp.tkbPayment.account">Account</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="account"><span>Description</span><span class="glyphicon glyphicon-sort"></span></th><th colspan="3"><span data-translate="bozorakaAdminApp.tkbPayment.amount">Amount</span></th><th colspan="3">Commission</th><th rowspan="2" jh-sort-by="state"><span data-translate="bozorakaAdminApp.tkbPayment.debitState">Debit State</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="creditState"><span data-translate="bozorakaAdminApp.tkbPayment.creditState">Credit State</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span>Transaction status</span></th><th rowspan="2" jh-sort-by="gateway"><span data-translate="bozorakaAdminApp.tkbPayment.gateway">Gateway</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbPayment.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span>Check</span></th><th rowspan="2"><span>Confirm</span></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="amount"><span>RUB</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commissionAmount"><span>RUB %</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountUzs"><span>UZS</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ubCommissionAmount">Bank<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spCommissionAmount">SP<span class="glyphicon glyphicon-sort"></span></th><th>Total</th></tr></thead><tbody><tr ng-repeat="tkbPayment in vm.tkbPayments track by tkbPayment.id"><td>{{tkbPayment.id}}</td><td id="mt{{tkbPayment.externalId}}" id="copyAhref" style="width: 200px"><a href="javascript:;" class="green mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbPayment.externalId}}" title="You can copy External ID">{{tkbPayment.externalId}}</a></td><td><a href="" ng-click="vm.openPaymentInfo(tkbPayment.id)">{{tkbPayment.account}}</a></td><td>{{tkbPayment.description}}</td><td>{{tkbPayment.amount}}</td><td>{{tkbPayment.commissionAmount}}</td><td>{{tkbPayment.amountUzs}}</td><td>{{tkbPayment.ubCommissionAmount}}</td><td>{{tkbPayment.spCommissionAmount}}</td><td>{{tkbPayment.ubCommissionAmount + tkbPayment.spCommissionAmount}}</td><td><div data-toggle="popover" id="{{tkbPayment.id}}" ng-click="vm.initPaymentPopover($event, tkbPayment)"><span class="label label-default" ng-if="tkbPayment.state === 0">INITIATED</span> <span class="label label-success" ng-if="tkbPayment.state === 3">SUCCESS</span> <span class="label label-danger" ng-if="tkbPayment.state !== 0 && tkbPayment.state !== 3">FAILED:{{tkbPayment.state}}</span></div></td><td><div data-toggle="popover" id="{{tkbPayment.id}}-credit" ng-click="vm.initPaymentCreditPopover($event, tkbPayment)"><span class="label label-default" ng-if="tkbPayment.creditState === -2">CREATED</span> <span class="label label-success" ng-if="tkbPayment.creditState === 0">SUCCESS</span> <span class="label label-danger" ng-if="tkbPayment.creditState === -21">CANCELLED</span> <span class="label label-danger" ng-if="tkbPayment.creditState !== -2 && tkbPayment.creditState !== 0 && tkbPayment.creditState !== -21">FAILED:{{tkbPayment.creditState}}</span></div></td><td><a ui-sref="transaction-detail({id:tkbPayment.transactionId})">{{tkbPayment.transactionStatus}}</a></td><td>{{tkbPayment.gateway}}</td><td>{{tkbPayment.createdDate | date:\'medium\'}}</td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.getPaymentState(tkbPayment.externalId)" style="margin-bottom: 15px" ng-disabled="tkbPayment.externalId === null || vm.checkList[tkbPayment.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down" data-translate="entity.action.check"></span></button></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.confirmPayment(tkbPayment.externalId)" style="margin-bottom: 15px" ng-disabled="vm.checkList[tkbPayment.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down">Confirm</span></button></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.pageTkbPayment" total="vm.queryCountTkbPayment" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItemsTkbPayment" items-per-page="vm.itemsPerPage" ng-model="vm.pageTkbPayment" ng-change="vm.transitionTkbPayment()"></uib-pagination></div></div></div></div></div></div></div></div></div><!-- END PROFILE CONTENT --></div></div><!-- END PAGE CONTENT-->');
$templateCache.put('app/entities/profile/profile-transfer-limit.html','<!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="profile" data-translate="profile.home.title">User information</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="profile.detail.title">User details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><!-- BEGIN PROFILE SIDEBAR --><div class="profile-sidebar"><!-- PORTLET MAIN --><div class="portlet light profile-sidebar-portlet"><!-- SIDEBAR USERPIC --><div class="profile-userpic"><img src="content/images/avatar_profile.png" class="img-responsive" alt=""></div><!-- END SIDEBAR USERPIC --><!-- SIDEBAR USER TITLE --><div class="profile-usertitle"><div ng-if="vm.profile.myID" class="verified-message"><img src="/content/images/blue-tick.png" style="margin-left: 3px; margin-bottom: 2px" width="16" height="16"> <span data-translate="profile.detail.verified">Verified</span></div><div ng-if="!vm.profile.myID" class="unverified-message"><i class="fa fa-exclamation-circle"></i> <span data-translate="profile.detail.unverified">Unverified</span></div><div class="profile-usertitle-name">{{vm.profile.customerFullName}}</div><div class="profile-usertitle-job">{{vm.profile.customerPhone | phoneNumber}}</div></div><!-- END SIDEBAR USER TITLE --><!-- SIDEBAR BUTTONS --><div class="profile-userbuttons"><button class="btn btn-circle green btn-sm" ng-if="vm.profile.customerStatus == \'ACTIVE\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle bg-yellow-lemon bg-font-yellow-lemon btn-sm" ng-if="vm.profile.customerStatus == \'DEACTIVATED\'">{{vm.profile.customerStatus}}</button> <button class="btn btn-circle red btn-sm" ng-if="vm.profile.customerStatus == \'BANNED\'">{{vm.profile.customerStatus}}</button> <button class="label label-sm label-info" ng-if="vm.profile.customerStatus == \'REACTIVATED\'">{{vm.profile.customerStatus}}</button></div><!-- END SIDEBAR BUTTONS --><!-- SIDEBAR MENU --><div class="profile-usermenu"><ul class="nav"><li><a ui-sref="profile-detail({id:vm.profile.id})"><i class="icon-home"></i> {{\'profile.detail.menu.generalInfo\' | translate}}</a></li><li><a ui-sref="profile-transaction({id:vm.profile.id})"><i class="icon-settings"></i> {{\'profile.detail.menu.transactions \' | translate}}</a></li><li><a ui-sref="profile-notification({id:vm.profile.id})"><i class="glyphicon glyphicon-bell"></i> {{\'profile.detail.menu.notification \' | translate}}</a></li><li class="active"><a ui-sref="profile-transfer-limit({id:vm.profile.id})"><i class="fa fa-bar-chart"></i> {{\'profile.detail.menu.limit \' | translate}}</a></li><li><a ui-sref="profile-ticket-orders({id:vm.profile.id})"><i class="fa fa-plane"></i> {{\'profile.detail.menu.tickets \' | translate}}</a></li></ul></div><!-- END MENU --></div><!-- END PORTLET MAIN --></div><!-- END BEGIN PROFILE SIDEBAR --><!-- BEGIN PROFILE CONTENT --><div class="profile-content"><div class="row"><div class="col-md-12"><div class="portlet light"><div class="card-body"><div><strong><p data-translate="profile.detail.dailyTransferLimit">Daily transfer limit:</p></strong><p ng-if="vm.dailyTransferCount !== null && vm.dailyTransferCount.limit"><span data-translate="profile.detail.dailyTransferLimitUsage.prefix">You have used</span> <span style="color: #337ab7; font-weight: bold">{{vm.dailyTransferCount.usage}}</span> <span data-translate="profile.detail.dailyTransferLimitUsage.suffix" translate-values="{dailyTransferCountLimit: \'{{vm.dailyTransferCount.limit}}\'}">out of {{vm.dailyTransferCount.limit}} transfers</span></p></div><div class="progress mb-3"><div class="progress-bar" role="progressbar" style="width: {{(vm.dailyTransferCount.usage / vm.dailyTransferCount.limit) * 100}}%" aria-valuenow="{{vm.dailyTransferCount.usage}}" aria-valuemin="0" aria-valuemax="{{vm.dailyTransferCount.limit}}">{{((vm.dailyTransferCount.usage / vm.dailyTransferCount.limit) * 100) | number:0}}%</div></div><div><strong><p data-translate="profile.detail.monthlyTransferLimit">Monthly transfer limit</p></strong><p ng-if="vm.monthlyTransferAmount !== null && vm.monthlyTransferAmount.limit"><span data-translate="profile.detail.monthlyTransferLimitUsage.prefix">You have used</span> <span style="color: #337ab7; font-weight: bold">{{vm.monthlyTransferAmount.usage | number}}</span> <span data-translate="profile.detail.monthlyTransferLimitUsage.suffix" translate-values="{monthlyTransferAmountLimit: \'{{vm.monthlyTransferAmount.limit | number}}\'}">out of {{vm.monthlyTransferAmount.limit | number}} rubles</span></p></div><div class="progress"><div class="progress-bar" role="progressbar" style="width: {{(vm.monthlyTransferAmount.usage / vm.monthlyTransferAmount.limit) * 100}}%" aria-valuenow="{{vm.monthlyTransferAmount.usage}}" aria-valuemin="0" aria-valuemax="{{vm.monthlyTransferAmount.limit}}">{{((vm.monthlyTransferAmount.usage / vm.monthlyTransferAmount.limit) * 100) | number:0}}%</div></div><div style="display: flex; justify-content: space-between"><span>{{vm.monthStart}}</span> <span>{{vm.monthEnd}}</span></div></div></div></div></div></div><!-- END PROFILE CONTENT --></div></div><!-- END PAGE CONTENT-->');
$templateCache.put('app/entities/profile/profiles.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-people font-dark"></i> <span class="caption-subject bold uppercase" data-translate="profile.home.title">User information</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="profile.form.search">Full Name / Phone / Account #</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{\'profile.form.search\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="profile.form.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="ACTIVE">ACTIVE</option><option value="DEACTIVATED">DEACTIVATED</option><option value="BANNED">BANNED</option><option value="REACTIVATED">REACTIVATED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="profile.form.passportNumber">Passport number</label><input type="text" class="form-control" ng-model="vm.searchQuery.passportNumber" placeholder="Passport number"></div></div><!--/span--><div class="col-md-5"><div class="form-group"><label class="control-label" data-translate="profile.form.date">Registration date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon" data-translate="profile.form.to.date">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div><!--/span--></div><!--/row--><!--/row--></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" class="text-center"><span data-translate="profile.userId">User ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="c.phone" class="text-center"><span data-translate="profile.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="c.fullName" class="text-center"><span data-translate="profile.fullName">Full Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="c.passportNumber" class="text-center"><span data-translate="profile.passportNumber">Passport number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="registrationDate" class="text-center"><span data-translate="profile.registrationDate">Registration date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="c.status" class="text-center"><span data-translate="profile.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr class="odd gradeX text-center" ng-repeat="profile in vm.profiles track by profile.id"><td>{{profile.customerId}}</td><td><div style="display: inline-block; width: 18ch"><a ui-sref="profile-detail({id:profile.id})" target="_blank" style="display: flex; align-items: center">{{profile.customerPhone | phoneNumber}} <img ng-if="profile.customerVerified" src="/content/images/blue-tick.png" style="margin-left: 3px" width="16" height="16"></a></div></td><td>{{profile.customerFullName}}</td><td><span style="display: flex; align-items: center; justify-content: center; text-wrap: nowrap">{{profile.passportNumber}} <i ng-if="profile.passportNumber && profile.myIDBlocked" class="icon-ban font-red" style="font-weight: bold; margin-left: 3px"></i></span></td><td>{{profile.registrationDate | date:\'medium\'}}</td><td><span class="label label-sm label-success" ng-if="profile.customerStatus == \'ACTIVE\'">{{profile.customerStatus}} </span><span class="label label-sm label-warning" ng-if="profile.customerStatus == \'DEACTIVATED\'">{{profile.customerStatus}} </span><span class="label label-sm label-danger" ng-if="profile.customerStatus == \'BANNED\'">{{profile.customerStatus}} </span><span class="label label-sm label-info" ng-if="profile.customerStatus == \'REACTIVATED\'">{{profile.customerStatus}}</span></td></tr></tbody></table></div></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><!-- END EXAMPLE TABLE PORTLET--></div></div>');
$templateCache.put('app/entities/provider-country/provider-countries.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.providerCountry.home.title">Provider Countries</span></div><div class="pull-right"><button class="btn btn-primary" ui-sref="provider-country.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.providerCountry.home.createLabel">Create new Provider Country</span></button></div></div><div class="portlet-body"><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="bozorakaAdminApp.providerCountry.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.providerCountry.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="flagImage"><span data-translate="bozorakaAdminApp.providerCountry.flagImage">Flag Image</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isFavourite"><span data-translate="bozorakaAdminApp.providerCountry.isFavourite">Is Favourite</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span data-translate="bozorakaAdminApp.providerCountry.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.providerCountry.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="providerCountry in vm.providerCountries track by providerCountry.id"><td><a ui-sref="provider-country.edit({id:providerCountry.id})">{{providerCountry.name}}</a></td><td data-translate="{{\'bozorakaAdminApp.ProviderStatus.\' + providerCountry.status}}">{{providerCountry.status}}</td><td><img ng-src="{{providerCountry.flagImage}}" style="max-height: 32px" alt="{{providerCountry.flagImage}}"></td><td>{{providerCountry.isFavourite}}</td><td>{{providerCountry.position}}</td><td>{{providerCountry.lastModifiedBy}}<br>{{providerCountry.lastModifiedDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="provider-country.delete({id:providerCountry.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/provider-country/provider-country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.providerCountry.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.providerCountry.delete.question" translate-values="{id: \'{{vm.providerCountry.id}}\'}">Are you sure you want to delete this Provider Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider-country/provider-country-detail.html','<div><h2><span data-translate="bozorakaAdminApp.providerCountry.detail.title">Provider Country</span> {{vm.providerCountry.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.providerCountry.name">Name</span></dt><dd><span>{{vm.providerCountry.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.code">Code</span></dt><dd><span>{{vm.providerCountry.code}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.ProviderStatus.\' + vm.providerCountry.status}}">{{vm.providerCountry.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.flagImage">Flag Image</span></dt><dd><span>{{vm.providerCountry.flagImage}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.isFavourite">Is Favourite</span></dt><dd><span>{{vm.providerCountry.isFavourite}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.position">Position</span></dt><dd><span>{{vm.providerCountry.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.createdBy">Created By</span></dt><dd><span>{{vm.providerCountry.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.createdDate">Created Date</span></dt><dd><span>{{vm.providerCountry.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.providerCountry.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCountry.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.providerCountry.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-country-detail.edit({id:vm.providerCountry.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider-country/provider-country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProviderCountryLabel" data-translate="bozorakaAdminApp.providerCountry.home.createOrEditLabel">Create or edit a Provider Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.providerCountry.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.providerCountry.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.providerCountry.name" required ng-maxlength="150"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.providerCountry.code" required ng-maxlength="3"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.providerCountry.status" id="field_status" required><option value="ENABLED" data-translate="bozorakaAdminApp.ProviderStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="bozorakaAdminApp.ProviderStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.flagImage" for="field_flagImage">Flag Image</label><input type="text" class="form-control" name="flagImage" id="field_flagImage" ng-model="vm.providerCountry.flagImage" required><div ng-show="editForm.flagImage.$invalid"><p class="help-block" ng-show="editForm.flagImage.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.isFavourite" for="field_isFavourite">Is Favourite</label><input type="checkbox" name="isFavourite" id="field_isFavourite" ng-model="vm.providerCountry.isFavourite"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCountry.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.providerCountry.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provider-category/provider-categories.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.providerCategory.home.title">Provider Categories</span></div><div class="pull-right"><button class="btn btn-primary" ui-sref="provider-category.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.providerCategory.home.createLabel">Create new Provider Category</span></button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.name">Category Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.name" placeholder="{{ \'bozorakaAdminApp.providerCategory.name\' | translate}}"></div></div><div class="col-xs-12 col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.country">Country</label><select class="form-control" id="field_providerCountry" name="field_providerCountry" ng-model="vm.searchQuery.countryId" ng-options="country.id as country.name for country in vm.providerCountries"><option value=""></option></select></div></div><div class="col-xs-12 col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.status">Kash Category Id</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="ENABLED">ENABLED</option><option value="DISABLED">DISABLED</option></select></div></div></div><div class="row"><div class="col-xs-12 col-md-3 pull-right"><div class="form-group"><div class="row-fluid"><button type="submit" class="btn green col-xs-6" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow col-xs-6" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></div></div></form></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="bozorakaAdminApp.providerCategory.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="providerCountryId"><span data-translate="bozorakaAdminApp.providerCategory.providerCountry">Provider Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.providerCategory.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span data-translate="bozorakaAdminApp.providerCategory.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.providerCategory.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="providerCategory in vm.providerCategories track by providerCategory.id"><td><a ui-sref="provider-category.edit({id:providerCategory.id})">{{providerCategory.name}}</a></td><td>{{providerCategory.providerCountryName}}</td><td><span ng-if="providerCategory.status  == \'ENABLED\'" class="btn btn-xs green-meadow">{{providerCategory.status}}</span> <span ng-if="providerCategory.status  == \'DISABLED\'" class="btn btn-xs red-mint">{{providerCategory.status}}</span></td><td>{{providerCategory.position}}</td><td>{{providerCategory.lastModifiedBy}}<br>{{providerCategory.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/provider-category/provider-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.providerCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.providerCategory.delete.question" translate-values="{id: \'{{vm.providerCategory.id}}\'}">Are you sure you want to delete this Provider Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider-category/provider-category-detail.html','<div><h2><span data-translate="bozorakaAdminApp.providerCategory.detail.title">Provider Category</span> {{vm.providerCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.providerCategory.name">Name</span></dt><dd><span>{{vm.providerCategory.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.status">Status</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.ProviderStatus.\' + vm.providerCategory.status}}">{{vm.providerCategory.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.kashCategoryId">Kash Category Id</span></dt><dd><span>{{vm.providerCategory.kashCategoryId}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.position">Position</span></dt><dd><span>{{vm.providerCategory.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.createdBy">Created By</span></dt><dd><span>{{vm.providerCategory.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.createdDate">Created Date</span></dt><dd><span>{{vm.providerCategory.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.providerCategory.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.providerCategory.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerCategory.providerCountry">Provider Country</span></dt><dd><a ui-sref="provider-country-detail({id:vm.providerCategory.providerCountryId})">{{vm.providerCategory.providerCountryId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-category-detail.edit({id:vm.providerCategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider-category/provider-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProviderCategoryLabel" data-translate="bozorakaAdminApp.providerCategory.home.createOrEditLabel">Create or edit a Provider Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.providerCategory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.providerCategory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.providerCategory.name" required ng-maxlength="150" ng-readonly="vm.providerCategory.id != null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.providerCategory.providerCountry" for="field_providerCountry">Provider Country</label><select class="form-control" id="field_providerCountry" name="providerCountry" ng-model="vm.providerCategory.providerCountryId" ng-options="providerCountry.id as providerCountry.name for providerCountry in vm.providercountries"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.kashCategoryId" for="field_kashCategoryId">Partner Category Id</label><input type="number" class="form-control" name="kashCategoryId" id="field_kashCategoryId" ng-model="vm.providerCategory.kashCategoryId" required><div ng-show="editForm.kashCategoryId.$invalid"><p class="help-block" ng-show="editForm.kashCategoryId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.kashCategoryId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.providerCategory.status" id="field_status" required><option value="ENABLED" data-translate="bozorakaAdminApp.ProviderStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="bozorakaAdminApp.ProviderStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerCategory.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.providerCategory.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/segment-field-option/segment-field-option-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.segmentFieldOption.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.segmentFieldOption.delete.question" translate-values="{id: \'{{vm.segmentFieldOption.id}}\'}">Are you sure you want to delete this Segment Field Option?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/segment-field-option/segment-field-option-detail.html','<div><h2><span data-translate="bozorakaAdminApp.segmentFieldOption.detail.title">Segment Field Option</span> {{vm.segmentFieldOption.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.label">Label</span></dt><dd><span>{{vm.segmentFieldOption.label}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.value">Value</span></dt><dd><span>{{vm.segmentFieldOption.value}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.position">Position</span></dt><dd><span>{{vm.segmentFieldOption.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.segmentFieldId">Segment Field Id</span></dt><dd><span>{{vm.segmentFieldOption.segmentFieldId}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.createdBy">Created By</span></dt><dd><span>{{vm.segmentFieldOption.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.createdDate">Created Date</span></dt><dd><span>{{vm.segmentFieldOption.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.segmentFieldOption.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentFieldOption.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.segmentFieldOption.lastModifiedDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="segment-field-option-detail.edit({id:vm.segmentFieldOption.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/segment-field-option/segment-field-option-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySegmentFieldOptionLabel" data-translate="bozorakaAdminApp.segmentFieldOption.home.createOrEditLabel">Create or edit a Segment Field Option</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.segmentFieldOption.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.segmentFieldOption.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.label" for="field_label">Label</label><input type="text" class="form-control" name="label" id="field_label" ng-model="vm.segmentFieldOption.label" required ng-maxlength="150" ng-readonly="vm.segmentFieldOption.id != null"><div ng-show="editForm.label.$invalid"><p class="help-block" ng-show="editForm.label.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.label.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.segmentFieldOption.value" required ng-maxlength="150"><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.value.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.segmentFieldId" for="field_segmentFieldId">Segment Field Id</label><input type="number" class="form-control" name="segmentFieldId" id="field_segmentFieldId" ng-model="vm.segmentFieldOption.segmentFieldId"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.segmentFieldOption.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/segment-field-option/segment-field-options.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.segmentFieldOption.home.title">Segment Field Options</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.label">Label</label><input type="text" class="form-control" ng-model="vm.searchQuery.label" placeholder="{{ \'bozorakaAdminApp.segmentFieldOption.label\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.value">Value</label><input type="text" class="form-control" ng-model="vm.searchQuery.value" placeholder="{{ \'bozorakaAdminApp.segmentFieldOption.value\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentFieldOption.segmentFieldId">Segment Field Id</label><input type="text" class="form-control" ng-model="vm.searchQuery.segmentFieldId" placeholder="{{ \'bozorakaAdminApp.segmentFieldOption.segmentFieldId\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label">Actions</label><div class="row-fluid"><button type="submit" class="btn green col-xs-6" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow col-xs-6" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></div></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center" jh-sort-by="label"><span data-translate="bozorakaAdminApp.segmentFieldOption.label">Label</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="value"><span data-translate="bozorakaAdminApp.segmentFieldOption.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="segmentFieldId"><span data-translate="bozorakaAdminApp.segmentFieldOption.segmentFieldId">Segment Field Id</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="position"><span data-translate="bozorakaAdminApp.segmentFieldOption.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-center" jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.segmentFieldOption.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="segmentFieldOption in vm.segmentFieldOptions track by segmentFieldOption.id"><td><a ui-sref="segment-field-option.edit({id:segmentFieldOption.id})">{{segmentFieldOption.label}}</a></td><td>{{segmentFieldOption.value}}</td><td>{{segmentFieldOption.segmentFieldId}}</td><td>{{segmentFieldOption.position}}</td><td>{{segmentFieldOption.lastModifiedBy}}<br>{{segmentFieldOption.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/provider-segment/provider-segment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.providerSegment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.providerSegment.delete.question" translate-values="{id: \'{{vm.providerSegment.id}}\'}">Are you sure you want to delete this Provider Segment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provider-segment/provider-segment-detail.html','<div><h2><span data-translate="bozorakaAdminApp.providerSegment.detail.title">Provider Segment</span> {{vm.providerSegment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.providerSegment.name">Name</span></dt><dd><span>{{vm.providerSegment.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountCharge">Amount Charge</span></dt><dd><span>{{vm.providerSegment.amountCharge}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountChargeRounding">Amount Charge Rounding</span></dt><dd><span>{{vm.providerSegment.amountChargeRounding}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountDisplayRounding">Amount Display Rounding</span></dt><dd><span>{{vm.providerSegment.amountDisplayRounding}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountChargeMin">Amount Charge Min</span></dt><dd><span>{{vm.providerSegment.amountChargeMin}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountChargeMax">Amount Charge Max</span></dt><dd><span>{{vm.providerSegment.amountChargeMax}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountWithdraw">Amount Withdraw</span></dt><dd><span>{{vm.providerSegment.amountWithdraw}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMin">Amount Withdraw Min</span></dt><dd><span>{{vm.providerSegment.amountWithdrawMin}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMax">Amount Withdraw Max</span></dt><dd><span>{{vm.providerSegment.amountWithdrawMax}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.senderDailyLimit">Sender Daily Limit</span></dt><dd><span>{{vm.providerSegment.senderDailyLimit}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.senderMonthlyLimit">Sender Monthly Limit</span></dt><dd><span>{{vm.providerSegment.senderMonthlyLimit}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.recipientDailyLimit">Recipient Daily Limit</span></dt><dd><span>{{vm.providerSegment.recipientDailyLimit}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.recipientMonthlyLimit">Recipient Monthly Limit</span></dt><dd><span>{{vm.providerSegment.recipientMonthlyLimit}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.amountField">Amount Field</span></dt><dd><span>{{vm.providerSegment.amountField}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.status">Status</span></dt><dd><span>{{vm.providerSegment.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.type">Type</span></dt><dd>{{vm.providerSegment.type}}</dd><dt><span data-translate="bozorakaAdminApp.providerSegment.kashServiceId">Kash Service Id</span></dt><dd><span>{{vm.providerSegment.kashServiceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.rate">Rate</span></dt><dd><span>{{vm.providerSegment.rate}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.displayRate">Display Rate</span></dt><dd><span>{{vm.providerSegment.displayRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.serviceCurrency">Service Currency</span></dt><dd><span>{{vm.providerSegment.serviceCurrency}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.serviceCurrencyEnabled">Service Currency Enabled</span></dt><dd><span>{{vm.providerSegment.serviceCurrencyEnabled}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.percentBonus">Percent Bonus</span></dt><dd><span>{{vm.providerSegment.percentBonus}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.accountFieldId">Account Field Id</span></dt><dd><span>{{vm.providerSegment.accountFieldId}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.mode">Mode</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.TransactionMode.\' + vm.providerSegment.mode}}">{{vm.providerSegment.mode}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.position">Position</span></dt><dd><span>{{vm.providerSegment.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.createdBy">Created By</span></dt><dd><span>{{vm.providerSegment.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.createdDate">Created Date</span></dt><dd><span>{{vm.providerSegment.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.providerSegment.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.providerSegment.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.providerSegment.provider">Provider</span></dt><dd><a ui-sref="provider-detail({id:vm.providerSegment.providerId})">{{vm.providerSegment.providerName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provider-segment-detail.edit({id:vm.providerSegment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provider-segment/provider-segment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProviderSegmentLabel" data-translate="bozorakaAdminApp.providerSegment.home.createOrEditLabel">Create or edit a Provider Segment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.providerSegment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.providerSegment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.providerSegment.name" required ng-maxlength="150" ng-readonly="vm.providerSegment.id != null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.kashServiceId" for="field_kashServiceId">Kash Service Id</label><input type="text" class="form-control" name="kashServiceId" id="field_kashServiceId" ng-model="vm.providerSegment.kashServiceId" required><div ng-show="editForm.kashServiceId.$invalid"><p class="help-block" ng-show="editForm.kashServiceId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.kashServiceId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.providerSegment.provider" for="field_provider">Provider</label><select class="form-control" id="field_provider" name="provider" ng-model="vm.providerSegment.providerId" ng-options="provider.id as provider.name for provider in vm.providers" required></select></div><div ng-show="editForm.provider.$invalid"><p class="help-block" ng-show="editForm.provider.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountCharge" for="field_amountCharge">Amount Charge</label><input type="number" class="form-control" name="amountCharge" id="field_amountCharge" ng-model="vm.providerSegment.amountCharge"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountChargeRounding" for="field_amountChargeRounding">Amount Charge Rounding</label><input type="number" class="form-control" name="amountChargeRounding" id="field_amountChargeRounding" ng-model="vm.providerSegment.amountChargeRounding" required><div ng-show="editForm.amountChargeRounding.$invalid"><p class="help-block" ng-show="editForm.amountChargeRounding.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountDisplayRounding" for="field_amountDisplayRounding">Amount Display Rounding</label><input type="number" class="form-control" name="amountDisplayRounding" id="field_amountDisplayRounding" ng-model="vm.providerSegment.amountDisplayRounding" required><div ng-show="editForm.amountDisplayRounding.$invalid"><p class="help-block" ng-show="editForm.amountDisplayRounding.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountChargeMin" for="field_amountChargeMin">Amount Charge Min</label><input type="number" class="form-control" name="amountChargeMin" id="field_amountChargeMin" ng-model="vm.providerSegment.amountChargeMin"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountChargeMax" for="field_amountChargeMax">Amount Charge Max</label><input type="number" class="form-control" name="amountChargeMax" id="field_amountChargeMax" ng-model="vm.providerSegment.amountChargeMax"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountWithdraw" for="field_amountWithdraw">Amount Withdraw</label><input type="number" class="form-control" name="amountWithdraw" id="field_amountWithdraw" ng-model="vm.providerSegment.amountWithdraw"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMin" for="field_amountWithdrawMin">Amount Withdraw Min</label><input type="number" class="form-control" name="amountWithdrawMin" id="field_amountWithdrawMin" ng-model="vm.providerSegment.amountWithdrawMin"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMax" for="field_amountWithdrawMax">Amount Withdraw Max</label><input type="number" class="form-control" name="amountWithdrawMax" id="field_amountWithdrawMax" ng-model="vm.providerSegment.amountWithdrawMax"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.senderDailyLimit" for="field_senderDailyLimit">Sender Daily Limit</label><input type="number" class="form-control" name="senderDailyLimit" id="field_senderDailyLimit" ng-model="vm.providerSegment.senderDailyLimit"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.senderMonthlyLimit" for="field_senderMonthlyLimit">Sender Monthly Limit</label><input type="number" class="form-control" name="senderMonthlyLimit" id="field_senderMonthlyLimit" ng-model="vm.providerSegment.senderMonthlyLimit"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.recipientDailyLimit" for="field_recipientDailyLimit">Recipient Daily Limit</label><input type="number" class="form-control" name="recipientDailyLimit" id="field_recipientDailyLimit" ng-model="vm.providerSegment.recipientDailyLimit"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.recipientMonthlyLimit" for="field_recipientMonthlyLimit">Recipient Monthly Limit</label><input type="number" class="form-control" name="recipientMonthlyLimit" id="field_recipientMonthlyLimit" ng-model="vm.providerSegment.recipientMonthlyLimit"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountField" for="field_amountField">Amount Field</label><input type="text" class="form-control" name="amountField" id="field_amountField" ng-model="vm.providerSegment.amountField" ng-maxlength="20"><div ng-show="editForm.amountField.$invalid"><p class="help-block" ng-show="editForm.amountField.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.rate" for="field_rate">Rate</label><input type="number" class="form-control" name="rate" id="field_rate" ng-model="vm.providerSegment.rate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.displayRate" for="field_rate">Display Rate</label><input type="number" class="form-control" name="displayRate" id="field_displayRate" ng-model="vm.providerSegment.displayRate" required><div ng-show="editForm.displayRate.$invalid"><p class="help-block" ng-show="editForm.displayRate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.displayCurrency" for="field_displayCurrency">Display Currency</label><input type="text" class="form-control" name="displayCurrency" id="field_displayCurrency" ng-model="vm.providerSegment.displayCurrency" required ng-maxlength="3"><div ng-show="editForm.displayCurrency.$invalid"><p class="help-block" ng-show="editForm.displayCurrency.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.serviceCurrency" for="field_serviceCurrency">Service Currency</label><input type="text" class="form-control" name="serviceCurrency" id="field_serviceCurrency" ng-model="vm.providerSegment.serviceCurrency" required ng-maxlength="3"><div ng-show="editForm.serviceCurrency.$invalid"><p class="help-block" ng-show="editForm.serviceCurrency.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.serviceCurrency.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.serviceCurrencyEnabled" for="field_serviceCurrencyEnabled">Service Currency Enabled</label><input type="checkbox" name="serviceCurrencyEnabled" id="field_serviceCurrencyEnabled" ng-model="vm.providerSegment.serviceCurrencyEnabled"><div ng-show="editForm.serviceCurrencyEnabled.$invalid"><p class="help-block" ng-show="editForm.serviceCurrencyEnabled.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.percentBonus" for="field_percentBonus">Percent Bonus</label><input type="number" class="form-control" name="percentBonus" id="field_percentBonus" ng-model="vm.providerSegment.percentBonus"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.accountFieldId" for="field_accountFieldId">Account Field Id</label><select class="form-control" id="field_accountFieldId" name="field_accountFieldId" ng-model="vm.providerSegment.accountFieldId" ng-options=\'fieldVariant.id as (fieldVariant.label + " ("+fieldVariant.name+")") for fieldVariant in vm.providerSegmentFields\'></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.providerSegment.type" id="field_type" required><option value="CHECK" data-translate="bozorakaAdminApp.ProviderSegmentType.CHECK">CHECK</option><option value="PAYMENT" data-translate="bozorakaAdminApp.ProviderSegmentType.PAYMENT">PAYMENT</option><option value="PAYMENT_DIRECT" data-translate="bozorakaAdminApp.ProviderSegmentType.PAYMENT_DIRECT">PAYMENT_DIRECT</option><option value="GET_INFO" data-translate="bozorakaAdminApp.ProviderSegmentType.GET_INFO">GET_INFO</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.mode" for="field_mode">Mode</label><select class="form-control" name="mode" ng-model="vm.providerSegment.mode" id="field_mode" required><option value="AUTO" data-translate="bozorakaAdminApp.TransactionMode.AUTO">AUTO</option><option value="MANUAL" data-translate="bozorakaAdminApp.TransactionMode.MANUAL">MANUAL</option><option value="DISABLED" data-translate="bozorakaAdminApp.TransactionMode.DISABLED">DISABLED</option></select><div ng-show="editForm.mode.$invalid"><p class="help-block" ng-show="editForm.mode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.providerSegment.status" id="field_status" required><option value="ENABLED" data-translate="bozorakaAdminApp.ProviderStatus.ENABLED">ENABLED</option><option value="DISABLED" data-translate="bozorakaAdminApp.ProviderStatus.DISABLED">DISABLED</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.shouldDisplayName" for="field_shouldDisplayName">Should display name</label><input type="checkbox" name="shouldDisplayName" id="field_shouldDisplayName" ng-model="vm.providerSegment.shouldDisplayName"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.repeatable" for="field_repeatable">Repeatable</label><input type="checkbox" name="repeatable" id="field_repeatable" ng-model="vm.providerSegment.repeatable"></div><div class="form-group" ng-show="vm.providerSegment.id && (vm.providerSegment.type == \'GET_INFO\' || vm.providerSegment.type == \'CHECK\') "><label data-translate="bozorakaAdminApp.providerSegment.nextProcessingSegment" for="field_nextProcessingSegment">Next Processing Segment</label><select class="form-control" id="field_nextProcessingSegment" name="nextProcessingSegment" ng-model="vm.providerSegment.nextProcessingSegmentId" ng-options="providerSegment.id as providerSegment.name for providerSegment in vm.providerSegments"><option value class selected="selected"></option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.hidden" for="field_hidden">Hidden</label><input type="checkbox" name="hidden" id="field_hidden" ng-model="vm.providerSegment.hidden"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.providerSegment.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provider-segment/provider-segments.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.providerSegment.home.title">Provider Segments</span></div><div class="pull-right"><button class="btn btn-primary" ui-sref="provider-segment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.providerSegment.home.createLabel">Create new Provider Segment</span></button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.name">Segment Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.name" placeholder="{{ \'bozorakaAdminApp.providerSegment.name\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.provider">Provider Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.providerName" placeholder="{{ \'bozorakaAdminApp.providerSegment.provider\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.kashServiceId">Kash Service Id</label><input type="text" class="form-control" ng-model="vm.searchQuery.partnerServiceId" placeholder="{{ \'bozorakaAdminApp.providerSegment.kashServiceId\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.accountFieldId">Account Field Id</label><input type="text" class="form-control" ng-model="vm.searchQuery.accountFieldId" placeholder="{{ \'bozorakaAdminApp.providerSegment.accountFieldId\' | translate}}"></div></div></div><div class="row"><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountCharge">Amount Charge</label><input type="text" class="form-control" ng-model="vm.searchQuery.amountCharge" placeholder="{{ \'bozorakaAdminApp.providerSegment.amountCharge\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.amountField">Amount Charge</label><input type="text" class="form-control" ng-model="vm.searchQuery.amountField" placeholder="{{ \'bozorakaAdminApp.providerSegment.amountField\' | translate}}"></div></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.type">Type</label><select class="form-control" ng-model="vm.searchQuery.type"><option value class selected="selected"></option><option value="PAYMENT">PAYMENT</option><option value="CHECK">CHECK</option><option value="PAYMENT_DIRECT">PAYMENT_DIRECT</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.mode">Mode</label><select class="form-control" ng-model="vm.searchQuery.mode"><option value class selected="selected"></option><option value="AUTO">AUTO</option><option value="MANUAL">MANUAL</option><option value="DISABLED">DISABLED</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.providerSegment.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="ENABLED">ENABLED</option><option value="DISABLED">DISABLED</option></select></div></div></div><div class="pull-right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div><br></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="bozorakaAdminApp.providerSegment.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="kashServiceId"><span data-translate="bozorakaAdminApp.providerSegment.kashServiceId">Kash Service Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="providerName"><span data-translate="bozorakaAdminApp.providerSegment.provider">Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountCharge"><span data-translate="bozorakaAdminApp.providerSegment.amountCharge">Amount Charge</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountChargeMin"><span data-translate="bozorakaAdminApp.providerSegment.amountChargeMin">Amount Charge Min</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountChargeMax"><span data-translate="bozorakaAdminApp.providerSegment.amountChargeMax">Amount Charge Max</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountWithdraw"><span data-translate="bozorakaAdminApp.providerSegment.amountWithdraw">Amount Withdraw</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountWithdrawMin"><span data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMin">Amount Withdraw Min</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountWithdrawMax"><span data-translate="bozorakaAdminApp.providerSegment.amountWithdrawMax">Amount Withdraw Max</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountField"><span data-translate="bozorakaAdminApp.providerSegment.amountField">Amount Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rate"><span data-translate="bozorakaAdminApp.providerSegment.rate">Rate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="percentBonus"><span data-translate="bozorakaAdminApp.providerSegment.percentBonus">Percent Bonus</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="accountFieldId"><span data-translate="bozorakaAdminApp.providerSegment.accountFieldId">Account Field Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="bozorakaAdminApp.providerSegment.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mode"><span data-translate="bozorakaAdminApp.providerSegment.mode">Mode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.providerSegment.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shouldDisplayName"><span data-translate="bozorakaAdminApp.providerSegment.shouldDisplayName">Should Display Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="repeatable"><span data-translate="bozorakaAdminApp.providerSegment.repeatable">Repeatable</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="bozorakaAdminApp.providerSegment.nextProcessingSegment">Next Processing Segment</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="bozorakaAdminApp.providerSegment.hidden">hidden</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span data-translate="bozorakaAdminApp.providerSegment.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.providerSegment.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="providerSegment in vm.providerSegments track by providerSegment.id"><td><a ui-sref="provider-segment.edit({id:providerSegment.id})">{{providerSegment.name}}</a></td><td>{{providerSegment.kashServiceId}}</td><td>{{providerSegment.providerName}}</td><td>{{providerSegment.amountCharge}}</td><td>{{providerSegment.amountChargeMin}}</td><td>{{providerSegment.amountChargeMax}}</td><td>{{providerSegment.amountWithdraw}}</td><td>{{providerSegment.amountWithdrawMin}}</td><td>{{providerSegment.amountWithdrawMax}}</td><td>{{providerSegment.amountField}}</td><td>{{providerSegment.rate}}</td><td>{{providerSegment.percentBonus}}</td><td>{{providerSegment.accountFieldId}}</td><td data-translate="{{\'bozorakaAdminApp.ProviderSegmentType.\' + providerSegment.type}}">{{providerSegment.type}}</td><td><span ng-if="providerSegment.mode  == \'AUTO\'" class="btn purple-sharp btn-xs">{{providerSegment.mode}}</span> <span ng-if="providerSegment.mode  == \'MANUAL\'" class="btn yellow-mint btn-xs">{{providerSegment.mode}}</span> <span ng-if="providerSegment.mode  == \'DISABLED\'" class="btn btn-xs red-mint">{{providerSegment.mode}}</span></td><td><span ng-if="providerSegment.status  == \'ENABLED\'" class="btn btn-xs green-meadow">{{providerSegment.status}}</span> <span ng-if="providerSegment.status  == \'DISABLED\'" class="btn btn-xs red-mint">{{providerSegment.status}}</span></td><td><h4 class="text-success" ng-if="providerSegment.shouldDisplayName"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!providerSegment.shouldDisplayName"><i class="fa fa-times"></i></h4></td><td><h4 class="text-success" ng-if="providerSegment.repeatable"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!providerSegment.repeatable"><i class="fa fa-times"></i></h4></td><td>{{providerSegment.nextProcessingSegmentName}}</td><td><h4 class="text-success" ng-if="providerSegment.hidden"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!providerSegment.hidden"><i class="fa fa-times"></i></h4></td><td>{{providerSegment.position}}</td><td>{{providerSegment.lastModifiedBy}}<br>{{providerSegment.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/segment-field/segment-field-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.segmentField.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.segmentField.delete.question" translate-values="{id: \'{{vm.segmentField.id}}\'}">Are you sure you want to delete this Segment Field?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/segment-field/segment-field-detail.html','<div><h2><span data-translate="bozorakaAdminApp.segmentField.detail.title">Segment Field</span> {{vm.segmentField.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.segmentField.label">Label</span></dt><dd><span>{{vm.segmentField.label}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.name">Name</span></dt><dd><span>{{vm.segmentField.name}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.type">Type</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.FieldType.\' + vm.segmentField.type}}">{{vm.segmentField.type}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.value">Value</span></dt><dd><span>{{vm.segmentField.value}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.minLength">Min Length</span></dt><dd><span>{{vm.segmentField.minLength}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.maxLength">Max Length</span></dt><dd><span>{{vm.segmentField.maxLength}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.min">Min</span></dt><dd><span>{{vm.segmentField.min}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.max">Max</span></dt><dd><span>{{vm.segmentField.max}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.format">Format</span></dt><dd><span>{{vm.segmentField.format}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.pattern">Pattern</span></dt><dd><span>{{vm.segmentField.pattern}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.hidden">Hidden</span></dt><dd><span>{{vm.segmentField.hidden}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.required">Required</span></dt><dd><span>{{vm.segmentField.required}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.prefixesJson">Prefixes Json</span></dt><dd><span>{{vm.segmentField.prefixesJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.position">Position</span></dt><dd><span>{{vm.segmentField.position}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.segmentFieldOptionId">Segment Field Option Id</span></dt><dd><span>{{vm.segmentField.segmentFieldOptionId}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.createdBy">Created By</span></dt><dd><span>{{vm.segmentField.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.createdDate">Created Date</span></dt><dd><span>{{vm.segmentField.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.segmentField.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.segmentField.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.segmentField.providerSegment">Provider Segment</span></dt><dd><a ui-sref="provider-segment-detail({id:vm.segmentField.providerSegmentId})">{{vm.segmentField.providerSegmentName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="segment-field-detail.edit({id:vm.segmentField.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/segment-field/segment-field-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySegmentFieldLabel" data-translate="bozorakaAdminApp.segmentField.home.createOrEditLabel">Create or edit a Segment Field</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.segmentField.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.segmentField.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.label" for="field_label">Label</label><input type="text" class="form-control" name="label" id="field_label" ng-model="vm.segmentField.label" required ng-maxlength="150" ng-readonly="vm.segmentField.id != null"><div ng-show="editForm.label.$invalid"><p class="help-block" ng-show="editForm.label.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.label.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.segmentField.name" required ng-maxlength="150" ng-readonly="vm.segmentField.id != null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.segmentField.providerSegment" for="field_providerSegment">Provider Segment</label><select class="form-control" id="field_providerSegment" name="providerSegment" ng-model="vm.segmentField.providerSegmentId" ng-options="providerSegment.id as providerSegment.name for providerSegment in vm.providerSegments" required></select></div><div ng-show="editForm.providerSegment.$invalid"><p class="help-block" ng-show="editForm.providerSegment.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.segmentFieldOptionId" for="field_segmentFieldOptionId">Segment Field Option Id</label><input type="number" class="form-control" name="segmentFieldOptionId" id="field_segmentFieldOptionId" ng-model="vm.segmentField.segmentFieldOptionId"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.segmentField.type" id="field_type" required><option value="NUMBER" data-translate="bozorakaAdminApp.FieldType.NUMBER">NUMBER</option><option value="STRING" data-translate="bozorakaAdminApp.FieldType.STRING">STRING</option><option value="DECIMAL" data-translate="bozorakaAdminApp.FieldType.DECIMAL">DECIMAL</option><option value="BOOLEAN" data-translate="bozorakaAdminApp.FieldType.BOOLEAN">BOOLEAN</option><option value="DATE" data-translate="bozorakaAdminApp.FieldType.DATE">DATE</option><option value="OPTION" data-translate="bozorakaAdminApp.FieldType.OPTION">OPTION</option><option value="PHONE" data-translate="bozorakaAdminApp.FieldType.PHONE">PHONE</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.segmentField.value" ng-maxlength="150"><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.minLength" for="field_minLength">Min Length</label><input type="number" class="form-control" name="minLength" id="field_minLength" ng-model="vm.segmentField.minLength"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.maxLength" for="field_maxLength">Max Length</label><input type="number" class="form-control" name="maxLength" id="field_maxLength" ng-model="vm.segmentField.maxLength"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.min" for="field_min">Min</label><input type="number" class="form-control" name="min" id="field_min" ng-model="vm.segmentField.min"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.max" for="field_max">Max</label><input type="number" class="form-control" name="max" id="field_max" ng-model="vm.segmentField.max"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.format" for="field_format">Format</label><input type="text" class="form-control" name="format" id="field_format" ng-model="vm.segmentField.format" ng-maxlength="150"><div ng-show="editForm.format.$invalid"><p class="help-block" ng-show="editForm.format.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.pattern" for="field_pattern">Pattern</label><input type="text" class="form-control" name="pattern" id="field_pattern" ng-model="vm.segmentField.pattern" ng-maxlength="150"><div ng-show="editForm.pattern.$invalid"><p class="help-block" ng-show="editForm.pattern.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.hidden" for="field_hidden">Hidden</label><input type="checkbox" name="hidden" id="field_hidden" ng-model="vm.segmentField.hidden"><div ng-show="editForm.hidden.$invalid"><p class="help-block" ng-show="editForm.hidden.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.required" for="field_required">Required</label><input type="checkbox" name="required" id="field_required" ng-model="vm.segmentField.required"><div ng-show="editForm.required.$invalid"><p class="help-block" ng-show="editForm.required.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.prefixesJson" for="field_prefixesJson">Prefixes Json</label><textarea class="form-control" name="prefixesJson" id="field_prefixesJson" ng-model="vm.segmentField.prefixesJson"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.shouldDisplayName" for="field_shouldDisplayName">Should display name</label><input type="checkbox" name="shouldDisplayName" id="field_shouldDisplayName" ng-model="vm.segmentField.shouldDisplayName"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.editable" for="field_editable">Should display name</label><input type="checkbox" name="editable" id="field_editable" ng-model="vm.segmentField.editable"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.position" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.segmentField.position"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/segment-field/segment-fields.html','<div><jhi-alert></jhi-alert><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.segmentField.home.title">Segment Fields</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.fieldLabel">Label</label><input type="text" class="form-control" ng-model="vm.searchQuery.label" placeholder="{{ \'bozorakaAdminApp.segmentField.fieldLabel\' | translate}}"></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.fieldName">Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.name" placeholder="{{ \'bozorakaAdminApp.segmentField.fieldName\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.providerName">Provider Name</label><input type="text" class="form-control" ng-model="vm.searchQuery.providerName" placeholder="{{ \'bozorakaAdminApp.segmentField.providerName\' | translate}}"></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.providerSegment">Provider Segment</label><input type="text" class="form-control" ng-model="vm.searchQuery.providerSegment" placeholder="{{ \'bozorakaAdminApp.segmentField.providerSegment\' | translate}}"></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.segmentField.type">Type</label><select class="form-control" ng-model="vm.searchQuery.type"><option value class selected="selected"></option><option value="NUMBER" data-translate="bozorakaAdminApp.FieldType.NUMBER">NUMBER</option><option value="STRING" data-translate="bozorakaAdminApp.FieldType.STRING">STRING</option><option value="DECIMAL" data-translate="bozorakaAdminApp.FieldType.DECIMAL">DECIMAL</option><option value="BOOLEAN" data-translate="bozorakaAdminApp.FieldType.BOOLEAN">BOOLEAN</option><option value="DATE" data-translate="bozorakaAdminApp.FieldType.DATE">DATE</option><option value="OPTION" data-translate="bozorakaAdminApp.FieldType.OPTION">OPTION</option><option value="PHONE" data-translate="bozorakaAdminApp.FieldType.PHONE">PHONE</option></select></div></div></div><div class="pull-right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div><br></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped table-bordered table-advance table-hover text-center"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="label"><span data-translate="bozorakaAdminApp.segmentField.label">Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="bozorakaAdminApp.segmentField.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="bozorakaAdminApp.segmentField.providerName">Provider Name</span></th><th jh-sort-by="providerSegmentName"><span data-translate="bozorakaAdminApp.segmentField.providerSegment">Provider Segment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="segmentFieldOptionId"><span data-translate="bozorakaAdminApp.segmentField.segmentFieldOptionId">Segment Field Option Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="bozorakaAdminApp.segmentField.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="bozorakaAdminApp.segmentField.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="minLength"><span data-translate="bozorakaAdminApp.segmentField.minLength">Min Length</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maxLength"><span data-translate="bozorakaAdminApp.segmentField.maxLength">Max Length</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="min"><span data-translate="bozorakaAdminApp.segmentField.min">Min</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="max"><span data-translate="bozorakaAdminApp.segmentField.max">Max</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="format"><span data-translate="bozorakaAdminApp.segmentField.format">Format</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pattern"><span data-translate="bozorakaAdminApp.segmentField.pattern">Pattern</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="hidden"><span data-translate="bozorakaAdminApp.segmentField.hidden">Hidden</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="required"><span data-translate="bozorakaAdminApp.segmentField.required">Required</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prefixesJson"><span data-translate="bozorakaAdminApp.segmentField.prefixesJson">Prefixes Json</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shouldDisplayName"><span data-translate="bozorakaAdminApp.segmentField.shouldDisplayName">Should Display Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="editable"><span data-translate="bozorakaAdminApp.segmentField.editable">Editable</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span data-translate="bozorakaAdminApp.segmentField.position">Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.segmentField.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="segmentField in vm.segmentFields track by segmentField.id"><td>{{segmentField.id}}</td><td><a ui-sref="segment-field.edit({id:segmentField.id})">{{segmentField.label}}</a></td><td>{{segmentField.name}}</td><td>{{segmentField.providerName}}</td><td>{{segmentField.providerSegmentName}}</td><td>{{segmentField.segmentFieldOptionId}}</td><td data-translate="{{\'bozorakaAdminApp.FieldType.\' + segmentField.type}}">{{segmentField.type}}</td><td>{{segmentField.value}}</td><td>{{segmentField.minLength}}</td><td>{{segmentField.maxLength}}</td><td>{{segmentField.min}}</td><td>{{segmentField.max}}</td><td>{{segmentField.format}}</td><td>{{segmentField.pattern}}</td><td><h4 class="text-success" ng-if="segmentField.hidden"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!segmentField.hidden"><i class="fa fa-times"></i></h4></td><td><h4 class="text-success" ng-if="segmentField.required"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!segmentField.required"><i class="fa fa-times"></i></h4></td><td>{{segmentField.prefixesJson}}</td><td><h4 class="text-success" ng-if="segmentField.shouldDisplayName"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!segmentField.shouldDisplayName"><i class="fa fa-times"></i></h4></td><td><h4 class="text-success" ng-if="segmentField.editable"><i class="fa fa-check"></i></h4><h4 class="text-danger" ng-if="!segmentField.editable"><i class="fa fa-times"></i></h4></td><td>{{segmentField.position}}</td><td>{{segmentField.lastModifiedBy}}<br>{{segmentField.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/sms-limit/sms-limit-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.smsLimit.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.smsLimit.delete.question" translate-values="{id: \'{{vm.smsLimit.id}}\'}">Are you sure you want to delete this Sms Limit?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sms-limit/sms-limit-detail.html','<div><h2><span data-translate="bozorakaAdminApp.smsLimit.detail.title">Sms Limit</span> {{vm.smsLimit.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.smsLimit.phone">Phone</span></dt><dd><span>{{vm.smsLimit.phone}}</span></dd><dt><span data-translate="bozorakaAdminApp.smsLimit.date">Date</span></dt><dd><span>{{vm.smsLimit.date | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sms-limit-detail.edit({id:vm.smsLimit.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sms-limit/sms-limit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySmsLimitLabel" data-translate="bozorakaAdminApp.smsLimit.home.createOrEditLabel">Create or edit a Sms Limit</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.smsLimit.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.smsLimit.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.smsLimit.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.smsLimit.phone" ng-maxlength="15"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.smsLimit.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" datetime-picker="{{dateformat}}" ng-model="vm.smsLimit.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sms-limit/sms-limits.html','<div><h2 data-translate="bozorakaAdminApp.smsLimit.home.title">Sms Limits</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sms-limit.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.smsLimit.home.createLabel">Create new Sms Limit</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="bozorakaAdminApp.smsLimit.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="bozorakaAdminApp.smsLimit.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="smsLimit in vm.smsLimits track by smsLimit.id"><td><a ui-sref="sms-limit-detail({id:smsLimit.id})">{{smsLimit.id}}</a></td><td>{{smsLimit.phone}}</td><td>{{smsLimit.date | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sms-limit-detail({id:smsLimit.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sms-limit.edit({id:smsLimit.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sms-limit.delete({id:smsLimit.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/stats-daily/stats-daily.html','<jhi-alert></jhi-alert><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark col-md-10"><i class="fa fa-calendar font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.daily">DAILY STATISTICS</span></div><div class="col-md-2"><span><button class="btn btn-info mt-ladda-btn ladda-button btn-block" ng-click="vm.search()"><i class="fa fa-search"></i> Show STATISTICS</button></span></div></div><div id="paginator"></div><label></label><div class="row portlet-light bordered"><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-line-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1520">{{vm.stats.totalTransactionsCount}}</span></div><div class="desc">Successful Transactions</div><h4 class="font-yellow-lemon bold">{{vm.stats.totalTransactionsAmount | number}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-bar-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="3">{{vm.stats.largestTransactionsCount}}</span></div><div class="desc">Largest Transaction</div><h4 class="font-yellow-lemon bold">{{vm.stats.largestTransactionsAmount | number}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 blue"><div class="visual"><i class="fa fa-user-plus"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="128">{{vm.stats.newUsers}}</span></div><div class="desc">New Users</div></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 red"><div class="visual"><i class="fa fa-stack-overflow"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="12,5">{{vm.stats.failureTransactionCount}}</span></div><div class="desc">Failed transactions</div></div></a></div></div><label></label><div class="row portlet-light bordered"><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-line-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1520">{{vm.stats.transfersCount}}</span></div><div class="desc">Successful Transfers</div><h4 class="font-yellow-lemon bold">{{(vm.stats.transfersAmount / 100) | number:0}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-bar-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="3">{{vm.stats.largestTransfersCount}}</span></div><div class="desc">Largest Transfer</div><h4 class="font-yellow-lemon bold">{{(vm.stats.largestTransfersAmount / 100) | number:0}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 blue"><div class="visual"><i class="fa fa-users"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1349">{{vm.stats.activeUsers}}</span></div><div class="desc">Active Users</div></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 green-jungle"><div class="visual"><i class="fa fa-dollar"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1349">{{vm.stats.transfersProfit | number:0}}</span> <i class="fa fa-rub"></i></div><div class="desc">Transfer Profit</div></div></a></div></div><label></label><div class="portlet light bordered"><div class="portlet-title"><div class="caption"><i class="fa fa-pie-chart font-green"></i> <span class="caption-subject font-green bold uppercase">Transaction per each service</span></div></div><div class="portlet-body"><div id="piechart1" class="amcharts-pie-slice"></div></div></div><label></label><div class="row portlet-light bordered"><div class="col-lg-12"><div class="portlet light portlet-fit bordered"><div class="portlet-title"><div class="caption"><i class="fa fa-pie-chart font-green"></i> <span class="caption-subject font-green bold uppercase">Active users per OS</span></div></div><div class="portlet-body"><div id="piechart2" style="width: 100%;height: 480px"></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="portlet light portlet-fit bordered"><div class="portlet-title"><div class="caption"><i class="fa fa-pie-chart font-green"></i> <span class="caption-subject font-green bold uppercase">Transactions per time slots of the day</span></div></div><div class="portlet-body"><div id="barchart" style="width: 100%; height: 500px"></div></div></div></div></div><label></label>');
$templateCache.put('app/entities/stats-partner/stats-partner.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.reconciliation">Reconciliation</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><!--/row--><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">Select partner</label><select class="form-control" ng-model="vm.searchQuery.field"><option value class selected="selected"></option><option value="vse_platezhi">VSE PLATEZHI</option><option value="tkb">TKB</option></select></div></div><!--/span--><div class="col-md-3"><div class="form-group"><label class="control-label">Select status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value="UNKNOWN" class selected="selected">ALL</option><option value="SUCCESS">SUCCESS</option><option value="FAILURE">FAILURE</option></select></div></div><div class="col-md-6"><label class="control-label">Select period</label><div class="input-group datetime-picker input-daterange"><input id="field_fromDate" type="text" class="form-control" name="fromZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.fromZonedDate" ng-click="vm.openCalendar(\'fromZonedDate\')" is-open="vm.datePickerOpenStatus.fromZonedDate" autocomplete="off"> <span class="input-group-addon" data-translate="transaction.form.to.date">to </span><input id="field_toDate" type="text" class="form-control" name="toZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.toZonedDate" ng-click="vm.openCalendar(\'toZonedDate\')" is-open="vm.datePickerOpenStatus.toZonedDate" autocomplete="off"></div></div><!--/span--></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span data-translate="transaction.ht">HT</span></th><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="requestNo"><span data-translate="transaction.request">Request #</span> <span class="glyphicon glyphicon-sort"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th jh-sort-by="mode"><span data-translate="transaction.mode">Mode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profileAccountNo"><span data-translate="transaction.phone">Phone #</span> <span class="glyphicon glyphicon-sort"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th jh-sort-by="gateway"><span data-translate="transaction.gateway">Gateway #</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="directAmount"><span data-translate="transaction.direct">Direct</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountInSom"><span data-translate="transaction.sent">Sent</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="transaction.details">Details</span> <span class="glyphicon glyphicon-sort"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th jh-sort-by="status"><span data-translate="transaction.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="transaction.agent">Agent</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="transaction in vm.transactions track by transaction.id" class="odd gradeX text-center"><td>{{vm.dateDiff(transaction) | handledTime}}</td><td>{{transaction.id}}</td><td><span ng-switch="transaction.serviceType"><a href="javascript:;" ui-sref="order-info-detail({id:transaction.orderInfoId})" ng-switch-when="SERVICE_MARKET"><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a><a href="javascript:;" ui-sref="transaction-detail({id:transaction.id})" ng-switch-default><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a></span></td><td><transaction-mode mode="transaction.mode"></transaction-mode></td><td><a href="javascript:;" ui-sref="profile-detail({id:transaction.profileId})"><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.profilePhone | phoneNumber}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.profilePhone | phoneNumber}}</spa></a></td><td><transaction-gateway gateway="transaction.gateway"></transaction-gateway></td><td>{{vm.getDirectAmount(transaction)}}</td><td>{{vm.getSentAmount(transaction)}}</td><td>{{transaction.description}}</td><td><transaction-status status="transaction.status"></transaction-status></td><td>{{transaction.lastModifiedBy}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/stats-my-id/stats-my-id.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase">MyID Count</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">Document number</label><input type="text" class="form-control" ng-model="vm.searchQuery.documentNumber"></div></div><div class="col-md-8"><label class="control-label">Select period</label><div class="input-group datetime-picker input-daterange"><input id="field_fromDate" type="text" class="form-control" name="fromZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.fromZonedDate" ng-click="vm.openCalendar(\'fromZonedDate\')" is-open="vm.datePickerOpenStatus.fromZonedDate" autocomplete="off"> <span class="input-group-addon" data-translate="transaction.form.to.date">to </span><input id="field_toDate" type="text" class="form-control" name="toZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.toZonedDate" ng-click="vm.openCalendar(\'toZonedDate\')" is-open="vm.datePickerOpenStatus.toZonedDate" autocomplete="off"></div></div><!--/span--></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Document number</span></th><th jh-sort-by="count(myID.id)"><span>Count</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="myID in vm.myIDCount" class="odd gradeX text-center"><td>{{myID.documentNumber}} <i ng-if="myID.blocked" class="icon-ban font-red" style="font-weight: bold; margin-left: 4px"></i></td><td>{{myID.count}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" x ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/stats-periodical/stats-periodical.html','<div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark col-md-5"><i class="fa fa-calendar-o font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.periodical">PERIODICAL STATISTICS</span></div></div><div class="portlet light bg-inverse"><div class="portlet-body form"><form class="horizontal-form ng-valid ng-valid-datetime ng-dirty"><div class="form-body"><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="input-group datetime-picker input-daterange"><input id="field_fromDate" type="text" class="form-control" name="fromDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.fromDate" ng-click="vm.openCalendar(\'fromDate\')" is-open="vm.datePickerOpenStatus.fromDate" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="toDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.toDate" ng-click="vm.openCalendar(\'toDate\')" is-open="vm.datePickerOpenStatus.toDate" autocomplete="off"></div></div></div></div><div class="form-actions right"><button class="btn btn-info" ng-click="vm.search()"><i class="fa fa-search"></i> Show STATISTICS</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button></div></form></div></div><div id="paginator"></div><label></label><div class="row portlet-light bordered"><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-line-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1520">{{vm.stats.totalTransactionsCount}}</span></div><div class="desc">Successful Transactions</div><h4 class="font-yellow-lemon bold">{{vm.stats.totalTransactionsAmount | number}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-bar-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="3">{{vm.stats.largestTransactionsCount}}</span></div><div class="desc">Largest Transaction</div><h4 class="font-yellow-lemon bold">{{vm.stats.largestTransactionsAmount | number}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 blue"><div class="visual"><i class="fa fa-user-plus"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="128">{{vm.stats.newUsers}}</span></div><div class="desc">New Users</div></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 red"><div class="visual"><i class="fa fa-stack-overflow"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="12,5">{{vm.stats.failureTransactionCount}}</span></div><div class="desc">Failed transactions</div></div></a></div></div><label></label><div class="row portlet-light bordered"><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-line-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1520">{{vm.stats.transfersCount}}</span></div><div class="desc">Successful Transfers</div><h4 class="font-yellow-lemon bold">{{(vm.stats.transfersAmount / 100) | number:0}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 purple"><div class="visual"><i class="fa fa-bar-chart"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="3">{{vm.stats.largestTransfersCount}}</span></div><div class="desc">Largest Transfer</div><h4 class="font-yellow-lemon bold">{{(vm.stats.largestTransfersAmount / 100) | number:0}} <i class="fa fa-rub"></i></h4></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 blue"><div class="visual"><i class="fa fa-users"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1349">{{vm.stats.activeUsers}}</span></div><div class="desc">Active Users</div></div></a></div><div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><a class="dashboard-stat dashboard-stat-v2 green-jungle"><div class="visual"><i class="fa fa-dollar"></i></div><div class="details"><div class="number bold"><span data-counter="counterup" data-value="1349">{{vm.stats.transfersProfit | number:0}}</span> <i class="fa fa-rub"></i></div><div class="desc">Transfer Profit</div></div></a></div></div></div><div id="statsByCountry" style="min-width: 310px; height: 600px; margin: 0 auto"></div>');
$templateCache.put('app/entities/stats-profit/stats-profit.html','<jhi-alert></jhi-alert><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="fa fa-money font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.profit">Profit</span></div><div class="actions col-lg-3 col-md-3 col-sm-4"><div class="input-group date" id="datetimepicker"><input type="text" size="16" readonly="readonly" class="form-control add-on" id="week"> <span class="input-group-btn add-on"><button class="btn default date-set" type="button"><i class="fa fa-calendar"></i></button></span></div></div></div><div id="barchart" style="min-width: 310px; height: 600px; margin: 0 auto"></div></div>');
$templateCache.put('app/entities/stats-monthly-balance/stats-monthly-balance.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="statistics-monthly-balance.home.title">Monthly Balance</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="statistics-monthly-balance.form.search">ID # / Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{ \'statistics-monthly-balance.form.search\' | translate}}"></div></div><div class="col-md-3"></div><div class="col-md-8"><div class="form-group"><label class="control-label" data-translate="statistics-monthly-balance.form.date">Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon" data-translate="statistics-monthly-balance.form.to.date">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div></div><div class="row"></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form></div></div><div class="portlet-body"><div class="row"><div class="col-md-3 col-xs-12"><div class="mt-element-ribbon bg-grey-steel"><div class="ribbon ribbon-color-primary uppercase" style="margin-bottom: -10px">Payment count</div><h4 class="ribbon-content font-blue"><span data-counter="counterup" data-value="{{vm.stats.paymentCount}}">{{vm.stats.paymentCount | number}}</span> <span class="font-blue"><i class="fa fa-rub"></i></span></h4></div></div><div class="col-md-3 col-xs-12"><div class="mt-element-ribbon bg-grey-steel"><div class="ribbon ribbon-color-success uppercase" style="margin-bottom: -10px">Total Payment</div><h4 class="ribbon-content font-blue-steel"><span data-counter="counterup" data-value="{{vm.stats.totalPaymentAmount}}">{{vm.stats.totalPaymentAmount | number}}</span> <span class="font-blue"><i class="fa fa-rub"></i></span></h4></div></div><div class="col-md-3 col-xs-12"><div class="mt-element-ribbon bg-grey-steel"><div class="ribbon ribbon-color-warning uppercase" style="margin-bottom: -10px">Transfer count</div><h4 class="ribbon-content font-blue-steel"><span data-counter="counterup" data-value="{{vm.stats.transferCount}}">{{vm.stats.transferCount | number}}</span> <span class="font-blue"><i class="fa fa-rub"></i></span></h4></div></div><div class="col-md-3 col-xs-12"><div class="mt-element-ribbon bg-grey-steel"><div class="ribbon ribbon-color-danger uppercase" style="margin-bottom: -10px">Total Transfer</div><h4 class="ribbon-content font-blue-steel"><span data-counter="counterup" data-value="{{vm.stats.totalTransferAmount / 100 | number:0}}">{{vm.stats.totalTransferAmount / 100 | number:0}}</span> <span class="font-blue"><i class="fa fa-rub"></i></span></h4></div></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span data-translate="statistics-monthly-balance.ID">ID</span></th><th class="text-center"><span>Phone</span></th><th class="text-center"><span>Payments</span></th><th class="text-center"><span>Transfers</span></th></tr></thead><tbody><tr ng-repeat="statistic in vm.statistics" class="odd gradeX text-center"><td>{{statistic.profileId}}</td><td><a href="javascript:;" ui-sref="profile-detail({id:statistic.profileId})">{{statistic.phone | phoneNumber}}</a></td><td><p>{{statistic.totalPaymentAmount}} <i class="fa fa-rub"></i></p></td><td><p>{{statistic.totalTransferAmount / 100 | number:0}} <i class="fa fa-rub"></i></p></td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/stats-transfer-receiver/stats-transfer-receiver.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.transferReceiverCount">Transfer Receiver Count</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.receiverCardNumber">Receiver Card Number</label><input type="text" class="form-control" ng-model="vm.searchQuery.receiverCardNumber" placeholder="{{\'bozorakaAdminApp.tkbTransfer.receiverCardNumber\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Transfer Count</label><input type="number" class="form-control" ng-model="vm.searchQuery.count" required></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Sender Count</label><input type="number" class="form-control" ng-model="vm.searchQuery.senderCount" required></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Amount</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount" required></div></div><div class="col-md-3"><label class="control-label">Select period</label><div class="input-group datetime-picker input-daterange"><input id="field_fromDate" type="text" class="form-control" name="fromZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.fromZonedDate" ng-click="vm.openCalendar(\'fromZonedDate\')" is-open="vm.datePickerOpenStatus.fromZonedDate" autocomplete="off"> <span class="input-group-addon" data-translate="transaction.form.to.date">to </span><input id="field_toDate" type="text" class="form-control" name="toZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.toZonedDate" ng-click="vm.openCalendar(\'toZonedDate\')" is-open="vm.datePickerOpenStatus.toZonedDate" autocomplete="off"></div></div><!--/span--></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Receiver Owner</span></th><th><span>Receiver Card Number</span></th><th jh-sort-by="count(tkb.id)"><span>Transfer Count</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="count(distinct tkb.user.id)"><span>Sender Count</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sum(tkb.amountRub)"><span>Total Amount</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="transfer in vm.transferCount" class="odd gradeX text-center"><td>{{transfer.receiverOwner}}</td><td>{{transfer.receiverCardNumber}}</td><td>{{transfer.count}}</td><td>{{transfer.senderCount}}</td><td>{{transfer.totalAmount | number}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" x ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/stats-weekly/stats-weekly.html','<jhi-alert></jhi-alert><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark col-md-6"><i class="fa fa-calendar-check-o font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.weekly">WEEKLY STATISTICS</span></div><div class="col-md-3" style="padding-bottom: 8px"></div><div class="col-lg-3 col-md-3 col-sm-3"><div class="input-group date col-md-10" id="datetimepicker"><input type="text" size="16" readonly="readonly" class="form-control add-on" id="week"> <span class="input-group-btn add-on"><button class="btn default date-set" type="button"><i class="fa fa-calendar"></i></button></span></div></div></div><div id="highchart" style="min-width: 310px; height: 400px; margin: 0 auto"></div><div id="highchartTransfer" style="min-width: 310px; height: 400px; margin: 0 auto"></div></div>');
$templateCache.put('app/entities/stats-search/stats-search.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="">SEARCH RESULTS</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="">Select type</label><select class="form-control" id="searchingType" ng-model="vm.searchQuery.field"><option value="most_used">Most used</option><option value="unique">Unique</option><option value="new">New</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="">Select period</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from"> <span class="input-group-addon" data-translate="">to </span><input type="text" class="form-control" name="to"></div></div></div></div><div class="row"><div class="col-md-12 pull-right" style="padding-top: 5px"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover" id="table1"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span data-translate="">Search Query</span></th><th class="text-center"><span data-translate="">Number</span></th></tr></thead><tbody><tr ng-init="cnt=0" ng-repeat="query in vm.queries track by $index" class="odd gradeX text-center"><td>{{query.query}}</td><td><span class="badge badge-info">{{query.count}}</span></td></tr></tbody></table></div></div><!--<div class="text-center">--><!--<jhi-item-count page="vm.page" total="vm.queryCount"--><!--items-per-page="vm.itemsPerPage"></jhi-item-count>--><!--<uib-pagination class="pagination-sm" total-items="vm.totalItems"--><!--items-per-page="vm.itemsPerPage"--><!--ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>--><!--</div>--></div></div></div>');
$templateCache.put('app/entities/stats-transfer-sender/stats-transfer-sender.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="global.menu.statistics.transferSenderCount">Transfer Sender Count</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.filterForm.userPhone">User phone #</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="{{\'bozorakaAdminApp.tkbTransfer.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Count</label><input type="number" class="form-control" ng-model="vm.searchQuery.count" required></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Amount</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount" required></div></div><div class="col-md-3"><label class="control-label">Select period</label><div class="input-group datetime-picker input-daterange"><input id="field_fromDate" type="text" class="form-control" name="fromZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.fromZonedDate" ng-click="vm.openCalendar(\'fromZonedDate\')" is-open="vm.datePickerOpenStatus.fromZonedDate" autocomplete="off"> <span class="input-group-addon" data-translate="transaction.form.to.date">to </span><input id="field_toDate" type="text" class="form-control" name="toZonedDate" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.toZonedDate" ng-click="vm.openCalendar(\'toZonedDate\')" is-open="vm.datePickerOpenStatus.toZonedDate" autocomplete="off"></div></div><!--/span--></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Customer ID</span></th><th><span>Phone</span></th><th jh-sort-by="count(tkb.id)"><span>Count</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sum(tkb.amountRub)"><span>Total Amount</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="transfer in vm.transferCount" class="odd gradeX text-center"><td>{{transfer.customerId}}</td><td><a href="javascript:;" ng-click="vm.openProfile(transfer.userPhone)">{{transfer.userPhone | phoneNumber}}</a></td><td>{{transfer.count}}</td><td>{{transfer.totalAmount | number}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" x ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/tkb-card/tkb-card-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tkbCard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="bozorakaAdminApp.tkbCard.delete.question" translate-values="{id: \'{{vm.tkbCard.id}}\'}">Are you sure you want to delete this Tkb Card?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tkb-card/tkb-card-detail.html','<div><h2><span data-translate="bozorakaAdminApp.tkbCard.detail.title">Tkb Card</span> {{vm.tkbCard.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.tkbCard.orderId">Order Id</span></dt><dd><span>{{vm.tkbCard.orderId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.externalId">External Id</span></dt><dd><span>{{vm.tkbCard.externalId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.state">State</span></dt><dd><span>{{vm.tkbCard.state}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.referenceId">Reference Id</span></dt><dd><span>{{vm.tkbCard.referenceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.number">Number</span></dt><dd><span>{{vm.tkbCard.number}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.expireYear">Expire Year</span></dt><dd><span>{{vm.tkbCard.expireYear}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.expireMonth">Expire Month</span></dt><dd><span>{{vm.tkbCard.expireMonth}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.owner">Owner</span></dt><dd><span>{{vm.tkbCard.owner}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.provider">Provider</span></dt><dd><span>{{vm.tkbCard.provider}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.statusCode">Status Code</span></dt><dd><span>{{vm.tkbCard.statusCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.message">Message</span></dt><dd><span>{{vm.tkbCard.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.createdBy">Created By</span></dt><dd><span>{{vm.tkbCard.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.createdDate">Created Date</span></dt><dd><span>{{vm.tkbCard.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tkbCard.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tkbCard.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbCard.user">User</span></dt><dd><a ui-sref="customer-detail({id:vm.tkbCard.userId})">{{vm.tkbCard.userPhone}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tkb-card-detail.edit({id:vm.tkbCard.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tkb-card/tkb-card-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTkbCardLabel" data-translate="bozorakaAdminApp.tkbCard.home.createOrEditLabel">Create or edit a Tkb Card</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tkbCard.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tkbCard.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.orderId" for="field_orderId">Order Id</label><input type="number" class="form-control" name="orderId" id="field_orderId" ng-model="vm.tkbCard.orderId" required><div ng-show="editForm.orderId.$invalid"><p class="help-block" ng-show="editForm.orderId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.orderId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.externalId" for="field_externalId">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.tkbCard.externalId" required ng-maxlength="30"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.state" for="field_state">State</label><input type="number" class="form-control" name="state" id="field_state" ng-model="vm.tkbCard.state"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.referenceId" for="field_referenceId">Reference Id</label><input type="text" class="form-control" name="referenceId" id="field_referenceId" ng-model="vm.tkbCard.referenceId" ng-maxlength="10"><div ng-show="editForm.referenceId.$invalid"><p class="help-block" ng-show="editForm.referenceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.number" for="field_number">Number</label><input type="text" class="form-control" name="number" id="field_number" ng-model="vm.tkbCard.number" ng-maxlength="20"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.expireYear" for="field_expireYear">Expire Year</label><input type="text" class="form-control" name="expireYear" id="field_expireYear" ng-model="vm.tkbCard.expireYear" ng-maxlength="4"><div ng-show="editForm.expireYear.$invalid"><p class="help-block" ng-show="editForm.expireYear.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="4">This field cannot be longer than 4 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.expireMonth" for="field_expireMonth">Expire Month</label><input type="text" class="form-control" name="expireMonth" id="field_expireMonth" ng-model="vm.tkbCard.expireMonth" ng-maxlength="2"><div ng-show="editForm.expireMonth.$invalid"><p class="help-block" ng-show="editForm.expireMonth.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.owner" for="field_owner">Owner</label><input type="text" class="form-control" name="owner" id="field_owner" ng-model="vm.tkbCard.owner" ng-maxlength="30"><div ng-show="editForm.owner.$invalid"><p class="help-block" ng-show="editForm.owner.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.provider" for="field_provider">Provider</label><input type="text" class="form-control" name="provider" id="field_provider" ng-model="vm.tkbCard.provider" ng-maxlength="15"><div ng-show="editForm.provider.$invalid"><p class="help-block" ng-show="editForm.provider.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.statusCode" for="field_statusCode">Status Code</label><input type="number" class="form-control" name="statusCode" id="field_statusCode" ng-model="vm.tkbCard.statusCode"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.tkbCard.message" ng-maxlength="100"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.tkbCard.createdBy" required ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbCard.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.tkbCard.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbCard.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.tkbCard.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.tkbCard.userId" ng-options="customer.id as customer.phone for customer in vm.customers" required></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tkb-card/tkb-cards.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.tkbCard.home.title">Cards</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.userPhone">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="{{\'bozorakaAdminApp.tkbCard.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.externalId">External Id</label><input type="text" class="form-control" ng-model="vm.searchQuery.externalId" placeholder="{{\'bozorakaAdminApp.tkbCard.filterForm.externalId\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.owner">Owner</label><input type="text" class="form-control" ng-model="vm.searchQuery.owner" placeholder="{{\'bozorakaAdminApp.tkbCard.owner\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.cardNumber">Card number</label><input type="text" class="form-control" ng-model="vm.searchQuery.cardNumber" placeholder="{{\'bozorakaAdminApp.tkbCard.filterForm.cardNumber\' | translate}}"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.referenceId">Reference ID</label><input type="text" class="form-control" ng-model="vm.searchQuery.referenceId" placeholder="{{\'bozorakaAdminApp.tkbCard.referenceId\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.state">State</label><select class="form-control" ng-model="vm.searchQuery.state"><option value="-1" class selected="selected">ALL</option><option value="0">INITIATED</option><option value="1">IN PROCESS</option><option value="5">SUCCESS</option><option value="6">FAILED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value="ALL">ALL</option><option value="TKB">TKB</option><option value="PAYGINE">PAYGINE</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.date">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.referenceId">Reference ID</label><input type="text" class="form-control" ng-model="vm.referenceId" placeholder="{{\'bozorakaAdminApp.tkbCard.referenceId\' | translate}}"></div></div><div class="col-md-3" style="height: 75px; display: flex; align-items: flex-end"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteByReferenceId()" style="margin-bottom: 15px" ng-disabled="vm.referenceId === null"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userPhone"><span data-translate="bozorakaAdminApp.tkbCard.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbCard.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceId"><span data-translate="bozorakaAdminApp.tkbCard.referenceId">Reference Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.tkbCard.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span data-translate="bozorakaAdminApp.tkbCard.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provider"><span data-translate="bozorakaAdminApp.tkbCard.provider">Provider</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="state"><span data-translate="bozorakaAdminApp.tkbCard.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gateway"><span>Gateway</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbCard.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tkbCard in vm.tkbCards track by tkbCard.id"><td>{{tkbCard.id}}</td><td><a href="javascript:;" ng-click="vm.openProfile(tkbCard.userPhone)">{{tkbCard.userPhone | phoneNumber}}</a></td><td>{{tkbCard.externalId}}</td><td>{{tkbCard.referenceId}}</td><td>{{tkbCard.number}}</td><td>{{tkbCard.owner}}</td><td>{{tkbCard.provider}}</td><td><span class="label label-default" ng-if="tkbCard.state === 0">INITIATED</span> <span class="label label-info" ng-if="tkbCard.state === 1">IN PROCESS</span> <span class="label label-success" ng-if="tkbCard.state === 5">SUCCESS</span> <span class="label label-danger" ng-if="tkbCard.state === 6">FAILED</span></td><td>{{tkbCard.gateway}}</td><td>{{tkbCard.createdDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tkb-card.delete({id:tkbCard.id})" class="btn btn-danger btn-sm" ng-disabled="{{tkbCard.referenceId === null}}"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/ticket-payment/ticket-order-detail-dialog.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()"><span>&times;</span></button><h4 class="modal-title">#{{vm.selectedTicket.orderId}}</h4></div><div class="modal-body"><div class="section-header" ng-click="vm.togglePassengers()"><div class="passenger-group-title">Passengers</div><i class="fa" ng-class="vm.passengersCollapsed ? \'fa-angle-down\' : \'fa-angle-up\'"></i></div><div uib-collapse="vm.passengersCollapsed"><div class="passenger-card card-box" ng-repeat="p in vm.selectedTicket.passengers track by (p.id || $index)"><div class="passenger-card-header"><div class="passenger-title">#{{$index + 1}}</div></div><div class="passenger-card-body"><div class="row"><div class="col-md-3 info-item"><div class="info-label">Last name</div><div class="info-value">{{p.name.last}}</div></div><div class="col-md-3 info-item"><div class="info-label">First name</div><div class="info-value">{{p.name.first}}</div></div><div class="col-md-3 info-item"><div class="info-label">Middle name</div><div class="info-value">{{p.name.middle}}</div></div><div class="col-md-3 info-item"><div class="info-label">Gender</div><div class="info-value">{{p.gender || \'\u2014\'}}</div></div></div><div class="row" style="margin-top: 10px"><div class="col-md-3 info-item"><div class="info-label">Date of birth</div><div class="info-value">{{p.birthdate || \'\u2014\'}}</div></div><div class="col-md-3 info-item"><div class="info-label">Citizenship</div><div class="info-value">{{p.citizenship || \'\u2014\'}}</div></div><div class="col-md-3 info-item"><div class="info-label">Document number</div><div class="info-value">{{p.document.num}}</div></div><div class="col-md-3 info-item"><div class="info-label">Expiry date</div><div class="info-value">{{p.document.expire.substring(0, 10)}}</div></div></div></div></div><div class="text-muted text-center" ng-if="!vm.selectedTicket.passengers || !vm.selectedTicket.passengers.length">No passengers</div></div><div ng-if="vm.segmentGroups.outgoing.length"><div class="segment-group-title">Departure</div><div class="segment-card card-box" ng-repeat="seg in vm.segmentGroups.outgoing track by (seg.id || $index)"><div class="segment-top"><div class="route">{{seg.dep.airport.title}} <i class="fa fa-angle-double-right"></i> {{seg.arr.airport.title}}</div><div class="meta"><button type="button" class="btn btn-circle btn-xs btn-info" style="pointer-events: none">{{seg.carrier.title}}</button> <button type="button" class="btn btn-circle btn-xs btn-primary" style="pointer-events: none">{{seg.class.title}}</button></div></div><div class="row"><div class="col-md-2"><small>{{seg.dep.date}}</small><div>{{seg.dep.city.title}} ({{seg.dep.city.code}})</div><div class="time">{{vm.hhmm(seg.dep.time)}}</div></div><div class="col-md-1" style="margin-block: 20px"><i class="icon-plane" style="margin-left: 20px; font-size: 30px; color: #ccc; transform: rotate(20deg)"></i></div><div class="col-md-6" style="margin-block: 40px; margin-bottom: 0"><div class="flight-duration">{{vm.durationLabel(seg.duration)}}</div><div class="tt-line"></div></div><div class="col-md-1" style="margin-block: 20px"><i class="icon-plane" style="margin-right: 20px; font-size: 30px; color: #ccc; transform: rotate(70deg)"></i></div><div class="col-md-2 text-right"><small>{{seg.arr.date}}</small><div>{{seg.arr.city.title}} ({{seg.arr.city.code}})</div><div class="time">{{vm.hhmm(seg.arr.time)}}</div></div></div></div></div><div ng-if="vm.segmentGroups.return.length" style="margin-top: 14px"><div class="segment-group-title">Return</div><div class="segment-card card-box" ng-repeat="seg in vm.segmentGroups.return track by (seg.id || $index)"><div class="segment-top"><div class="route">{{seg.dep.airport.title}} <i class="fa fa-angle-double-right"></i> {{seg.arr.airport.title}}</div><div class="meta"><button type="button" class="btn btn-circle btn-xs btn-info" style="pointer-events: none">{{seg.carrier.title}}</button> <button type="button" class="btn btn-circle btn-xs btn-primary" style="pointer-events: none">{{seg.class.title}}</button></div></div><div class="row"><div class="col-md-2"><small>{{seg.dep.date}}</small><div>{{seg.dep.city.title}} ({{seg.dep.city.code}})</div><div class="time">{{vm.hhmm(seg.dep.time)}}</div></div><div class="col-md-1" style="margin-block: 20px"><i class="icon-plane" style="margin-left: 20px; font-size: 30px; color: #ccc; transform: rotate(20deg)"></i></div><div class="col-md-6" style="margin-block: 40px; margin-bottom: 0"><div class="flight-duration">{{vm.durationLabel(seg.duration)}}</div><div class="tt-line"></div></div><div class="col-md-1" style="margin-block: 20px"><i class="icon-plane" style="margin-right: 20px; font-size: 30px; color: #ccc; transform: rotate(70deg)"></i></div><div class="col-md-2 text-right"><small>{{seg.arr.date}}</small><div>{{seg.arr.city.title}} ({{seg.arr.city.code}})</div><div class="time">{{vm.hhmm(seg.arr.time)}}</div></div></div></div></div><div class="text-muted" ng-if="!vm.selectedTicket.segments || !vm.selectedTicket.segments.length">No segment data</div></div><div class="modal-footer"><button class="btn btn-default" ng-click="vm.close()">Close</button></div>');
$templateCache.put('app/entities/ticket-payment/ticket-order.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-plane font-dark"></i> <span class="caption-subject bold uppercase">My Safar Tickets</span></div></div><div class="portlet-body"><!-- FILTER FORM --><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form" ng-submit="vm.search(vm.searchQuery)"><div class="form-body"><div class="row"><!-- field --><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.userPhone">User phone #</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{ \'bozorakaAdminApp.ticketPayment.form.search\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value=""></option><option value="confirmed">Ticketed</option><option value="cancelled">Cancelled</option><option value="created">Created</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.date">Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div></div></div><div class="form-actions right"><button type="submit" class="btn green"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr><th>Order ID</th><th>Customer Phone</th><th>From</th><th>To</th><th>Provider</th><th>Flight Number</th><th>Class</th><th>Status</th><th>Amount</th><th>Code</th><th>Passengers</th><th>Ordered Date</th><th>Details</th></tr></thead><tbody><tr ng-repeat="ticket in vm.ticketPayments track by ticket.orderId"><td>{{ticket.orderId}}</td><td><a ng-click="vm.openProfile(ticket.passengers[0].phone)">{{ticket.passengers[0].phone}}</a></td><td>{{ticket.fromCity}}<br>({{ticket.fromAirport}})<br>{{ticket.depDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{ticket.toCity}}<br>({{ticket.toAirport}})<br>{{ticket.arrDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{ticket.provider}}<br>{{ticket.jetNumber}}</td><td>{{ticket.flightNumber}}<br><div><i ng-if="ticket.tripType === \'ONE_WAY\'" class="fa fa-long-arrow-right"></i> <i ng-if="ticket.tripType !== \'ONE_WAY\'" class="fa fa-exchange"></i></div></td><td>{{ticket.flightClass}}</td><td><button type="button" class="btn btn-xs green-seagreen" ng-if="ticket.status === \'Ticketed\'" style="pointer-events: none">Ticketed</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="ticket.status !== \'Ticketed\'" style="pointer-events: none">{{ticket.status}}</button></td><td>{{ticket.price | number}}</td><td>{{ticket.code}}</td><td><div ng-repeat="passenger in ticket.passengers track by passenger.id">{{passenger.name.last}} {{passenger.name.first}} {{passenger.name.middle}}<br>{{passenger.document.num}}<hr style="margin: 6px 0" ng-if="!$last"></div></td><td>{{ticket.orderedDate}}</td><td><button type="button" class="btn btn-xs btn-primary" ng-click="vm.openTicketDetails(ticket)"><i class="fa fa-eye"></i> View</button></td></tr><tr ng-if="!vm.loading && (!vm.orders || vm.orders.length === 0)"><td colspan="12" class="text-center text-muted">No data</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" max-size="7" boundary-links="true" rotate="false"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/ticket-payment/ticket-payment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketPayment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.ticketPayment.delete.question" translate-values="{id: \'{{vm.ticketPayment.id}}\'}">Are you sure you want to delete this Ticket Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket-payment/ticket-payment-detail.html','<div><h2><span data-translate="bozorakaAdminApp.ticketPayment.detail.title">Ticket Payment</span> {{vm.ticketPayment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.ticketPayment.ticketId">Ticket Id</span></dt><dd><span>{{vm.ticketPayment.ticketId}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.transactionId">Transaction Id</span></dt><dd><span>{{vm.ticketPayment.transactionId}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.fromCity">From City</span></dt><dd><span>{{vm.ticketPayment.fromCity}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.toCity">To City</span></dt><dd><span>{{vm.ticketPayment.toCity}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.departureDate">Departure Date</span></dt><dd><span>{{vm.ticketPayment.departureDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.status">Status</span></dt><dd><span>{{vm.ticketPayment.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.amount">Amount</span></dt><dd><span>{{vm.ticketPayment.amount}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.currency">Currency</span></dt><dd><span>{{vm.ticketPayment.currency}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.createdBy">Created By</span></dt><dd><span>{{vm.ticketPayment.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.createdDate">Created Date</span></dt><dd><span>{{vm.ticketPayment.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.ticketPayment.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.ticketPayment.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.ticketPayment.customer">Customer</span></dt><dd><a ui-sref="customer-detail({id:vm.ticketPayment.customerId})">{{vm.ticketPayment.customerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-payment-detail.edit({id:vm.ticketPayment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticket-payment/ticket-payment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketPaymentLabel" data-translate="bozorakaAdminApp.ticketPayment.home.createOrEditLabel">Create or edit a Ticket Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketPayment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketPayment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.ticketId" for="field_ticketId">Ticket Id</label><input type="number" class="form-control" name="ticketId" id="field_ticketId" ng-model="vm.ticketPayment.ticketId" required><div ng-show="editForm.ticketId.$invalid"><p class="help-block" ng-show="editForm.ticketId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.ticketId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.transactionId" for="field_transactionId">Transaction Id</label><input type="text" class="form-control" name="transactionId" id="field_transactionId" ng-model="vm.ticketPayment.transactionId" required><div ng-show="editForm.transactionId.$invalid"><p class="help-block" ng-show="editForm.transactionId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.fromCity" for="field_fromCity">From City</label><input type="text" class="form-control" name="fromCity" id="field_fromCity" ng-model="vm.ticketPayment.fromCity" ng-minlength="3" ng-maxlength="5"><div ng-show="editForm.fromCity.$invalid"><p class="help-block" ng-show="editForm.fromCity.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.fromCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="5">This field cannot be longer than 5 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.toCity" for="field_toCity">To City</label><input type="text" class="form-control" name="toCity" id="field_toCity" ng-model="vm.ticketPayment.toCity" ng-minlength="3" ng-maxlength="5"><div ng-show="editForm.toCity.$invalid"><p class="help-block" ng-show="editForm.toCity.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.toCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="5">This field cannot be longer than 5 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.departureDate" for="field_departureDate">Departure Date</label><div class="input-group"><input id="field_departureDate" type="text" class="form-control" name="departureDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketPayment.departureDate" is-open="vm.datePickerOpenStatus.departureDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'departureDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.ticketPayment.status" required><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.ticketPayment.amount" required><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.currency" for="field_currency">Currency</label><input type="text" class="form-control" name="currency" id="field_currency" ng-model="vm.ticketPayment.currency" required ng-maxlength="3"><div ng-show="editForm.currency.$invalid"><p class="help-block" ng-show="editForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.currency.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.ticketPayment.createdBy" ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketPayment.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.ticketPayment.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketPayment.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.ticketPayment.customer" for="field_customer">Customer</label><select class="form-control" id="field_customer" name="customer" ng-model="vm.ticketPayment.customerId" ng-options="customer.id as customer.id for customer in vm.customers"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket-payment/ticket-payments.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-refresh font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.ticketPayment.home.title">Ticket Payments</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.userPhone">User phone #</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{ \'bozorakaAdminApp.ticketPayment.form.search\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="PAID">PAID</option><option value="UNPAID">UNPAID</option></select></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.ticketPayment.filterForm.date">Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div></div></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticketId"><span data-translate="bozorakaAdminApp.ticketPayment.ticketId">Ticket Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="transactionId"><span data-translate="bozorakaAdminApp.ticketPayment.transactionId">Transaction Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fromCity"><span data-translate="bozorakaAdminApp.ticketPayment.fromCity">From City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="toCity"><span data-translate="bozorakaAdminApp.ticketPayment.toCity">To City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="departureDate"><span data-translate="bozorakaAdminApp.ticketPayment.departureDate">Departure Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="departureDate"><span data-translate="bozorakaAdminApp.ticketPayment.returnDate">Departure Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.ticketPayment.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="bozorakaAdminApp.ticketPayment.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currency"><span data-translate="bozorakaAdminApp.ticketPayment.currency">Currency</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currency"><span data-translate="bozorakaAdminApp.ticketPayment.tripType">Trip Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdBy"><span data-translate="bozorakaAdminApp.ticketPayment.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="bozorakaAdminApp.ticketPayment.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="ticketPayment in vm.ticketPayments track by ticketPayment.id"><td><a ui-sref="ticket-payment-detail({id:ticketPayment.id})">{{ticketPayment.id}}</a></td><td>{{ticketPayment.ticketId}}</td><td>{{ticketPayment.transactionId}}</td><td>{{ticketPayment.fromCity}}</td><td>{{ticketPayment.toCity}}</td><td>{{ticketPayment.departureDate | date:\'medium\'}}</td><td>{{ticketPayment.returnDate | date:\'medium\'}}</td><td><button type="button" class="btn btn-xs green-seagreen" ng-if="ticketPayment.status == \'PAID\'" style="pointer-events: none">{{ticketPayment.status}}</button> <button type="button" class="btn btn-xs yellow-gold" ng-if="ticketPayment.status != \'PAID\'" style="pointer-events: none">{{ticketPayment.status}}</button></td><td>{{ticketPayment.amount | number}}</td><td>{{ticketPayment.currency}}</td><td>{{ticketPayment.tripType}}</td><td>{{ticketPayment.createdBy}}<br>{{ticketPayment.createdDate | date:\'medium\'}}</td><td>{{ticketPayment.lastModifiedBy}}<br>{{ticketPayment.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/tkb-transfer/tkb-transfer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tkbTransfer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.tkbTransfer.delete.question" translate-values="{id: \'{{vm.tkbTransfer.id}}\'}">Are you sure you want to delete this Tkb Transfer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tkb-transfer/tkb-transfer-detail.html','<div><h2><span data-translate="bozorakaAdminApp.tkbTransfer.detail.title">Tkb Transfer</span> {{vm.tkbTransfer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.tkbTransfer.orderId">Order Id</span></dt><dd><span>{{vm.tkbTransfer.orderId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.externalId">External Id</span></dt><dd><span>{{vm.tkbTransfer.externalId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.referenceId">Reference Id</span></dt><dd><span>{{vm.tkbTransfer.referenceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.type">Type</span></dt><dd><span>{{vm.tkbTransfer.type}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.senderOwner">Sender Owner</span></dt><dd><span>{{vm.tkbTransfer.senderOwner}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.senderCardNumber">Sender Card Number</span></dt><dd><span>{{vm.tkbTransfer.senderCardNumber}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.receiverCardNumber">Receiver Card Number</span></dt><dd><span>{{vm.tkbTransfer.receiverCardNumber}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.amountRub">Amount Rub</span></dt><dd><span>{{vm.tkbTransfer.amountRub}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.amountUzs">Amount Uzs</span></dt><dd><span>{{vm.tkbTransfer.amountUzs}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.rate">Rate</span></dt><dd><span>{{vm.tkbTransfer.rate}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.tkbCommissionAmount">Tkb Commission Amount</span></dt><dd><span>{{vm.tkbTransfer.tkbCommissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.ubCommissionAmount">Ub Commission Amount</span></dt><dd><span>{{vm.tkbTransfer.ubCommissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.spCommissionAmount">Sp Commission Amount</span></dt><dd><span>{{vm.tkbTransfer.spCommissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.tkbCommissionRate">Tkb Commission Rate</span></dt><dd><span>{{vm.tkbTransfer.tkbCommissionRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.ubCommissionRate">Ub Commission Rate</span></dt><dd><span>{{vm.tkbTransfer.ubCommissionRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.spCommissionRate">Sp Commission Rate</span></dt><dd><span>{{vm.tkbTransfer.spCommissionRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.state">State</span></dt><dd><span>{{vm.tkbTransfer.state}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.statusCode">Status Code</span></dt><dd><span>{{vm.tkbTransfer.statusCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.message">Message</span></dt><dd><span>{{vm.tkbTransfer.message}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.createdBy">Created By</span></dt><dd><span>{{vm.tkbTransfer.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.createdDate">Created Date</span></dt><dd><span>{{vm.tkbTransfer.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tkbTransfer.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tkbTransfer.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbTransfer.user">User</span></dt><dd><a ui-sref="customer-detail({id:vm.tkbTransfer.userId})">{{vm.tkbTransfer.userPhone}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tkb-transfer-detail.edit({id:vm.tkbTransfer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tkb-transfer/tkb-transfer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTkbTransferLabel" data-translate="bozorakaAdminApp.tkbTransfer.home.createOrEditLabel">Create or edit a Tkb Transfer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tkbTransfer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tkbTransfer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.orderId" for="field_orderId">Order Id</label><input type="number" class="form-control" name="orderId" id="field_orderId" ng-model="vm.tkbTransfer.orderId" required><div ng-show="editForm.orderId.$invalid"><p class="help-block" ng-show="editForm.orderId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.orderId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.externalId" for="field_externalId">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.tkbTransfer.externalId" required ng-maxlength="30"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.referenceId" for="field_referenceId">Reference Id</label><input type="text" class="form-control" name="referenceId" id="field_referenceId" ng-model="vm.tkbTransfer.referenceId" required ng-maxlength="10"><div ng-show="editForm.referenceId.$invalid"><p class="help-block" ng-show="editForm.referenceId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.referenceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.tkbTransfer.type" required ng-maxlength="10"><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.type.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.senderOwner" for="field_senderOwner">Sender Owner</label><input type="text" class="form-control" name="senderOwner" id="field_senderOwner" ng-model="vm.tkbTransfer.senderOwner" required ng-maxlength="30"><div ng-show="editForm.senderOwner.$invalid"><p class="help-block" ng-show="editForm.senderOwner.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.senderOwner.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.senderCardNumber" for="field_senderCardNumber">Sender Card Number</label><input type="text" class="form-control" name="senderCardNumber" id="field_senderCardNumber" ng-model="vm.tkbTransfer.senderCardNumber" required ng-maxlength="20"><div ng-show="editForm.senderCardNumber.$invalid"><p class="help-block" ng-show="editForm.senderCardNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.senderCardNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.receiverCardNumber" for="field_receiverCardNumber">Receiver Card Number</label><input type="text" class="form-control" name="receiverCardNumber" id="field_receiverCardNumber" ng-model="vm.tkbTransfer.receiverCardNumber" required ng-maxlength="16"><div ng-show="editForm.receiverCardNumber.$invalid"><p class="help-block" ng-show="editForm.receiverCardNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.receiverCardNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.amountRub" for="field_amountRub">Amount Rub</label><input type="number" class="form-control" name="amountRub" id="field_amountRub" ng-model="vm.tkbTransfer.amountRub" required min="0"><div ng-show="editForm.amountRub.$invalid"><p class="help-block" ng-show="editForm.amountRub.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amountRub.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amountRub.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.amountUzs" for="field_amountUzs">Amount Uzs</label><input type="number" class="form-control" name="amountUzs" id="field_amountUzs" ng-model="vm.tkbTransfer.amountUzs" required min="0"><div ng-show="editForm.amountUzs.$invalid"><p class="help-block" ng-show="editForm.amountUzs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amountUzs.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amountUzs.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.rate" for="field_rate">Rate</label><input type="number" class="form-control" name="rate" id="field_rate" ng-model="vm.tkbTransfer.rate" required><div ng-show="editForm.rate.$invalid"><p class="help-block" ng-show="editForm.rate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.rate.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.tkbCommissionAmount" for="field_tkbCommissionAmount">Tkb Commission Amount</label><input type="number" class="form-control" name="tkbCommissionAmount" id="field_tkbCommissionAmount" ng-model="vm.tkbTransfer.tkbCommissionAmount"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.ubCommissionAmount" for="field_ubCommissionAmount">Ub Commission Amount</label><input type="number" class="form-control" name="ubCommissionAmount" id="field_ubCommissionAmount" ng-model="vm.tkbTransfer.ubCommissionAmount"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.spCommissionAmount" for="field_spCommissionAmount">Sp Commission Amount</label><input type="number" class="form-control" name="spCommissionAmount" id="field_spCommissionAmount" ng-model="vm.tkbTransfer.spCommissionAmount"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.tkbCommissionRate" for="field_tkbCommissionRate">Tkb Commission Rate</label><input type="number" class="form-control" name="tkbCommissionRate" id="field_tkbCommissionRate" ng-model="vm.tkbTransfer.tkbCommissionRate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.ubCommissionRate" for="field_ubCommissionRate">Ub Commission Rate</label><input type="number" class="form-control" name="ubCommissionRate" id="field_ubCommissionRate" ng-model="vm.tkbTransfer.ubCommissionRate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.spCommissionRate" for="field_spCommissionRate">Sp Commission Rate</label><input type="number" class="form-control" name="spCommissionRate" id="field_spCommissionRate" ng-model="vm.tkbTransfer.spCommissionRate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.state" for="field_state">State</label><input type="number" class="form-control" name="state" id="field_state" ng-model="vm.tkbTransfer.state"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.statusCode" for="field_statusCode">Status Code</label><input type="number" class="form-control" name="statusCode" id="field_statusCode" ng-model="vm.tkbTransfer.statusCode"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.tkbTransfer.message" ng-maxlength="100"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.tkbTransfer.createdBy" required ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbTransfer.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.tkbTransfer.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbTransfer.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.tkbTransfer.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.tkbTransfer.userId" ng-options="customer.id as customer.phone for customer in vm.customers" required></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tkb-transfer/tkb-transfer-info-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button></div><div class="modal-body"><div class="sender-info-title" ng-if="vm.payment.senderCardNumber || vm.myID"><img ng-src="content/images/icon-info.png" alt="Photo" style="margin-bottom: 3px; width: 25px"> <span>Sender info</span></div><div class="card-container"><div class="credit-card" ng-if="vm.payment.senderCardNumber"><div class="bank-name">{{vm.payment.senderCardBank}}</div><div class="contactless">{{vm.payment.senderCardProvider}}</div><div class="chip"></div><div class="card-number"><span class="number-text">{{vm.payment.senderCardNumber}}</span> <a href="javascript:;" class="mt-clipboard" data-clipboard-text="{{vm.payment.senderCardNumber}}" title="Copy card number"><i class="fa fa-clone" style="font-size: 10px; color: white"></i></a></div><div class="card-info"><div><div>EXPIRE DATE</div><div>{{vm.payment.senderCardExpire}}</div></div></div><div class="cardholder-name"><span>{{vm.payment.senderOwner}}</span> <a href="javascript:;" class="mt-clipboard" data-clipboard-text="{{vm.payment.senderOwner}}" title="Copy card owner"><i class="fa fa-clone" style="font-size: 10px; color: white"></i></a></div></div><div class="id-card"><div class="header"><div ng-if="vm.myID" class="header-left"><div><div style="font-weight: 600">O\u02BBZBEKISTON RESPUBLIKASI</div><div class="id-card-title">SHAXS GUVOHNOMASI</div></div></div><div ng-if="!vm.myID" class="header-left"><div><div style="font-size: 15px; font-weight: 700; margin: 5px 0; color: #ff0505"><i class="fa fa-exclamation-circle"></i> UNVERIFIED CUSTOMER</div></div></div><div ng-if="vm.myID" class="uz-circle">UZ</div><div ng-if="!vm.myID" class="uz-circle"><i class="fa fa-info"></i></div></div><div class="sender-info"><div class="photo"><img ng-src="content/images/avatar_profile.png" alt="Photo"></div><div class="id-card-details" ng-if="vm.myID"><div class="row"><div class="col-md-6"><div>Surname</div><div><strong>{{vm.myID.firstName}}</strong></div></div></div><div class="row"><div class="col-md-6"><div>Name</div><div><strong>{{vm.myID.lastName}}</strong></div></div></div><div class="row"><div class="col-md-6"><div>Second name</div><div><strong>{{vm.myID.middleName}}</strong></div></div><div class="col-md-6" style="text-align: right"><div>Birth place</div><div><strong>{{vm.myID.birthPlace}}</strong></div></div></div><div class="row"><div class="col-md-6"><div>Birth date</div><div><strong>{{vm.myID.birthDate | date:\'yyyy-MM-dd\'}}</strong></div></div><div class="col-md-6" style="text-align: right"><div>Gender</div><div><strong>{{vm.myID.gender}}</strong></div></div></div><div class="row"><div class="col-md-6"><div>Date of issue</div><div><strong>{{vm.myID.issuedDate | date:\'yyyy-MM-dd\'}}</strong></div></div><div class="col-md-6" style="text-align: right"><div>Document number</div><div><strong>{{vm.myID.documentNumber}}</strong> <a href="javascript:;" class="mt-clipboard" data-clipboard-text="{{vm.myID.documentNumber}}" title="Copy card owner"><i class="fa fa-clone" style="font-size: 10px"></i></a></div></div></div><div class="row"><div class="col-md-6"><div>Date of expiry</div><div><strong>{{vm.myID.expiryDate | date:\'yyyy-MM-dd\'}}</strong></div></div><div class="col-md-6" style="text-align: right"><div>PINFL</div><div><strong>{{vm.myID.pinfl}}</strong> <a href="javascript:;" class="mt-clipboard" data-clipboard-text="{{vm.myID.pinfl}}" title="Copy card owner"><i class="fa fa-clone" style="font-size: 10px"></i></a></div></div></div></div><div class="customer-infos" ng-if="!vm.myID"><div class="row" style="margin-top: 5px"><div ng-if="vm.customer.fullName" class="col-md-12"><div>Full name</div><div><strong>{{vm.customer.fullName}}</strong></div></div></div><div class="row" style="margin-top: 5px"><div ng-if="vm.customer.dateOfBirth" class="col-md-12"><div>Birth date</div><div><strong>{{vm.customer.dateOfBirth | date:\'yyyy-MM-dd\'}}</strong></div></div></div><div class="row" style="margin-top: 5px"><div ng-if="vm.customer.passportNumber" class="col-md-12"><div>Passport number</div><div><strong>{{vm.customer.passportNumber}}</strong></div></div></div><div class="row" style="margin-top: 5px"><div ng-if="vm.customer.nationality" class="col-md-12"><div>Nationality</div><div><strong>{{vm.customer.nationality}}</strong></div></div></div></div></div></div></div><div class="device-info"><div style="color: #337ab7; font-size: 1.3em; font-weight: 700; margin-bottom: 10px"><img ng-src="content/images/icon-info.png" alt="Photo" style="margin-bottom: 3px; width: 25px"> <span>Device info</span></div><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><tbody class="row"><tr><td style="text-align: right"><i class="fa fa-mobile"></i><label class="control-label" style="text-align: right; margin-left: 3px">App version name:</label></td><td style="text-align: left"><strong>{{vm.payment.appVersionName}}&nbsp;</strong></td></tr><tr><td style="text-align: right"><i class="fa fa-map-marker"></i><label class="control-label" style="text-align: left; margin-left: 3px">IP address:</label></td><td style="text-align: left"><strong>{{vm.payment.ipAddress}}</strong></td></tr><tr><td style="text-align: right"><i class="fa fa-laptop"></i><label class="control-label" style="text-align: left; margin-left: 3px">Device name:</label></td><td style="text-align: left"><strong>{{vm.payment.deviceName}}</strong></td></tr><tr><td style="text-align: right"><i class="fa fa-microchip"></i><label class="control-label" style="text-align: left; margin-left: 3px">Device OS:</label></td><td style="text-align: left"><strong>{{vm.payment.deviceOS}}</strong></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span data-translate="entity.action.close">Close</span></button></div></div>');
$templateCache.put('app/entities/tkb-transfer/tkb-transfers.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-refresh font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.tkbTransfer.home.title">Transfers</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.filterForm.userPhone">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="{{\'bozorakaAdminApp.tkbTransfer.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.filterForm.externalId">External ID</label><input type="text" class="form-control" ng-model="vm.searchQuery.externalId" placeholder="{{\'bozorakaAdminApp.tkbTransfer.filterForm.externalId\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.filterForm.amount">Amount</label><input type="text" class="form-control" ng-model="vm.searchQuery.amount" placeholder="{{\'bozorakaAdminApp.tkbTransfer.filterForm.amount\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.receiverOwner">Receiver Owner</label><input type="text" class="form-control" ng-model="vm.searchQuery.receiverOwner" placeholder="{{\'bozorakaAdminApp.tkbTransfer.receiverOwner\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.receiverCardNumber">Receiver Card number</label><input type="text" class="form-control" ng-model="vm.searchQuery.receiverCardNumber" placeholder="{{\'bozorakaAdminApp.tkbTransfer.receiverCardNumber\' | translate}}"></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.debitState">Debit State</label><select class="form-control" ng-model="vm.searchQuery.state"><option value="-1" class selected="selected"></option><option value="0">INITIATED</option><option value="3">SUCCESS</option><option value="-2">FAILED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.creditState">Credit State</label><select class="form-control" ng-model="vm.searchQuery.creditState"><option value="-1" class selected="selected"></option><option value="0">CREATED</option><option value="4">SUCCESS</option><option value="-2">FAILED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.gateway">Gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value="ALL">ALL</option><option value="TKB">TKB</option><option value="MTS">MTS</option><option value="PAYGINE">PAYGINE</option><option value="SBP">SBP</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.currency">Currency</label><select class="form-control" ng-model="vm.searchQuery.currency"><option value class selected="selected"></option><option value="UZS">UZS</option><option value="USD">USD</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbTransfer.filterForm.date">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th rowspan="2" jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbTransfer.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="userPhone" style="min-width: 150px"><span data-translate="bozorakaAdminApp.tkbTransfer.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbTransfer.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span data-translate="bozorakaAdminApp.tkbTransfer.gateway">Gateway</span></th><th rowspan="2" jh-sort-by="receiverOwner"><span data-translate="bozorakaAdminApp.tkbTransfer.receiver">Receiver</span> <span class="glyphicon glyphicon-sort"></span></th><th colspan="2">Amount</th><th rowspan="2" jh-sort-by="rate" style="white-space: normal"><span data-translate="bozorakaAdminApp.tkbTransfer.rate">Rate</span> <span class="glyphicon glyphicon-sort"></span></th><th colspan="3">Commission</th><th colspan="2">State</th><th rowspan="2"><span>Check</span></th><th rowspan="2"><span>Confirm</span></th><th rowspan="2"></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th rowspan="2" jh-sort-by="amountRub">RUB <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="amountUzs">UZS/USD <span class="glyphicon glyphicon-sort"></span></th><th>Bank</th><th>SP</th><th>Total</th><th rowspan="2"><span>Debit</span></th><th rowspan="2"><span>Credit</span></th></tr></thead><tbody><tr ng-repeat="tkbTransfer in vm.tkbTransfers track by tkbTransfer.id"><td>{{tkbTransfer.createdDate | date:\'medium\'}}</td><td><a href="javascript:;" style="display: flex; align-items: center; justify-content: center; text-wrap: nowrap" ng-click="vm.openProfile(tkbTransfer.userPhone)">{{tkbTransfer.userPhone | phoneNumber}} <img ng-if="tkbTransfer.customerVerified" src="/content/images/blue-tick.png" style="margin-left: 3px" width="16" height="16"> &nbsp; <i ng-if="tkbTransfer.userStatus !== \'ACTIVE\'" class="icon-ban font-red" style="font-weight: bold"></i></a></td><td id="mt{{tkbTransfer.externalId}}" id="copyAhref" style="width: 200px"><a href="javascript:;" class="green mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbTransfer.externalId}}" title="You can copy External ID">{{tkbTransfer.externalId}}</a></td><td><div><span class="btn btn-xs bg-green-seagreen bg-font-green-seagreen" ng-if="tkbTransfer.merchant === \'APEXTECH\'">APEXTECH</span> <span class="btn purple-sharp btn-xs" ng-if="tkbTransfer.merchant === \'GLOBIZ\'">GLOBIZ</span></div><div style="margin-top: 5px"><span>{{tkbTransfer.gateway}}</span></div></td><td><div><span>{{tkbTransfer.receiverOwner}}</span></div><div id="mt{{tkbTransfer.receiverCardNumber}}" id="copyAhref"><a href="javascript:;" class="green mt-clipboard" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbTransfer.receiverCardNumber}}" title="You can copy card number"><span>{{tkbTransfer.receiverCardNumber}}</span></a></div></td><td>{{((tkbTransfer.amountRub) / 100) | number}}</td><td>{{(tkbTransfer.amountUzs / 100) | number}} {{tkbTransfer.currency}}</td><td>{{tkbTransfer.rate}}</td><td>{{(tkbTransfer.bankFixedCommission + tkbTransfer.bankVariableCommission) | number:2}}</td><td>{{(tkbTransfer.spFixedCommission + tkbTransfer.spVariableCommission) | number:2}}</td><td>{{tkbTransfer.commissionAmount / 100 | number:2}}</td><td><div data-toggle="popover" id="{{tkbTransfer.id}}" ng-click="vm.initPopover($event, tkbTransfer)"><span class="label label-default" ng-if="tkbTransfer.state === 0" style="cursor: pointer">INITIATED </span><span class="label label-success" ng-if="tkbTransfer.state === 3" style="cursor: pointer">SUCCESS </span><span class="label label-danger" ng-if="tkbTransfer.state !== 0 && tkbTransfer.state !== 3" style="cursor: pointer">FAILED:{{tkbTransfer.state}}</span></div></td><td><div data-toggle="popover" id="{{tkbTransfer.id}}-credit" ng-click="vm.initCreditPopover($event, tkbTransfer)"><span class="label label-default" ng-if="tkbTransfer.creditState === 0">CREATED </span><span class="label label-success" ng-if="tkbTransfer.creditState === 4">SUCCESS </span><span class="label label-danger" ng-if="tkbTransfer.creditState !== 0 && tkbTransfer.creditState !== 4">FAILED:{{tkbTransfer.creditState}}</span></div></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.getTransferState(tkbTransfer.externalId)" ng-disabled="tkbTransfer.externalId === null || vm.checkList[tkbTransfer.externalId] === true"><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down" data-translate="entity.action.check"></span></button></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.confirmTransfer(tkbTransfer.externalId)" ng-disabled="vm.checkList[tkbTransfer.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down">Confirm</span></button></td><td><img ng-click="vm.openTransferInfo(tkbTransfer.id)" ng-src="content/images/icon-info.png" alt="Photo" style="width: 20px"></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/tkb-payment/tkb-payment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tkbPayment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.tkbPayment.delete.question" translate-values="{id: \'{{vm.tkbPayment.id}}\'}">Are you sure you want to delete this Tkb Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tkb-payment/tkb-payment-detail.html','<div><h2><span data-translate="bozorakaAdminApp.tkbPayment.detail.title">Tkb Payment</span> {{vm.tkbPayment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.tkbPayment.serviceId">Service Id</span></dt><dd><span>{{vm.tkbPayment.serviceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.orderId">Order Id</span></dt><dd><span>{{vm.tkbPayment.orderId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.externalId">External Id</span></dt><dd><span>{{vm.tkbPayment.externalId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.referenceId">Reference Id</span></dt><dd><span>{{vm.tkbPayment.referenceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.account">Account</span></dt><dd><span>{{vm.tkbPayment.account}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.senderOwner">Sender Owner</span></dt><dd><span>{{vm.tkbPayment.senderOwner}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.senderCardNumber">Sender Card Number</span></dt><dd><span>{{vm.tkbPayment.senderCardNumber}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.amount">Amount</span></dt><dd><span>{{vm.tkbPayment.amount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.commissionAmount">Commission Amount</span></dt><dd><span>{{vm.tkbPayment.commissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.amountUzs">Amount Uzs</span></dt><dd><span>{{vm.tkbPayment.amountUzs}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.ubCommissionAmount">Ub Commission Amount</span></dt><dd><span>{{vm.tkbPayment.ubCommissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.spCommissionAmount">Sp Commission Amount</span></dt><dd><span>{{vm.tkbPayment.spCommissionAmount}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.fieldJson">Field Json</span></dt><dd><span>{{vm.tkbPayment.fieldJson}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.state">State</span></dt><dd><span>{{vm.tkbPayment.state}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.errorCode">Error Code</span></dt><dd><span>{{vm.tkbPayment.errorCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.errorMessage">Error Message</span></dt><dd><span>{{vm.tkbPayment.errorMessage}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.createdBy">Created By</span></dt><dd><span>{{vm.tkbPayment.createdBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.createdDate">Created Date</span></dt><dd><span>{{vm.tkbPayment.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tkbPayment.lastModifiedBy}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tkbPayment.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.user">User</span></dt><dd><a ui-sref="customer-detail({id:vm.tkbPayment.userId})">{{vm.tkbPayment.userPhone}}</a></dd><dt><span data-translate="bozorakaAdminApp.tkbPayment.transaction">Transaction</span></dt><dd><a ui-sref="transaction-detail({id:vm.tkbPayment.transactionId})">{{vm.tkbPayment.transactionId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tkb-payment-detail.edit({id:vm.tkbPayment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tkb-payment/tkb-payment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTkbPaymentLabel" data-translate="bozorakaAdminApp.tkbPayment.home.createOrEditLabel">Create or edit a Tkb Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tkbPayment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tkbPayment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.tkbPayment.serviceId" required ng-maxlength="32"><div ng-show="editForm.serviceId.$invalid"><p class="help-block" ng-show="editForm.serviceId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.serviceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.orderId" for="field_orderId">Order Id</label><input type="number" class="form-control" name="orderId" id="field_orderId" ng-model="vm.tkbPayment.orderId" required><div ng-show="editForm.orderId.$invalid"><p class="help-block" ng-show="editForm.orderId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.orderId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.externalId" for="field_externalId">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.tkbPayment.externalId" required ng-maxlength="30"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.referenceId" for="field_referenceId">Reference Id</label><input type="text" class="form-control" name="referenceId" id="field_referenceId" ng-model="vm.tkbPayment.referenceId" required ng-maxlength="10"><div ng-show="editForm.referenceId.$invalid"><p class="help-block" ng-show="editForm.referenceId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.referenceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.account" for="field_account">Account</label><input type="text" class="form-control" name="account" id="field_account" ng-model="vm.tkbPayment.account" required ng-maxlength="32"><div ng-show="editForm.account.$invalid"><p class="help-block" ng-show="editForm.account.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.account.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.senderOwner" for="field_senderOwner">Sender Owner</label><input type="text" class="form-control" name="senderOwner" id="field_senderOwner" ng-model="vm.tkbPayment.senderOwner" required ng-maxlength="30"><div ng-show="editForm.senderOwner.$invalid"><p class="help-block" ng-show="editForm.senderOwner.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.senderOwner.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.senderCardNumber" for="field_senderCardNumber">Sender Card Number</label><input type="text" class="form-control" name="senderCardNumber" id="field_senderCardNumber" ng-model="vm.tkbPayment.senderCardNumber" required ng-maxlength="20"><div ng-show="editForm.senderCardNumber.$invalid"><p class="help-block" ng-show="editForm.senderCardNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.senderCardNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.tkbPayment.amount" required min="0"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.commissionAmount" for="field_commissionAmount">Commission Amount</label><input type="number" class="form-control" name="commissionAmount" id="field_commissionAmount" ng-model="vm.tkbPayment.commissionAmount" required min="0"><div ng-show="editForm.commissionAmount.$invalid"><p class="help-block" ng-show="editForm.commissionAmount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.commissionAmount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.commissionAmount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.amountUzs" for="field_amountUzs">Amount Uzs</label><input type="number" class="form-control" name="amountUzs" id="field_amountUzs" ng-model="vm.tkbPayment.amountUzs" required min="0"><div ng-show="editForm.amountUzs.$invalid"><p class="help-block" ng-show="editForm.amountUzs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amountUzs.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amountUzs.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.ubCommissionAmount" for="field_ubCommissionAmount">Ub Commission Amount</label><input type="number" class="form-control" name="ubCommissionAmount" id="field_ubCommissionAmount" ng-model="vm.tkbPayment.ubCommissionAmount" required><div ng-show="editForm.ubCommissionAmount.$invalid"><p class="help-block" ng-show="editForm.ubCommissionAmount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.ubCommissionAmount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.spCommissionAmount" for="field_spCommissionAmount">Sp Commission Amount</label><input type="number" class="form-control" name="spCommissionAmount" id="field_spCommissionAmount" ng-model="vm.tkbPayment.spCommissionAmount" required><div ng-show="editForm.spCommissionAmount.$invalid"><p class="help-block" ng-show="editForm.spCommissionAmount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.spCommissionAmount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.fieldJson" for="field_fieldJson">Field Json</label><textarea class="form-control" name="fieldJson" id="field_fieldJson" ng-model="vm.tkbPayment.fieldJson"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.state" for="field_state">State</label><input type="number" class="form-control" name="state" id="field_state" ng-model="vm.tkbPayment.state"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.errorCode" for="field_errorCode">Error Code</label><input type="number" class="form-control" name="errorCode" id="field_errorCode" ng-model="vm.tkbPayment.errorCode"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.errorMessage" for="field_errorMessage">Error Message</label><input type="text" class="form-control" name="errorMessage" id="field_errorMessage" ng-model="vm.tkbPayment.errorMessage" ng-maxlength="100"><div ng-show="editForm.errorMessage.$invalid"><p class="help-block" ng-show="editForm.errorMessage.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.tkbPayment.createdBy" required ng-maxlength="50"><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createdBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbPayment.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.lastModifiedBy" for="field_lastModifiedBy">Last Modified By</label><input type="text" class="form-control" name="lastModifiedBy" id="field_lastModifiedBy" ng-model="vm.tkbPayment.lastModifiedBy" ng-maxlength="50"><div ng-show="editForm.lastModifiedBy.$invalid"><p class="help-block" ng-show="editForm.lastModifiedBy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.lastModifiedDate" for="field_lastModifiedDate">Last Modified Date</label><div class="input-group"><input id="field_lastModifiedDate" type="text" class="form-control" name="lastModifiedDate" datetime-picker="{{dateformat}}" ng-model="vm.tkbPayment.lastModifiedDate" is-open="vm.datePickerOpenStatus.lastModifiedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastModifiedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.tkbPayment.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.tkbPayment.userId" ng-options="customer.id as customer.phone for customer in vm.customers" required></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="bozorakaAdminApp.tkbPayment.transaction" for="field_transaction">Transaction</label><select class="form-control" id="field_transaction" name="transaction" ng-model="vm.tkbPayment.transactionId" ng-options="transaction.id as transaction.id for transaction in vm.transactions" required></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tkb-payment/tkb-payment-info-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Payment details</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Date:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.createdDate | date:\'yyyyMMdd\'}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Account:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.account}}</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Phone:</strong></label><div class="col-md-9"><p class="form-control-static"><a href="javascript:;" ui-sref="profile-detail({id:vm.payment.userId})">{{vm.payment.userPhone | phoneNumber}}</a></p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Gateway:</strong></label><div class="col-md-9"><p class="form-control-static"><button type="button" class="btn btn-xs yellow-casablanca" style="pointer-events: none">{{vm.payment.gateway}}</button></p></div></div></div><!--/span--></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Sent amount:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.amount | number}} {{vm.payment.selectedCurrency}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Commission amount:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.commissionAmount | number}} {{vm.payment.selectedCurrency}}</p></div></div></div><!--/span--></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Details:</strong></label><div class="col-md-6"><div class="note note-success text-center" style="padding: 0px 5px 0px 5px"><h4 class="block text-info"><strong>{{vm.payment.description}}</strong></h4></div></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Receiver amount:</strong></label><div class="col-md-6"><div class="note note-success text-center" style="padding: 0px 1px 0px 0px"><h4 class="block text-info"><strong>{{vm.payment.amountUzs | number}} {{vm.payment.displayCurrency}}</strong></h4></div></div></div></div><!--/span--></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Country:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.providerCountryName}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Category:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.providerCategoryName}}</p></div></div></div><!--/span--></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Provider:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.providerName}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Segment:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.providerSegmentName}}</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Debit state:</strong></label><div class="col-md-9"><div style="margin: 10px 0"><span class="label label-default" ng-if="vm.payment.debitState === 0">INITIATED</span> <span class="label label-success" ng-if="vm.payment.debitState === 3">SUCCESS</span> <span class="label label-danger" ng-if="vm.payment.debitState !== 0 && vm.payment.debitState !== 3">FAILED:{{vm.payment.debitState}}</span></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Credit state:</strong></label><div class="col-md-9"><div style="margin: 10px 0"><span class="label label-default" ng-if="vm.payment.creditState === -2">CREATED</span> <span class="label label-success" ng-if="vm.payment.creditState === 0">SUCCESS</span> <span class="label label-danger" ng-if="vm.payment.creditState === -21">CANCELLED</span> <span class="label label-danger" ng-if="vm.payment.creditState !== -2 && vm.payment.creditState !== 0 && vm.payment.creditState !== -21">FAILED:{{vm.payment.creditState}}</span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Debit message:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.debitMessage}}</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Credit message:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.creditMessage}}</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Client:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.payment.client}}</p></div></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span data-translate="entity.action.close">Close</span></button></div>');
$templateCache.put('app/entities/tkb-payment/tkb-payments.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-refresh font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.tkbPayment.home.title">Tkb Payments</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.filterForm.userPhone">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="{{\'bozorakaAdminApp.tkbPayment.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.filterForm.externalId">External Id</label><input type="text" class="form-control" ng-model="vm.searchQuery.externalId" placeholder="{{\'bozorakaAdminApp.tkbPayment.filterForm.externalId\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.account">Account</label><input type="text" class="form-control" ng-model="vm.searchQuery.account" placeholder="{{\'bozorakaAdminApp.tkbPayment.account\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.transactionStatus">Transaction Status</label><select class="form-control" ng-model="vm.searchQuery.transactionStatus"><option value="UNKNOWN" class selected="selected"></option><option value="SUCCESS">SUCCESS</option><option value="FAILURE">FAILURE</option></select></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.debitState">Debit State</label><select class="form-control" ng-model="vm.searchQuery.state"><option value="-1" class selected="selected"></option><option value="0">INITIATED</option><option value="3">SUCCESS</option><option value="-2">FAILED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.creditState">Credit State</label><select class="form-control" ng-model="vm.searchQuery.creditState"><option value="-1" class selected="selected"></option><option value="-2">CREATED</option><option value="0">SUCCESS</option><option value="-21">CANCELLED</option><option value="-99">FAILED</option></select></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.gateway">Gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value="ALL">ALL</option><option value="TKB">TKB</option><option value="MTS">MTS</option><option value="SBP">SBP</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbPayment.filterForm.date">Date</label><div class="input-group datetime-picker input-daterange"><input type="text" class="form-control" name="from" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.from" ng-click="vm.openCalendar(\'from\')" is-open="vm.datePickerOpenStatus.from" autocomplete="off"> <span class="input-group-addon">to </span><input id="field_toDate" type="text" class="form-control" name="to" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.searchQuery.to" ng-click="vm.openCalendar(\'to\')" is-open="vm.datePickerOpenStatus.to" autocomplete="off"></div></div></div></div><div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn green-meadow" ng-click="vm.excel()"><i class="fa fa-file-excel-o"></i> &nbsp;Excel</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th rowspan="2" jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" style="min-width: 150px"><span data-translate="bozorakaAdminApp.tkbPayment.user">User</span></th><th rowspan="2" jh-sort-by="externalId"><span data-translate="bozorakaAdminApp.tkbPayment.externalId">External Id</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="account"><span data-translate="bozorakaAdminApp.tkbPayment.account">Account</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="account"><span>Description</span><span class="glyphicon glyphicon-sort"></span></th><th colspan="3"><span data-translate="bozorakaAdminApp.tkbPayment.amount">Amount</span></th><th colspan="3">Commission</th><th rowspan="2" jh-sort-by="state"><span data-translate="bozorakaAdminApp.tkbPayment.debitState">Debit State</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="creditState"><span data-translate="bozorakaAdminApp.tkbPayment.creditState">Credit State</span><span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span>Transaction status</span></th><th rowspan="2" jh-sort-by="gateway"><span data-translate="bozorakaAdminApp.tkbPayment.gateway">Gateway</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.tkbPayment.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"><span>Check</span></th><th rowspan="2"><span>Confirm</span></th><th rowspan="2"><span>Recredit</span></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="amount"><span>RUB</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commissionAmount"><span>RUB %</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountUzs"><span>UZS</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ubCommissionAmount">Bank<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="spCommissionAmount">SP<span class="glyphicon glyphicon-sort"></span></th><th>Total</th></tr></thead><tbody><tr ng-repeat="tkbPayment in vm.tkbPayments track by tkbPayment.id"><td>{{tkbPayment.id}}</td><td class="text-center"><a href="javascript:;" ng-click="vm.openProfile(tkbPayment.userPhone)">{{tkbPayment.userPhone | phoneNumber}}</a></td><td id="mt{{tkbPayment.externalId}}" id="copyAhref">{{tkbPayment.externalId}} <a href="javascript:;" class="green mt-clipboard pull-right" data-clipboard-action="copy" data-clipboard-target="#mt{{tkbPayment.externalId}}" title="You can copy External ID"><i style="font-size: 20px" class="fa fa-copy"></i></a></td><td><a href="" ng-click="vm.openPaymentInfo(tkbPayment.id)">{{tkbPayment.account}}</a></td><td>{{tkbPayment.description}}</td><td>{{tkbPayment.amount}}</td><td>{{tkbPayment.commissionAmount}}</td><td>{{tkbPayment.amountUzs}}</td><td>{{tkbPayment.ubCommissionAmount}}</td><td>{{tkbPayment.spCommissionAmount}}</td><td>{{tkbPayment.ubCommissionAmount + tkbPayment.spCommissionAmount}}</td><td><div data-toggle="popover" id="{{tkbPayment.id}}" ng-click="vm.initPopover($event, tkbPayment)"><span class="label label-default" ng-if="tkbPayment.state === 0">INITIATED</span> <span class="label label-success" ng-if="tkbPayment.state === 3">SUCCESS</span> <span class="label label-danger" ng-if="tkbPayment.state !== 0 && tkbPayment.state !== 3">FAILED:{{tkbPayment.state}}</span></div></td><td><div data-toggle="popover" id="{{tkbPayment.id}}-credit" ng-click="vm.initCreditPopover($event, tkbPayment)"><span class="label label-default" ng-if="tkbPayment.creditState === -2">CREATED</span> <span class="label label-success" ng-if="tkbPayment.creditState === 0">SUCCESS</span> <span class="label label-danger" ng-if="tkbPayment.creditState === -21">CANCELLED</span> <span class="label label-danger" ng-if="tkbPayment.creditState !== -2 && tkbPayment.creditState !== 0 && tkbPayment.creditState !== -21">FAILED:{{tkbPayment.creditState}}</span></div></td><td><a ui-sref="transaction-detail({id:tkbPayment.transactionId})">{{tkbPayment.transactionStatus}}</a></td><td>{{tkbPayment.gateway}}</td><td>{{tkbPayment.createdDate | date:\'medium\'}}</td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.getPaymentState(tkbPayment.externalId)" style="margin-bottom: 15px" ng-disabled="tkbPayment.externalId === null || vm.checkList[tkbPayment.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down" data-translate="entity.action.check"></span></button></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.confirmPayment(tkbPayment.externalId)" style="margin-bottom: 15px" ng-disabled="vm.checkList[tkbPayment.externalId] === true "><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down">Confirm</span></button></td><td><button type="button" class="btn btn green btn-sm" ng-click="vm.recreditPayment(tkbPayment.orderId)" style="margin-bottom: 15px" ng-disabled="vm.checkList[tkbPayment.orderId] === true || tkbPayment.state !== 3 || tkbPayment.creditState === 0"><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm-down">Recredit</span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/transaction/transaction-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.transaction.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.transaction.delete.question" translate-values="{id: \'{{vm.transaction.id}}\'}">Are you sure you want to delete this Transaction?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/transaction/transaction-detail.html','<!-- BEGIN PAGE HEADER--><div class="page-bar"><ul class="page-breadcrumb"><li><i class="fa fa-circle"></i> <a ui-sref="transaction" data-translate="global.menu.transactions">Transactions</a></li></ul><div class="page-toolbar"><div class="btn-group pull-right"></div></div></div><h3 class="page-title" data-translate="transaction.detail.subtitle.transaction">Transaction details</h3><!-- END PAGE HEADER--><!-- BEGIN PAGE CONTENT--><div class="row"><div class="col-md-12"><div class="portlet box {{vm.statusColor}}"><div class="portlet-title"><div class="caption"><i class="icon-equalizer"></i> <span ng-if="vm.transaction.status == \'SUCCESS\'">{{\'transaction.detail.status.success\' | translate}} </span><span ng-if="vm.transaction.status == \'INPROGRESS\'">{{\'transaction.detail.status.inprogress\' | translate}} </span><span ng-if="vm.transaction.status == \'FAILURE\'">{{\'transaction.detail.status.failure\' | translate}}</span></div><div class="tools form-actions right"><span has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><a ng-if="vm.transaction.status == \'SUCCESS\' && vm.transaction.kashTrId != null " class="fa fa-file-pdf-o font-white" ng-click="vm.generatePaynetReceipt(vm.transaction.id)"></a> </span><span has-any-authority="ROLE_ADMIN, ROLE_MANAGER"><a ng-if="vm.isEditable()" class="fa fa-edit font-white" ui-sref="transaction-detail.editStatus({id:vm.transaction.id})"></a></span></div></div><div class="portlet-body form"><!-- BEGIN FORM--><form class="form-horizontal" role="form"><div class="form-body"><div ng-if="vm.transaction.status == \'INPROGRESS\'"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.details\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-warning text-center"><h3 class="block text-info"><strong>{{vm.transaction.description}}</strong></h3></div></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.sent\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-warning text-center"><h3 class="block text-info"><strong>{{vm.getSentAmount(vm.transaction)}}</strong></h3></div></div></div></div><!--/span--></div><!--/row--></div><div ng-if="vm.transaction.status == \'INPROGRESS\'" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_AGENT_KOR, ROLE_AGENT_UZB, ROLE_CUSTOMER_SUPPORT_PAYGRAM"><div class="row"><div class="col-md-6"><div class="row" style="padding-bottom: 10px"><div class="col-md-12"><button type="submit" ui-sref="transaction-detail.edit({id:vm.transaction.id, status:\'success\'})" class="btn green-jungle btn-block">{{\'transaction.detail.button.successful\' | translate}}</button></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><button type="button" ui-sref="transaction-detail.edit({id:vm.transaction.id, status:\'fail\'})" class="btn red-mint btn-block">{{\'transaction.detail.button.failed\' | translate}}</button></div></div></div></div><h6 class="form-section"></h6></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.date\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.pubDate | date:\'yyyyMMdd\'}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.request\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.requestNo}}</p></div></div></div><!--/span--></div><!--/row--><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.phone\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static"><a href="javascript:;" ui-sref="profile-detail({id:vm.transaction.profileId})">{{vm.transaction.profilePhone | phoneNumber}}</a></p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.gateway\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static"><transaction-gateway gateway="vm.transaction.gateway"></transaction-gateway></p></div></div></div><!--/span--></div><!--/row--><div class="row"><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>Direct amount:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.directAmount | number}} ruble</p></div></div></div><!--/span--></div><!--/row--><div ng-if="vm.transaction.status == \'SUCCESS\'"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.details\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-success text-center"><h3 class="block text-info"><strong>{{vm.transaction.description}}</strong></h3></div></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.sent\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-success text-center"><h3 class="block text-info"><strong>{{vm.getSentAmount(vm.transaction)}}</strong></h3></div></div></div></div><!--/span--></div><!--/row--></div><div ng-if="vm.transaction.status == \'FAILURE\'"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.details\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-danger text-center"><h3 class="block text-info"><strong>{{vm.transaction.description}}</strong></h3></div></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.sent\' | translate}}:</strong></label><div class="col-md-9"><div class="note note-danger text-center"><h3 class="block text-info"><strong>{{vm.getSentAmount(vm.transaction)}}</strong></h3></div></div></div></div><!--/span--></div><!--/row--></div><!--/row--><div ng-if="vm.transaction.status != \'INPROGRESS\'"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.status\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static"><a class="btn btn-xs green-seagreen" ng-if="vm.transaction.status == \'SUCCESS\'" style="pointer-events: none">{{\'transaction.detail.status.success\' | translate}} </a><a class="btn btn-xs yellow-saffron" ng-if="vm.transaction.status == \'INPROGRESS\'" style="pointer-events: none">{{\'transaction.detail.status.inprogress\' | translate}} </a><a class="btn btn-xs red-mint" ng-if="vm.transaction.status == \'FAILURE\'" style="pointer-events: none">{{\'transaction.detail.status.failure\' | translate}}</a></p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.agent\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.lastModifiedBy}}</p></div></div></div><!--/span--></div><!--/row--></div><div ng-if="vm.transaction.status == \'FAILURE\'"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.errorMessage\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.getErrorMessage(vm.transaction)}}</p></div></div></div><!--/span--></div><!--/row--></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.client\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.client}}</p></div></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.ht\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.dateDiff(vm.transaction) | handledTime}}</p></div></div></div><!--/span--></div><div class="row"><div class="col-md-6" ng-if="vm.transaction.statusChangeReason != null"><div class="form-group"><label class="control-label col-md-3"><strong>{{\'transaction.modified\' | translate}}:</strong></label><div class="col-md-9"><p class="form-control-static">{{vm.transaction.statusChangeReason}}</p></div></div></div></div><!--/row--><div class="row"><div class="col-md-12"><div class="panel-group accordion" id="accordion3"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle accordion-toggle-styled" href="javascript:;" ng-click="vm.collapse()">{{\'transaction.serverResponse\' | translate}}</a></h4></div><div class="panel-collapse" style="display: block" ng-if="vm.shouldCollapse"><div class="panel-body">{{vm.serverResponse}}</div></div><div class="panel-collapse" style="display: none" ng-if="vm.shouldCollapse"><div class="panel-body">{{vm.serverResponse}}</div></div></div></div></div><!--/span--></div><!--/row--></div></form><!-- END FORM--></div></div></div></div><!-- END PAGE CONTENT-->');
$templateCache.put('app/entities/transaction/transaction-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title font-red-mint" ng-if="vm.status == \'fail\'" data-translate="transaction.dialog.fail.title">Confirm failed transaction</h3><h3 class="modal-title font-green-jungle" ng-if="vm.status == \'success\'" data-translate="transaction.dialog.success.title">Confirm successful transaction</h3></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.status == \'fail\'"><label class="control-label" for="field_error_message" data-translate="transaction.dialog.fail.specifyReason">Specify reason</label><select class="form-control" name="errorMessage" ng-model="vm.transaction.errorMessage" id="field_error_message" required><option value="ERROR_MESSAGE_TRY_LATER">{{\'transaction.dialog.fail.ERROR_MESSAGE_TRY_LATER\' | translate}}</option><option value="ERROR_MESSAGE_MAINTENANCE">{{\'transaction.dialog.fail.ERROR_MESSAGE_MAINTENANCE\' | translate}}</option><option value="ERROR_MESSAGE_WRONG_NUMBER">{{\'transaction.dialog.fail.ERROR_MESSAGE_WRONG_NUMBER\' | translate}}</option><option value="ERROR_MESSAGE_LEGAL_ENTITY">{{\'transaction.dialog.fail.ERROR_MESSAGE_LEGAL_ENTITY\' | translate}}</option><option value="ERROR_MESSAGE_DISABLED">{{\'transaction.dialog.fail.ERROR_MESSAGE_DISABLED\' | translate}}</option><option value="ERROR_MESSAGE_INVALID_VOIP">{{\'transaction.dialog.fail.ERROR_MESSAGE_INVALID_VOIP\' | translate}}</option><option value="ERROR_MESSAGE_VISA_EXPIRED">{{\'transaction.dialog.fail.ERROR_MESSAGE_VISA_EXPIRED\' | translate}}</option><option value="ERROR_MESSAGE_NUMBER_OFF">{{\'transaction.dialog.fail.ERROR_MESSAGE_NUMBER_OFF\' | translate}}</option><option value="ERROR_MESSAGE_WRONG_NUMBER_LINEPHONE">{{\'transaction.dialog.fail.ERROR_MESSAGE_WRONG_NUMBER_LINEPHONE\' | translate}}</option><option value="ERROR_MESSAGE_NUMBER_NOT_CONNECTED_TO_MANGO">{{\'transaction.dialog.fail.ERROR_MESSAGE_NUMBER_NOT_CONNECTED_TO_MANGO\' | translate}}</option><option value="ERROR_MESSAGE_NUMBER_NOT_CHARGED_DURING_CALL">{{\'transaction.dialog.fail.ERROR_MESSAGE_NUMBER_NOT_CHARGED_DURING_CALL\' | translate}}</option><option value="ERROR_MESSAGE_NUMBER_NOT_REGISTERED">{{\'transaction.dialog.fail.ERROR_MESSAGE_NUMBER_NOT_REGISTERED\' | translate}}</option><option value="ERROR_MESSAGE_BLOCKED_PAYMENT">{{\'transaction.dialog.fail.ERROR_MESSAGE_BLOCKED_PAYMENT\' | translate}}</option><option value="ERROR_MESSAGE_DEACTIVATED_NUMBER">{{\'transaction.dialog.fail.ERROR_MESSAGE_DEACTIVATED_NUMBER\' | translate}}</option><option value="ERROR_MESSAGE_SMALL_AMOUNT">{{\'transaction.dialog.fail.ERROR_MESSAGE_SMALL_AMOUNT\' | translate}}</option><option value="ERROR_MESSAGE_LARGE_AMOUNT">{{\'transaction.dialog.fail.ERROR_MESSAGE_LARGE_AMOUNT\' | translate}}</option><option value="ERROR_MESSAGE_TKB_PAYMENT_FAILURE">{{\'transaction.dialog.fail.ERROR_MESSAGE_TKB_PAYMENT_FAILURE\' | translate}}</option><option value="ERROR_MESSAGE_TKB_PAYMENT_DECLINE">{{\'transaction.dialog.fail.ERROR_MESSAGE_TKB_PAYMENT_DECLINE\' | translate}}</option></select><div ng-show="editForm.errorMessage.$invalid"><p class="help-block" ng-show="editForm.errorMessage.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.status == \'success\'"><label class="control-label" data-translate="transaction.dialog.success.message">I confirm that this transaction has been successfully processed.</label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn red-mint" ng-if="vm.status == \'fail\'"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.confirm">Confirm</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn green-jungle" ng-if="vm.status == \'success\'"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/transaction/transaction-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="modal-header"><strong>{{\'transaction.statusChangeReason.title\' | translate}}:</strong></div><div class="modal-body"><div class="form-group"><div class="col-md-15" s><input type="text" class="form-control" name="statusChangeReason" id="field_statusChangeReason" ng-model="vm.transaction.statusChangeReason" required><div ng-show="editForm.statusChangeReason.$invalid"><p class="help-block" ng-show="editForm.statusChangeReason.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn red-mint"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/transaction/transactions.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><!-- BEGIN EXAMPLE TABLE PORTLET--><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="transaction.home.title.payments">Transactions</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="transaction.form.search">Request # / Phone # / Details</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{ \'transaction.form.search\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Direct</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount"></div></div><!--/span--><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="transaction.form.date">Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon" data-translate="transaction.form.to.date">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div><!--/span--></div><!--/row--><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="transaction.form.gateway">Select gateway</label><select class="form-control" ng-model="vm.searchQuery.gateway"><option value="vse_platezhi">VSE PLATEZHI</option><option value="tkb">TKB</option></select></div></div><!--/span--><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="transaction.form.status">Status</label><select class="form-control" ng-model="vm.searchQuery.status"><option value class selected="selected"></option><option value="INPROGRESS">IN PROGRESS</option><option value="SUCCESS">SUCCESS</option><option value="FAILURE">FAILURE</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="transaction.form.mode">Mode</label><select class="form-control" ng-model="vm.searchQuery.mode"><option value class selected="selected"></option><option value="AUTO">AUTO</option><option value="MANUAL">MANUAL</option></select></div></div><!--/span--></div><div class="row"><div class="col-md-3"><div class="form-group"><label data-translate="global.form.providerCountry">Provider Country</label><select class="form-control" name="providerCountryId" ng-model="vm.searchQuery.providerCountryId" ng-options="country.id as country.name for country in vm.providerCountries" ng-change="vm.getProviderCategories()"><option value=""></option></select></div></div><div class="col-md-3"><div class="form-group"><label data-translate="transaction.form.providerCategory">Provider Category</label><select class="form-control" name="providerCategoryId" ng-model="vm.searchQuery.providerCategoryId" ng-options="category.id as category.name for category in vm.providerCategories" ng-change="vm.getProviders()"><option value=""></option></select></div></div><div class="col-md-3"><div class="form-group"><label data-translate="transaction.form.provider">Provider</label><select class="form-control" name="providerId" ng-model="vm.searchQuery.providerId" ng-options="provider.id as provider.name for provider in vm.providers" ng-change="vm.getProviderSegments()"></select></div></div><div class="col-md-3"><div class="form-group"><label data-translate="transaction.form.providerSegment">Provider Service</label><select class="form-control" name="providerSegmentId" ng-model="vm.searchQuery.providerSegmentId" ng-options="providerSegments.id as providerSegments.name for providerSegments in vm.providerSegments"></select></div></div></div><!--/row--></div><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></form><!-- END FORM--></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-center"><span data-translate="transaction.ht">HT</span></th><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="requestNo"><span data-translate="transaction.request">Request #</span> <span class="glyphicon glyphicon-sort"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th jh-sort-by="mode"><span data-translate="transaction.mode">Mode</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="transaction.phone">Phone #</span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th><span data-translate="transaction.gateway">Gateway #</span></th><th jh-sort-by="directAmount"><span data-translate="transaction.direct">Direct</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountInSom"><span data-translate="transaction.sent">Sent</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="transaction.details">Details</span> <span class="glyphicon glyphicon-sort"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th><th jh-sort-by="status"><span data-translate="transaction.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="transaction.agent">Agent</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="transaction in vm.transactions track by transaction.id" class="odd gradeX text-center"><td>{{vm.dateDiff(transaction) | handledTime}}</td><td>{{transaction.id}}</td><td><span ng-switch="transaction.serviceType"><a href="javascript:;" ui-sref="order-info-detail({id:transaction.orderInfoId})" ng-switch-when="SERVICE_MARKET"><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a><a href="javascript:;" ui-sref="transaction-detail({id:transaction.id})" ng-switch-default><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.requestNo}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.requestNo}}</spa></a></span></td><td><transaction-mode mode="transaction.mode"></transaction-mode></td><td><a href="javascript:;" ng-click="vm.openProfile(transaction.profilePhone)"><spa class="font-red" ng-if="transaction.status == \'INPROGRESS\'">{{transaction.profilePhone | phoneNumber}}</spa><spa ng-if="transaction.status == \'SUCCESS\' || transaction.status == \'FAILURE\'">{{transaction.profilePhone | phoneNumber}}</spa></a></td><td><transaction-gateway gateway="transaction.gateway"></transaction-gateway></td><td>{{vm.getDirectAmount(transaction)}}</td><td>{{vm.getSentAmount(transaction)}}</td><td>{{transaction.description}}</td><td><transaction-status status="transaction.status"></transaction-status></td><td>{{transaction.lastModifiedBy}}</td></tr></tbody></table></div></div><div class="row"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-right" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/uzb-card/uzb-card-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.uzbCard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.uzbCard.delete.question" translate-values="{id: \'{{vm.uzbCard.id}}\'}">Are you sure you want to delete this Uzb Card?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/uzb-card/uzb-card-detail.html','<div><h2><span data-translate="bozorakaAdminApp.uzbCard.detail.title">Uzb Card</span> {{vm.uzbCard.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.uzbCard.owner">Owner</span></dt><dd><span>{{vm.uzbCard.owner}}</span></dd><dt><span data-translate="bozorakaAdminApp.uzbCard.number">Number</span></dt><dd><span>{{vm.uzbCard.number}}</span></dd><dt><span data-translate="bozorakaAdminApp.uzbCard.user">User</span></dt><dd><a ui-sref="customer-detail({id:vm.uzbCard.userId})">{{vm.uzbCard.userPhone}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="uzb-card-detail.edit({id:vm.uzbCard.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/uzb-card/uzb-card-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUzbCardLabel" data-translate="bozorakaAdminApp.uzbCard.home.createOrEditLabel">Create or edit a Uzb Card</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.uzbCard.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.uzbCard.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.uzbCard.owner" for="field_owner">Owner</label><input type="text" class="form-control" name="owner" id="field_owner" ng-model="vm.uzbCard.owner" ng-maxlength="30" ng-readonly="vm.isEdit" ng-change="vm.uzbCard.owner = vm.uzbCard.owner && vm.uzbCard.owner.toUpperCase()" style="text-transform: uppercase"><div ng-show="editForm.owner.$invalid"><p class="help-block" ng-show="editForm.owner.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.uzbCard.number" for="field_number">Number</label><input type="text" class="form-control" name="number" id="field_number" ng-model="vm.uzbCard.number" ng-maxlength="16" ng-readonly="vm.isEdit"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.uzbCard.user" for="field_user">User</label><input type="text" class="form-control" name="number" id="field_user" ng-model="vm.uzbCard.userPhone" ng-maxlength="16" ng-readonly="vm.isEdit" required></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label for="field_isBlocked">Card state</label><select required class="form-control" ng-model="vm.uzbCard.isBlocked" id="field_isBlocked"><option value="true" ng-selected="vm.uzbCard.isBlocked === true">Blocked</option><option value="false" ng-selected="vm.uzbCard.isBlocked === false">Unblocked</option></select></div><div ng-show="editForm.isBlocked.$invalid"><p class="help-block" ng-show="editForm.isBlocked.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/uzb-card/uzb-cards.html','<jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="portlet light bordered"><div class="row"><div class="portlet-title col-md-6"><div class="caption font-dark"><i class="icon-credit-card font-dark"></i> <span class="caption-subject bold uppercase ng-scope" data-translate="bozorakaAdminApp.uzbCard.home.title">Uzb Cards</span></div></div><div class="col-md-6"><button type="button" ui-sref="uzb-card.new" class="btn btn-success ng-binding pull-right"><i class="fa fa-plus"></i> New</button></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.userPhone">User Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.userPhone" placeholder="{{\'bozorakaAdminApp.tkbCard.filterForm.userPhone\' | translate}}"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.owner">Owner</label><input type="text" class="form-control" ng-model="vm.searchQuery.owner" placeholder="{{\'bozorakaAdminApp.tkbCard.owner\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.tkbCard.filterForm.cardNumber">Card number</label><input type="text" class="form-control" ng-model="vm.searchQuery.cardNumber" placeholder="{{\'bozorakaAdminApp.tkbCard.filterForm.cardNumber\' | translate}}"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Owner Phone</label><input type="text" class="form-control" ng-model="vm.searchQuery.phone" placeholder="Phone"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Card state</label><select class="form-control" ng-model="vm.searchQuery.blocked"><option value="-1" class selected="selected">ALL</option><option value="1">Blocked</option><option value="0">Unblocked</option></select></div></div></div></div><div class="row"><div class="form-actions right"><button type="submit" class="btn green" ng-click="vm.search()"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></form></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover text-centered-table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.id"><span data-translate="bozorakaAdminApp.uzbCard.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span data-translate="bozorakaAdminApp.uzbCard.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.uzbCard.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="bozorakaAdminApp.uzbCard.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span>Owner Phone </span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isBlocked"><span>Card state</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visibleState"><span>Visible state</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last modified</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span>Created</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="uzbCard in vm.uzbCards track by uzbCard.id"><td><a ui-sref="uzb-card-detail({id:uzbCard.id})">{{uzbCard.id}}</a></td><td><a href="javascript:;" ng-click="vm.openProfile(uzbCard.userPhone)">{{uzbCard.userPhone | phoneNumber}}</a></td><td>{{uzbCard.owner}}</td><td>{{uzbCard.number}}</td><td>{{uzbCard.type | uppercase}}</td><td>{{uzbCard.phone}}</td><td><span class="label label-danger" ng-if="uzbCard.isBlocked === true">Blocked</span> <span class="label label-success" ng-if="uzbCard.isBlocked !== true">Unblocked</span></td><td><span class="label label-danger" ng-if="uzbCard.visibleState === \'DELETED\'">DELETED</span> <span class="label label-success" ng-if="uzbCard.visibleState === \'ACTIVE\'">ACTIVE</span></td><td><div>{{uzbCard.lastModifiedBy}}</div><div>{{uzbCard.lastModifiedDate | date:\'medium\'}}</div></td><td><div>{{uzbCard.createdBy }}</div><div>{{uzbCard.createdDate | date:\'medium\'}}</div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="uzb-card.edit({id:uzbCard.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/transaction-async-task/transaction-async-task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.transactionAsyncTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.transactionAsyncTask.delete.question" translate-values="{id: \'{{vm.transactionAsyncTask.id}}\'}">Are you sure you want to delete this Transaction Async Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/transaction-async-task/transaction-async-task-detail.html','<div><h2><span data-translate="bozorakaAdminApp.transactionAsyncTask.detail.title">Transaction Async Task</span> {{vm.transactionAsyncTask.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.gateway">Gateway</span></dt><dd><span>{{vm.transactionAsyncTask.gateway}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.serviceId">Service Id</span></dt><dd><span>{{vm.transactionAsyncTask.serviceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.method">Method</span></dt><dd><span>{{vm.transactionAsyncTask.method}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.errorMessage">Error Message</span></dt><dd><span>{{vm.transactionAsyncTask.errorMessage}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.status">Status</span></dt><dd><span>{{vm.transactionAsyncTask.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.repeatTime">Repeat Time</span></dt><dd><span>{{vm.transactionAsyncTask.repeatTime}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.nextCheckDate">Next Check Date</span></dt><dd><span>{{vm.transactionAsyncTask.nextCheckDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.createdDate">Created Date</span></dt><dd><span>{{vm.transactionAsyncTask.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.transactionAsyncTask.transaction">Transaction</span></dt><dd><a ui-sref="transaction-detail({id:vm.transactionAsyncTask.transactionId})">{{vm.transactionAsyncTask.transactionRequestNo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="transaction-async-task-detail.edit({id:vm.transactionAsyncTask.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/transaction-async-task/transaction-async-task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTransactionAsyncTaskLabel" data-translate="bozorakaAdminApp.transactionAsyncTask.home.createOrEditLabel">Create or edit a Transaction Async Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.transactionAsyncTask.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.transactionAsyncTask.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.gateway" for="field_gateway">Gateway</label><input type="text" class="form-control" name="gateway" id="field_gateway" ng-model="vm.transactionAsyncTask.gateway" ng-maxlength="20"><div ng-show="editForm.gateway.$invalid"><p class="help-block" ng-show="editForm.gateway.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.transactionAsyncTask.serviceId" ng-maxlength="20"><div ng-show="editForm.serviceId.$invalid"><p class="help-block" ng-show="editForm.serviceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.method" for="field_method">Method</label><input type="text" class="form-control" name="method" id="field_method" ng-model="vm.transactionAsyncTask.method" ng-maxlength="20"><div ng-show="editForm.method.$invalid"><p class="help-block" ng-show="editForm.method.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.errorMessage" for="field_errorMessage">Error Message</label><input type="text" class="form-control" name="errorMessage" id="field_errorMessage" ng-model="vm.transactionAsyncTask.errorMessage"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.transactionAsyncTask.status" ng-maxlength="10"><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.repeatTime" for="field_repeatTime">Repeat Time</label><input type="number" class="form-control" name="repeatTime" id="field_repeatTime" ng-model="vm.transactionAsyncTask.repeatTime"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.nextCheckDate" for="field_nextCheckDate">Next Check Date</label><div class="input-group"><input id="field_nextCheckDate" type="text" class="form-control" name="nextCheckDate" datetime-picker="{{dateformat}}" ng-model="vm.transactionAsyncTask.nextCheckDate" is-open="vm.datePickerOpenStatus.nextCheckDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'nextCheckDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.transactionAsyncTask.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" datetime-picker="{{dateformat}}" ng-model="vm.transactionAsyncTask.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="bozorakaAdminApp.transactionAsyncTask.transaction" for="field_transaction">Transaction</label><select class="form-control" id="field_transaction" name="transaction" ng-model="vm.transactionAsyncTask.transactionId" ng-options="transaction.id as transaction.requestNo for transaction in vm.transactions" required></select></div><div ng-show="editForm.transaction.$invalid"><p class="help-block" ng-show="editForm.transaction.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/transaction-async-task/transaction-async-tasks.html','<div><h2 data-translate="bozorakaAdminApp.transactionAsyncTask.home.title">Transaction Async Tasks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="transaction-async-task.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="bozorakaAdminApp.transactionAsyncTask.home.createLabel">Create new Transaction Async Task</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gateway"><span data-translate="bozorakaAdminApp.transactionAsyncTask.gateway">Gateway</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="serviceId"><span data-translate="bozorakaAdminApp.transactionAsyncTask.serviceId">Service Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="method"><span data-translate="bozorakaAdminApp.transactionAsyncTask.method">Method</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="errorMessage"><span data-translate="bozorakaAdminApp.transactionAsyncTask.errorMessage">Error Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.transactionAsyncTask.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="repeatTime"><span data-translate="bozorakaAdminApp.transactionAsyncTask.repeatTime">Repeat Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nextCheckDate"><span data-translate="bozorakaAdminApp.transactionAsyncTask.nextCheckDate">Next Check Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="bozorakaAdminApp.transactionAsyncTask.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="transactionRequestNo"><span data-translate="bozorakaAdminApp.transactionAsyncTask.transaction">Transaction</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="transactionAsyncTask in vm.transactionAsyncTasks track by transactionAsyncTask.id"><td><a ui-sref="transaction-async-task-detail({id:transactionAsyncTask.id})">{{transactionAsyncTask.id}}</a></td><td>{{transactionAsyncTask.gateway}}</td><td>{{transactionAsyncTask.serviceId}}</td><td>{{transactionAsyncTask.method}}</td><td>{{transactionAsyncTask.errorMessage}}</td><td>{{transactionAsyncTask.status}}</td><td>{{transactionAsyncTask.repeatTime}}</td><td>{{transactionAsyncTask.nextCheckDate | date:\'medium\'}}</td><td>{{transactionAsyncTask.createdDate | date:\'medium\'}}</td><td><a ui-sref="transaction-detail({id:transactionAsyncTask.transactionId})">{{transactionAsyncTask.transactionRequestNo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="transaction-async-task-detail({id:transactionAsyncTask.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="transaction-async-task.edit({id:transactionAsyncTask.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="transaction-async-task.delete({id:transactionAsyncTask.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/vp-payment/vp-payment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.vpPayment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="bozorakaAdminApp.vpPayment.delete.question" translate-values="{id: \'{{vm.vpPayment.id}}\'}">Are you sure you want to delete this Vp Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/vp-payment/vp-payment-detail.html','<div><h2><span data-translate="bozorakaAdminApp.vpPayment.detail.title">Vp Payment</span> {{vm.vpPayment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="bozorakaAdminApp.vpPayment.serviceId">Service Id</span></dt><dd><span>{{vm.vpPayment.serviceId}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.account">Account</span></dt><dd><span>{{vm.vpPayment.account}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.amount">Amount</span></dt><dd><span>{{vm.vpPayment.amount}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.amountFee">Amount Fee</span></dt><dd><span>{{vm.vpPayment.amountFee}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.localRate">Local Rate</span></dt><dd><span>{{vm.vpPayment.localRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.serviceRate">Service Rate</span></dt><dd><span>{{vm.vpPayment.serviceRate}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.date">Date</span></dt><dd><span>{{vm.vpPayment.date | date:\'medium\'}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.sign">Sign</span></dt><dd><span>{{vm.vpPayment.sign}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.agentRequestId">Agent Request Id</span></dt><dd><span>{{vm.vpPayment.agentRequestId}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.serverRequestId">Server Request Id</span></dt><dd><span>{{vm.vpPayment.serverRequestId}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.serverTransactionId">Server Transaction Id</span></dt><dd><span>{{vm.vpPayment.serverTransactionId}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.payUrl">Pay Url</span></dt><dd><span>{{vm.vpPayment.payUrl}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.client">Client</span></dt><dd><span>{{vm.vpPayment.client}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.method">Method</span></dt><dd><span data-translate="{{\'bozorakaAdminApp.VpRequestType.\' + vm.vpPayment.method}}">{{vm.vpPayment.method}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.status">Status</span></dt><dd><span>{{vm.vpPayment.status}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.responseCode">Response Code</span></dt><dd><span>{{vm.vpPayment.responseCode}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.verifyRawXml">Verify Raw Xml</span></dt><dd><span>{{vm.vpPayment.verifyRawXml}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.paymentRawXml">Payment Raw Xml</span></dt><dd><span>{{vm.vpPayment.paymentRawXml}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.statusChecked">Status Checked</span></dt><dd><span>{{vm.vpPayment.statusChecked}}</span></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.transaction">Transaction</span></dt><dd><a ui-sref="transaction-detail({id:vm.vpPayment.transactionId})">{{vm.vpPayment.transactionId}}</a></dd><dt><span data-translate="bozorakaAdminApp.vpPayment.user">User</span></dt><dd>{{vm.vpPayment.userPhone}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/vp-payment/vp-payment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVpPaymentLabel" data-translate="bozorakaAdminApp.vpPayment.home.createOrEditLabel">Create or edit a Vp Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.vpPayment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.vpPayment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.vpPayment.serviceId" required ng-maxlength="32"><div ng-show="editForm.serviceId.$invalid"><p class="help-block" ng-show="editForm.serviceId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.serviceId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.account" for="field_account">Account</label><input type="text" class="form-control" name="account" id="field_account" ng-model="vm.vpPayment.account" required ng-maxlength="32"><div ng-show="editForm.account.$invalid"><p class="help-block" ng-show="editForm.account.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.account.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.vpPayment.amount" required min="0"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.amountFee" for="field_amountFee">Amount Fee</label><input type="number" class="form-control" name="amountFee" id="field_amountFee" ng-model="vm.vpPayment.amountFee" required min="0"><div ng-show="editForm.amountFee.$invalid"><p class="help-block" ng-show="editForm.amountFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amountFee.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.amountFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.localRate" for="field_localRate">Local Rate</label><input type="number" class="form-control" name="localRate" id="field_localRate" ng-model="vm.vpPayment.localRate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.serviceRate" for="field_serviceRate">Service Rate</label><input type="number" class="form-control" name="serviceRate" id="field_serviceRate" ng-model="vm.vpPayment.serviceRate"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" datetime-picker="{{dateformat}}" ng-model="vm.vpPayment.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.sign" for="field_sign">Sign</label><input type="text" class="form-control" name="sign" id="field_sign" ng-model="vm.vpPayment.sign" ng-maxlength="512"><div ng-show="editForm.sign.$invalid"><p class="help-block" ng-show="editForm.sign.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="512">This field cannot be longer than 512 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.agentRequestId" for="field_agentRequestId">Agent Request Id</label><input type="text" class="form-control" name="agentRequestId" id="field_agentRequestId" ng-model="vm.vpPayment.agentRequestId" required ng-maxlength="64"><div ng-show="editForm.agentRequestId.$invalid"><p class="help-block" ng-show="editForm.agentRequestId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.agentRequestId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.serverRequestId" for="field_serverRequestId">Server Request Id</label><input type="text" class="form-control" name="serverRequestId" id="field_serverRequestId" ng-model="vm.vpPayment.serverRequestId" ng-maxlength="64"><div ng-show="editForm.serverRequestId.$invalid"><p class="help-block" ng-show="editForm.serverRequestId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.serverTransactionId" for="field_serverTransactionId">Server Transaction Id</label><input type="text" class="form-control" name="serverTransactionId" id="field_serverTransactionId" ng-model="vm.vpPayment.serverTransactionId" ng-maxlength="64"><div ng-show="editForm.serverTransactionId.$invalid"><p class="help-block" ng-show="editForm.serverTransactionId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.payUrl" for="field_payUrl">Pay Url</label><input type="text" class="form-control" name="payUrl" id="field_payUrl" ng-model="vm.vpPayment.payUrl" ng-maxlength="512"><div ng-show="editForm.payUrl.$invalid"><p class="help-block" ng-show="editForm.payUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="512">This field cannot be longer than 512 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.client" for="field_client">Client</label><input type="text" class="form-control" name="client" id="field_client" ng-model="vm.vpPayment.client" ng-maxlength="20"><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.method" for="field_method">Method</label><select class="form-control" name="method" ng-model="vm.vpPayment.method" id="field_method"><option value="UNKNOWN" data-translate="bozorakaAdminApp.VpRequestType.UNKNOWN">UNKNOWN</option><option value="VERIFY" data-translate="bozorakaAdminApp.VpRequestType.VERIFY">VERIFY</option><option value="PAYMENT" data-translate="bozorakaAdminApp.VpRequestType.PAYMENT">PAYMENT</option></select></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.status" for="field_status">Status</label><input type="number" class="form-control" name="status" id="field_status" ng-model="vm.vpPayment.status"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.responseCode" for="field_responseCode">Response Code</label><input type="number" class="form-control" name="responseCode" id="field_responseCode" ng-model="vm.vpPayment.responseCode"></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.verifyRawXml" for="field_verifyRawXml">Verify Raw Xml</label><textarea class="form-control" name="verifyRawXml" id="field_verifyRawXml" ng-model="vm.vpPayment.verifyRawXml"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.paymentRawXml" for="field_paymentRawXml">Payment Raw Xml</label><textarea class="form-control" name="paymentRawXml" id="field_paymentRawXml" ng-model="vm.vpPayment.paymentRawXml"></textarea></div><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.statusChecked" for="field_statusChecked">Status Checked</label><input type="checkbox" name="statusChecked" id="field_statusChecked" ng-model="vm.vpPayment.statusChecked"></div><div class="form-group"><label data-translate="bozorakaAdminApp.vpPayment.transaction" for="field_transaction">Transaction</label><select class="form-control" id="field_transaction" name="transaction" ng-model="vm.vpPayment.transactionId" ng-options="transaction.id as transaction.id for transaction in vm.transactions"><option value=""></option></select></div><div class="form-group"><label data-translate="bozorakaAdminApp.vpPayment.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.vpPayment.userId" ng-options="customer.id as customer.phone for customer in vm.customers" required></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/vp-payment/vp-payments.html','<div class="row"><jhi-alert></jhi-alert><div class="col-md-12"><div class="portlet light bordered"><div class="portlet-title"><div class="caption font-dark"><i class="icon-list font-dark"></i> <span class="caption-subject bold uppercase" data-translate="bozorakaAdminApp.vpPayment.home.title">Vp Payments</span></div></div><div class="portlet-body"><div class="portlet light bg-inverse"><div class="portlet-body form"><!-- BEGIN FORM--><form name="searchForm" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">{{"bozorakaAdminApp.vpPayment.userId" | translate}} / {{"bozorakaAdminApp.vpPayment.phone" | translate}} / {{"bozorakaAdminApp.vpPayment.paymentId" | translate}}</label><input type="text" class="form-control" ng-model="vm.searchQuery.field" placeholder="{{\'bozorakaAdminApp.vpPayment.userId\' | translate}} / {{\'bozorakaAdminApp.vpPayment.phone\' | translate}} / {{\'bozorakaAdminApp.vpPayment.paymentId\' | translate}}"></div></div><!--/span--><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.account"></label><input type="text" class="form-control" ng-model="vm.searchQuery.client" placeholder="{{\'bozorakaAdminApp.vpPayment.account\' | translate}}"></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.amount">Amount</label><input type="number" class="form-control" ng-model="vm.searchQuery.amount" placeholder="{{\'bozorakaAdminApp.vpPayment.amount\' | translate}}"></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.account">Operator</label><select class="form-control" ng-model="vm.searchQuery.valueString1"><option value="" class selected="selected"></option><option value="mts">{{"bozorakaAdminApp.vpPayment.operators.mts" | translate}}</option><option value="beelinehphone">{{"bozorakaAdminApp.vpPayment.operators.beelinehphone" | translate}}</option><option value="yota_phone">{{"bozorakaAdminApp.vpPayment.operators.yota_phone" | translate}}</option><option value="tele2">{{"bozorakaAdminApp.vpPayment.operators.tele2" | translate}}</option><option value="megafon">{{"bozorakaAdminApp.vpPayment.operators.megafon" | translate}}</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.status">Status</label><select class="form-control" ng-model="vm.searchQuery.valueLong1"><option value="" class selected="selected"></option><option value="1">{{"bozorakaAdminApp.vpPayment.paymentStatus.status1" | translate}}</option><option value="4">{{"bozorakaAdminApp.vpPayment.paymentStatus.status4" | translate}}</option><option value="5">{{"bozorakaAdminApp.vpPayment.paymentStatus.status5" | translate}}</option><option value="6">{{"bozorakaAdminApp.vpPayment.paymentStatus.status6" | translate}}</option><option value="7">{{"bozorakaAdminApp.vpPayment.paymentStatus.status7" | translate}}</option><option value="8">{{"bozorakaAdminApp.vpPayment.paymentStatus.status8" | translate}}</option><option value="9">{{"bozorakaAdminApp.vpPayment.paymentStatus.status9" | translate}}</option><option value="13">{{"bozorakaAdminApp.vpPayment.paymentStatus.status13" | translate}}</option><option value="14">{{"bozorakaAdminApp.vpPayment.paymentStatus.status14" | translate}}</option><option value="15">{{"bozorakaAdminApp.vpPayment.paymentStatus.status15" | translate}}</option></select></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" data-translate="bozorakaAdminApp.vpPayment.date">Date</label><div class="input-group date-picker input-daterange" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" name="from" autocomplete="off"> <span class="input-group-addon">to </span><input type="text" class="form-control" name="to" autocomplete="off"></div></div></div></div><div class="form-actions"><div class="col-md-3" style="padding-left: 3px"><span class="caption-subject">{{"bozorakaAdminApp.vpPayment.totalAmount" | translate}} &nbsp; </span><span class="caption-subject bold" style="font-size: medium"><i class="fa fa-ruble"></i> {{vm.totalAmount | number}}</span></div><div class="col-md-offset-10"><button type="button" class="btn green" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search"></i> {{\'entity.action.search\' | translate}}</button> <button type="button" class="btn yellow" ng-click="vm.clear()"><i class="fa fa-times"></i> {{\'entity.action.reset\' | translate}}</button></div></div></div></form></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-advance table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.id"><span data-translate="bozorakaAdminApp.vpPayment.userId">User Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.phone"><span data-translate="bozorakaAdminApp.vpPayment.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span> <span style="padding-left: 50px"></span></th><th jh-sort-by="account"><span data-translate="bozorakaAdminApp.vpPayment.account">Account</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agentRequestId"><span data-translate="bozorakaAdminApp.vpPayment.paymentId">Agent Request Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="serviceId"><span data-translate="bozorakaAdminApp.vpPayment.operator">Service Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="bozorakaAdminApp.vpPayment.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amountFee"><span data-translate="bozorakaAdminApp.vpPayment.amountFee">Amount Fee</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="bozorakaAdminApp.vpPayment.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="transactionId"><span data-translate="bozorakaAdminApp.vpPayment.transaction">Transaction</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="bozorakaAdminApp.vpPayment.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="bozorakaAdminApp.vpPayment.lastModifiedDate">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="vpPayment in vm.vpPayments track by vpPayment.id"><td>{{vpPayment.id}}</td><td>{{vpPayment.userId}}</td><td><a href="javascript:;" ui-sref="vp-payment.profile({phone:vpPayment.userPhone})" target="_blank">{{vpPayment.userPhone | phoneNumber}}</a></td><td>{{vpPayment.account}}</td><td>{{vpPayment.agentRequestId}}</td><td>{{vpPayment.serviceId}}</td><td>{{vpPayment.amount}}</td><td>{{vpPayment.amountFee}}</td><td>{{"bozorakaAdminApp.vpPayment.paymentStatus.status" + vpPayment.status | translate}}</td><td><a ui-sref="transaction-detail({id:vpPayment.transactionId})">{{vpPayment.transactionId}}</a></td><td>{{vpPayment.date | date:\'medium\'}}</td><td>{{vpPayment.lastModifiedDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="vp-payment-detail({id:vpPayment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');}]);})();